(function () {
  'use strict';

  angular
    .module('app', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ui.router',
      'ui.bootstrap',
      'angular-jwt',
      'angular-storage',
      'toaster',
      'app.logged',
      'app.login',
      'app.pay_advertiser',
      'ng.deviceDetector'
    ]);

})();

( function () {
  'use strict';

  angular
    .module( 'app' )
    .factory( 'WorldPactFactory', WorldPactFactory );

  WorldPactFactory.$inject = [ '$http', 'URLS', '$q', 'toaster' ];

  /** @ngInject */
  function WorldPactFactory ( $http, URLS, $q, toaster ) {
    var factory = {
      getModules    : getModules,
      sendInitCourse: sendInitCourse,
      sendContent   : sendContent,
      sendFeedback  : sendFeedback,
      sendTest      : sendTest,
      getStats      : getStats
    };
    return factory;

    function getModules (id) {
      var deferred = $q.defer();

      var settings = {
        method: 'GET',
        url   : URLS.API + 'course/' + id,
        cache : false
        //  timeout: deferred.promise,
      };
      return http();

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' && typeof data.data !== 'undefined' ) deferred.resolve( data.data );
        else httpError();
      }

      function httpError () {
        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'No ha sido posible mostrar el módulo',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.reject( 'error' );
      }
    }

    function sendInitCourse ( idCourse ) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url   : URLS.API + 'course/' + idCourse + '/inscribe',
        cache : false
      };
      return http();

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' ) {
          deferred.resolve( data );
        } else {
          httpError();
        }
      }

      function httpError () {
        deferred.reject( 'error' );
      }

    }

    function sendContent ( idCourse, idModule, idContent ) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url   : URLS.API + 'course/' + idCourse + '/module/' + idModule + '/content/' + idContent,
        cache : false
      };
      return http();

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' ) {
          deferred.resolve( data );
        } else {
          httpError();
        }
      }

      function httpError () {
        deferred.reject( 'error' );
      }

    }

    function sendFeedback ( idCourse, idModule, idContent, feedback ) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url   : URLS.API + 'course/' + idCourse + '/module/' + idModule + '/content/' + idContent + '/feedback',
        cache : false,
        data  : feedback

      };
      return http();

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' ) {
          toaster.pop( {
                         type           : 'success',
                         title          : 'OK',
                         body           : 'Módulo finalizado con éxito',
                         showCloseButton: true,
                         timeout        : 2000
                       } );
          deferred.resolve( data );
        } else {
          httpError();
        }
      }

      function httpError () {
        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'No ha sido posible enviar el feedback',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.reject( 'error' );
      }

    }

    function sendTest ( idCourse, idModule, idContent, test ) {

      var settings = {
        method: 'POST',
        url   : URLS.API + 'course/' + idCourse + '/module/' + idModule + '/content/' + idContent + '/test',
        cache : false,
        data  : {
          test: test
        }

      };
      return http();

      function http () {
        $http( settings )
      }

    }

    function getStats (id, params) {
      var deferred = $q.defer();

      var settings = {
        method: 'GET',
        url   : URLS.API + 'course/' + id + '/stats',
        cache : false,
        params: params
        //  timeout: deferred.promise,
      };
      return http();

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' && typeof data.data !== 'undefined' ) deferred.resolve( data.data );
        else httpError();
      }

      function httpError () {
        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'No ha sido posible mostrar las estadísticas de este curso',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.reject( 'error' );
      }
    }

  }

} )();

( function () {
  'use strict';

  angular
    .module( 'app.logged', [
      'summernote',
      'angularMoment',
      'pascalprecht.translate',
      'iso-3166-country-codes-es',
      'wu.masonry',
      'ui.calendar',
      'uiGmapgoogle-maps',
      'ngFileUpload',
      'datePicker',
      'localytics.directives',
      'chart.js'
    ] )
    .run( runLogged );

  runLogged.$inject = ['$rootScope', '$state', '$window', '$location', 'BroadcastFactory', 'deviceDetector', 'StatsFactory'];

  function runLogged ( $rootScope, $state, $window, $location, BroadcastFactory, deviceDetector, StatsFactory ) {
    var initialized;
    var stateChangeStartListener = $rootScope.$on( '$stateChangeStart', function ( event, toState ) {
      var appTo = toState.name.indexOf( 'logged' ) !== -1;

      if ( appTo && ( typeof $rootScope.token == 'undefined' || !$rootScope.token ) ) {
        initialized = true;
        event.preventDefault();
        //$location.path( '/login' );
        $state.go( 'app.login' );
      } else if ( !initialized ) {
        initialized = true;
        var names = ['app.password_recovery', 'app.password_recovery_first', 'app.login', 'app.pay_advertiser'];
        if ( names.indexOf( toState.name ) < 0 ) {
          $state.go( 'app.login' );
        }
      }
    } );

    var stateChangeSuccessListener = $rootScope.$on( '$stateChangeSuccess', function ( e, toState, toParams, fromState, fromParams ) {

      if ( toState.name !== 'app.logged.home.countries' ) {
        $window.scrollTo( 0, 0 );
      }

      if ( !fromState.name ) {
        if ( !$state.includes( 'app.logged.home.countries' ) ) $window.scrollTo( 0, 0 );
        if ( $state.includes( 'app.logged.mailbox.compose' ) ) BroadcastFactory.send( 'sideBarEvent', {
          type   : 4,
          id     : toParams.id,
          data   : false,
          noStats: true
        } );
        if ( $state.includes( 'app.logged.mailbox.email_view' ) ) BroadcastFactory.send( 'sideBarEvent', {
          type   : 3,
          id     : toParams.id,
          data   : false,
          noStats: true
        } );
        if ( $state.includes( 'app.logged.events.event' ) ) BroadcastFactory.send( 'sideBarEvent', {
          type   : 7,
          id     : toParams.id,
          data   : false,
          noStats: true
        } );
        if ( $state.includes( 'app.logged.events.compose' ) ) BroadcastFactory.send( 'sideBarEvent', {
          type   : 8,
          id     : toParams.id,
          data   : false,
          noStats: true
        } );
        if ( $state.includes( 'app.logged.advertisers.advertiser' ) ) BroadcastFactory.send( 'sideBarEvent', {
          type   : 16,
          id     : toParams.id,
          data   : false,
          noStats: true
        } );
        if ( $state.includes( 'app.logged.advertisers.compose' ) ) BroadcastFactory.send( 'sideBarEvent', {
          type   : 17,
          id     : toParams.id,
          data   : false,
          noStats: true
        } );
      }
      var superAdminModules = ['app.logged.users', 'app.logged.ads', 'app.logged.ads.banners', 'app.logged.ads.positions', 'app.logged.ads.positions.edit', 'app.logged.ads.banners.edit'];
      if ( superAdminModules.indexOf( toState.name ) > -1 && $rootScope.myUser.group !== 'superadmin' ) $state.go( 'app.logged.home' );
      var adminModules = ['app.logged.stats'];
      if ( adminModules.indexOf( toState.name ) > -1 && $rootScope.myUser.group !== 'superadmin' && $rootScope.myUser.group !== 'admin' ) $state.go( 'app.logged.home' );
      /*
       console.log('stateChange TOSTATE', toState)
       console.log('stateChange TOPARAMS', toParams)
       console.log('stateChange FROMSTATE', fromState)
       console.log('stateChange FROMPARAMS', fromParams)
       */
      $window.gtag( 'send', 'pageview', '/app' + $location.path() );
      /*
       var mobile;
       if (deviceDetector.device === 'unknown') mobile = false;
       else mobile = true;
       */
      var type_device;
      if ( deviceDetector.isDesktop() ) type_device = 1;
      else if ( deviceDetector.isMobile() ) type_device = 2;
      else if ( deviceDetector.isTablet() ) type_device = 3;

      if ( typeof $rootScope.token !== 'undefined' && $rootScope.token ) {
        StatsFactory.sendRoute( {
                                  route          : $location.path(),
                                  origin_route   : $state.href( fromState.name, fromParams ),
                                  os             : deviceDetector.os,
                                  os_version     : deviceDetector.os_version,
                                  browser        : deviceDetector.browser,
                                  browser_version: deviceDetector.browser_version,
                                  type_device    : type_device
                                } );
      }

      if ( typeof toState.data !== 'undefined' && typeof toState.data.languageTemplate !== 'undefined' && toState.data.languageTemplate ) {
        if ( !$state.includes( 'app.logged.mailbox' ) && !$state.includes( 'app.logged.directory' ) && !$state.includes( 'app.logged.press_releases' ) ) {
          angular.element( '#side-menu' ).find( 'li' ).removeClass( 'active' );
          angular.element( '#side-menu' ).find( 'ul' ).removeClass( 'in' );
        }
        /*
         var templateLanguage = toState.data.languageTemplate;
         if (angular.isArray(templateLanguage)) {
         for (var i = 0; i < templateLanguage.length; i++) {
         $translatePartialLoader.addPart(templateLanguage[i]);
         }
         } else {
         $translatePartialLoader.addPart(toState.data.languageTemplate);
         }
         */
      }
    } );
    $rootScope.$on( '$destroy', function () {
      //translatePartialLoaderStructureChangedListener();
      stateChangeSuccessListener();
      stateChangeStartListener();
    } );
  }


} )();



( function () {
    'use strict';

    angular.module( 'app.logged' )
           .controller( 'WorldPactController', WorldPactController )
           .controller( 'WorldPactStatsController', WorldPactStatsController );

    WorldPactController.$inject = [ '$scope', 'WorldPactFactory', '$timeout', '$sce', '$state' ];
    WorldPactStatsController.$inject = [ 'WorldPactFactory' ];

    /** @ngInject */
    function WorldPactController ( $scope, WorldPactFactory, $timeout, $sce, $state ) {
      var vm = this;
      var courseId = 1;
      var modules;
      var $owl;
      var cancelTimeoutSlider;
      var cancelTimeoutApply;
      var cancelTimeoutMinimized;
      var CourseProgressObj;
      var Courserealized;
      vm.itemHeight;
      vm.module;
      vm.modulesPrev;
      vm.course;
      vm.loadingPrevModule = true;
      vm.loadingModule = false;
      vm.minimizedActive = false;
      vm.minimizeLoading = false;
      vm.courseProgress = 0;

      var resset = function ( id ) {
        vm.contentSelected = 0;
        vm.feedback = {
          feedback: '',
          stars   : 0
        };
        vm.testForm = [];
        vm.updateTestAnswerVal = [];
        if ( !id ) {
          vm.loadingPrevModule = true;
        }
      };
      resset();

      var loadSlider = function () {
        cancelTimeoutSlider = $timeout( function () {
          $owl = $( ".owl-carousel" );
          $owl.owlCarousel( {
                              items: 1,
                              nav  : true,
                              dots : false
                            } );
          vm.itemHeight = $owl.height();
          var contentsItems = [];
          if ( CourseProgressObj && vm.module ) {
            if ( CourseProgressObj.course_id === courseId && CourseProgressObj.course_module_id === vm.module.id ) {
              contentsItems = Courserealized;
              vm.module.progress = Math.round( ( ( contentsItems.length ) / vm.module.contents.length ) * 100 );
            } else if ( CourseProgressObj.course_id === courseId && CourseProgressObj.course_module_id < vm.module.id ) {
              contentsItems.push( vm.module.contents[ 0 ].id );
              vm.module.progress = Math.round( ( ( contentsItems.length ) / vm.module.contents.length ) * 100 );
            } else if ( CourseProgressObj.course_id === courseId && CourseProgressObj.course_module_id > vm.module.id ) {
              vm.module.progress = 100;
            }
          } else if ( vm.module ) {
            contentsItems.push( vm.module.contents[ 0 ].id );
            vm.module.progress = Math.round( ( ( contentsItems.length ) / vm.module.contents.length ) * 100 );
          }

          $owl.on( 'changed.owl.carousel', function ( event ) {
            event.stopPropagation();
            var $worldPackIframeVideo = $( '.worldPackIframeVideo' );
            if ( $worldPackIframeVideo.length ) {
              var $elementVideo;
              var videoSrc;
              for ( var iVideo = 0; iVideo < $worldPackIframeVideo.length; iVideo++ ) {
                $elementVideo = $( $worldPackIframeVideo[ iVideo ] );
                videoSrc = $elementVideo.attr( 'src' );
                $elementVideo.attr( 'src', '' );
                $elementVideo.attr( 'src', videoSrc );
              }
            }
            if ( !vm.minimizeLoading ) {
              vm.showFeedback = true;

              /* init feedback slider */
              if ( event.item.index + 1 === vm.module.contents.length ) {
                if ( ( !CourseProgressObj || !CourseProgressObj.hasOwnProperty( 'course_module_id' ) || !CourseProgressObj.course_module_id ) && ( ( vm.module.contents.length - 1 ) > contentsItems.length ) ) {
                  vm.showFeedback = false;
                  console.log( 'Not all content is viewed' );
                } else if ( CourseProgressObj && CourseProgressObj.hasOwnProperty( 'course_module_id' ) && CourseProgressObj.course_module_id && CourseProgressObj.course_module_id <= vm.module.id && ( vm.module.contents.length - 1 ) > contentsItems.length ) {
                  vm.showFeedback = false;
                  console.log( 'Not all content is viewed' );
                }

                if ( vm.testForm.length ) {
                  WorldPactFactory.sendTest( vm.course.id, vm.module.id, vm.module.contents[ event.item.index - 1 ].id, vm.testForm );
                }
              }
              /* / feedback slider */

              if ( vm.showFeedback ) {
                WorldPactFactory.sendContent( 1, vm.module.id, ( vm.module.contents[ event.item.index ].id ) ).then( function ( dataOk ) {
                  if ( dataOk && dataOk.hasOwnProperty( 'data' ) && dataOk.data.hasOwnProperty( 'inscribe' ) && dataOk.data.inscribe ) {
                    vm.module.progress = Math.round( ( ( contentsItems.length + 1 ) / vm.module.contents.length ) * 100 );
                    if ( contentsItems.indexOf( vm.module.contents[ event.item.index ].id ) < 0 ) {
                      contentsItems.push( vm.module.contents[ event.item.index ].id );
                    }
                  }
                } );
              }

            }
            cancelTimeoutApply = $timeout( function () {
              $scope.$apply( function () {
                vm.contentSelected = event.item.index;
              } );
            } );
          } );
        }, 500 );
      };

      function generateFormTest ( id ) {
        var fileTest = modules[ [ ( id - 1 ) ] ].contents[ modules[ [ ( id - 1 ) ] ].contents.length - 2 ].file;
        var fileResult = modules[ [ ( id - 1 ) ] ].contents[ modules[ [ ( id - 1 ) ] ].contents.length - 2 ].result;
        for ( var iTest = 0; iTest < fileTest.length; iTest++ ) {
          var answerTest = '';
          vm.updateTestAnswerVal.push( null );
          for ( var iAnswer = 0; iAnswer < fileTest[ iTest ].answers.length; iAnswer++ ) {
            if ( fileResult && fileResult.hasOwnProperty( 'test' ) && !angular.equals( {}, fileResult.test ) ) {
              for ( var question in fileResult.test ) {
                if ( question === fileTest[ iTest ].question && fileResult.test[ question ] && fileResult.test[ question ] === fileTest[ iTest ].answers[ iAnswer ].answer ) {
                  answerTest = fileTest[ iTest ].answers[ iAnswer ].answer;
                }
              }
            }
          }
          vm.testForm.push( {
                              answer  : answerTest,
                              question: fileTest[ iTest ].question
                            } );

        }
      }

      var getModules = function ( id ) {
        vm.loadingModule = true;
        WorldPactFactory.getModules( courseId )
                        .then( function ( courseData ) {
                          vm.course = {
                            id         : courseData.course.id,
                            title      : courseData.course.title,
                            description: courseData.course.description,
                            progress   : 0
                          };

                          var modulesPrev = [];

                          modules = courseData.course.modules;
                          if ( courseData.progress ) {
                            CourseProgressObj = courseData.progress;
                            Courserealized = courseData.realized;
                          }
                          for ( var i = 0; i < modules.length; i++ ) {
                            if ( courseData.progress ) {
                              if ( ( courseData.progress.course_module_id ) > modules[ i ].id ) {
                                modules[ i ].progress = 100;
                                modules[ i ].available = true;
                              } else if ( ( courseData.progress.course_module_id ) === modules[ i ].id ) {
                                /*
                                 for ( var j = 0; j < modules[ i ].contents.length; j++ ) {
                                 if ( courseData.progress.course_module_content_id === modules[ i ].contents[ j ].id ) {
                                 modules[ i ].progress = Math.round( ( j + 1 ) / modules[ i ].contents.length * 100 );
                                 vm.course.progress = Math.round( ( i + 1 ) / modules.length * 100 );
                                 break;
                                 }
                                 }
                                 */
                                modules[ i ].progress = Math.round( Courserealized.length / modules[ i ].contents.length * 100 );
                                vm.course.progress = Math.round( ( i + 1 ) / modules.length * 100 );
                                modules[ i ].available = true;
                              } else {
                                modules[ i ].progress = 0;
                                if ( modules[ i - 1 ].progress >= 100 ) {
                                  modules[ i ].available = true;
                                  vm.course.progress = Math.round( ( i ) / modules.length * 100 );
                                } else {
                                  modules[ i ].available = false;
                                }

                              }
                            } else {
                              modules[ i ].progress = 0;
                            }
                            if ( i === 0 ) {
                              modules[ i ].available = true;
                            }

                            modulesPrev.push( {
                                                title: modules[ i ].title
                                              } );


                          }

                          if ( id ) {
                            generateFormTest( id );
                            vm.module = modules[ ( id - 1 ) ];
                            WorldPactFactory.sendContent( 1, vm.module.id, vm.module.contents[ 0 ].id );
                          }
                          vm.modulesPrev = modulesPrev;
                          vm.loadingPrevModule = false;

                          loadSlider();

                        }, function ( errorModule ) {
                          console.log( 'courseError', errorModule );
                        } )
                        .finally( function () {
                          vm.loadingModule = false;
                        } );
      };

      vm.changeModulePrev = function ( index ) {
        vm.module = modules[ index ];
        vm.moduleSelected = index + 1;
      };

      vm.goTo = function ( index ) {
        if ( $owl ) {
          $owl.trigger( 'to.owl.carousel', [ index, 500 ] );
        }
      };

      vm.startCourse = function () {
        if ( !vm.course.progress ) {
          WorldPactFactory.sendInitCourse( vm.course.id );
        }
        $state.go( '.module', {
          id: 1
        } );
      };

      vm.sendFeedback = function ( contentId, sendFeedback ) {
        if ( sendFeedback.$valid ) {
          WorldPactFactory.sendFeedback( vm.course.id, vm.module.id, contentId, vm.feedback )
                          .then( function ( response ) {
                            $state.go( 'app.logged.worldpact' );
                          } )
                          .finally( function () {

                          } );
        }

      };

      vm.minimalize = function () {
        vm.minimizeLoading = true;
        vm.minimizedActive = !vm.minimizedActive;
        if ( $owl ) {
          $timeout( function () {
            $owl.trigger( 'refresh.owl.carousel' );
            vm.minimizeLoading = false;
          }, 300 );

        }

      };

      vm.updateTestAnswer = function ( index, answer ) {
        /*resset*/
        for ( var iUpdate = 0; iUpdate < vm.updateTestAnswerVal.length; iUpdate++ ) {
          vm.updateTestAnswerVal[ iUpdate ] = null;
        }
        var fileTest = vm.module.contents[ vm.module.contents.length - 2 ].file;
        var ok = false;
        for ( var iTestUpdate = 0; iTestUpdate < fileTest.length; iTestUpdate++ ) {
          var answerTest;
          for ( var iAnswer = 0; iAnswer < fileTest[ iTestUpdate ].answers.length; iAnswer++ ) {
            if ( fileTest[ iTestUpdate ].answers[ iAnswer ].correct && fileTest[ iTestUpdate ].answers[ iAnswer ].answer === answer ) {
              answerTest = fileTest[ iTestUpdate ].answers[ iAnswer ].answer;
              vm.updateTestAnswerVal[ index ] = {
                result: true
              };
              ok = true;
              break;
            }
          }
        }
        if ( !ok ) {
          vm.updateTestAnswerVal[ index ] = {
            result: false
          };
        }
      };

      $scope.$on( '$stateChangeSuccess',
                  function ( event, toState, toParams ) {
                    if ( toState.name.indexOf( 'worldpact' ) > -1 ) {
                      if ( toState.name !== 'app.logged.worldpact' ) {
                        var idModule = toParams.id;
                        resset( idModule );
                        if ( !modules ) {
                          getModules( idModule );
                        } else {
                          vm.module = modules[ ( idModule - 1 ) ];
                          WorldPactFactory.sendContent( 1, idModule, vm.module.contents[ 0 ].id );
                          generateFormTest( idModule );
                          loadSlider();
                        }
                      } else {
                        resset();
                        getModules();
                        /*
                         if ( !modules ) {
                         getModules();
                         }
                         */
                      }

                    }
                  }
      );

      $scope.$on( '$destroy', function () {
        if ( cancelTimeoutSlider ) {
          $timeout.cancel( cancelTimeoutSlider );
        }
        if ( cancelTimeoutApply ) {
          $timeout.cancel( cancelTimeoutApply );
        }
        if ( cancelTimeoutMinimized ) {
          $timeout.cancel( cancelTimeoutMinimized );
        }
      } );

    }

    function WorldPactStatsController ( WorldPactFactory ) {
      var courseId = 1;
      var vm = this;

      vm.stats = [];

      vm.ressetParams = function () {
        vm.today = new Date();
        vm.todayTo = new Date();
        vm.params = {
          company_id: '',
          page      : 1,
          from      : vm.todayTo.setDate( vm.todayTo.getDate() - 90 ),
          to        : vm.today.setDate( vm.today.getDate() + 1 ),
          finalized : ''
        };
      };
      vm.ressetParams();
      vm.handleCompanySelection = function (companyId) {
        vm.params.company_id = companyId;
        //vm.changeCompany();
      };

      var dateTotimeStamp = function ( date ) {
        var dateOut = new Date( date );
        return dateOut;
      };

      vm.filter = function ( pagination ) {
        vm.loadingStats = true;
        vm.params.from = moment( vm.params.from ).format( "YYYY-MM-DD" ).toString();
        vm.params.to = moment( vm.params.to ).format( "YYYY-MM-DD" ).toString();
        if ( !pagination ) {
          vm.params.page = 1;
        }

        WorldPactFactory.getStats( courseId, vm.params )
                        .then( function ( data ) {
                          if ( data && data.hasOwnProperty( 'stats' ) && data.stats.length ) {
                            for ( var i = 0; i < data.stats.length; i++ ) {
                              data.stats[ i ].started_at = dateTotimeStamp( data.stats[ i ].started_at );
                              data.stats[ i ].last_access_at = dateTotimeStamp( data.stats[ i ].last_access_at );
                            }
                            vm.stats = data.stats;
                            vm.total = data.total;
                          } else {
                            vm.stats = [];
                            vm.total = 0;
                          }
                        }, function ( errorData ) {
                          console.log( errorData );
                        } )
                        .finally( function () {
                          vm.loadingStats = false;
                        } );
      };
      vm.filter();
    }
  }
)();

(function () {
  'use strict'

  angular.module('app')
    .service('UsersService', UsersService);

  UsersService.$inject = [
    '$rootScope',
    '$q',
    '$http',
    'URLS'
  ];

  /** @ngInject */
  function UsersService($rootScope, $q, $http, URLS) {
    var service = {
      login: login,
      logout: logout,
      get: get,
      put: put,
      create: create,
      changeStatus: changeStatus,
      recovery: recovery
    }
    return service;

    function recovery(data, reset) {
      var deferred = $q.defer();
      var param = 'email'
      if(reset) param = 'reset';
      var settings = {
        method: 'POST',
        url: URLS.API + 'password/' + param,
        cache: false,
        data: data
        //  timeout: deferred.promise,
      };
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);
        return deferred.promise;
      }
      function httpOk(data) {
        if(typeof data !== 'undefined' && typeof data.data !== 'undefined' && typeof data.data.success !== 'undefined' && data.data.success) deferred.resolve('ok');
        else httpError(data);
      }
      function httpError(responseError) {
        deferred.reject(responseError);
      }
    }

    function create(user) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'users',
        cache: false,
        data: user
        //  timeout: deferred.promise,
      };
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);
        return deferred.promise;
      }
      function httpOk() {
        deferred.resolve('ok');
      }
      function httpError(responseError) {
        deferred.reject(responseError);
      }
    }

    function changeStatus(status, id) {
      var url = URLS.API + 'users/' + id + '/activate';
      var method = 'POST';
      if(status) {
        url = URLS.API + 'users/' + id;
        method = 'DELETE';
      }
      var deferred = $q.defer();
      var settings = {
        method: method,
        url: url,
        cache: false
        //  timeout: deferred.promise,
      };
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);
        return deferred.promise;
      }
      function httpOk() {
        deferred.resolve('ok');
      }
      function httpError(responseError) {
        deferred.reject(responseError);
      }
    }

    function put(id, data) {
      var deferred = $q.defer();
      var settings = {
        method: 'PUT',
        url: URLS.API + 'users/' + id,
        cache: false,
        data: data
        //  timeout: deferred.promise,
      };
      return http();
      function http() {
        $http(settings)
          .then(httpOk, httpError)
          .catch(function (catchReponse) {
            deferred.reject(catchReponse);
          });
        return deferred.promise
      }
      function httpOk() {
        deferred.resolve('ok')
      }
      function httpError() {
        deferred.reject('error')
      }

    }

    function get(id, params) {
      var deferred = $q.defer();
      var url = URLS.API + 'users'
      if (id) url = url + '/' + id;
      var settings = {
        method: 'GET',
        url: url,
        cache: false,
        params: params
        //  timeout: deferred.promise,
      };
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError)
          .catch(function (catchReponse) {
            deferred.reject(catchReponse);
          });
        return deferred.promise
      }
      function httpOk(users) {
        if (id && id == 'me') {
          if (typeof users !== 'undefined' && users && typeof users.data !== 'undefined') {
            $rootScope.myUser = users.data;
            deferred.resolve(users.data);
          } else {
            /*
            users.error == 'forbidden'
            httpError(-1);
            users.error == 'token_expired'
            httpError(1);
            */
            httpError(-1);
          }
        } else {
          if(typeof users !== 'undefined' && typeof users.data !== 'undefined') deferred.resolve(users.data);
          else httpError(1);
        }
      }

      function httpError(error) {
        deferred.reject(error)
      }
    }

    function login(myUser) {
      var deferred = $q.defer()
      if (!myUser) {
        deferred.reject({
          code: 1
        })
        return true
      }
      var settings = {
        method: 'POST',
        url: URLS.API + 'login',
        cache: false,
        skipAuthorization: true,
        //  timeout: deferred.promise,
        data: myUser
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError)
        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined' && typeof data.data.user !== 'undefined' && data.data.user.status == 1) {
          $rootScope.myUser = data.data.user;
          $rootScope.token = data.data.token;
          deferred.resolve(data.data.user);
        } else {
          httpError(data)
        }
      }
      function httpError(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined' && typeof data.data.message !== 'undefined' && typeof data.data.message.id !== 'undefined' && data.data.message.id == 'many_attemps') {
          deferred.reject('many_attemps');
        } else deferred.reject('error');

      }
    }

    function logout() {
      var deferred = $q.defer()
      var settings = {
        method: 'GET',
        url: URLS.API + 'logout',
        cache: false,
        skipAuthorization: false
      }
      return http()

      function http() {
        $http(settings);
        deferred.resolve('ok');
        return deferred.promise
      }
    }
  }
}());

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('UsersController', UsersController)

  UsersController.$inject = ['UsersService'];

  /** @ngInject */
  function UsersController(UsersService) {
    var vm = this;
    vm.loading = true;

    vm.total = 0;
    vm.selectStatus = [
      {name: 'Inactivo', value: 0},
      {name: 'Activo', value: 1},
      {name: 'Desactivado', value: 2},
      {name: 'Seleccionar estado', value: -1}
    ];
    vm.params = {
      status: '',
      company_id: '',
      page: 1
    };
    vm.handleCompanySelection = function (companyId) {
      vm.params.company_id = companyId;
      //vm.changeCompany();
    };
    vm.filter = function () {
      vm.loading = true;
      UsersService.get(false, vm.params).then(function (users) {
        vm.users = users.data;
        vm.total = users.total
      }).finally(function(){
        vm.loading = false;
      });
    }
    vm.filter();

    vm.changeStatus = function (status, id, index) {
      UsersService.changeStatus(status, id, index).then(function () {
        if(status) vm.users[index].status = 2;
        else vm.users[index].status = 1;
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('StatsFactory', StatsFactory);

  StatsFactory.$inject = ['$http', 'URLS', '$q', 'toaster'];

  /** @ngInject */
  function StatsFactory($http, URLS, $q, toaster) {
    var factory = {
      sendRoute: sendRoute,
      getStats: getStats,
      getStatsNotices: getStatsNotices,
      getAccess: getAccess,
      exportExcel: exportExcel
    };
    return factory;

    function getStats(params, key) {
      var deferred = $q.defer();
      /*
      from
      to
      */
      var settings = {
        method: 'GET',
        url: URLS.API + 'stats/' + key,
        cache: false,
        params: params
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar las estadísticas',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function getAccess(params) {
      var deferred = $q.defer();
      var settings = {
        method: 'GET',
        url: URLS.API + 'stats/companies',
        cache: false,
        params: params
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar los accesos',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    ////////////////
    function sendRoute(data) {
      /*
      route:,
      origin_route:,
      os:
      browser:
      mobile:	Boolean
      */
      var settings = {
        method: 'POST',
        url: URLS.API + 'stats/routes',
        cache: false,
        data: data
        //  timeout: deferred.promise,
      }
      return $http(settings)
    }

    function getStatsNotices(params) {
      var deferred = $q.defer();
      /*
      from
      to
      */
      var settings = {
        method: 'GET',
        url: URLS.API + 'stats/notices',
        cache: false,
        params: params
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar las estadísticas',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }


    function exportExcel(params) {
      var deferred = $q.defer();
      var settings = {
        method: 'GET',
        url: URLS.API + 'stats/export',
        cache: false,
        params: params
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar los accesos',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('StatsController', StatsController)

  StatsController.$inject = ['StatsFactory', 'moment'];

  /** @ngInject */
  function StatsController(StatsFactory, moment) {
    var vm = this;
    vm.today = new Date();
    vm.todayTo = new Date();
    vm.totalActions = 0;
    vm.totalRoutes = 0;
    vm.loadingAccess = true;
    vm.loadingNotices = false;
    vm.loadingExport = false;
    vm.linkExport = false;
    vm.data = {
      actions: [],
      routes: []
    };
    vm.labels = {
      actions: [],
      routes: []
    };
    vm.total = {
      actions: 0,
      routes: 0
    };

    vm.notices = [];

    vm.params = {
      company_id: '',
      from: vm.todayTo.setDate(vm.todayTo.getDate() - 1),
      to: vm.today.setDate(vm.today.getDate() + 1)
    };

    vm.handleCompanySelection = function (companyId) {
      vm.param.company_id = companyId;
      //vm.changeCompany();
    };

    vm.exportExcel = function () {
      StatsFactory.exportExcel(vm.params).then(function (data) {
        vm.linkExport = data.url;
      }).finally(function () {
        vm.loadingExport = false;

      });
    }

    vm.getStats = function (type, init, id) {
      if(id) {
        vm.params.company_id = id;
        vm.params.from = '2017-09-13',
        vm.params.to = vm.today.setDate(vm.today.getDate() + 1);
        document.getElementById('routesList').scrollIntoView();
      }

      vm.params.from = moment(vm.params.from).format("YYYY-MM-DD").toString();
      vm.params.to = moment(vm.params.to).format("YYYY-MM-DD").toString();
      if (type == 1 || !type) {
        vm.loadingRoutes = true;
        StatsFactory.getStats(vm.params, 'routes').then(function (routes) {
          vm.routes = routes.routes;
          proccessData(routes.routes, 'routes');
        }).finally(function () {
          vm.loadingRoutes = false;
        });
      }
      if (type == 2 || !type) {
        vm.loadingActions = true;
        StatsFactory.getStats(vm.params, 'actions').then(function (actions) {
          vm.actions = actions;
          proccessData(actions, 'actions');
        }).finally(function () {
          vm.loadingActions = false;
        });
      }
      if (type == 3 || !type) {
        var dataAccess = false;
        if(init) dataAccess = vm.params;
        StatsFactory.getAccess(dataAccess).then(function (access) {
          vm.access = access;
        }).finally(function () {
          vm.loadingAccess = false;
        });
      }

      vm.loadingNotices = true;
      StatsFactory.getStatsNotices(vm.params).then(function (notices) {
        vm.loadingNotices = false;
        vm.notices = notices;
      });

    };
    vm.getStats();



    function proccessData(array, key) {
      var keyDay = 'day';
      if(key == 'actions') keyDay = 'date';
      var labels = [];
      var data = [];
      var day = '';
      var total = 0;
      var totalWidget = 0;
      for (var index = 0; index < array.length; index++) {
        var element = array[index];
        totalWidget = totalWidget + element.total;
        if (element[keyDay] != day) {
          data.push(total);
          total = element.total;
          labels.push(day);
          day = element[keyDay];
        } else {
          total += element.total;
        }
        if(index == length) {
          data.push(total);
          labels.push(day);
        }
      }
      data.splice(0, 1);
      labels.splice(0, 1);
      if (data.length && labels.length) {
        vm.data[key] = data;
        vm.labels[key] = labels;
      } else {
        vm.data[key] = [];
        vm.labels[key] = [];
      }
      vm.total[key] = totalWidget;
    }

    vm.onClick = function (points) {
      vm.params.from = vm.labels[points[0]._index];
      vm.params.to = moment(vm.labels[points[0]._index], "YYYY-MM-DD").add(1, 'days');
      vm.getStats();
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('app.logged')
    .factory('ProfileFactory', ProfileFactory);

  ProfileFactory.$inject = ['$http', '$q', 'URLS', 'Upload', 'toaster']

  /** @ngInject */
  function ProfileFactory($http, $q, URLS, Upload, toaster) {
    var factory = {
      sendCompany: sendCompany,
      getCompany: getCompany,
      sendCompanyLogo: sendCompanyLogo,
      sendInterview: sendInterview,
      updateFinancials: updateFinancials
    };
    return factory;

    function sendInterview(interview, id) {
      var deferred = $q.defer();
      var settings = {
        url: URLS.API + 'companies/' + id + '/interview',
        data: interview,
        method: 'POST',
        // withCredentials: true,
        cache: false
      }
      return http()

      function http() {
        Upload.upload(settings)
          .then(httpOk, httpError);
        return deferred.promise
      }

      function httpOk(data) {
        toaster.pop({
          type: 'success',
          title: 'OK',
          body: 'Entrevista publicada correctamente',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.resolve(data);
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible guardar esta entrevista',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');

      }
    }

    function sendCompanyLogo(file, name, id) {
      var deferred = $q.defer();
      // $log.log(contacts)
      var data = {};
      var url = URLS.API + 'contacts/' + id + '/image';
      if(name == 'logo') {
        data[name] = file;
        url = URLS.API + 'companies/' + id + '/logo';
      } else data[name] = file;
      var settings = {
        method: 'POST',
        //url: CONFIG.APIURL+'?send_contacts=1',
        url: url,
        cache: false,
        //  skipAuthorization: true,
        //  timeout: deferred.promise,
        data: data
      }
      return http()

      function http () {
        Upload.upload(settings)
          .then(httpOk, httpError)
        return deferred.promise
      }
      function httpOk (data) {
        deferred.resolve(data.data)
      }
      function httpError (data) {
        deferred.reject(data.data)
      }
    }

    function updateFinancials (financials, id) {
      var deferred = $q.defer()
      // $log.log(contacts)

      var settings = {
        method: 'POST',
        //url: CONFIG.APIURL+'?send_contacts=1',
        url: URLS.API + 'companies/' + id + '/financial',
        cache: false,
        //  skipAuthorization: true,
        //  timeout: deferred.promise,
        data: financials
      }
      return http()

      function http () {
        $http(settings)
          .then(httpOk)
          .catch(httpError)
        return deferred.promise
      }
      function httpOk (data) {
        if(typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError()
      }
      function httpError () {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible guardar estos datos, por favor revise los datos',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    ////////////////
    function sendCompany(company, id) {
      var deferred = $q.defer()
      // $log.log(contacts)

      var settings = {
        method: 'POST',
        //url: CONFIG.APIURL+'?send_contacts=1',
        url: URLS.API + 'companies/' + id,
        cache: false,
        //  skipAuthorization: true,
        //  timeout: deferred.promise,
        data: company
      }
      return http()

      function http () {
        $http(settings)
          .then(httpOk)
          .catch(httpError)
        return deferred.promise
      }
      function httpOk (data) {
        if(typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError ({data: 'error'});
      }
      function httpError (data) {
        deferred.reject(data.data)
      }
    }
    function getCompany(id) {
      var deferred = $q.defer()

      var settings = {
        method: 'GET',
        url: URLS.API + 'companies/' + id,
        //url: CONFIG.APIURL + '?get_company=1&code='+key,
        cache: false
        //  skipAuthorization: true,
        //  timeout: deferred.promise,
        // data: contacts
      }
      return http()

      function http () {
        $http(settings)
          .then(httpOk)
          .catch(httpError)
        return deferred.promise
      }
      function httpOk (data) {
        deferred.resolve(data.data)
      }
      function httpError (data) {
        deferred.reject(data.data)
      }
    }
  }
})();
( function () {
  'use strict';

  angular.module( 'app.logged' )
         .controller( 'ProfileController', ProfileController )
         .controller( 'ProfileStep1Controller', ProfileStep1Controller )
         /*
          .controller( 'ProfileStep2Controller', ProfileStep2Controller )
          */
         .controller( 'ProfileStep2FinancialsController', ProfileStep2FinancialsController )
         .controller( 'ProfileStep3Controller', ProfileStep3Controller )
         .controller( 'ProfileStep4Controller', ProfileStep4Controller )
         .controller( 'ProfileStep5Controller', ProfileStep5Controller )
         .controller( 'ProfileStep6Controller', ProfileStep6Controller )


  ProfileController.$inject = [
    '$scope',
    '$rootScope',
    '$log',
    'ProfileFactory',
    '$sce',
    '$state',
    'toaster',
    '$window',
    'CompaniesFactory',
    'DirectoryFactory',
    'YEARS'
  ];
  ProfileStep1Controller.$inject = [
    '$scope',
    '$rootScope',
    '$stateParams',
    'ProfileFactory',
    'SUMMERNOTE',
    '$log',
    'ProvincesFactory',
    '$state',
    'toaster',
    '$timeout'
  ];
  /*
   ProfileStep2Controller.$inject = [ '$scope', 'ProfileFactory', '$state', 'YEARS' ];
   */
  ProfileStep2FinancialsController.$inject = [ '$scope', 'ProfileFactory', '$state', 'YEARS' ];
  ProfileStep3Controller.$inject = [ '$scope', 'ProfileFactory', 'toaster' ];
  ProfileStep4Controller.$inject = [ '$scope' ];
  ProfileStep5Controller.$inject = [ '$scope', '$rootScope', '$stateParams', '$timeout', '$window', 'toaster', 'UsersService' ];
  ProfileStep6Controller.$inject = [ '$scope', '$rootScope', '$stateParams', 'ProfileFactory', 'toaster', 'SUMMERNOTE', '$timeout' ];

  /** @ngInject */
  function ProfileController ( $scope, $rootScope, $log, ProfileFactory, $sce, $state, toaster, $window, CompaniesFactory, DirectoryFactory, YEARS ) {
    var vm = this;
    vm.ready = false;
    vm.year = YEARS.ACTUAL;
    var emptyAddress = {
      "phone_number": "",
      "street"      : "",
      "postal_code" : "",
      "town"        : "",
      "province_id" : ""
    };
    var emptyContact = {
      "name"        : "",
      "surname"     : "",
      "phone_number": "",
      "job_title"   : "",
      "departament" : "",
      "email"       : ""
    };
    vm.filename = '';
    vm.company = {};
    vm.companies = [];
    vm.countriesMarketIds = [];
    vm.countriesOfficeIds = [];
    vm.contactsCompanyLength = 0;
    vm.param = parseInt( $rootScope.myUser.company.id );
    vm.changeCompany = function () {
      vm.loading = true;
      ProfileFactory.getCompany( vm.param ).then( getCompanyOk, getCompanyError ).finally( function () {
        vm.loading = false;
        //$('#company_param').trigger('chosen:updated');
      } );
    };
    vm.changeCompany();
    vm.handleCompanySelection = function (companyId) {
      vm.param = companyId;
      //vm.changeCompany();
    };
    vm.more = function ( key ) {
      var array = '';
      if ( key == 'addresses' ) array = angular.copy( emptyAddress );
      if ( key == 'contacts' ) array = angular.copy( emptyContact );
      vm.company[ key ].push( array );
    };
    vm.less = function ( key, index ) {
      if ( key == 'contacts' ) {

        if ( typeof vm.company[ key ][ index ].id !== 'undefined' && vm.company[ key ][ index ].id ) {
          swal( {
                  title     : "¿Estás seguro de que quieres eliminar este contacto?",
                  text      : "No podrás recuperarlo",
                  icon      : "warning",
                  buttons   : true,
                  dangerMode: true
                } ).then( function ( isConfirm ) {
            if ( isConfirm ) {
              vm.loadingContactsRemove = true;
              DirectoryFactory.removeContact( vm.company[ key ][ index ].id ).then( function () {
                vm.company[ key ].splice( index, 1 );
              } ).then( function () {
                vm.loadingContactsRemove = false;
              } );
            }
          } );
        } else {
          vm.company[ key ].splice( index, 1 );
        }
      }
      else vm.company[ key ].splice( index, 1 );

    };
    vm.scrollUp = function () {
      $window.scrollTo( 0, 0 );
    }

    vm.contactDefault = function ( index ) {
      var contactDefault = false;
      var indexContactDefault = 0;
      if ( vm.company.contacts[ index ].default ) {
        for ( indexContactDefault = 0; indexContactDefault < vm.company.contacts.length; indexContactDefault++ ) {
          if ( index !== indexContactDefault ) vm.company.contacts[ indexContactDefault ].default = false;
        }
      } else {
        for ( indexContactDefault = 0; indexContactDefault < vm.company.contacts.length; indexContactDefault++ ) {
          if ( vm.company.contacts[ indexContactDefault ].default ) contactDefault = true;
        }
        if ( !contactDefault ) vm.company.contacts[ index ].default = true;
        else vm.company.contacts[ index ].default = false;
      }
    }

    vm.passFinancialsToNumber = function ( arrayFinancials ) {
      var obejct = {};
      for ( var iFinancials = 0; iFinancials < arrayFinancials.length; iFinancials++ ) {
        obejct = arrayFinancials[ iFinancials ];
        for ( var prop in obejct ) {
          if ( obejct[ prop ] && typeof obejct[ prop ] !== 'number' ) {
            obejct[ prop ] = + parseFloat( obejct[ prop ] ).toFixed(2);
          }
          if ( prop === 'ebitda' && obejct[ prop ] ) {
            obejct[ prop ] = obejct[ prop ] * 1000;
          }
        }
        arrayFinancials[ iFinancials ] = obejct;
      }
      return arrayFinancials;
    };

    function getCompanyOk ( data ) {
      vm.ready = true;
      if ( data.web ) {
        if ( data.web.substr( 0, 7 ) !== 'http://' && data.web.substr( 0, 8 ) !== 'https://' ) data.web = 'http://' + data.web;
      }
      if ( !data.addresses.length ) {
        data.addresses = [ angular.copy( emptyAddress ) ];
        if ( typeof data.province !== 'undefined' && typeof data.province.id !== 'undefined' && data.province.id ) data.addresses[ 0 ].province_id = parseInt( data.province.id );
      } else {
        for ( var indexProvince = 0; indexProvince < data.addresses.length; indexProvince++ ) {
          if ( typeof data.addresses[ indexProvince ].province_id !== 'undefined' && data.addresses[ indexProvince ].province_id ) data.province.id = data.addresses[ indexProvince ].province_id;
        }
      }

      if ( !data.contacts.length ) {
        data.contacts = [ angular.copy( emptyContact ) ];
      } else {
        for ( var indexContacts = 0; indexContacts < data.contacts.length; indexContacts++ ) {
          if ( data.contacts[ indexContacts ].default != '0' ) data.contacts[ indexContacts ].default = true;
          else data.contacts[ indexContacts ].default = false;
        }
      }

      /*
       Get and print only first contact
       if (data.contacts.length > 1) data.contacts.splice(1, data.contacts.length - 1);
       */

      if ( data.countries_market.length > 0 ) {
        var arrayCMarket = [];
        for ( var indexMarket = 0; indexMarket < data.countries_market.length; indexMarket++ ) {
          arrayCMarket.push( data.countries_market[ indexMarket ].id );
        }
        vm.countriesMarketIds = arrayCMarket;
      } else {
        vm.countriesMarketIds = [ 'ES' ];
      }

      if ( data.countries_office.length > 0 ) {
        var arrayCOffice = [];
        for ( var indexMarketO = 0; indexMarketO < data.countries_office.length; indexMarketO++ ) {
          arrayCOffice.push( data.countries_office[ indexMarketO ].id );
        }
        vm.countriesOfficeIds = arrayCOffice;
      } else {
        vm.countriesOfficeIds = [ 'ES' ];
      }

      if ( data.hasOwnProperty( 'financials' ) && data.financials.length ) {
        data.financials = vm.passFinancialsToNumber( data.financials );
      }

      vm.company = angular.copy( data );
      vm.contactsCompanyLength = data.contacts.length;
    }

    function getCompanyError ( data ) {
      toaster.pop( {
                     type           : 'error',
                     title          : 'ERROR',
                     body           : 'Error al intentar acceder a los datos de esta empresa',
                     showCloseButton: true,
                     timeout        : 2000
                   } );
      $state.go( 'index' );
      $log.log( 'getCompanyError', data )
    }

    var deregisterLinkedUserinListener = $scope.$on( 'linkedinDataUser', function ( event, data ) {
      event.stopPropagation();
      deregisterLinkedUserinListener();
      // if(data.name)
      // $log.log('LinkedinUser', data.user);
      if ( typeof data.user !== 'undefined' && !angular.equals( {}, data.user ) ) {
        $scope.$apply( function () {
          if ( typeof data.user.emailAddress !== 'undefined' && data.user.emailAddress && vm.company.contacts.length && !vm.company.contacts[ 0 ].email ) vm.company.contacts[ 0 ].email = data.user.emailAddress;
          if ( typeof data.user.firstName !== 'undefined' && data.user.firstName && vm.company.contacts.length && !vm.company.contacts[ 0 ].name ) vm.company.contacts[ 0 ].name = data.user.firstName;
          if ( typeof data.user.lastName !== 'undefined' && data.user.lastName && vm.company.contacts.length && !vm.company.contacts[ 0 ].lastName ) vm.company.contacts[ 0 ].surname = data.user.lastName;
          if ( typeof data.user.pictureUrl !== 'undefined' && data.user.pictureUrl ) vm.company.contacts[ 0 ].image_url = data.user.pictureUrl;
          if ( typeof data.user.numConnections !== 'undefined' && data.user.numConnections ) vm.company.contacts[ 0 ].linkedin_contacs = data.user.numConnections;
          if ( typeof data.user.publicProfileUrl !== 'undefined' && data.user.publicProfileUrl ) vm.company.contacts[ 0 ].linkedin = data.user.publicProfileUrl;
          if ( typeof data.user.positions !== 'undefined' && typeof data.user.positions.values !== 'undefined' && data.user.positions.values.length > 0 && typeof data.user.positions.values[ 0 ].title !== 'undefined' && data.user.positions.values[ 0 ].title ) vm.company.contacts[ 0 ].job_title = data.user.positions.values[ 0 ].title;
        } )
      }
    } )
    var deregisterLinkedCompanyinListener = $scope.$on( 'linkedinDataCompany', function ( event, data ) {
      event.stopPropagation();
      deregisterLinkedCompanyinListener();
      $log.log( 'LinkedinCompany', data );
      if ( typeof data.company !== 'undefined' && !angular.equals( {}, data.company ) ) {
        $scope.$apply( function () {
          if ( typeof data.company.description !== 'undefined' && data.company.description ) vm.company.description = data.company.description;
          if ( typeof data.company.websiteUrl !== 'undefined' && data.company.websiteUrl && !vm.company.web ) {
            if ( data.company.websiteUrl.substr( 0, 7 ) !== 'http://' && data.company.websiteUrl.substr( 0, 8 ) !== 'https://' ) data.company.websiteUrl = 'http://' + data.company.websiteUrl
            vm.company.web = data.company.websiteUrl;
          }
          if ( typeof data.company.numFollowers !== 'undefined' && data.company.numFollowers ) vm.company.linkedin_contacs = data.company.numFollowers;
          if ( typeof data.company.logoUrl !== 'undefined' && data.company.logoUrl ) vm.company.logo_url = data.company.logoUrl;
          if ( typeof data.company.twitterId !== 'undefined' && data.company.twitterId ) vm.company.twitter = data.company.twitterId;
          if ( typeof data.company.universalName !== 'undefined' && data.company.universalName ) vm.company.linkedin = data.company.universalName;
          if ( typeof data.company.locations !== 'undefined' && !angular.equals( {}, data.company.locations ) && typeof data.company.locations.values !== 'undefined' && data.company.locations.values.length > 0 ) {
            if ( typeof data.company.locations.values[ 0 ].address !== 'undefined' && !angular.equals( {}, data.company.locations.values[ 0 ].address ) ) {
              if ( typeof data.company.locations.values[ 0 ].address.city !== 'undefined' && data.company.locations.values[ 0 ].address.city ) vm.company.addresses[ 0 ].town = data.company.locations.values[ 0 ].address.city;
              if ( typeof data.company.locations.values[ 0 ].address.postalCode !== 'undefined' && data.company.locations.values[ 0 ].address.postalCode ) vm.company.addresses[ 0 ].postal_code = parseInt( data.company.locations.values[ 0 ].address.postalCode );
              if ( typeof data.company.locations.values[ 0 ].address.street1 !== 'undefined' && data.company.locations.values[ 0 ].address.street1 ) vm.company.addresses[ 0 ].street = data.company.locations.values[ 0 ].address.street1;
            }
            if ( typeof data.company.locations.values[ 0 ].contactInfo !== 'undefined' && !angular.equals( {}, data.company.locations.values[ 0 ].contactInfo ) ) {
              if ( typeof data.company.locations.values[ 0 ].contactInfo.phone1 !== 'undefined' && data.company.locations.values[ 0 ].contactInfo.phone1 ) vm.company.addresses[ 0 ].phone = data.company.locations.values[ 0 ].contactInfo.phone1;
            }
          }


        } );
      }

    } )

    var deregisterMapCountrySelectedSalesListener = $scope.$on( 'mapCountrySelecedSales', function ( event, data ) {
      event.stopPropagation();
      // deregisterMapCountrySelectedSalesListener();
      vm.countriesMarketIds = data;
      // if(data.name)
      //  $log.log('mapCountrySelecedSales', data);
    } );
    var deregisterMapCountrySelectedOficceListener = $scope.$on( 'mapCountrySelecedOffice', function ( event, data ) {
      event.stopPropagation();

      // deregisterMapCountrySelectedOficceListener();
      vm.countriesOfficeIds = data;
      // if(data.name)
      //  $log.log('mapCountrySelecedOffice', data);
    } );

    var deregisterFileuploadListener = $scope.$on( 'fileuploaded', function ( event, data ) {
      event.stopPropagation();
      if ( angular.isObject( data.response ) || data.response > 0 ) {
        if ( typeof data.response.company_id !== 'undefined' ) {
          for ( var indexContactFiles = 0; indexContactFiles < vm.company.contacts.length; indexContactFiles++ ) {
            if ( vm.company.contacts[ indexContactFiles ].id == data.response.id ) {
              vm.company.contacts[ indexContactFiles ].image = data.response.image;
            }
          }
        } else if ( typeof data.response.company_id === 'undefined' ) {
          vm.company.logo = data.response.logo;
        }
      }
    } );

    $scope.$on( '$destroy', function () {
      deregisterMapCountrySelectedOficceListener();
      deregisterMapCountrySelectedSalesListener();
      deregisterFileuploadListener();
    } )
  }

  function ProfileStep1Controller ( $scope, $rootScope, $stateParams, ProfileFactory, SUMMERNOTE, $log, ProvincesFactory, $state, toaster, $timeout ) {

    if ( $stateParams.id && ( $rootScope.myUser.group == 'superadmin' || $rootScope.myUser.group == 'admin' ) ) {
      $scope.$parent.Profile.param = $stateParams.id;
      $scope.$parent.Profile.changeCompany();
    }
    var vm = this;
    vm.title = 1
    vm.config = SUMMERNOTE;
    vm.provinces = ProvincesFactory.getProvinces();
    var timeoutPaste = null;

    vm.pasteSummernote = function () {
      var timeoutPaste = $timeout( function () {
        $scope.$parent.Profile.company.description = $scope.$parent.Profile.company.description.replace( /style="[^"]*"/g, "" );
      }, 500 );
    };

    vm.step1Submit = function ( form ) {
      var defaultContact = false;
      for ( var indexCF = 0; indexCF < $scope.$parent.Profile.company.contacts.length; indexCF++ ) {
        var element = $scope.$parent.Profile.company.contacts[ indexCF ];
        if ( element.default ) {
          defaultContact = true;
          break;
        }
      }
      if ( form.$valid && $scope.$parent.Profile.company.addresses.length && $scope.$parent.Profile.company.contacts.length && defaultContact ) {
        $scope.$parent.Profile.loading = true;


        $scope.$parent.Profile.company.countries_office = $scope.$parent.Profile.countriesOfficeIds;
        $scope.$parent.Profile.company.countries_market = $scope.$parent.Profile.countriesMarketIds;

        /*
         REMOVE ALL CONTACTS WITHOUT EMAIL / PHONE
         */
        /*
         var contacts = angular.copy($scope.$parent.Profile.company.contacts);
         var contactsOk = [];

         if (contacts.length) {
         for (var index = 0; index < contacts.length; index++) {
         if (contacts[index].email && contacts[index].phone_number) {
         //$scope.$parent.Profile.company.contacts.splice(index, 1);
         contactsOk.push(contacts[index]);
         }
         }
         $scope.$parent.Profile.company.contacts = contactsOk;
         }
         */

        ProfileFactory.sendCompany( $scope.$parent.Profile.company, $scope.$parent.Profile.param ).then( sendContactsOk, sendContactsError )
                      .finally( function () {
                        $scope.$parent.Profile.loading = false
                      } );
      } else {
        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'Faltan campos por rellenar, revisa que haya al menos una dirección y contacto completo por defecto',
                       showCloseButton: true,
                       timeout        : 4000
                     } );
      }
    }

    function sendContactsOk ( data ) {
      //$log.log('sendContactsOk', data)
      for ( var indexContacts = 0; indexContacts < data.contacts.length; indexContacts++ ) {
        if ( !data.contacts[ indexContacts ].email ) data.contacts.splice( indexContacts, 1 );
      }
      if ( data.contacts.length ) {
        for ( var indexContactsDef = 0; indexContactsDef < data.contacts.length; indexContactsDef++ ) {
          if ( data.contacts[ indexContactsDef ].default !== '0' ) data.contacts[ indexContactsDef ].default = true;
          else data.contacts[ indexContactsDef ].default = false;
        }
      }
      if ( typeof data.addresses !== 'undefined' && data.addresses.length > 0 && data.addresses[ 0 ].province_id ) data.addresses[ 0 ].province_id = parseInt( data.addresses[ 0 ].province_id );
      if ( data.contacts.length > 1 ) data.contacts.splice( 1, data.contacts.length - 1 );
      $scope.$parent.Profile.company = {};
      $scope.$parent.Profile.company = data;
      $scope.$parent.Profile.scrollUp();
      $state.go( '^.step_two_financials', { key: $scope.$parent.Profile.key } )
    }

    function sendContactsError ( data ) {
      toaster.pop( {
                     type           : 'error',
                     title          : 'Error',
                     body           : 'Error al intentar actualizar los datos',
                     showCloseButton: true,
                     timeout        : 2000
                   } );
      $log.log( 'sendContactsError', data )
    }

    $scope.$on( '$destroy', function () {
      if ( timeoutPaste ) $timeout.cancel( timeoutPaste );
    } );
  }

  /*
   function ProfileStep2Controller ( $scope, ProfileFactory, $state ) {
   var vm = this;
   if ( $scope.$parent.Profile.company.hasOwnProperty( 'financials' ) && $scope.$parent.Profile.company.financials.length && $scope.$parent.Profile.company.financials[ 0 ].year == ( $scope.$parent.Profile.year - 1 ) ) {

   $scope.$parent.Profile.company.financials[ 0 ].cagr = parseFloat( $scope.$parent.Profile.company.financials[ 0 ].cagr );
   $scope.$parent.Profile.company.financials[ 0 ].ebitda = parseFloat( $scope.$parent.Profile.company.financials[ 0 ].ebitda );
   $scope.$parent.Profile.company.financials[ 0 ].roa = parseFloat( $scope.$parent.Profile.company.financials[ 0 ].roa );

   } else {

   var financialsNew = {
   cagr                : null,
   roa                 : null,
   employees           : null,
   ebitda              : null,
   development         : null,
   foreign_investiments: null,
   sales               : null,
   investigation       : null,
   patents             : null,
   editable            : 1,
   year                : ( $scope.$parent.Profile.year - 1 )
   };
   if ( !$scope.$parent.Profile.company.hasOwnProperty( 'financials' ) ) {
   $scope.$parent.Profile.company.financials = [];
   }
   $scope.$parent.Profile.company.financials.splice( 0, 0, financialsNew );

   }

   vm.update = function () {
   var i = false;
   for ( var prop in $scope.$parent.Profile.company.financials[ 0 ] ) {
   var element = $scope.$parent.Profile.company.financials[ 0 ][ prop ];
   if ( !element ) {
   delete $scope.$parent.Profile.company.financials[ 0 ][ prop ];
   } else {
   i++;
   }
   }
   if ( i > 2 ) {
   vm.loading = true;
   ProfileFactory.updateFinancials( $scope.$parent.Profile.company.financials[ 0 ], $scope.$parent.Profile.company.id ).then( function () {
   $state.go( '^.step_three', { key: $scope.$parent.Profile.key } )
   } ).finally( function () {
   vm.loading = false;
   } );
   }
   }
   }
   */

  function ProfileStep2FinancialsController ( $scope, ProfileFactory, $state, YEARS ) {
    var vm = this;
    vm.loading = false;
    vm.years = [];
    vm.year = new Date().getFullYear() - 1;
    var yearFinancial;
    for ( var iYears = YEARS.FINANCIALSINIT; iYears < vm.year + 1; iYears++ ) {
      vm.years.push( iYears );
    }
    vm.years = vm.years.reverse();

    var resetFinancials = function () {
      vm.financialsNew = {
        cagr                : null,
        roa                 : null,
        employees           : null,
        ebitda              : null,
        development         : null,
        foreign_investiments: null,
        sales               : null,
        investigation       : null,
        patents             : null,
        editable            : 1,
        year                : null
      };
    };
    resetFinancials();

    var checkYearinFinancials = function () {
      for ( var i = 0; i < $scope.$parent.Profile.company.financials.length; i++ ) {
        if ( $scope.$parent.Profile.company.financials[ i ].year == vm.year ) {
          return i + 1;
        }
      }
      return false;
    };


    var checkLastFinancials = function () {
      if ( $scope.$parent.Profile.company.hasOwnProperty( 'financials' ) && $scope.$parent.Profile.company.financials.length ) {
        if ( yearFinancial = checkYearinFinancials() ) {
          vm.financialsNew = angular.copy( $scope.$parent.Profile.company.financials[ yearFinancial - 1 ] );
        } else {
          resetFinancials();
        }
      } else {
        resetFinancials();
      }
    };
    checkLastFinancials();

    vm.updateYear = function () {
      checkLastFinancials();
    };

    vm.update = function () {
      var valueOk = 0;
      var financialsOK;
      for ( var prop in vm.financialsNew ) {
        if ( prop !== 'editable' && vm.financialsNew[ prop ] ) {
          valueOk++
        } else if(prop !== 'editable')  {
          delete vm.financialsNew[ prop ];
        }
      }
      if ( valueOk > 0) {
        vm.loading = true;
        vm.financialsNew.year = vm.year;
        if(vm.financialsNew.ebitda) {
          vm.financialsNew.ebitda = vm.financialsNew.ebitda / 1000;
        }
        ProfileFactory.updateFinancials( vm.financialsNew, $scope.$parent.Profile.company.id ).then( function ( dataResponse ) {
          //$scope.$parent.Profile.company.financials = dataResponse;
          financialsOK = $scope.$parent.Profile.passFinancialsToNumber( dataResponse );
          $scope.$parent.Profile.company.financials = financialsOK;
          resetFinancials();
          $state.go( '^.step_three', { key: $scope.$parent.Profile.key } );
        }, function () {
          vm.financialsNew.ebitda = vm.financialsNew.ebitda * 1000;
        } ).finally( function () {
          vm.loading = false;
        } );
      }
    }

  }

  function ProfileStep3Controller ( $scope, ProfileFactory, toaster ) {
    var vm = this;
    vm.loading = {
      logo : false,
      image: false
    };
    vm.upload = function ( file, name, id, index ) {
      vm.loading[ name ] = true;
      if ( name == 'logo' ) id = $scope.$parent.Profile.company.id;
      ProfileFactory.sendCompanyLogo( file, name, id ).then( function ( data ) {
        if ( name == 'logo' ) {
          $scope.$parent.Profile.company.logo = data.logo;
          vm[ name ] = {};
        } else {
          $scope.$parent.Profile.company.contacts[ index ].image = data.image;
          vm[ name ][ index ] = {};
        }
      }, function () {
        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'Error al intentar actualizar la image',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
      } ).finally( function () {
        vm.loading[ name ] = false;
      } )
    }
    vm.removeFile = function ( name, index ) {
      //if (name == 'images') vm.pReleease.article[name].splice(index, 1);
      if ( !index ) vm[ name ] = {};
      else vm[ name ].splice( index, 1 );
    }
  }

  function ProfileStep4Controller ( $scope ) {
    var vm = this;
    vm.vectorMapReady = false;
    vm.mapReady = false;

    var watchListenerCountries = $scope.$watch( '$parent.Profile.company', function ( newValue ) {
      if ( !angular.equals( newValue, {} ) ) {
        if ( newValue.countries_market.length > 0 ) {
          var arrayCMarket = [];
          for ( var indexMarket = 0; indexMarket < newValue.countries_market.length; indexMarket++ ) {
            if ( typeof newValue.countries_market[ indexMarket ].id !== 'undefined' ) {
              arrayCMarket.push( newValue.countries_market[ indexMarket ].id );
              continue;
            } else arrayCMarket.push( newValue.countries_market[ indexMarket ] );
          }
          vm.countriesMarketIds = arrayCMarket;
        }
        if ( newValue.countries_office.length > 0 ) {
          var arrayCOffice = [];
          for ( var indexMarketO = 0; indexMarketO < newValue.countries_office.length; indexMarketO++ ) {
            if ( typeof newValue.countries_office[ indexMarketO ].id !== 'undefined' ) {
              arrayCOffice.push( newValue.countries_office[ indexMarketO ].id );
              continue;
            } else arrayCOffice.push( newValue.countries_office[ indexMarketO ] );
          }
          vm.countriesOfficeIds = arrayCOffice;
        }
        vm.vectorMapReady = true;

        vm.map = {
          center : {
            latitude : ( newValue.addresses[ 0 ].lat ) ? newValue.addresses[ 0 ].lat : 40.21444287032146,
            longitude: ( newValue.addresses[ 0 ].lng ) ? newValue.addresses[ 0 ].lng : -4.408278462499999
          }, zoom: 5
        };
        vm.markerOptions = { icon: 'https://d3cbxno87ymraz.cloudfront.net/app/assets/images/marker.png' };
        vm.mapReady = true;
        watchListenerCountries();
      }
    } );
  }

  function ProfileStep5Controller ( $scope, $rootScope, $stateParams, $timeout, ProfileFactory, toaster, UsersService ) {
    var vm = this;
    vm.available = true;
    vm.user = {
      id        : '',
      name      : '',
      email     : '',
      password  : '',
      group     : 'user',
      company_id: ''
    };
    vm.users = [];
    vm.user.id = $rootScope.myUser.id;
    vm.user.email = $rootScope.myUser.email;
    vm.user.name = $rootScope.myUser.name;
    vm.user.group = $rootScope.myUser.group;
    vm.user.company_id = $rootScope.myUser.company.id;
    if ( $stateParams.id && ( $rootScope.myUser.group == 'admin' || $rootScope.myUser.group == 'superadmin' || $scope.$parent.Profile.company.id ) ) {
      $scope.$parent.Profile.param = $stateParams.id;
      vm.user.company_id = parseInt( $stateParams.id );
      $scope.$parent.Profile.changeCompany();
    }
    if ( $rootScope.myUser.group == 'superadmin' || $rootScope.myUser.group == 'admin' ) {
      $scope.$watch( '$parent.Profile.company.id', function ( newValue ) {
        if ( newValue ) {
          vm.users = [];
          vm.user = {
            id             : '',
            name           : '',
            email          : '',
            password       : '',
            password_repeat: '',
            group          : 'user',
            company_id     : ''
          };

          UsersService.get( false, { company_id: newValue } ).then( function ( data ) {
            if ( data.data.length ) {

              //vm.users = data.data;
              for ( var index = 0; index < data.data.length; index++ ) {
                var element = data.data[ index ];
                if ( element.group == 'user' ) data.data[ index ].company_id = element.company.id;
              }
              vm.users = data.data;

              vm.user.id = data.data[ 0 ].id;
              vm.user.group = data.data[ 0 ].group;
              vm.user.email = data.data[ 0 ].email;
              vm.user.name = data.data[ 0 ].name;
              if ( data.data[ 0 ].group == 'user' ) vm.user.company_id = data.data[ 0 ].company.id;

            } else {
              vm.user = {
                id             : '',
                name           : '',
                email          : '',
                password       : '',
                password_repeat: '',
                group          : 'user',
                company_id     : ''
              }
              if ( $scope.$parent.Profile.company.contacts.length > 0 ) {
                vm.user.name = $scope.$parent.Profile.company.contacts[ 0 ].name + $scope.$parent.Profile.company.contacts[ 0 ].surname;
                if ( typeof $scope.$parent.Profile.company.contacts[ 0 ].email && $scope.$parent.Profile.company.contacts[ 0 ].email ) vm.user.email = $scope.$parent.Profile.company.contacts[ 0 ].email;
                vm.user.company_id = $scope.$parent.Profile.company.id;
              }
            }
            vm.available = true;
          }, function () {
            vm.available = false;
          } )
        }
      } );
    }

    vm.editUser = function ( index ) {
      vm.user = vm.users[ index ];
    }

    vm.submit = function ( form ) {
      if ( form.$valid ) {
        vm.available = false;
        if ( typeof vm.user.id !== 'undefined' && vm.user.id ) {
          var userMe = vm.user.id;
          if ( $rootScope.myUser.id == vm.user.id ) userMe = 'me';
          UsersService.put( userMe, vm.user ).then( function () {
            toaster.pop( {
                           type           : 'success',
                           title          : 'OK',
                           body           : 'Datos actualizados correctamente',
                           showCloseButton: true,
                           timeout        : 2000
                         } );
            vm.user.password = '';
            vm.user.password_repeat = '';
            form.$dirty = true;
          }, function () {
            toaster.pop( {
                           type           : 'error',
                           title          : 'ERROR',
                           body           : 'No se ha prodido actualizar los datos',
                           showCloseButton: true,
                           timeout        : 2000
                         } );
          } ).finally( function () {
            vm.available = true;
          } )
        } else {
          UsersService.create( vm.user ).then( function ( data ) {
            vm.user.password = '';
            vm.user.id = data.id;
            form.$dirty = true;
          }, function () {

          } ).finally( function () {
            vm.available = true;
          } );
        }
      }
    }
  }

  function ProfileStep6Controller ( $scope, $rootScope, $stateParams, ProfileFactory, toaster, SUMMERNOTE, $timeout ) {
    var vm = this;
    vm.config = SUMMERNOTE;
    vm.loading = false;
    vm.image = {};
    var timeoutPaste = null;
    if ( $stateParams.id && ( $rootScope.myUser.group == 'admin' || $rootScope.myUser.group == 'superadmin' || $scope.$parent.Profile.company.id ) ) {
      $scope.$parent.Profile.param = $stateParams.id;
      $scope.$parent.Profile.changeCompany();
    }

    vm.submit = function ( form ) {
      if ( form.$valid ) {
        vm.loading = true;
        if ( !$scope.$parent.Profile.company.interview.image ) $scope.$parent.Profile.company.interview.image = {};
        if ( !angular.equals( vm.image, {} ) || !vm.image ) $scope.$parent.Profile.company.interview.image = vm.image;
        else delete $scope.$parent.Profile.company.interview.image;
        ProfileFactory.sendInterview( $scope.$parent.Profile.company.interview, $scope.$parent.Profile.company.id ).then(
          function ( data ) {
            $scope.$parent.Profile.company.interview = data.data.interview;
          }
        ).finally( function () {
          vm.loading = false;
        } );
      }
    }

    vm.removeFile = function () {
      $scope.$parent.Profile.company.interview.image = {};
    }

    vm.pasteSummernote = function () {
      timeoutPaste = $timeout( function () {
        $scope.$parent.Profile.company.interview.interview = $scope.$parent.Profile.company.interview.interview.replace( /style="[^"]*"/g, "" );
      }, 500 );
    };

    $scope.$on( '$timeout', function () {
      if ( timeoutPaste ) $timeout.cancel( timeoutPaste );
    } );
  }

} )();

(function () {
  'use strict';

  angular
    .module('app.logged')
    .factory('StartupsFactory', StartupsFactory);

  StartupsFactory.$inject = ['$q', '$http', 'URLS', 'toaster'];

  /** @ngInject */
  function StartupsFactory($q, $http, URLS, toaster) {
    var factory = {
      get: get,
      remove: remove,
      favourite: favourite
    };
    return factory;

    function remove(id) {
      var deferred = $q.defer();
      var settings = {
        method: 'DELETE',
        url: URLS.API + 'startups/' + id,
        cache: false
        //  timeout: deferred.promise,
      }
      return http();
      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Startup eliminada de tus favoritos',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible eliminar esta Startup a tus favoritos',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function favourite(id, favourite) {
      var deferred = $q.defer();
      var method = 'POST';
      if(favourite) method = 'DELETE';
      var settings = {
        method: method,
        url: URLS.API + 'startups/' + id + '/favourite',
        cache: false
        //  timeout: deferred.promise,
      }
      return http();
      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Startup añadida a tus favoritos',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible añadir esta Startup a tus favoritos',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function get(params, id) {
      var deferred = $q.defer();
      /*
      q
      sector
      favourite
      */
      var url = URLS.API + 'startups';
      if (id) url = url + '/' + id;
      var settings = {
        method: 'GET',
        url: url,
        cache: false,
        params: params
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar las Startups',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

  }
})();
(function () {
  'use strict';

  angular.module('app.logged')
    .controller('StartupsController', StartupsController)

  StartupsController.$inject = ['StartupsFactory', '$stateParams', 'BroadcastFactory'];

  /** @ngInject */
  function StartupsController(StartupsFactory, $stateParams, BroadcastFactory) {
    var vm = this;
    if($stateParams.id)  BroadcastFactory.send('sideBarEvent', { type: 12, id: $stateParams.id, data: false, noStats: true });
    vm.text = 'Startups';
    vm.params = {
      q: '',
      sector: '',
      favourite: 0,
      page: 1
    };
    vm.total = 0;
    vm.loading_favourite;
    vm.loading_remove;
    vm.startups = [];

    vm.getList = function () {
      vm.loading = true;
      StartupsFactory.get(vm.params).then(function (startups) {
        vm.startups = startups.data;
        vm.total = startups.total;
      }).finally(function () {
        vm.loading = false;
      })
    }
    vm.getList();

    vm.favourite = function (index, id, isFavourite) {
      vm.loading_favourite = true;
      StartupsFactory.favourite(id, isFavourite).then(function () {
        vm.startups[index].isFavourite = !isFavourite;
      }).finally(function(){
        vm.loading_favourite = false;
      })
    }
    vm.remove = function (index, id) {
      vm.loading_remove = true;
      StartupsFactory.remove(id).then(function () {
        vm.startups.splice(index, 1);
      }).finally(function(){
        vm.loading_remove = false;
      })
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.logged')
    .factory('ProjetcsFactory', ProjetcsFactory);

  ProjetcsFactory.$inject = ['$q', '$http', 'URLS', 'toaster'];

  /** @ngInject */
  function ProjetcsFactory($q, $http, URLS, toaster) {
    var factory = {
      send: send,
      addUser: addUser,
      removeUser: removeUser,
      get: get

    };
    return factory;
    /*
    title
    url
    date_to
    date_from
    scope
    description
    comments
    aproach
    phone
    email
    person_contact
    */
    function send(project) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'projects',
        cache: false,
        data: project
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Proyecto publicado correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible publicar este proyecto',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function addUser(id_project, company_id) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'projects/' + id_project + '/join',
        cache: false,
        data: {
          join: company_id
        }
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Te has unido al proyecto correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No has podido unirte al proyecto',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function removeUser(id_project, company_id) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'projects/' + id_project + '/dissociate',
        cache: false,
        data: {
          dissociate: company_id
        }
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Te has desligado del proyecto correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No te has podido desligar del proyecto',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }
    /*
    if(id) param = id (company_id)
    else param = page
    */
    function get(params, id) {
      var deferred = $q.defer();
      var url = URLS.API + 'projects';
      if(id) url = url + '/' + id;
      var settings = {
        method: 'GET',
        url: url,
        cache: false,
        params: params
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if(id && typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else if (typeof data !== 'undefined' && typeof data.data !== 'undefined' && data.data.data.length) deferred.resolve(data.data);
        else httpError();
      }
      function httpError() {
        /*
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible encontrar proyectos',
          showCloseButton: true,
          timeout: 2000
        });
        */
        deferred.reject('error');
      }
    }


  }
})();
(function () {
  'use strict';

  angular.module('app.logged')
    .controller('ProjectsController', ProjectsController)

  ProjectsController.$inject = ['ProjetcsFactory', '$rootScope', '$stateParams', 'BroadcastFactory'];

  /** @ngInject */
  function ProjectsController(ProjetcsFactory, $rootScope, $stateParams, BroadcastFactory) {
    var vm = this;
    if ($stateParams.id == 'compose') BroadcastFactory.send('sideBarEvent', { type: 15, id: $stateParams.id, data: false, noStats: true });
    else if ($stateParams.id) BroadcastFactory.send('sideBarEvent', { type: 14, id: $stateParams.id, data: false, noStats: true });
    vm.text = 'Projects';
    vm.params = {
      page: 1,
      company_id: ''
    };
    vm.total = 0;
    vm.projects = [];
    vm.companies = [];
    vm.handleCompanySelection = function (companyId) {
      vm.params.company_id = companyId;
      //vm.changeCompany();
    };

    vm.getList = function () {
      vm.loading = true;
      ProjetcsFactory.get(vm.params)
        .then(function (projects) {
          if (projects.data.length) {
            for (var index = 0; index < projects.data.length; index++) {
              if (projects.data[index].participants.length) {
                for (var indexJ = 0; indexJ < projects.data[index].participants.length; indexJ++) {
                  if (projects.data[index].participants[indexJ].company_id == $rootScope.myUser.company.id) projects.data[index].added = true;
                  else projects.data[index].added = false;
                }
              }
            }
            vm.projects = projects.data;
            vm.total = projects.total;
          } else {
            vm.projects = [];
            vm.total = 0;
          }
        }, function () {
          vm.projects = [];
          vm.total = 0;
        }).finally(function () {
          vm.loading = false;
        });
    };
    vm.getList();

    vm.addUser = function (id, index) {
      vm.loadingAdd = true;
      ProjetcsFactory.addUser(id, $rootScope.myUser.company.id)
        .then(function () {
          vm.projects[index].participants.push({
            company_id: $rootScope.myUser.company.id,
            company: [$rootScope.myUser.company]
          });
          vm.projects[index].added = true;
        })
        .finally(function () {
          vm.loadingAdd = false;
        });
    };
    vm.removeUser = function (id, index) {
      vm.loadingAdd = true;
      ProjetcsFactory.removeUser(id, $rootScope.myUser.company.id)
        .then(function () {
          for (var indexP = 0; indexP < vm.projects[index].participants.length; indexP++) {
            if (vm.projects[index].participants[indexP].company_id == $rootScope.myUser.company.id) {
              vm.projects[index].participants.splice(indexP, 1);
              vm.projects[index].added = false;
              break;
            }
          }
        })
        .finally(function () {
          vm.loadingAdd = false;
        });
    };
  }
})();

( function () {
  'use strict';

  angular
    .module( 'app' )
    .factory( 'ShopFactory', ShopFactory );

  ShopFactory.$inject = [ '$http', '$q', 'URLS', '$window', 'Upload', 'toaster' ];

  /** @ngInject */
  function ShopFactory ( $http, $q, URLS, $window, Upload, toaster ) {
    var factory = {
      getStripe         : getStripe,
      getToken          : getToken,
      pay               : pay,
      sendProduct       : sendProduct,
      get               : get,
      remove            : remove,
      payment           : payment,
      getIntentToUseCard: getIntentToUseCard
    };
    return factory;

    ///////////////
    function remove ( id ) {
      var deferred = $q.defer();

      var settings = {
        method: 'DELETE',
        url   : URLS.API + 'shop/' + id,
        cache : false
        //  timeout: deferred.promise,
      }
      return http();

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' && typeof data.data !== 'undefined' ) {
          toaster.pop( {
                         type           : 'success',
                         title          : 'OK',
                         body           : 'Producto eliminado',
                         showCloseButton: true,
                         timeout        : 2000
                       } );
          deferred.resolve( data.data );
        }
        else httpError();
      }

      function httpError () {
        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'No ha sido posible eliminar el producto',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.reject( 'error' );
      }
    }

    ///////////////
    function get ( page, id ) {
      var deferred = $q.defer();
      var url = URLS.API + 'shop';
      if ( id && id != 0 ) url = url + '/' + id;
      var settings = {
        method: 'GET',
        url   : url,
        cache : false,
        params: {
          page: page
        }
      }
      return http();

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( id && id != 0 ) {
          if ( typeof data !== 'undefined' && typeof data.data !== 'undefined' ) {
            deferred.resolve( data.data );
          } else httpError();
        } else {
          if ( typeof data !== 'undefined' && typeof data.data !== 'undefined' && typeof data.data.data !== 'undefined' && data.data.data.length ) deferred.resolve( data.data );
          else httpError();
        }
      }

      function httpError () {
        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'No ha sido posible mostrar los productos',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.reject( 'error' );
      }
    }

    ///////////////
    function sendProduct ( product, id ) {
      var deferred = $q.defer();
      var url = URLS.API + 'shop';
      if ( id && id != 0 ) {
        url = url + '/' + id;
      }
      var settings = {
        url   : url,
        data  : product,
        method: 'POST',
        // withCredentials: true,
        cache : false
      }
      return http()

      function http () {
        Upload.upload( settings )
              .then( httpOk, httpError );
        return deferred.promise
      }

      function httpOk ( data ) {
        toaster.pop( {
                       type           : 'success',
                       title          : 'OK',
                       body           : 'Producto añadido correctamente',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.resolve( data );
      }

      function httpError () {
        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'No ha sido posible añadir el producto',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.reject( 'error' );

      }
    }

    ////////////////
    function pay ( id, data ) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url   : URLS.API + 'shop/' + id + '/pay',
        cache : false,
        data  : data
        //  timeout: deferred.promise,
      }
      return http();

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' && typeof data.data && typeof data.data.exception == 'undefined' ) {
          toaster.pop( {
                         type           : 'ok',
                         title          : 'OK',
                         body           : 'Producto comprado correctamente',
                         showCloseButton: true,
                         timeout        : 2000
                       } );
          deferred.resolve( data );
        } else {
          httpError( data );
        }
      }

      function httpError ( data ) {
        var title = 'Error';
        var msg = 'No ha sido posible comprar este producto, no se ha cargado ningún importe en tu tarjeta';
        if ( typeof data !== 'undefined' && typeof data.data !== 'undefined' && typeof data.data.message !== 'undefined' && typeof data.data.message.title !== 'undefined' && data.data.message.title ) {
          title = data.data.message.title;
        }
        toaster.pop( {
                       type           : 'error',
                       title          : title,
                       body           : msg,
                       showCloseButton: true,
                       timeout        : 4000
                     } );
        deferred.reject( 'error' );
      }
    }

    ////////////////
    function getStripe () {
      var deferred = $q.defer();
      return http();

      function http () {
        $window.$.getScript( 'https://js.stripe.com/v3/', function () {
          deferred.resolve( 'ok' )
          $window.stripe = $window.Stripe( 'pk_test_gzgGORsr1ETZIgzOrS4dXzlv' );
        }, function () {
          deferred.reject( 'error' );
        } );
        return deferred.promise;
      }
    }

    ////////////////
    function getToken ( card ) {
      var deferred = $q.defer();
      if ( typeof $window.stripe == 'undefined' ) {
        factory.getStripe().then( function () {
          $window.stripe.createToken( card ).then( function ( token ) {
            deferred.resolve( token )
          }, function () {
            deferred.reject( 'error' );
          } );
        }, function () {
          deferred.reject( 'error' );
        } )
      } else {
        $window.stripe.createToken( card ).then( function ( token ) {
          deferred.resolve( token )
        }, function () {
          deferred.reject( 'error' );
        } );
      }
      return deferred.promise;
    }


    function getIntentToUseCard ( id ) {
      var deferred = $q.defer();
      var url = URLS.API + 'shop/' + id + '/pay-with-card';
      var settings = {
        method: 'GET',
        url   : url,
        cache : false,
      }
      return http();

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' && typeof data.data !== 'undefined' ) deferred.resolve( data.data );
        else httpError(data);
      }


      function httpError (data) {
        var message = 'Hubo una incidencia en el pago, compra cancelada'
        if(data && data.hasOwnProperty('message') && data.message.hasOwnProperty(title)){
          message = data.message.title;
        }
        deferred.reject( message );
      }
    }

    function payment ( id, data ) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url   : URLS.API + 'shop/' + id + '/pay',
        cache : false,
        data  : data
        //  timeout: deferred.promise,
      }
      return http();

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' && typeof data.data && typeof data.data.exception == 'undefined' ) {
          deferred.resolve( data.data );
        } else {
          httpError( data );
        }
      }

      function httpError ( data ) {
        if ( typeof data !== 'undefined' && typeof data.data !== 'undefined' && typeof data.data.message !== 'undefined' && typeof data.data.message.title !== 'undefined' && data.data.message.title ) {
          deferred.reject( data.data.message.title );
        } else {
          deferred.reject( 'error' );
        }
      }
    }
  }
} )();

(function () {
        'use strict';

        angular.module('app.logged')
            .controller('ShopController', ShopController)
            .controller('ShopEditController', ShopEditController)

        ShopController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'ShopFactory', '$window', 'UsersService', '$timeout', 'STRIPE'];
        ShopEditController.$inject = ['$scope', '$state', '$stateParams', 'SUMMERNOTE', 'ShopFactory', '$timeout'];


        /*

         */

        /** @ngInject */
        function ShopEditController($scope, $state, $stateParams, SUMMERNOTE, ShopFactory, $timeout) {
            var vm = this;
            vm.config = SUMMERNOTE;
            var resetProduct = function () {
                vm.product = {
                    'title': '',
                    'description': '',
                    'price': 0,
                    'status': 'active',
                    'type': 'direct',
                    'url': '',
                    'image': {}
                };
                vm.copyFile = '';
            }
            var timeoutPaste = null;
            $scope.$parent.Shop.product = null;

            if ($stateParams.id && $stateParams.id != 0) {
                ShopFactory.get(false, $stateParams.id).then(function (data) {
                    vm.product = data;

                    /*if(typeof data.type == 'undefined') vm.product.type = 'direct';*/
                    if (typeof data.image.real_path !== 'undefined') vm.copyFile = angular.copy(data.image.real_path);
                }).finally(function () {
                    vm.loadingProduct = false;
                })
            } else resetProduct();

            vm.removeFile = function () {
                vm.product.image = {};
            }

            vm.submit = function (form) {
                if (form.$valid) {
                    vm.loading = true;
                    ShopFactory.sendProduct(vm.product, $stateParams.id).then(function () {
                        $state.go('app.logged.shop', {}, {reload: true});
                    }).finally(function () {
                        vm.loading = false;
                    })
                }
            }

            vm.pasteSummernote = function () {
                timeoutPaste = $timeout(function () {
                    vm.product.description = vm.product.description.replace(/style="[^"]*"/g, "");
                }, 500);
            };

            $scope.$on('$destroy', function () {
                if (timeoutPaste) $timeout.cancel(timeoutPaste);
            });

        }

        /** @ngInject */
        function ShopController($scope, $rootScope, $state, $stateParams, ShopFactory, $window, UsersService, $timeout, STRIPE) {
            $window.scrollTo(0, 0);
            var vm = this;
            vm.text = 'Shop';
            vm.available = false;
            vm.loading;
            vm.page = 1;
            var timeoutStripe;
            var cardElement;
            var stripe;
            var elements;
            vm.products = {
                data: [],
                total: 0
            };
            vm.product;
            vm.paymentResult = {
                code: 0,
                message: ''
            };

            var publication = [];
            for (var iP = 1; iP < 4; iP++) {
                ShopFactory.get(false, iP).then(function (data) {
                    if (data.status == 'active') publication.push(data);
                });
            }
            vm.publication = publication;


            vm.getList = function () {
                vm.loading = true;
                ShopFactory.get(vm.page).then(function (data) {
                    vm.products.data = vm.products.data.concat(data.data);
                    if (vm.products.data.length < data.total) vm.available = true;
                    else vm.available = false;
                    vm.page++;
                }).finally(function () {
                    vm.loading = false;
                });
            }
            vm.getList();

            if ($stateParams.id && $stateParams.id != 0 && $state.current.name !== 'app.logged.shop.edit') {
                vm.loadingProduct = true;
                ShopFactory.get(false, $stateParams.id).then(function (data) {
                    vm.product = data;
                    timeoutStripe = $timeout(function () {
                        stripe = Stripe(STRIPE.key);
                        elements = stripe.elements();
                        cardElement = elements.create('card');
                        cardElement.mount('#card-element-' + data.id);
                    }, 250);
                }).finally(function () {
                    vm.loadingProduct = false;
                });
            } else vm.product = null;

            /*
             vm.submit = function () {
             vm.loadingProduct = true;
             if ( !$rootScope.myUser.company.customer_id ) {
             var pay = angular.copy( vm.card );
             pay.need_pay = true;
             pay.code = $stateParams.code;
             pay.card_exp_year = pay.card_exp_year - 2000;
             } else {
             pay = {}
             }
             ShopFactory.pay( $stateParams.id, pay ).then( function () {
             ressetCard();
             if ( !$rootScope.myUser.company.customer_id ) {
             UsersService.get( 'me' ).then( function ( data ) {
             if ( typeof data.company.customer_id !== 'undefined' && data.company.customer_id ) $rootScope.myUser.company.customer_id = data.company.customer_id
             } );
             $state.go( 'app.logged.shop', { id: 0 }, { reload: true, notify: true } );
             } else $state.go( 'app.logged.shop', { id: 0 } );
             } ).finally( function () {
             vm.loadingProduct = false;
             } );
             };
             */

            vm.removeProduct = function (id) {
                vm.loadingProduct = true;
                vm.loading = true;
                ShopFactory.remove(id).then(function () {
                    $state.go('app.logged.shop', {}, {reload: true, notify: true});
                }).finally(function () {
                    vm.loadingProduct = false;
                    vm.loading = true;
                })
            };

            var paymentWithCardData = function (id) {
                vm.loading = true;
                stripe.createPaymentMethod('card', cardElement, {
                    billing_details: {name: 'card'}
                })
                    .then(function (result) {
                        if (result.error) {
                            $scope.$apply(function () {
                                vm.loading = false;
                                vm.paymentResult = {
                                    code: -1,
                                    message: result.error.hasOwnProperty('message') ? result.error.message : 'Se ha cancelado la compra, hubo un problema con el pago'
                                };

                            });
                            return;
                        }
                        ShopFactory.payment(id, {payment_method_id: result.paymentMethod.id}).then(function (response) {
                            if (response.hasOwnProperty('error')) {
                                var message = 'Se ha cancelado la compra, hubo un problema con el pago';
                                if (response.error.hasOwnProperty('message') && response.error.message) {
                                    message = response.error.message
                                }
                                $scope.$apply(function () {
                                    vm.loading = false;
                                    vm.paymentResult = {
                                        code: -1,
                                        message: message
                                    };
                                });
                            } else if (response.requires_action) {
                                stripe.handleCardAction(
                                    response.payment_intent_client_secret
                                ).then(function (result) {
                                    if (!result || typeof result.error !== 'undefined') {
                                        $scope.$apply(function () {
                                            vm.loading = false;
                                            vm.paymentResult = {
                                                code: -1,
                                                message: 'Se ha cancelado la compra, hubo un problema con el pago'
                                            };
                                        });
                                        return
                                    } else if (result && result.hasOwnProperty('error')) {
                                        var message = 'Se ha cancelado la compra, hubo un problema con el pago';
                                        if (result.error.hasOwnProperty('message') && result.error.message) {
                                            message = result.error.message
                                        }
                                        $scope.$apply(function () {
                                            vm.loading = false;
                                            vm.paymentResult = {
                                                code: -1,
                                                message: message
                                            };
                                        });
                                    } else {
                                        ShopFactory.payment(id, {payment_intent_id: result.paymentIntent.id})
                                            .then(function (data) {
                                                cardElement.clear();
                                                vm.paymentResult = {
                                                    code: 1,
                                                    message: 'Se ha realizado el pago correctamente'
                                                };
                                                vm.loading = false;
                                            }, function (errorApi) {
                                                var message = errorApi || 'Se ha cancelado la compra, hubo un problema con el pago';
                                                vm.loading = false;
                                                vm.paymentResult = {
                                                    code: -1,
                                                    message: message
                                                };
                                                cardElement.clear();
                                            });
                                    }
                                }, function (errorPay) {
                                    var messsage = 'Hubo una incidencia en el pago, compra cancelada';
                                    if (errorPay && errorPay.hasOwnProperty('message')) {
                                        messsage = errorPay.message;
                                    }
                                    $scope.$apply(function () {
                                        vm.paymentResult = {
                                            code: -1,
                                            message: messsage
                                        };
                                        vm.loading = false;
                                    });
                                });
                            } else if (response.requires_capture) {
                                ShopFactory.payment(id, {capture_payment_intent_id: response.payment_intent_id})
                                    .then(function (data) {
                                        vm.paymentResult = {
                                            code: 1,
                                            message: 'Compra realizada con éxito'
                                        };
                                        cardElement.clear();
                                        vm.loading = false;
                                    }, function (errorApi) {
                                        var message = 'Se ha cancelado la compra, hubo un problema con el pago';
                                        if (errorApi && errorApi.hasOwnProperty('error') && errorApi.error.hasOwnProperty('message') && errorApi.error.message) {
                                            message = result.error.message;
                                        }
                                        cardElement.clear();
                                        vm.loading = false;
                                        vm.paymentResult = {
                                            code: -1,
                                            message: message
                                        };


                                    });
                            } else {
                                cardElement.clear();
                                vm.paymentResult = {
                                    code: 1,
                                    message: 'Se ha realizado el pago correctamente'
                                };
                                vm.loading = false;
                            }
                        });
                    }, function (errorPay) {
                        var messsage = 'Hubo una incidencia en el pago, compra cancelada';
                        if (errorPay && errorPay.hasOwnProperty('message')) {
                            messsage = errorPay.message;
                        }
                        $scope.$apply(function () {
                            vm.paymentResult = {
                                code: -1,
                                message: messsage
                            };
                            vm.loading = false;
                        });
                    });
            };

            var paymentWithoutCardData = function (id) {
                vm.loading = true;
                ShopFactory.getIntentToUseCard(id)
                    .then(function (response) {
                        if (response && response.hasOwnProperty('intent') && response.intent && response.intent.hasOwnProperty('client_secret')) {

                            if(response.intent.status == 'requires_capture'){

                                ShopFactory.payment(id, {capture_payment_intent_id: response.payment_intent_id})
                                    .then(function (data) {
                                        vm.paymentResult = {
                                            code: 1,
                                            message: 'Compra realizada con éxito'
                                        };
                                        cardElement.clear();
                                        vm.loading = false;
                                    }, function (errorApi) {
                                        var message = 'Se ha cancelado la compra, hubo un problema con el pago';
                                        if (errorApi && errorApi.hasOwnProperty('error') && errorApi.error.hasOwnProperty('message') && errorApi.error.message) {
                                            message = result.error.message;
                                        }
                                        cardElement.clear();
                                        vm.loading = false;
                                        vm.paymentResult = {
                                            code: -1,
                                            message: message
                                        };


                                    });

                            }else{

                                stripe.handleCardAction(
                                    response.intent.client_secret
                                )
                                    .then(function (result) {
                                       // console.log('result',result);
                                        if (result.error) {
                                            var message = 'Hubo una incidencia en el pago, compra cancelada';
                                            if (result.error.hasOwnProperty('message')) {
                                                message = result.error.message;
                                            }
                                            $scope.$apply(function () {
                                                vm.paymentResult = {
                                                    code: -1,
                                                    message: message
                                                };
                                                vm.loading = false;
                                            });
                                        } else {
                                            //console.log('ñlanzo  apiu');
                                            ShopFactory.payment(id, {payment_intent_id: result.paymentIntent.id})
                                                .then(function (data) {
                                                    if (data && data.hasOwnProperty('success') && data.success) {
                                                        vm.paymentResult = {
                                                            code: 1,
                                                            message: 'Compra realizada con éxito'
                                                        };
                                                        vm.loading = false;
                                                    } else {
                                                        vm.paymentResult = {
                                                            code: -1,
                                                            message: 'Hubo una incidencia en el pago, compra cancelada'
                                                        };
                                                        vm.loading = false;
                                                    }
                                                }, function (errroPay) {
                                                    vm.paymentResult = {
                                                        code: -1,
                                                        message: errroPay
                                                    };
                                                    vm.loading = false;
                                                });
                                        }
                                    }, function (errorPay) {

                                        console.log('error', errorPay);
                                        var messsage = 'Hubo una incidencia en el pago, compra cancelada';
                                        if (errorPay && errorPay.hasOwnProperty('message')) {
                                            messsage = errorPay.message;
                                        }
                                        $scope.$apply(function () {
                                            vm.paymentResult = {
                                                code: -1,
                                                message: messsage
                                            };
                                            vm.loading = false;
                                        });
                                    });
                            }


                        } else {
                            var message = 'Hubo una incidencia en el pago, compra cancelada';
                            if (response && response.hasOwnProperty('message') && response.message.hasOwnProperty('title')) {
                                message = response.message.title;
                            }
                            vm.paymentResult = {
                                code: -1,
                                message: message
                            };
                            vm.loading = false;
                        }

                    }, function (errorApi) {
                        vm.loading = false;
                        vm.paymentResult = {
                            code: -1,
                            message: errorApi
                        };
                    });
            };

            vm.payment = function (id) {
                vm.paymentResult = {
                    code: 0,
                    message: ''
                };

                if ($rootScope.myUser.company.customer_id) {
                    paymentWithoutCardData(id);
                } else {
                    paymentWithCardData(id);
                }
            };

            $scope.$on('$destroy', function () {
                if (timeoutStripe) $timeout.cancel(timeoutStripe);
            });
        }

    }

)();

( function () {
  'use strict';

  angular
    .module( 'app.logged' )
    .factory( 'PressReleaseFactory', PressReleaseFactory );

  PressReleaseFactory.$inject = [ '$q', '$http', 'URLS', 'toaster', 'Upload' ];

  /** @ngInject */
  function PressReleaseFactory ( $q, $http, URLS, toaster, Upload ) {
    var factory = {
      get        : get,
      send       : send,
      getComments: getComments,
      sendComment: sendComment
    };
    return factory;

    ////////////////
    function get ( page, id, id_notice ) {

      var deferred = $q.defer();
      ( page ) ? page : 1;
      var url = URLS.API + 'notices';
      if ( id_notice ) url = url + '/' + id_notice;
      if ( id ) url = URLS.API + 'notices/company/' + id;

      var settings = {
        method: 'GET',
        url   : url,
        cache : false,
        params: {
          per_page: 20,
          page    : page
        }
        //  timeout: deferred.promise,
      }
      return http()

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( !id_notice && typeof data !== 'undefined' && typeof data.data !== 'undefined' && typeof data.data.data !== 'undefined' ) {
          deferred.resolve( data.data );
        } else if ( id_notice && typeof data !== 'undefined' && typeof data.data !== 'undefined' ) {
          deferred.resolve( data.data );
        } else httpError();
      }

      function httpError () {

        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'No ha sido posible cargar las noticias. Te mostramos las últimas guardadas en tu navegador',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.reject( 'error' );
      }
    }

    function getComments ( id ) {
      var deferred = $q.defer();
      var settings = {
        method: 'GET',
        url   : URLS.API + 'notices/' + id + '/comments',
        cache : false
      }
      return http()

      function http () {
        $http( settings )
          .then( httpOk, httpError );

        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' && typeof data.data !== 'undefined' && typeof data.data.comments !== 'undefined' && data.data.total > 0 ) {
          deferred.resolve( data.data.comments );
        } else {
          deferred.reject( 0 );
        }
      }

      function httpError () {

        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'No ha sido posible mostrar los comentarios.',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.reject( 0 );
      }
    }

    function send ( article, update ) {
      var url = URLS.API + 'notices';

      if ( typeof update !== "undefined" && update ) {
        article._method = "PATCH";
      }

      if ( typeof article.id !== "undefined" && article.id ) {
        url = url + '/' + article.id;
      }
      var deferred = $q.defer();
      var settings = {
        url   : url,
        data  : article,
        method: 'POST',
        // withCredentials: true,
        cache : false
      };

      return http();

      function http () {
        Upload.upload( settings )
              .then( httpOk, httpError );
        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data === "undefined" ) {
          httpError();
        } else {
          toaster.pop( {
                         type           : 'success',
                         title          : 'OK',
                         body           : 'Nota de prensa publicada correctamente',
                         showCloseButton: true,
                         timeout        : 2000
                       } );
          deferred.resolve( data );
        }
      }

      function httpError () {
        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'No ha sido posible cargar las noticias, por favor revisa los campos.',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.reject( 'error' );

      }
    }

    function sendComment ( id, comment ) {
      var deferred = $q.defer();
      var settings = {
        url   : URLS.API + 'notices/' + id + '/comments',
        data  : {
          comment: comment
        },
        method: 'POST',
        // withCredentials: true,
        cache : false
      }
      return http()

      function http () {
        Upload.upload( settings )
              .then( httpOk, httpError );
        return deferred.promise;
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' && typeof data.data !== 'undefined' && typeof data.data.comment !== 'undefined' ) {
          toaster.pop( {
                         type           : 'success',
                         title          : 'OK',
                         body           : 'Comentario publicado correctamente',
                         showCloseButton: true,
                         timeout        : 2000
                       } );
          deferred.resolve( data.data.comment );
        } else httpError();

      }

      function httpError () {
        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'No ha sido posible añadir este comentario',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.reject( 'error' );

      }
    }
  }
} )();

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('PressReleasesListController', PressReleasesListController)

  PressReleasesListController.$inject = ['$rootScope', '$window', '$state', '$stateParams', 'BroadcastFactory', 'PressReleaseFactory'];

  function PressReleasesListController($rootScope, $window, $state, $stateParams, BroadcastFactory, PressReleaseFactory) {
    var vm = this;
    var page = 1;
    vm.id = false;
    vm.viewMoreAvailable = false;
    vm.run = false;
    vm.news = [];
    $window.scrollTo( 0, 0 );

    getList(vm.id);

    function getList (id, refresh) {
      if(refresh) vm.news = [];
      vm.loading = true;
      PressReleaseFactory.get(page, id).then(responseOk, responseError).finally(function () {
        if(!vm.run) vm.run = true;
        vm.loading = false;
        page++;
      });
    }

    function responseOk (data) {
      vm.news = vm.news.concat(data.data);
      if(data.total > (20 * page)) vm.viewMoreAvailable = true;
      else vm.viewMoreAvailable = false;

    }
    function responseError () {
    }

    vm.viewMore = function () {
      getList(vm.id);
    }

    vm.getListById = function (user_id, refresh) {
      if(!user_id) vm.id = false;
      else vm.id = user_id;
      page = 1;
      getList(user_id, refresh);
    }


  }


})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('PremiumFactory', PremiumFactory);

  PremiumFactory.$inject = ['$http', '$q', 'URLS', '$window', 'toaster'];

  /** @ngInject */
  function PremiumFactory($http, $q, URLS, $window, toaster) {

    var factory = {
      pay: pay,
      check: check
    };
    return factory;
    ////////////////
    function pay(card) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'premium',
        cache: false,
        data: card
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data && typeof data.data.exception == 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Contratación realizada correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError(data);
        }
      }
      function httpError(data) {
        var title = 'Error';
        var msg = 'No ha sido posible contratar este servicio, no se ha cargado ningún importe en tu tarjeta';
        //console.log(data);
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined' && typeof data.data.message !== 'undefined' && typeof data.data.message.title !== 'undefined' && data.data.message.title) {
          //console.log(data);
          title = data.data.message.title;
        }
        toaster.pop({
          type: 'error',
          title: title,
          body: msg,
          showCloseButton: true,
          timeout: 4000
        });
        deferred.reject(title);
      }
    }

    function check() {
      var deferred = $q.defer();
      var settings = {
        method: 'GET',
        url: URLS.API + 'premium',
        cache: false
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data && typeof data.data.exception == 'undefined') {
          deferred.resolve(data.data);
        } else {
          httpError();
        }
      }
      function httpError() {
        deferred.reject('error');
      }
    }

  }
})();

( function () {
  'use strict';

  angular.module( 'app.logged' )
         .controller( 'PremiumController', PremiumController );

  PremiumController.$inject = [ '$window', '$rootScope', 'PremiumFactory', 'UsersService' ];

  /** @ngInject */
  function PremiumController ( $window, $rootScope, PremiumFactory, UsersService ) {
    var vm = this;
    vm.loading = true;
    vm.toggle = false;
    vm.check = false;
    var ressetCard = function () {
      vm.card = {
        card_number   : '',
        card_exp_month: '',
        card_exp_year : '',
        card_cv       : ''
      };
    };
    ressetCard();
    $window.scrollTo( 0, 0 );

    PremiumFactory.check().then( function ( data ) {
      if ( data.hasOwnProperty( "has_premium" ) && data.has_premium ) {
        vm.hasPremium = true;
      } else {
        vm.hasPremium = false;
      }
    }, function () {
      vm.hasPremium = false;
    } ).then( function () {
      vm.loading = false;
    } );

    vm.submit = function () {
      vm.error = false;
      vm.loadingPay = true;
      if ( !$rootScope.myUser.company.customer_id ) {
        var pay = angular.copy( vm.card );
        pay.card_exp_year = pay.card_exp_year - 2000;
      } else {
        pay = {}
      }
      PremiumFactory.pay( pay ).then( function () {
        ressetCard();
        vm.hasPremium = true;
        vm.toggle = false;
        if ( !$rootScope.myUser.company.customer_id ) {
          UsersService.get( 'me' ).then( function ( data ) {
            if ( typeof data.company.customer_id !== 'undefined' && data.company.customer_id ) $rootScope.myUser.company.customer_id = data.company.customer_id
          } );
        }
      }, function (title) {
        vm.error = title;
      } ).finally( function () {
        vm.loadingPay = false;
      } );
    };

  }

} )();

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('PatronsController', PatronsController)

  PatronsController.$inject = ['$stateParams', '$sce', '$window', '$document'];

  /** @ngInject */
  function PatronsController($stateParams, $sce, $window, $document) {
    var vm = this;
    var webs = {
      'banco_santander': 'https://www.bancosantander.es/empresas/santander-growth',
      'informa': 'https://www.informa.es/',
      'ico': 'https://www.ico.es/',
      'bme': 'https://www.bmegrowth.es/esp/BME-Growth/Que-Es.aspx',
      'ecoembes': 'https://www.ecoembes.com/es',
      'wolters_kluwer': 'https://www.wolterskluwer.com/es-es/know/s-info-c198-pack-emprende?utm_source=colectivos&utm_medium=link&utm_campaign=c198-pack-emprende&utm_content=colectivos-empresas',
      'orange': 'https://www.orange.es/empresas/PYMES',
      'mapfre': 'https://www.mapfre.es/empresas/',
      'randstad': 'https://www.randstad.es/empresas/',
      'aenor': 'https://www.aenor.com/',
      'volvo': 'https://www.volvocars.com/es/',
      'sabadell': 'https://www.bancsabadell.com/',
      'eroski': 'https://www.eroski.es/',
      'sage': 'https://www.sage.com/es-es/',
      'top_digital': 'https://grupotopdigital.es/',
      'tiktok_shop': 'https://seller-es-accounts.tiktok.com/',
      'extrategia': 'https://extrategia.com/',
      'conversia': 'https://www.conversia.es/'
    }
    vm.patron = '';
    if($stateParams.id){
      if(webs.hasOwnProperty($stateParams.id)){
        vm.height = $window.innerHeight - 100;
        vm.patron = $sce.trustAsResourceUrl(webs[$stateParams.id]);
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.logged')
    .factory('PartnersTrainingFactory', PartnersTrainingFactory);

  PartnersTrainingFactory.$inject = ['$q', '$http', 'URLS', 'toaster'];

  /** @ngInject */
  function PartnersTrainingFactory($q, $http, URLS, toaster) {
    var factory = {
      get: get
    };
    return factory;

    function get(partnerId) {
      if(typeof partnerId === 'undefined' || !partnerId){
        return;
      }

      var deferred = $q.defer();
      var settings = {
        method: 'GET',
        url: '../app/logged/partners_training/partners_training_v1.json',
        cache: false
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          deferred.resolve(data.data);
        } else {
          httpError();
        }
      }
      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible publicar esta oferta',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('PartnersTrainingController', PartnersTrainingController)

  PartnersTrainingController.$inject = ['$stateParams', 'PartnersTrainingFactory'];

  /** @ngInject */
  function PartnersTrainingController($stateParams, PartnersTrainingFactory) {
    var vm = this;
    vm.partner = {};
    if($stateParams.id){
      vm.loading = true;
      PartnersTrainingFactory.get($stateParams.id).then(partnerOk).finally(function () {
        vm.loading = false;
      });
    }
    function partnerOk(data){
      if(data.hasOwnProperty($stateParams.id)){
        vm.partner = data[$stateParams.id];
      }
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.logged')
    .factory('NewsFactory', NewsFactory);

  NewsFactory.$inject = ['$q', '$http', 'toaster', 'store'];

  /** @ngInject */
  function NewsFactory($q, $http, toaster, store) {
    var factory = {
      get: get
    };
    return factory;

    ////////////////
    function get(page) {
      var deferred = $q.defer();
      (page) ? page : 1;

      var settings = {
        method: 'GET',
        url: 'https://cepymenews.es/wp-json/wp/v2/posts?callback=JSON_CALLBACK',
        cache: false,
        params: {
          per_page: 20,
          page: page,
          categories_exclude: [4594]
        },
        skipAuthorization: true
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if(typeof data !== 'undefined' && typeof data.data !== 'undefined') {
          if(!page || page == 1) {
            var articles = [];
            var article = {};
            for (var index = 0; index < data.data.length; index++) {
               article = {};
               article.title = {rendered: data.data[index].title.rendered};
               article.featured_image_thumbnail_url = data.data[index].featured_image_thumbnail_url;
               article.date = data.data[index].date;
               article.link = data.data[index].link;
               article.excerpt = {rendered: data.data[index].excerpt.rendered};
               articles.push(article);
            }
            store.set('news', articles);
          }
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible cargar las noticias. Te mostramos las últimas guardadas en tu navegador',
          showCloseButton: true,
          timeout: 2000
        });
        var articles = store.get('news') || [];
        if(!page || page == 1 && articles.length) deferred.resolve(articles);
        else deferred.reject('error');
      }
    }
  }
})();
(function () {
  'use strict';

  angular.module('app.logged')
    .controller('NewsController', NewsController)

  NewsController.$inject = ['$scope', 'NewsFactory', 'store'];

  /** @ngInject */
  function NewsController($scope, NewsFactory, store) {
    var vm = this;
    var page = 1;
    var articles = store.get('news') || [];
    vm.articles = angular.copy(articles);

    vm.viewMore = function () {
      vm.loading = true;
      NewsFactory.get(page).then(newsOk).finally(function () {
        vm.loading = false;
      });
    }
    vm.viewMore();
    function newsOk(data) {
      if(page == 1) vm.articles = [];
      vm.articles = vm.articles.concat(data);
      page++;
    }

  }


})();

(function () {
  'use strict';

  angular
    .module('app.logged')
    .factory('OffersFactory', OffersFactory);

  OffersFactory.$inject = ['$q', '$http', 'URLS', 'toaster', 'Upload'];

  /** @ngInject */
  function OffersFactory($q, $http, URLS, toaster, Upload) {
    var factory = {
      send: send
    };
    return factory;

    function send(offer) {
      if(typeof offer.price !== 'undefined' && !offer.price) delete offer.price;
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'offers',
        cache: false,
        data: offer
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        Upload.upload(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Oferta publicada correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible publicar esta oferta',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }
  }
})();
(function () {
  'use strict';

  angular.module('app.logged')
    .controller('OffersController', OffersController)

  OffersController.$inject = ['$stateParams', 'BroadcastFactory'];

  /** @ngInject */
  function OffersController($stateParams, BroadcastFactory) {
    if($stateParams.id) BroadcastFactory.send('sideBarEvent', { type: 13, id: $stateParams.id, data: false, noStats: true });
  }

})();

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('MyWebController', MyWebController)

  MyWebController.$inject = [];

  /** @ngInject */
  function MyWebController() {
    var vm = this;
    vm.text = 'Mi web';
  }

})();

( function () {
  'use strict';

  angular.module( 'app.logged' )
         .controller( 'MapController', MapController );

  MapController.$inject = [ 'DirectoryFactory', 'CompaniesFactory', 'ProvincesFactory', 'YEARS' ];

  /** @ngInject */
  function MapController ( DirectoryFactory, CompaniesFactory, ProvincesFactory, YEARS ) {
    var vm = this;
    vm.years = YEARS.ALL;
    vm.companies = [];
    vm.total = 0;

    var resetParams = function ( key, value ) {
      vm.params = {
        cnae_id       : '',
        province_id   : '',
        random        : 0,
        q             : '',
        active        : 1,
        company_id    : '',
        withJobContact: '',
        page          : 1,
        limit         : 20,
        year          : YEARS.ACTUAL
      };
      if ( typeof key !== "undefined" && key ) {
        vm.params[ key ] = value;
        if ( key === "company_id" ) vm.params[ "year" ] = "all";
      }
    };
    resetParams();

    vm.mapCenter = { latitude: 42.7999285, longitude: -8.0177344 };
    vm.markerOptions = { icon: 'https://d3cbxno87ymraz.cloudfront.net/app/assets/images/marker.png' };
    vm.window = {
      marker    : {},
      show      : false,
      closeClick: function () {
        this.show = false;
      },
      options   : {} // define when map is ready
    };
    vm.markersEvents = {
      click: function ( marker, eventName, model ) {
        vm.window.model = model;
        vm.window.show = true;
      }
    };
    vm.handleCompanySelection = function (companyId) {
      vm.params.company_id = companyId;
      vm.getCompanies();
    };
    /*
    CompaniesFactory.getCompanies().then( function ( companiesSelect ) {
      vm.companiesSelect = companiesSelect;
    } );
    */
    vm.provincesSelect = ProvincesFactory.getProvinces();

    vm.getCompanies = function ( search ) {
      vm.loading = true;
      if ( search ) vm.params.page = 1;
      if ( vm.params.company_id ) resetParams( "company_id", vm.params.company_id );
      vm.window.show = false;
      DirectoryFactory.getCompanies( vm.params ).then( function ( companies ) {
        vm.total = companies.total;
        var addresses = [];
        for ( var index = 0; index < companies.data.length; index++ ) {
          var element = companies.data[ index ];
          element.principal_address.latitude = element.principal_address.lat;
          element.principal_address.longitude = element.principal_address.lng;
          element.principal_address.name = element.name;
          element.principal_address.id = element.id;
          addresses.push( element.principal_address );
        }
        vm.addresses = addresses;
        vm.mapReady = true;
      }, function () {
      } ).finally( function () {
        vm.loading = false;
      } )
    };
    vm.getCompanies();
  }
} )();

(function () {
  'use strict';

  angular
    .module('app.logged')
    .factory('MailboxFactory', MailboxFactory);

  MailboxFactory.$inject = ['$q', '$http', 'URLS', 'toaster', 'Upload'];

  /** @ngInject */
  function MailboxFactory($q, $http, URLS, toaster, Upload) {
    var factory = {
      get: get,
      getPartners: getPartners,
      getFolderUnread: getFolderUnread,
      getTagUnread: getTagUnread,
      markReadUnread: markReadUnread,
      getThread: getThread,
      move: move,
      send: send,
      sendReply: sendReply,
      getIdsObject: getIdsObject
    };
    return factory;

    function getIdsObject(object) {
      var keys = Object.keys(object);
      var ids = [];
      for (var index = 0; index < keys.length; index++) {
        if (object[keys[index]] == true) ids.push(parseInt(keys[index]));
      }
      return ids
    }

    function send(mail, filters) {
      if(
        filters.cnae.length ||
        filters.province.length ||
        filters.sector.length
      ){
        mail.to = 'all';
        mail.cnae = filters.cnae;
        mail.province = filters.province;
        mail.sector = filters.sector;
      }
      var deferred = $q.defer();
      var settings = {
        url: URLS.API + 'messages',
        data: mail,
        method: 'POST',
        // withCredentials: true,
        cache: false
      }
      return http()

      function http() {
        Upload.upload(settings)
          .then(httpOk, httpError);
        return deferred.promise
      }

      function httpOk(data) {
        if(data && data.hasOwnProperty('status') && (data.status === 200 || data.status === 201)) {
          toaster.pop({
            type: 'success',
            title: 'OK',
            body: 'Mensaje enviado correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible enviar el mensaje',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');

      }
    }

    function sendReply(id, reply) {
      var deferred = $q.defer();
      var settings = {
        url: URLS.API + 'messages/' + id,
        data: reply,
        method: 'POST',
        // withCredentials: true,
        cache: false
      }
      return http()

      function http() {
        Upload.upload(settings)
          .then(httpOk, httpError);
        return deferred.promise
      }

      function httpOk(data) {
        toaster.pop({
          type: 'success',
          title: 'OK',
          body: 'Respuesta enviado correctamente',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.resolve(data);
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible enviar el mensaje',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');

      }
    }

    function get(page, folder, tag, search) {
      var deferred = $q.defer();

      var settings = {
        method: 'GET',
        url: URLS.API + 'messages',
        cache: false,
        params: {
          folder: folder,
          tag: tag,
          search: search,
          page: page
        }
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        deferred.resolve(data.data);
      }

      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar los mensajes',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function getPartners() {
      var deferred = $q.defer();

      var settings = {
        method: 'GET',
        url: URLS.API + 'messages/partners',
        cache: false
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        deferred.resolve(data.data);
      }

      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar los mensajes',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function getThread(id) {
      var deferred = $q.defer();

      var settings = {
        method: 'GET',
        url: URLS.API + 'messages/' + id,
        cache: false
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {

        if(typeof data !== 'undefined' && typeof data.data !== 'undefined' && typeof data.data.data !== 'undefined' && data.data.data.length) {
          deferred.resolve(data.data.data);
        }
        else httpError();
      }

      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar el mensaje',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function getFolderUnread() {
      var deferred = $q.defer();

      var settings = {
        method: 'GET',
        url: URLS.API + 'messages/folders',
        cache: false
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if(typeof data !== 'undefined' && data && data.data !== 'undefined') deferred.resolve(data.data);
        else deferred.reject('error');
      }

      function httpError() {
        deferred.reject('error');
      }
    }

    function getTagUnread() {
      var deferred = $q.defer();

      var settings = {
        method: 'GET',
        url: URLS.API + 'messages/tags',
        cache: false
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if(typeof data !== 'undefined' && data && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else deferred.reject('error');
      }

      function httpError() {
        deferred.reject('error');
      }
    }

    function markReadUnread(type, ids) {
      var deferred = $q.defer();
      var settings = {
        url: URLS.API + 'messages/markReadUnread',
        data: {
          thread: ids,
          read: type
        },
        method: 'POST',
        // withCredentials: true,
        cache: false
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);
        return deferred.promise
      }

      function httpOk(data) {
        toaster.pop({
          type: 'success',
          title: 'OK',
          body: 'Mensaje movido correctamente',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.resolve(data);
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mover este mensaje',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');

      }
    }

    function move(folder, ids) {
      var deferred = $q.defer();
      var settings = {
        url: URLS.API + 'messages/moveToFolder',
        data: {
          thread: ids,
          folder: folder
        },
        method: 'POST',
        // withCredentials: true,
        cache: false
      }
      return http()

      function http() {
        Upload.upload(settings)
          .then(httpOk, httpError);
        return deferred.promise
      }

      function httpOk(data) {
        toaster.pop({
          type: 'success',
          title: 'OK',
          body: 'Mensaje movido correctamente',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.resolve(data);
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mover este mensaje',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');

      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('MailboxController', MailboxController)

  MailboxController.$inject = ['$scope', 'MailboxFactory', 'BroadcastFactory'];

  /** @ngInject */
  function MailboxController($scope, MailboxFactory, BroadcastFactory) {
    var vm = this;
    vm.page = 1;
    vm.total = 0;
    /*
    folder: 'inbox', 'send', 'trash', 'important'
    tag: 'event_invitation', 'special_offer', 'comunication_cepyme500', 'collaborative_projects', 'startup_presentation'
    */
    vm.folder = 'inbox';
    vm.tag = '';
    vm.search = '';
    vm.text = 'ListController';

    vm.getList = function () {
      vm.loading = true;
      MailboxFactory.get(vm.page, vm.folder, vm.tag, vm.search).then(function (messages) {
        for (var index = 0; index < messages.data.length; index++) {
          for (var indexM = 0; indexM < messages.data[index].recipients.length; indexM++) {
            var element = messages.data[index].recipients[indexM];
            if(element.id == messages.data[index].last.company_id) {
              messages.data[index].last_sender = element;
              messages.data[index].recipients.splice(indexM, 1);
            }
          }
        }
        vm.messages = messages.data;
        vm.total = messages.total;
      }, function () {

      }).finally(function () {
        vm.loading = false;
      });
    }

    vm.getList();

    vm.changeSearch = function () {
      vm.getList();
    }


    /*
    type 1: folder; 2: tag
    */
    vm.changeType = function (type, name) {

      if (type === 1) {
        vm.folder = name;
        vm.tag = '';
      }
      if (type === 2) {
        vm.folder = '';
        vm.tag = name;
      }
      vm.getList();
    }

    vm.changeMailFolder = function (type) {
      if (typeof vm.check !== 'undefined' && !angular.equals(vm.check, {})) {
        var ids = MailboxFactory.getIdsObject(vm.check);
        MailboxFactory.move(type, ids).then(function () {
          /*
          if we want to set messages to read when messages move to trash
          if(type === 'trash') {
            console.log(type);
          }
          */
          vm.getList();
        });
      }
    }

    vm.markRead = function (index, type) {
      if (!index && index !== 0) {
        if (typeof vm.check !== 'undefined' && !angular.equals(vm.check, {})) {
          var ids = MailboxFactory.getIdsObject(vm.check);
          MailboxFactory.markReadUnread(type, ids).then(function () {
            for (var index = 0; index < vm.messages.length; index++) {
              var sendNotifyMailActivate = false;
              if (ids.indexOf(vm.messages[index].id) > -1) {
                if (type) {
                  if(vm.messages[index].unread) {
                    vm.messages[index].unread = false;
                    sendNotifyMailActivate = true;
                  }
                } else {
                  if(!vm.messages[index].unread) {
                    vm.messages[index].unread = true;
                    sendNotifyMailActivate = true;
                  }
                }
                if(sendNotifyMailActivate) {
                  var sendNotifyMail = {
                    is_read: type,
                    tag    : vm.tag,
                    folder : vm.folder
                  };
                  BroadcastFactory.send( 'topNavBarMail', sendNotifyMail );
                }

              }
            }
          });
        }
      } else vm.messages[index].unread = false;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('MagazineController', MagazineController)

  MagazineController.$inject = ['YEARS', '$sce'];

  /** @ngInject */
  function MagazineController(YEARS, $sce) {
    var vm = this;
    vm.year = YEARS.ACTUAL;
    vm.magazines = [
      "https://www.yumpu.com/es/embed/view/etqKXgQpYc763HAy",
      "https://www.yumpu.com/es/embed/view/MqSFp4uOGKaBrJwc",
      "https://www.yumpu.com/es/embed/view/TpUdqf7DrXYtaEGR",
      "https://www.yumpu.com/es/embed/view/mWSgMTIds4EkPrX8",
      "https://www.yumpu.com/es/embed/view/6jlN0t9QorYJI8BU",
      "https://www.yumpu.com/es/embed/view/j9cFWix3ITkyw15Y",
      "https://www.yumpu.com/es/embed/view/BIJFjhgWlSG9aTmL",
      "https://www.yumpu.com/es/embed/view/X14fI7yTHBZeh8zL"
    ];

    vm.trustSrc = function(src) {
      return $sce.trustAsResourceUrl(src);
    }

  }

})();

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('HomeController', HomeController)
    .controller('CountriesController', CountriesController)

  HomeController.$inject = ['$scope', 'DirectoryFactory', 'PressReleaseFactory', 'EventsFactory', 'moment', 'AdvertisersFactory', 'MailboxFactory', 'YEARS'];
  CountriesController.$inject = ['$scope', '$rootScope', '$stateParams', '$timeout', 'DirectoryFactory', 'YEARS'];

  /** @ngInject */
  function HomeController($scope, DirectoryFactory, PressReleaseFactory, EventsFactory, moment, AdvertisersFactory, MailboxFactory, YEARS) {
    var vm = this;
    vm.countriesActive = false;
    vm.activeTab = 1;
    vm.tabsSearch = '';
    vm.advertisers = [];
    vm.messages = [];
    var date_from = '';
    var date_to = '';
    vm.yearActual = YEARS.ACTUAL;
    vm.map = {
      mapCenter: { latitude: 42.7999285, longitude: -8.0177344 },
      markerOptions: { icon: 'https://d3cbxno87ymraz.cloudfront.net/app/assets/images/marker.png' },
      addresses: [],
      window: {
        marker: {},
        show: false,
        closeClick: function () {
          this.show = false;
        },
        options: {} // define when map is ready
      },
      markersEvents: {
        click: function (marker, eventName, model) {
          vm.map.window.model = model;
          vm.map.window.show = true;
        }
      }
    };

    MailboxFactory.getPartners().then(function (messages) {
      if(messages.data.length) {
        if(messages.data.length > 4) messages.data = messages.data.slice(0, 4);
        vm.messages = messages.data;
      }
    }, function () {

    }).finally(function () {
      vm.loading = false;
    });

    vm.viewMore = function (type) {
      if (type == 1 || !type) {
        vm.loadingCompanies = true;
        DirectoryFactory.getCompanies({ random: 1, active: 1, q: vm.tabsSearch, year: YEARS.ACTUAL}).then(function (data) {
          if (data.data.length > 5) vm.companies = data.data.slice(0, 5);
          else vm.companies = data.data;
          var addresses = [];
          for (var index = 0; index < data.data.length; index++) {
            var element = data.data[index];
            element.principal_address.latitude = element.principal_address.lat;
            element.principal_address.longitude = element.principal_address.lng;
            element.principal_address.name = element.name;
            addresses.push(element.principal_address);
          }
          vm.map.addresses = addresses;
          vm.map.mapReady = true;
        }).finally(function () {
          vm.loadingCompanies = false;
        });
      }
      if (type == 2 || !type) {
        vm.loadingContacts = true;
        DirectoryFactory.getContacts({ random: 1, default: 1, q: vm.tabsSearch, year: YEARS.ACTUAL }).then(function (data) {
          if(typeof data !== 'undefined' && data && typeof data.data !== 'undefined' && data && data.data.length) {
            if (data.data.length > 5) vm.contacts = data.data.slice(0, 5);
            else vm.contacts = data.data;
          } else vm.contacts = [];
        }).finally(function () {
          vm.loadingContacts = false;
        });
      }
      if (type == 3 || !type) {
        vm.loadingPR = true;
        PressReleaseFactory.get().then(function (data) {
          if (data.data.length > 10) vm.preleases = data.data.slice(0, 10);
          else vm.preleases = data.data;
        }).finally(function () {
          vm.loadingPR = false;
        });
      }
    };
    vm.viewMore();

    function loadEvents() {
      date_from = moment(new Date()).format('YYYY-MM-DD');
      date_to = moment().add(+2, 'months').format('YYYY-MM-DD');
      vm.loadingEvents = true;
      EventsFactory.get({ date_from: date_from, date_to: date_to }).then(function (events) {
        if (events.data.length > 0) {
          if (events.data.length > 5) events.data.splice(0, events.data.length - 5);
          for (var index = 0; index < events.data.length; index++) {
            events.data[index].dateFrom = moment(events.data[index].date_from).format('D MMM HH:mm');
          }
          vm.events = events.data;
        }
      }).finally(function () {
        vm.loadingEvents = false;
      });
    }
    loadEvents();

    function loadAdvertisers() {
      vm.loadingAdvertisers = true;
      AdvertisersFactory.getAdvertisers({ status: 'active' })
        .then(function (advertisers) {
          if (advertisers.data.length > 0) {
            if (advertisers.data.length > 5) advertisers.data.splice(0, 5);
          }
          vm.advertisers = advertisers.data;
        })
        .finally(function () {
          vm.loadingAdvertisers = false;
        });
    }
    loadAdvertisers();
  }

  /** @ngInject */
  function CountriesController($scope, $rootScope, $stateParams, $timeout, DirectoryFactory, YEARS) {
    var vm = this;
    var timeout;
    vm.companies = [];
    if (typeof $stateParams.code !== 'undefined' && $stateParams.code) {
      $scope.Home.countriesActive = true;
      vm.country = $stateParams.code;
      vm.loading = true;
      DirectoryFactory.getCompanies({ country_market: vm.country, random: 1, fields: 'id,name', year: YEARS.ACTUAL }).then(function (data) {
        vm.companies = data.data;
      }).finally(function () {
        vm.loading = false;
      })
      timeout = $timeout(function () {
        $rootScope.$broadcast('mapRegionSelected', { code: $stateParams.code });
      }, 500);
    }
    $scope.$on('$destroy', function () {
      $timeout.cancel(timeout);
    })
  }

})();

(function () {
  'use strict';

  angular
    .module('app.logged')
    .factory('DirectoryFactory', DirectoryFactory);

  DirectoryFactory.$inject = ['$q', '$http', 'URLS', 'toaster', 'Upload'];

  /** @ngInject */
  function DirectoryFactory($q, $http, URLS, toaster, Upload) {
    var factory = {
      getCompanies: getCompanies,
      searchCompanies: searchCompanies,
      removeCompany: removeCompany,
      removeContact: removeContact,
      uploadCompanies: uploadCompanies,
      activateCompany: activateCompany,
      deactivateCompany: deactivateCompany,
      getCompany: getCompany,
      getContacts: getContacts,
      getContact: getContact,
      exportCompanies: exportCompanies
    };
    return factory;

    function searchCompanies(searchTerm) {
      var paramsRequest = angular.copy(searchTerm);

      var deferred = $q.defer();
      var settings = {
        method: 'GET',
        url: URLS.API + 'companies/search' + (paramsRequest ? '/' + paramsRequest : ''),
        cache: false
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && data && typeof data.data !== 'undefined' && data.data && angular.isArray(data.data) && data.data.length) {

          /*
          var companies = [];
          if (typeof params !== 'undefined' && params && typeof params.page !== 'undefined' && (params.page || params.page == 1)) {
            companies = companies.concat(data.data.data.slice(0, 10));
            //store.set('companies', companies);
          }
          */
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible cargar las empresas. Te mostramos las últimas guardadas en tu navegador',
          showCloseButton: true,
          timeout: 2000
        });
        /*
        var companies = store.get('companies') || [];
        if (typeof params == 'undefined' && params && typeof params.page !== 'undefined' && (!params.page || params.page == 1) && companies.length) {
          deferred.resolve(companies);
        } else deferred.reject('error');
        */
        deferred.reject('error');
      }
    }


    function uploadCompanies(excel) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'import/companies',
        cache: false,
        data: {
          file: excel
        }
      }
      return http();
      function http() {
        Upload.upload(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') {
          toaster.pop({
            type: 'success',
            title: 'OK',
            body: 'Empresas añadidads',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data.data);
        }
        else httpError();
      }
      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible añadir las empresas',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function activateCompany(id) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'companies/' + id + '/activate',
        cache: false
      }
      return http();
      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'success',
            title: 'OK',
            body: 'Empresa activada',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible activar la empresa',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function deactivateCompany(id) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'companies/' + id + '/deactivate',
        cache: false
      }
      return http();
      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'success',
            title: 'OK',
            body: 'Empresa Desactivada',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible desactivar la empresa',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function removeCompany(id) {
      var deferred = $q.defer();
      var settings = {
        method: 'DELETE',
        url: URLS.API + 'companies/' + id,
        cache: false
      }
      return http();
      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'success',
            title: 'OK',
            body: 'Empresa eleminada',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible eleminar la empresa',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function removeContact(id) {
      var deferred = $q.defer();
      var settings = {
        method: 'DELETE',
        url: URLS.API + 'contacts/' + id,
        cache: false
      }
      return http();
      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'success',
            title: 'OK',
            body: 'Contacto eleminado',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible eleminar el contacto',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    ////////////////
    function getCompany(id) {
      var url = URLS.API + 'companies'
      if (id) url = url + '/' + id;
      var deferred = $q.defer();
      var settings = {
        method: 'GET',
        url: url,
        cache: false
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') {
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar la empresa',
          showCloseButton: true,
          timeout: 4000
        });
        deferred.reject('error');
      }
    }

    ////////////////
    function getContact(id) {
      var deferred = $q.defer();
      var settings = {
        method: 'GET',
        url: URLS.API + 'contacts/' + id,
        cache: false
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') {
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar la empresa',
          showCloseButton: true,
          timeout: 4000
        });
        deferred.reject('error');
      }
    }

    ////////////////
    function getCompanies(params) {
      var paramsRequest = angular.copy(params);
      if(paramsRequest && typeof paramsRequest.province_id !== 'undefined' && paramsRequest.province_id.length) {
        paramsRequest['province_id[]'] = paramsRequest.province_id;
        delete paramsRequest.province_id;
      }
      var deferred = $q.defer();
      var settings = {
        method: 'GET',
        url: URLS.API + 'companies',
        cache: false,
        params: paramsRequest
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && data && typeof data.data !== 'undefined' && data.data && typeof data.data.data !== 'undefined' && angular.isArray(data.data.data) && data.data.data.length) {
          /*
          var companies = [];
          if (typeof params !== 'undefined' && params && typeof params.page !== 'undefined' && (params.page || params.page == 1)) {
            companies = companies.concat(data.data.data.slice(0, 10));
            //store.set('companies', companies);
          }
          */
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible cargar las empresas. Te mostramos las últimas guardadas en tu navegador',
          showCloseButton: true,
          timeout: 2000
        });
        /*
        var companies = store.get('companies') || [];
        if (typeof params == 'undefined' && params && typeof params.page !== 'undefined' && (!params.page || params.page == 1) && companies.length) {
          deferred.resolve(companies);
        } else deferred.reject('error');
        */
        deferred.reject('error');
      }
    }

    function exportCompanies(params) {
      var paramsRequest = angular.copy(params);
      if(paramsRequest && typeof paramsRequest.province_id !== 'undefined' && paramsRequest.province_id.length) {
        paramsRequest['province_id[]'] = paramsRequest.province_id;
        delete paramsRequest.province_id;
      }
      var deferred = $q.defer();
      var settings = {
        method: 'GET',
        url: URLS.API + 'companies/export',
        cache: false,
        params: paramsRequest
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        //  console.log(data);
        if (typeof data !== 'undefined' && data && typeof data.data !== 'undefined' && data.data && typeof data.data.url !== 'undefined' && data.data.url) {
          /*
           var companies = [];
           if (typeof params !== 'undefined' && params && typeof params.page !== 'undefined' && (params.page || params.page == 1)) {
           companies = companies.concat(data.data.data.slice(0, 10));
           //store.set('companies', companies);
           }
           */
          deferred.resolve(data.data.url);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
                      type: 'error',
                      title: 'Error',
                      body: 'No ha sido posible generar el excel',
                      showCloseButton: true,
                      timeout: 2000
                    });
        /*
         var companies = store.get('companies') || [];
         if (typeof params == 'undefined' && params && typeof params.page !== 'undefined' && (!params.page || params.page == 1) && companies.length) {
         deferred.resolve(companies);
         } else deferred.reject('error');
         */
        deferred.reject('error');
      }
    }


    function getContacts(params) {
      var deferred = $q.defer();

      var settings = {
        method: 'GET',
        url: URLS.API + 'contacts',
        cache: false,
        params: params
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && data && typeof data.data !== 'undefined' && data.data && typeof data.data !== 'undefined') {
          /*
          var contacts = store.get('contacts') || [];
          if (typeof params == 'undefined' || typeof params.page == 'undefined' || !params.page || params.page == 1 && data.data.data.length > 0) {
            contacts = contacts.concat(data.data.data.slice(0, 10));
            store.set('contacts', contacts);
          }
          */
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible cargar los contactos. Te mostramos los últimos guardados en tu navegador',
          showCloseButton: true,
          timeout: 2000
        });
        /*
        var contacts = store.get('contacts') || [];
        if (typeof params == 'undefined' || typeof params.page == 'undefined' || !params.page || params.page == 1 && contacts.length) {
          deferred.resolve(contacts);
        } else deferred.reject('error');
        */
        deferred.reject('error');
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('DirectoryController', DirectoryController)
    .controller('CompaniesController', CompaniesController)
    .controller('ContactsController', ContactsController)
  // .controller('CompanyController', CompanyController)
  // .controller('ContactController', ContactController)

  DirectoryController.$inject = ['ProvincesFactory', 'CompaniesFactory', 'CommunitiesFactory', 'YEARS'];
  CompaniesController.$inject = ['$state', '$stateParams', 'BroadcastFactory', 'DirectoryFactory', 'CommunitiesFactory', 'YEARS'];
  ContactsController.$inject = ['$stateParams', 'BroadcastFactory', 'DirectoryFactory', 'YEARS'];
  // CompanyController.$inject = [];
  // ContactController.$inject = [];

  /** @ngInject */
  function DirectoryController(ProvincesFactory, CompaniesFactory, CommunitiesFactory, YEARS) {
    var vm = this;
    vm.years = YEARS.ALL;
    /*
    CompaniesFactory.getCompanies().then(function (companiesSelect) {
      vm.companiesSelect = companiesSelect;
    });
    */
    vm.provincesSelect = ProvincesFactory.getProvinces();
    vm.comunitiesSelect = CommunitiesFactory.getCommunities();

  }

  /** @ngInject */
  function CompaniesController($state, $stateParams, BroadcastFactory, DirectoryFactory, CommunitiesFactory, YEARS) {
    var vm = this;
    vm.companies = [];
    vm.file = {};
    vm.sales = 0;
    vm.linkExport = false;
    var comunities;
    var resetParams = function (key, value) {
      vm.params = {
        province_id: [],
        community_name: '',
        random: 0,
        q: '',
        active: 1,
        withJobContact: '',
        page: 1,
        per_page: 20,
        company_id: '',
        sales_to: '',
        sales_from: '',
        year: YEARS.ACTUAL,
        has_premium: '',
        sector: ''
      };
      if (typeof key !== "undefined" && key) {
        vm.params[key] = value;
        if (key === "company_id") vm.params["year"] = "all";
      }
    };
    resetParams();

    vm.handleCompanySelection = function (companyId) {
      vm.params.company_id = companyId;
      vm.getCompanies();
    };


    vm.cleanFilters = function () {
      resetParams();
    };

    if ($stateParams.id) {
      BroadcastFactory.send('sideBarEvent', {type: 1, id: $stateParams.id, data: false, noStats: true});
    }

    vm.salesSelect = [
      {
        id: 1,
        sales_from: 1,
        sales_to: 20000000,
        name: '1 - 20 M€'
      },
      {
        id: 2,
        sales_from: 20000000,
        sales_to: 30000000,
        name: '20 - 30 M€'
      },
      {
        id: 3,
        sales_from: 30000000,
        sales_to: 50000000,
        name: '30 - 50 M€'
      },
      {
        id: 4,
        sales_from: 50000000,
        sales_to: 100000000,
        name: '50 - 100 M€'
      },
      {
        id: 5,
        sales_from: 100000000,
        sales_to: 150000000,
        name: '100 - 150 M€'
      },
      {
        id: 6,
        sales_from: 150000000,
        sales_to: 9999999999999999,
        name: '> 150 M€'
      }
    ];

    vm.getCompanies = function (search) {
      vm.linkExport = false;
      vm.loading = true;
      if (search) vm.params.page = 1;
      if (vm.params.company_id) resetParams("company_id", vm.params.company_id);
      if (vm.sales) {
        vm.params.sales_from = vm.salesSelect[vm.sales - 1].sales_from;
        vm.params.sales_to = vm.salesSelect[vm.sales - 1].sales_to;
      } else {
        vm.params.sales_from = '';
        vm.params.sales_to = '';
      }
      if (vm.params.community_name) {
        if (!comunities) {
          comunities = CommunitiesFactory.getCommunities();
        }
        for (var i = 0; i < comunities.length; i++) {
          if (comunities[i].name === vm.params.community_name) {
            angular.extend(vm.params.province_id, comunities[i].provinces);
            break;
          }
        }
      }
      //  console.log(vm.params);

      DirectoryFactory.getCompanies(vm.params).then(function (companies) {
        vm.companies = companies;
      }, function () {
        vm.companies = [];
      }).finally(function () {
        vm.loading = false;
      });

    };
    vm.getCompanies();
    /*
     CnaesFactory.getCnaes().then( function ( cnaesSelect ) {
     vm.cnaesSelect = cnaesSelect;
     } );
     */
    vm.remove = function (id, index) {
      DirectoryFactory.removeCompany(id).then(function () {
        vm.companies.data.splice(index, 1);
      });
    };

    vm.changeStatus = function (id, index, deactivate) {
      if (deactivate) {
        DirectoryFactory.deactivateCompany(id).then(function () {
          vm.companies.data[index].active = 0;
        });
      } else {
        DirectoryFactory.activateCompany(id).then(function () {
          vm.companies.data[index].active = 1;
        });
      }

    };

    vm.upLoadfile = function () {
      vm.loadingExcel = true;
      DirectoryFactory.uploadCompanies(vm.file).then().finally(function () {
        vm.loadingExcel = false;
        $state.reload();
      })
    };

    vm.exportSearch = function () {
      vm.loading = true;
      vm.linkExport = false;
      if (vm.params.company_id) resetParams("company_id", vm.params.company_id);
      if (vm.sales) {
        vm.params.sales_from = vm.salesSelect[vm.sales - 1].sales_from;
        vm.params.sales_to = vm.salesSelect[vm.sales - 1].sales_to;
      } else {
        vm.params.sales_from = '';
        vm.params.sales_to = '';
      }
      if (vm.params.community_name) {
        if (!comunities) {
          comunities = CommunitiesFactory.getCommunities();
        }
        for (var i = 0; i < comunities.length; i++) {
          if (comunities[i].name === vm.params.community_name) {
            angular.extend(vm.params.province_id, comunities[i].provinces);
            break;
          }
        }
      }
      DirectoryFactory.exportCompanies(vm.params).then(
        function (data) {
          vm.linkExport = data;

        }
      ).finally(function () {
        vm.loading = false;
      })
    }

    vm.removeFile = function () {
      vm.file = {};
    };
  }

  /** @ngInject */
  function ContactsController($stateParams, BroadcastFactory, DirectoryFactory) {
    var vm = this;
    var resetParams = function (key, value) {
      vm.params = {
        company_id: 0,
        random: 0,
        default: 1,
        page: 1,
        search: ''
        //  year      : YEARS.ACTUAL
      };
      if (typeof key !== "undefined" && key) {
        vm.params[key] = value;
      }
    };
    resetParams();

    vm.handleCompanySelection = function (companyId) {
      vm.params.company_id = companyId;
      vm.getContacts();
    };

    if ($stateParams.id) {
      BroadcastFactory.send('sideBarEvent', {type: 2, id: $stateParams.id, data: false, noStats: true})
    }

    vm.getContacts = function (search) {
      if (search) vm.params.page = 1;
      if (vm.params.company_id) resetParams("company_id", vm.params.company_id);
      vm.loading = true;
      DirectoryFactory.getContacts(vm.params).then(function (contacts) {
        vm.contacts = contacts;
      }, function () {
        vm.contacts = [];
      }).finally(function () {
        vm.loading = false;
      })
    }
    vm.getContacts();

  }

})();

(function () {
  'use strict';

  angular
    .module('app.logged')
    .factory('TVFactory', TVFactory);

  TVFactory.$inject = ['$q', '$http', 'URLS', 'toaster'];

  /** @ngInject */
  function TVFactory($q, $http, URLS, toaster) {
    var factory = {
      get: get,
      send: send,
      remove: remove
    };
    return factory;

    function remove(id) {
      var deferred = $q.defer();
      var settings = {
        method: 'DELETE',
        url: URLS.API + 'videos/' + id,
        cache: false
        //  timeout: deferred.promise,
      }
      return http();
      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Video eliminado correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible eliminar este video',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function send(video, id) {
      var deferred = $q.defer();
      var url = URLS.API + 'videos'
      var method = 'POST';
      if(id) {
        url = url + '/' + id;
        method = 'PUT';
      }
      var settings = {
        method: method,
        url: url,
        cache: false,
        data: video
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Video publicado correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible publicar este video',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }

    }
    ////////////////
    function get(params, id) {
      var deferred = $q.defer();
      var url = URLS.API + 'videos';
      if(!params.company_id) delete params.company_id;
      if (id) url = url + '/' + id;
      var settings = {
        method: 'GET',
        url: url,
        cache: false,
        params: params
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar los videos seleccionados',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }
  }
})();
(function () {
  'use strict';

  angular.module('app.logged')
    .controller('TvController', TvController)

  TvController.$inject = ['$stateParams', 'BroadcastFactory', 'TVFactory', 'CompaniesFactory', '$sce'];

  /** @ngInject */
  function TvController($stateParams, BroadcastFactory, TVFactory, CompaniesFactory, $sce) {
    var videos = [];
    var vm = this;
    vm.videos = [];
    vm.params = {
      company_id: false,
      page: 1
    };
    var live = false;
    if ($stateParams.id) {
      BroadcastFactory.send('sideBarEvent', { type: 11, id: $stateParams.id, data: false, noStats: true });
    }
    vm.handleCompanySelection = function(companyId) {
      vm.params.company_id = companyId;
      vm.viewMore(true, companyId);
    };
    vm.viewMore = function (resetPage, id) {
      vm.loading = true;
      live = false;
      if (resetPage) {
        vm.params.page = 1;
        vm.params.company_id = false;
      }
      if(id) vm.params.company_id = id;
      TVFactory.get(vm.params).then(function (videosData) {
        videos = [];
        vm.live = null;
        vm.total = 0;
        if(videosData.data.length > 0) {
          for (var index = 0; index < videosData.data.length; index++) {
            var element = videosData.data[index];
            var iframe = getId(element.url);
            if(iframe) {
              element.yt_id = $sce.trustAsResourceUrl('//www.youtube.com/embed/' + iframe);
              videos.push(element);
            }
            if(element.live && !live) {
              live = true;
              vm.live = element;
              videos.splice(index, 1);
            }
          }
        }
        vm.videos = videos
        vm.total = videosData.total;
      }, function () {
        vm.live = null;
        vm.videos = [];
        vm.total = 0;
      }).finally(function () {
        vm.loading = false;
      })
    }
    vm.viewMore();

    vm.remove = function(id, index) {
      vm.loading = true;
      TVFactory.remove(id).then(function(){
        vm.videos.splice(index, 1);
      }).finally(function(){
        vm.loading = false;
      });

    }

    function getId(url) {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      if (match && match[2].length == 11) {
        return match[2];
      } else {
        return 'error';
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.logged')
    .factory('EventsFactory', EventsFactory);

  EventsFactory.$inject = ['$q', '$http', 'URLS', 'toaster', 'Upload'];

  /** @ngInject */
  function EventsFactory($q, $http, URLS, toaster, Upload) {
    var factory = {
      get: get,
      send: send
    };
    return factory;

    function send(event, id) {
      var deferred = $q.defer();
      var url = URLS.API + 'events';
      if(id) url = url + '/' + id;
      var settings = {
        method: 'POST',
        url: url,
        cache: false,
        data: event
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        Upload.upload(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Evento publicado correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible publicar este evento',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }

    }
    ////////////////
    function get(params, id) {
      var deferred = $q.defer();
      /*
      date_from
      date_to
      category: event / direct / cepyme500
      company_id
      */
      var url = URLS.API + 'events';
      if(!params.company_id) delete params.company_id;
      if (id) url = URLS.API + 'events/' + id;
      var settings = {
        method: 'GET',
        url: url,
        cache: false,
        params: params
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && data && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar los eventos',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

  }
})();
( function () {
  'use strict';

  angular.module( 'app.logged' )
         .controller( 'EventsController', EventsController )

  EventsController.$inject = [ '$scope', '$window', 'EventsFactory', '$stateParams', 'moment', 'BroadcastFactory', '$rootScope', '$timeout', 'uiCalendarConfig' ];

  /** @ngInject */
  function EventsController ( $scope, $window, EventsFactory, $stateParams, moment, BroadcastFactory, $rootScope, $timeout, uiCalendarConfig ) {
    $window.scrollTo(0, 0);
    var vm = this;
    vm.day_events = [];
    //vm.calendar_events = [];
    var initDateTo = new Date();
    if ( typeof $stateParams !== 'undefined' && $stateParams.hasOwnProperty( "date" ) && $stateParams.date ) {
      initDateTo = $stateParams.date;
    }

    vm.params = {
      date_from : moment( initDateTo ).add( -1, 'months' ).format( 'YYYY-MM-DD' ),
      date_to   : moment( initDateTo ).add( +1, 'months' ).format( 'YYYY-MM-DD' ),
      category  : null,
      company_id: null
    };


    var alertOnEventClick;
    var viewRender;
    var once = false;
    var timeout;
    var timeout2;

    /* type 0:calendar events; 1:my events; 2:today events*/
    var getEvents = function ( type ) {
      var key = 'calendar_events';
      if ( type == 1 ) key = 'my_events';
      else if ( type == 2 ) key = 'today_events';
      vm.loading = true;
      vm[ key ] = [];

      EventsFactory.get( vm.params ).then( function ( events ) {

        if ( events.data.length ) {
          var eventsCalendar = []
          var event = {};
          if ( !type ) {
            for ( var index = 0; index < events.data.length; index++ ) {
              var element = events.data[ index ];
              event = element;
              event.backgroundColor = '#9b59b6';
              if ( event.category == 'cepyme500' ) event.backgroundColor = '#046240';
              else if ( event.category == 'direct' ) event.backgroundColor = '#ed5565';
              else if ( event.category == 'bme' ) event.backgroundColor = '#003d71';
              else if ( event.category == 'bankinter' ) event.backgroundColor = '#e64c13';
              else if ( event.category == 'cepyme' ) event.backgroundColor = '#1abc9c';
              else if ( event.category == 'santander' ) event.backgroundColor = '#EC0000';

              event.start = moment( element.date_from ).format( "YYYY-MM-DDTHH:mm:ss" );
              if ( element.date_to ) event.end = moment( element.date_to ).format( "YYYY-MM-DDTHH:mm:ss" );
              event.allDay = element.all_day;
              eventsCalendar.push( event );
            }
            vm[ key ][ 0 ] = eventsCalendar;
            $timeout( function () {
              uiCalendarConfig.calendars[ "myCalendar" ].fullCalendar( 'removeEvents' );
              if ( eventsCalendar.length ) {
                uiCalendarConfig.calendars[ "myCalendar" ].fullCalendar( 'addEventSource', eventsCalendar );
              }
              uiCalendarConfig.calendars[ "myCalendar" ].fullCalendar( 'refetchEvents' );
            }, 250 );
          } else {
            vm[ key ] = events.data;
          }
        }
      } ).finally( function () {
        once = true;
        vm.loading = false;
      } );
    }

    getEvents();

    /* message on eventClick */
    alertOnEventClick = function ( event ) {
      var eventOk = {
        id           : event.id,
        title        : event.title,
        planner      : event.planner,
        category     : event.category,
        place        : event.place,
        lng          : event.lng,
        lat          : event.lat,
        date_from    : event.date_from,
        date_to      : event.date_to,
        web          : event.web,
        link_register: event.link_register,
        description  : event.description,
        comment      : event.comment,
        company      : event.company,
        image        : event.image,
        all_day      : event.all_day
      };
      var type = 7;
      if ( ( event.company.id == $rootScope.myUser.company.id ) || $rootScope.myUser.group == 'superadmin' ) type = 8;
      BroadcastFactory.send( 'sideBarEvent', { type: type, id: event.id, data: eventOk, noStats: false } );
    };

    viewRender = function ( view ) {
      if ( !once ) {
        timeout = $timeout( function () {
          vm.params.date_from = moment().add( -1, 'months' ).format( 'YYYY-MM-DD' );
          vm.params.date_to = '';
          vm.params.company_id = $rootScope.myUser.company.id;
          getEvents( 1 );
        } );
        timeout2 = $timeout( function () {
          vm.params.date_from = moment( new Date() ).format( 'YYYY-MM-DD' );
          vm.params.date_to = moment().add( 1, 'day' ).format( 'YYYY-MM-DD' );
          vm.params.company_id = '';
          getEvents( 2 );
        }, 250 );
      } else {
        vm.params.date_from = moment( view.start._d ).format( 'YYYY-MM-DD' );
        vm.params.date_to = moment( view.end._d ).format( 'YYYY-MM-DD' );
        vm.params.company_id = '';
        getEvents();
      }

    }

    /* config object */
    vm.uiConfig = {
      calendar: {
        height     : 450,
        editable   : false,
        stick      : true,
        header     : {
          left  : 'prev,next',
          center: 'title',
          right : 'month,agendaWeek,agendaDay'
        },
        lang       : 'es',
        changeYear : true,
        changeMonth: true,
        eventClick : alertOnEventClick,
        viewRender : viewRender,
        defaultDate: moment( initDateTo ).format( 'YYYY-MM-DD' )
      }
    };

    $scope.$on( '$destroy', function () {
      if ( timeout ) $timeout.cancel( timeout );
      if ( timeout2 ) $timeout.cancel( timeout2 );
    } );
  }

} )();

(function () {
  'use strict';

  angular
    .module('app.logged')
    .factory('EmploymentFactory', EmploymentFactory);

  EmploymentFactory.$inject = ['$q', '$http', 'URLS', 'toaster'];

  /** @ngInject */
  function EmploymentFactory($q, $http, URLS, toaster) {
    var factory = {
      get: get,
      send: send,
      getRequests: getRequests,
      sendRequest: sendRequest
    };
    return factory;

    function sendRequest(request, id) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'jobs/' + id + '/requests',
        cache: false,
        data: request
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Candidatura enviada correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible enviar la candidatura',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }

    }

    function send(employ, method) {
      var deferred = $q.defer();
      var url = URLS.API + 'jobs'
      if(method !== 'POST') url = url + '/' + employ.id;
      var settings = {
        method: method,
        url: url,
        cache: false,
        data: employ
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Oferta de empleo actualizada correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible publicar la oferta de empleo',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }

    }
    ////////////////
    function get(params, id_job) {
      var deferred = $q.defer();
      /*
      company_id
      date_from
      date_to
      salary_from
      salary_to
      province_id
      type
      page
      */
      var url = URLS.API + 'jobs';
      if(!params.company_id) delete params.company_id;
      if (id_job) url = URLS.API + 'jobs/' + id_job;
      var settings = {
        method: 'GET',
        url: url,
        cache: false,
        params: params
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar esta oferta de trabajo',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    function getRequests(id) {
      ///jobs/:id/requests
      var deferred = $q.defer();
      var settings = {
        method: 'GET',
        url:  URLS.API + 'jobs/' + id + '/requests',
        cache: false
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        deferred.reject('error');
      }
    }
  }
})();
(function () {
  'use strict';

  angular.module('app.logged')
    .controller('EmploymentController', EmploymentController)

  EmploymentController.$inject = ['jobType', '$rootScope', '$stateParams', 'BroadcastFactory', 'EmploymentFactory'];

  /** @ngInject */
  function EmploymentController(jobType, $rootScope, $stateParams, BroadcastFactory, EmploymentFactory) {
    var vm = this;
    vm.loading = false;
    vm.id = false;
    vm.jobs = [];
    vm.total = 0;
    vm.params = {
      page: 1,
      company_id: false
    };
    if ($stateParams.id && $stateParams.id !== 'compose') {

      EmploymentFactory.get({}, $stateParams.id).then(function (job) {
        BroadcastFactory.send('sideBarEvent', { type: 9, id: false, data: job, noStats: true });
        /*
        if(job.company.id == $rootScope.myUser.company.id) BroadcastFactory.send('sideBarEvent', { type: 10, id: false, data: job, noStats: true });
        else BroadcastFactory.send('sideBarEvent', { type: 9, id: false, data: job, noStats: true });
        */
      });
    } else if($stateParams.id && $stateParams.id === 'compose') BroadcastFactory.send('sideBarEvent', { type: 10, id: $stateParams.id, data: false, noStats: true })
    vm.jobType = jobType;
    vm.viewMore = function (id) {
      vm.loading = true;
      if(id) vm.params.company_id = id;
      else vm.params.company_id = false;
      vm.jobs = [];
      EmploymentFactory.get(vm.params).then(function (data) {
        vm.jobs = data.data;
        vm.total = data.total;
      }).finally(function () {
        vm.loading = false;
      });
    }
    vm.viewMore($rootScope.myUser.company.id);
    vm.active = function (id, active, index) {
      EmploymentFactory.send({ id: id, active: active }, 'PUT').then(function () {
        vm.jobs[index].active = active;
      }, function () {

      })
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('AdvertisersFactory', AdvertisersFactory);

  AdvertisersFactory.$inject = ['$q', '$http', 'URLS', 'toaster'];

  /** @ngInject */
  function AdvertisersFactory($q, $http, URLS, toaster) {
    var factory = {
      getAdvertisers: getAdvertisers,
      addAdvertiser: addAdvertiser,
      changeStatus: changeStatus,
      inactiveAdvertiser: inactiveAdvertiser,
      activateByCode: activateByCode,
      validate: validate

    };
    return factory;

    ////////////////
    function getAdvertisers(params, id) {
      var deferred = $q.defer();
      var url = URLS.API + 'suppliers';
      if(id) url = url + '/' + id;
      var settings = {
        method: 'GET',
        url: url,
        cache: false,
        params: params
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if(!id) {
          if (typeof data !== 'undefined' && data && typeof data.data !== 'undefined' && typeof data.data.data !== 'undefined' && angular.isArray(data.data.data) && data.data.data.length) {
            deferred.resolve(data.data);
          } else httpError();
        } else {
          if (typeof data !== 'undefined' && typeof data.data !== 'undefined'){
            deferred.resolve(data.data);
          } else httpError();
        }
      }

      function httpError() {
        /*
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible cargar los anunciantes',
          showCloseButton: true,
          timeout: 2000
        });
        */
        deferred.reject('error');
      }
    }

    /*
    pay: {
      code
      need_pay
      card_number
      card_exp_month
      card_exp_year
      date expiration
      card_cvc
    }
    */
    ////////////////
    function activateByCode(code, pay) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'suppliers/' + code + '/activate',
        cache: false,
        data: pay
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') {
          toaster.pop({
            type: 'success',
            title: 'OK',
            body: 'Anunciante dado de alta',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible activar a este anunciante',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    ////////////////
    function validate(id) {
      var deferred = $q.defer();
      var settings = {
        method: 'PATCH',
        url: URLS.API + 'suppliers/' + id + '/validates',
        cache: false
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') {
          toaster.pop({
            type: 'success',
            title: 'OK',
            body: 'Anunciante pdte de pago',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible camiar el estado de este anunciante',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    ////////////////
    function inactiveAdvertiser(id) {
      var deferred = $q.defer();
      var settings = {
        method: 'POST',
        url: URLS.API + 'suppliers/' + id + '/inactive',
        cache: false
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') {
          toaster.pop({
            type: 'success',
            title: 'OK',
            body: 'Anunciante desactivado correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible desactivar este anunciante',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    ////////////////
    function changeStatus(id) {
      var deferred = $q.defer();
      var settings = {
        method: 'PATCH',
        url: URLS.API + 'suppliers/' + id + '/activate',
        cache: false
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'success',
            title: 'OK',
            body: 'Anunciante activado correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible activar este anunciante',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

    ////////////////
    function addAdvertiser(advertiser, id) {
      var deferred = $q.defer();
      var method = 'POST';
      var url = URLS.API + 'suppliers';
      if(id) {
        method = 'PATCH';
        url = url + '/' + id;
      }
      var settings = {
        method: method,
        url: url,
        cache: false,
        data: advertiser
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'success',
            title: 'OK',
            body: 'Anunciante guardado correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data.data);
        }
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible guarda este anunciante',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }
    }

  }
})();
(function () {
  'use strict';

  angular.module('app.logged')
    .controller('AdvertisersController', AdvertisersController)

    AdvertisersController.$inject = ['AdvertisersFactory', '$rootScope'];

  /** @ngInject */
  function AdvertisersController(AdvertisersFactory, $rootScope) {
    var vm = this;
    vm.params = {
      page: 1,
      search: '',
      catalog: false,
      online: false,
      status: 'active'
    };
    if($rootScope.myUser.group == 'admin' || $rootScope.myUser.group == 'superadmin') vm.params.status = '';
    vm.advertisers = [];
    vm.total = 0;

    vm.getAdvertisers = function (search) {
      if(search) vm.params.page = 1;
      vm.loading = true;
      AdvertisersFactory.getAdvertisers(vm.params)
        .then(function (advertisers) {
          vm.advertisers = advertisers.data;
          vm.total = advertisers.total;
        }, function () {
          vm.advertisers = [];
          vm.total = 0;
        })
        .finally(function () {
          vm.loading = false;
        });
    };
    vm.getAdvertisers();
    /*0:activate; 1:validate(pending); 2: inactive*/
    vm.changeStatus = function (id, activate, index) {
      if(!activate) {
        vm.loadingStatus = true;
        AdvertisersFactory.changeStatus(id).then(function () {
          vm.advertisers[index].status = 'active';
        }).finally(function () {
          vm.loadingStatus = false;
        });
      } else if (activate == 2) {
        AdvertisersFactory.inactiveAdvertiser(id).then(function () {
          vm.advertisers[index].status = 'inactive';
        }).finally(function () {
          vm.loadingStatus = false;
        });
      } else if (activate == 1) {
        vm.loadingStatus = true;
        AdvertisersFactory.validate(id).then(function () {
          vm.advertisers[index].status = 'pending';
        }).finally(function () {
          vm.loadingStatus = false;
        });
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('AdsFactory', AdsFactory);

  AdsFactory.$inject = ['$q', '$http', 'URLS', 'toaster', 'Upload'];

  /** @ngInject */
  function AdsFactory($q, $http, URLS, toaster, Upload) {
    var factory = {
      getBanners: getBanners,
      getPositions: getPositions,
      sendBanner: sendBanner,
      sendPosition: sendPosition,
      remove: remove
    };
    return factory;

    function remove(id, position) {
      var deferred = $q.defer();
      var url = URLS.API + 'blocks/' + id;
      if (position) url = URLS.API + 'blocks/positions/' + id;
      var settings = {
        method: 'DELETE',
        url: url,
        cache: false
      }
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError);
        return deferred.promise
      }
      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible mostrar los eventos',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }

    }

    function sendPosition(position, id) {
      var deferred = $q.defer();
      var url = URLS.API + 'blocks/positions';
      var method = 'POST';
      if (id && id != 0) {
        url = url + '/' + id
        method = 'PUT'
      }
      var settings = {
        method: method,
        url: url,
        cache: false,
        data: position
        //  timeout: deferred.promise,
      }
      return http();
      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise;
      }

      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Posición publicado correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible publicar esta posición',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }

    }

    function sendBanner(banner, id) {
      var deferred = $q.defer();
      var url = URLS.API + 'blocks';
      var method = 'POST';
      if (id && id != 0) url = url + '/' + id;
      var settings = {
        method: method,
        url: url,
        cache: false,
        data: banner
        //  timeout: deferred.promise,
      }
      return http();

      function http() {
        Upload.upload(settings)
          .then(httpOk, httpError);

        return deferred.promise;
      }
      function httpOk(data) {
        if (typeof data !== 'undefined') {
          toaster.pop({
            type: 'ok',
            title: 'OK',
            body: 'Banner publicado correctamente',
            showCloseButton: true,
            timeout: 2000
          });
          deferred.resolve(data);
        } else {
          httpError();
        }
      }
      function httpError() {

        toaster.pop({
          type: 'error',
          title: 'Error',
          body: 'No ha sido posible publicar este banner',
          showCloseButton: true,
          timeout: 2000
        });
        deferred.reject('error');
      }

    }

    ////////////////
    function getBanners(params, id) {
      var deferred = $q.defer();
      /*
      page
      limit
      */
      var url = URLS.API + 'blocks';
      if (id) url = URLS.API + 'blocks/' + id;
      var settings = {
        method: 'GET',
        url: url,
        cache: false,
        params: params
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        deferred.reject('error');
      }
    }

    ////////////////
    function getPositions(params, id) {
      var deferred = $q.defer();
      /*
      page
      limit
      */
      var url = URLS.API + 'blocks/positions';
      if (id) url = URLS.API + 'blocks/positions/' + id;
      var settings = {
        method: 'GET',
        url: url,
        cache: false,
        params: params
        //  timeout: deferred.promise,
      }
      return http()

      function http() {
        $http(settings)
          .then(httpOk, httpError);

        return deferred.promise
      }

      function httpOk(data) {
        if (typeof data !== 'undefined' && typeof data.data !== 'undefined') deferred.resolve(data.data);
        else httpError();
      }

      function httpError() {
        deferred.reject('error');
      }
    }

  }
})();
(function () {
  'use strict';

  angular.module('app.logged')
    .controller('AdsController', AdsController)

  AdsController.$inject = ['$scope', '$window', 'AdsFactory', '$q', '$state'];

  /** @ngInject */
  function AdsController($scope, $window, AdsFactory, $q, $state) {
    var vm = this;
    var toParamsCtrl = {};
    var toStateCtrl;
    vm.params = {
      page: 1,
      limit: 200
    };
    vm.banners = {
      total: 0,
      data: []
    };
    vm.positions = {
      total: 0,
      data: []
    };
    vm.getBanners = function (callback) {
      vm.loading = true;
      if(callback) vm.loadingEdit = true;
      AdsFactory.getBanners(vm.params).then(function (banners) {
        vm.banners = banners;
        if(callback) callback();
      }).finally(function () {
        vm.loading = false;
        vm.loadingEdit = false;
      });
    };

    vm.getPositions = function (callback) {
      vm.loading = true;
      if(callback) vm.loadingEdit = true;
      AdsFactory.getPositions(vm.params).then(function (positions) {
        vm.positions = positions;
        if(callback) callback();
      }).finally(function () {
        vm.loading = false;
        vm.loadingEdit = false;
      });
    };

    vm.positionSubmit = function (form) {
      if (form.$valid) {
        vm.loadingEdit = true;
        AdsFactory.sendPosition(vm.position, toParamsCtrl.id).then(function (position) {
          if(!toParamsCtrl.id || toParamsCtrl.id == 0) vm.positions.data.push(position.data);
          else {
            var index = getElementIndexById('positions', toParamsCtrl.id);
            if(index > -1) vm.positions.data[index] = position.data;
          }
        }).finally(function () {
          vm.loadingEdit = false;
        });
      }
    }

    vm.bannerSubmit = function (form) {
      if (form.$valid) {
        vm.loadingEdit = true;
        AdsFactory.sendBanner(vm.banner, toParamsCtrl.id).then(function (banner) {
          if(!toParamsCtrl.id || toParamsCtrl.id == 0) vm.banners.data.push(banner.data);
          else {
            var index = getElementIndexById('banners', toParamsCtrl.id);
            if(index > -1) vm.banners.data[index] = banner.data;
          }
          vm.banner.image = {};
          vm.banner.imageOld = banner.data.image
        }).finally(function () {
          vm.loadingEdit = false;
        });
      }
    };

    vm.removeElement = function (id, index, type) {
      vm.loadingRemove = true;
      var typeSend = true;
      if(type == 'banners') typeSend = false;
      AdsFactory.remove(id, typeSend).then(function () {
        vm[type].data.splice(index, 1);
      }).finally(function () {
        vm.loadingRemove = false;
      })
    }

    vm.removeFile = function () {
      vm.banner.image = {};
    };

    function getbannerIdFromPosition(array, id) {
      for (var index = 0; index < array.length; index++) {
        var element = array[index].positions;
        for (var indexJ = 0; indexJ < element.length; indexJ++) {
          var position = element[indexJ];
          if (position.id == id) return array[index].id;
        }
      }
    }

    function getElementbyId(key, id) {
      var deferred = $q.defer();
      for (var index = 0; index < vm[key].data.length; index++) {
        var element = vm[key].data[index];
        if (element.id == id) {
          deferred.resolve(element);
          return deferred.promise;
        }
      }
      if(key == 'banners') {
        AdsFactory.getBanners({}, id).then(function (data) {
          deferred.resolve(data);
        }, function () {
          deferred.reject('error');
        });
      } else {
        AdsFactory.getPositions({}, id).then(function (data) {
          deferred.resolve(data);
        }, function () {
          deferred.reject('error');
        });
      }
      return deferred.promise

    }

    function getElementIndexById(key, id) {
      for (var index = 0; index < vm[key].data.length; index++) {
        var element = vm[key].data[index];
        if (element.id == id) return index;
      }
      return -1;
    }

    function process() {
      if (!angular.equals({}, toParamsCtrl)) {
        if (toParamsCtrl.id != 0) {
          if (toStateCtrl.name == 'app.logged.ads.positions.edit') {
            var banner_id = getbannerIdFromPosition(vm.banners.data, toParamsCtrl.id);
            vm.position = {
              id: toParamsCtrl.id,
              title: '',
              block_id: banner_id
            };
            getElementbyId('positions', toParamsCtrl.id).then(function (data) {
              vm.position.title = data.title;
            }, function () {
              $state.go('app.logged.ads.positions');
            });
          } else {
            getElementbyId('banners', toParamsCtrl.id).then(function (data) {
              var element = data;
              var ids = [];
              for (var index = 0; index < element.positions.length; index++) {
                if (element.positions.length) ids.push(element.positions[index].id);
              }
              vm.banner = element;
              vm.banner = {
                id: toParamsCtrl.id,
                title: element.title,
                url: element.url,
                positions: ids,
                imageOld: element.image,
                image: {},
                active: element.active
              };
            }, function () {
              $state.go('app.logged.ads.banners');
            });
          }
        } else {
          if (toStateCtrl.name == 'app.logged.ads.positions.edit') {
            vm.position = {
              id: '',
              title: '',
              block_id: ''
            };
          } else {
            vm.banner = {
              id: '',
              title: '',
              url: '',
              image: {},
              active: 1,
              positions: []
            };
          }
        }
      } else {
        vm.params.page = 1;
      }
    }

    $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
      toParamsCtrl = toParams;
      toStateCtrl = toState;
      $window.scrollTo(0, 0);
      vm.getBanners(process);
      vm.getPositions(process);
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('SidebarController', SidebarController);

  SidebarController.$inject = ['$scope', '$rootScope', '$state', 'URLS', '$window', '$document', '$timeout', 'SUMMERNOTE', 'PressReleaseFactory', '$translate', 'StatsFactory', '$location', '$anchorScroll', 'deviceDetector', 'jobType', '$filter', 'ProvincesFactory', 'CnaesFactory', 'EmploymentFactory', 'DirectoryFactory', 'CompaniesFactory', 'MailboxFactory', 'TVFactory', 'StartupsFactory', 'EventsFactory', 'moment', 'OffersFactory', 'ProjetcsFactory', 'AdvertisersFactory', 'BroadcastFactory'];

  /** @ngInject */
  function SidebarController($scope, $rootScope, $state, URLS, $window, $document, $timeout, SUMMERNOTE, PressReleaseFactory, $translate, StatsFactory, $location, $anchorScroll, deviceDetector, jobType, $filter, ProvincesFactory, CnaesFactory, EmploymentFactory, DirectoryFactory, CompaniesFactory, MailboxFactory, TVFactory, StartupsFactory, EventsFactory, moment, OffersFactory, ProjetcsFactory, AdvertisersFactory, BroadcastFactory) {
    var vm = this;
    var url;
    var stateSidebar;
    var stateSidebarOld;
    var reload = false;
    var type_device;
    var timeoutPaste = null;

    var sideBarEventListener = $rootScope.$on('sideBarEvent', function (event, data) {
      stateSidebarOld = $state.current.name || 'app.logged.home';
      event.preventDefault();
      $scope.$apply(function () {
        vm.type = data.type;
      });
      var id;

      if (typeof data.data !== 'undefined' && typeof data.data.id !== 'undefined' && data.data.id) id = data.data.id;
      else if (typeof data.data !== 'undefined' && typeof data.data.company !== 'undefined' && data.data.company.id) id = data.data.company.id;
      else if (typeof data.id !== 'undefined' && data.id) id = data.id;

      if (data.type == 1) {
        /*
         $translate('directory.check').then(null, function () {
         $translatePartialLoader.addPart('directory');
         $translate.refresh();
         });
         */
        stateSidebar = 'app.logged.directory.companies';
        url = $state.href(stateSidebar, {id: id});
        reload = false;
        loadCompany(id, data.data);

      } else if (data.type == 2) {
        /*
         $translate('directory.check').then(null, function () {
         $translatePartialLoader.addPart('directory');
         $translate.refresh();
         });
         */
        stateSidebar = 'app.logged.directory.contacts';
        url = $state.href(stateSidebar, {id: id});
        reload = false;
        loadContact(id, data.data);

      } else if (data.type == 3) {
        /*
         $translate('mailbox.check').then(null, function () {
         $translatePartialLoader.addPart('mailbox');
         $translate.refresh();
         });
         */
        // stateSidebarOld = 'app.logged.mailbox';
        stateSidebar = 'app.logged.mailbox.email_view';
        url = $state.href(stateSidebar, {id: id});
        reload = false;
        loadEmail(id);

      } else if (data.type == 4) {
        /*
         $translate('mailbox.check').then(null, function () {
         $translatePartialLoader.addPart('mailbox');
         $translate.refresh();
         });
         */
        stateSidebarOld = 'app.logged.mailbox';
        stateSidebar = 'app.logged.mailbox.compose';
        url = $state.href(stateSidebar, {id: id});
        reload = true;
        loadComposeEmail(data.id);

      } else if (data.type == 5) {
        /*
         $translate('press_releases.check').then(null, function () {
         $translatePartialLoader.addPart('press_releases');
         $translate.refresh();
         });
         */
        stateSidebar = 'app.logged.press_releases';
        url = $state.href(stateSidebar, {id: id});
        reload = false;
        loadPressRelease(data.id, data.data);

      } else if (data.type == 6) {
        /*
         $translate('press_releases.check').then(null, function () {
         $translatePartialLoader.addPart('press_releases');
         $translate.refresh();
         });
         */
        stateSidebar = 'app.logged.press_releases';
        url = $state.href(stateSidebar, {id: id});
        reload = true;
        loadComposePressRelease(id, data.data);

      } else if (data.type == 7) {
        /*
         $translate('events.check').then(null, function () {
         $translatePartialLoader.addPart('events');
         $translate.refresh();
         });
         */
        stateSidebar = 'app.logged.events.event';
        url = $state.href(stateSidebar, {id: id});
        reload = false;
        loadEvent(id, data.data);

      } else if (data.type == 8) {
        /*
         $translate('events.check').then(null, function () {
         $translatePartialLoader.addPart('events');
         $translate.refresh();
         });
         */
        stateSidebar = 'app.logged.events.compose';
        url = $state.href(stateSidebar, {id: id});
        reload = true;
        loadComposeEvent(id, data.data);

      } else if (data.type == 9) {
        /*
         $translate('employment.check').then(null, function () {
         $translatePartialLoader.addPart('employment');
         $translate.refresh();
         });
         */
        stateSidebar = 'app.logged.employment';
        url = $state.href(stateSidebar, {id: id});
        reload = false;
        loadEmploy(id, data);

      } else if (data.type == 10) {
        /*
         $translate('employment.check').then(null, function () {
         $translatePartialLoader.addPart('employment');
         $translate.refresh();
         });
         */
        reload = true;
        stateSidebar = 'app.logged.employment'
        url = $state.href(stateSidebar, {id: id});
        loadComposeEmploy(id, data.data);

      } else if (data.type == 11) {
        /*
         $translate('cepyme500tv.check').then(null, function () {
         $translatePartialLoader.addPart('cepyme500tv');
         $translate.refresh();
         });
         */
        reload = true;
        stateSidebar = 'app.logged.cepyme500tv';
        url = $state.href(stateSidebar, {id: id});
        loadComposeTv(id, data.data);

      } else if (data.type == 12) {
        /*
         $translate('startups.check').then(null, function () {
         $translatePartialLoader.addPart('startups');
         $translate.refresh();
         });
         */
        stateSidebar = 'app.logged.startups';
        url = $state.href(stateSidebar, {id: id});
        reload = false;
        loadStartup(id, data.data);

      } else if (data.type == 13) {
        /*
         $translate('offers.check').then(null, function () {
         $translatePartialLoader.addPart('offers');
         $translate.refresh();
         });
         */
        stateSidebar = 'app.logged.offers';
        url = $state.href(stateSidebar, {id: id});
        reload = false;
        loadComposeOffer();

      } else if (data.type == 14) {
        /*
         $translate('projects.check').then(null, function () {
         $translatePartialLoader.addPart('projects');
         $translate.refresh();
         });
         */
        stateSidebar = 'app.logged.projects';
        url = $state.href(stateSidebar, {id: id});
        reload = false;
        loadProject(id, data.data);

      } else if (data.type == 15) {
        /*
         $translate('projects.check').then(null, function () {
         $translatePartialLoader.addPart('projects');
         $translate.refresh();
         });
         */
        stateSidebar = 'app.logged.projects';
        url = $state.href(stateSidebar, {id: id});
        reload = true;
        loadComposeProject();

      } else if (data.type == 16) {
        /*
         $translate('advertisers.check').then(null, function () {
         $translatePartialLoader.addPart('advertisers');
         $translate.refresh();
         });
         */
        stateSidebarOld = 'app.logged.advertisers';
        stateSidebar = 'app.logged.advertisers.advertiser';
        url = $state.href(stateSidebar, {id: id});
        reload = true;
        loadAdvertiser(id, data.data);

      } else if (data.type == 17) {
        /*
         $translate('advertisers.check').then(null, function () {
         $translatePartialLoader.addPart('advertisers');
         $translate.refresh();
         });
         */
        stateSidebarOld = 'app.logged.advertisers';
        stateSidebar = 'app.logged.advertisers.compose';
        url = $state.href(stateSidebar, {id: id});
        reload = true;
        loadComposeAdvertiser(id, data.data);

      }

      if (typeof data.noStats === 'undefined' || !data.noStats) {
        if (id) $state.go(stateSidebar, {id: id}, {notify: false});
        else $state.go(stateSidebar, {notify: false});
        if (deviceDetector.isDesktop()) type_device = 1;
        else if (deviceDetector.isMobile()) type_device = 2;
        else if (deviceDetector.isTablet()) type_device = 3;
        StatsFactory.sendRoute({
          route: url,
          origin_route: $location.path(),
          os: deviceDetector.os,
          os_version: deviceDetector.os_version,
          browser: deviceDetector.browser,
          browser_version: deviceDetector.browser_version,
          type_device: type_device
        });
      }
    });

    vm.close = function (type, noReloadClose) {
      if (noReloadClose) reload = false;
      vm.type = false;
      if (type == 1) {
        vm.loadingCompany;
        vm.company;
        vm.vectorMapReady;
        vm.map;
        vm.markerOptions;
        vm.gMapReady;
        vm.mapCenter;
      } else if (type == 2) {
        vm.loadingContact;
        vm.contact = {};
      } else if (type == 3) vm.mail = {};
      else if (type == 4) vm.composeMail = {};
      else if (type == 5 || type == 6) vm.pReleease = {};
      else if (type == 8) {
        if (reload) {
          $state.go(stateSidebarOld, {id: undefined, date: vm.event.data.date_to}, {reload: true});
        }
        vm.event = {};
        return;
      } else if (type == 7) vm.event = {};
      else if (type == 9) vm.employ = {};
      else if (type == 10) vm.employCompose = {};
      else if (type == 11) vm.tv = {};
      else if (type == 12) vm.startup = {};
      else if (type == 13) vm.offer = {};
      else if (type == 14 || type == 15) vm.project = {};
      else if (type == 16 || type == 17) vm.advertiser = {};
      if (reload) {
        $state.go(stateSidebarOld, {id: undefined}, {reload: true});
      } else $state.go(stateSidebarOld, {id: undefined}, {notify: false});
    }

    function loadCompany(id, data) {
      vm.company = {};
      vm.vectorMapReady = false;
      vm.loadingCompany = false;
      vm.gMapReady = false;
      vm.mapCenter = {};
      var changeCountries = function (countries_market, countries_office) {
        if (countries_market.length > 0) {
          var arrayCMarket = [];
          for (var indexMarket = 0; indexMarket < countries_market.length; indexMarket++) {
            arrayCMarket.push(countries_market[indexMarket].id);
          }
          vm.company.countriesMarketIds = arrayCMarket;
        } else {
          vm.company.countriesMarketIds = ['ES'];
        }
        if (countries_office.length > 0) {
          var arrayCOffice = [];
          for (var indexMarketO = 0; indexMarketO < countries_office.length; indexMarketO++) {
            arrayCOffice.push(countries_office[indexMarketO].id);
          }
          vm.company.countriesOfficeIds = arrayCOffice;
        } else {
          vm.company.countriesOfficeIds = ['ES'];
        }
      }

      if (data) vm.company = data;
      else vm.loadingCompany = true;
      DirectoryFactory.getCompany(id).then(function (data) {

        if (typeof data.web !== 'undefined' && data.web && data.web.substr(0, 7) !== 'http://' && data.web.substr(0, 8) !== 'https://') {
          data.web = 'http://' + data.web;
        }
        vm.company = data;

        changeCountries(data.countries_market, data.countries_office);
        vm.vectorMapReady = true;
        vm.mapCenter = {latitude: data.principal_address.lat, longitude: data.principal_address.lng};
        vm.markerOptions = {icon: 'https://d3cbxno87ymraz.cloudfront.net/app/assets/images/marker.png'};
        vm.gMapReady = true;
      }).finally(function () {
        vm.loadingCompany = false;
      });
    }

    function loadContact(id, data) {
      vm.loadingContact = false;
      if (data) vm.contact = data;
      else vm.loadingContact = true;
      DirectoryFactory.getContact(id).then(function (data) {
        vm.contact = data;
      }).finally(function () {
        vm.loadingContact = false;
      });
    }

    function loadEmail(id) {

      vm.mail = {
        type_response: false,
        message: {
          id: id
        },
        config: SUMMERNOTE,
        companies: [],
        reply: {
          to: [],
          body: '',
          files: [],
          thread: id
        },
        isCollapsedReply: true,
        pasteSummernote: function () {
          timeoutPaste = $timeout(function () {
            vm.mail.reply.body = vm.mail.reply.body.replace(/style="[^"]*"/g, "");
          }, 500);
        }
      };

      vm.mail.loading = true;
      vm.mail.checkTypeImg = function (url) {
        if (['jpg', 'gif', 'png'].indexOf(url.substr(-3)) > -1) return true;
        else return false;
      }

      MailboxFactory.getThread(id).then(function (message) {
        vm.mail.message = message;
        if (typeof message !== 'undefined' && message.length) {
          if (typeof message[0].is_read !== 'undefined' && !message[0].is_read) {
            var sendNotifyMail = {
              is_read: 1,
              tag: message[0].tag,
              folder: message[0].folder
            }
            BroadcastFactory.send('topNavBarMail', sendNotifyMail);
          }
        }
      }).finally(function () {
        vm.mail.loading = false;
      });
      /*type 1: sender; 2: all; 3: forward*/
      vm.mail.replyCollapse = function (scroll, type) {
        if (scroll) {
          $location.hash('reply');
          $anchorScroll();
        }
        vm.mail.reply.to = [];
        if (type == 1) {
          vm.mail.reply.to.push(vm.mail.message[0].sender.id);
        } else if (type == 2) {
          if (vm.mail.message[0].recipients.length) {
            for (var index = 0; index < vm.mail.message[0].recipients.length; index++) {
              vm.mail.reply.to.push(vm.mail.message[0].recipients[index].id);
            }
          }
        }
        if (type == vm.mail.type_response) {
          vm.mail.isCollapsedReply = true;
        } else {
          vm.mail.isCollapsedReply = false;
        }
        vm.mail.type_response = type;
      }
      vm.mail.removeFile = function (index) {
        vm.mail.reply.files.splice(index, 1);
      }
      vm.mail.replySubmit = function (form) {
        if (form.$valid) {
          vm.mail.loading = false;
          MailboxFactory.sendReply(vm.mail.message[0].id, vm.mail.reply).finally(function () {
            vm.mail.loading = false;
            vm.close(3);
          });
        }
      }
    }

    function loadComposeEmail(id) {
      vm.composeMail = {};
      vm.composeMail.provincesSelect = ProvincesFactory.getProvinces();
      vm.composeMail.cnaesSelect = [];
      CnaesFactory.getCnaes().then(function (cnaes){
        vm.composeMail.cnaesSelect = cnaes;
      });
      vm.composeMail.filters = {
        cnae: [],
        province: [],
        sector: []
      }
      vm.composeMail.handleCompanySelection = function (companyId) {
        vm.composeMail.mail.to = companyId;
        //vm.changeCompany();
      };
      vm.composeMail.filtersChange = function(){
        if(
          vm.composeMail.filters.province.length ||
          vm.composeMail.filters.cnae.length ||
          vm.composeMail.filters.sector.length
        ) {
          vm.composeMail.mail.to = 'Active filters';
        } else {
          vm.composeMail.mail.to = [];
        }
      }
      vm.composeMail.mail = {
        to: [],
        subject: '',
        body: '',
        files: []
      };
      vm.composeMail.config = SUMMERNOTE;
      vm.composeMail.pasteSummernote = function () {
        timeoutPaste = $timeout(function () {
          vm.composeMail.mail.body = vm.composeMail.mail.body.replace(/style="[^"]*"/g, "");
        }, 500);
      }
      if (id) {
        id = parseInt(id);
        vm.composeMail.mail.to = [id];
      } else if ($rootScope.myUser.company.id === 1) {
        var cepymeBottomSign = '<br><br>' +
          '<div>cepyme500@cepyme.es</div>' +
          '<div><img src="https://d3cbxno87ymraz.cloudfront.net/firmas/tania/logo.png"></div>' +
          '<div><a href="https://cepymenews.es" target="_blank"><img src="https://d3cbxno87ymraz.cloudfront.net/firmas/tania/logo_cpnews.jpg"></a></div>' +
          '<div style="color: #046240; margin-top: 10px" class="text-primary  m-t"><strong>Confederación Española de la Pequeña y Mediana Empresa</strong></div>' +
          '<div style="color: #046240;" class="text-primary">' +
          'Tlf: +34 914 116 161 – Fax. +34 915 645 269<br>' +
          'C/ Diego de León, 50  3ª Planta - 28006 Madrid' +
          '</div>' +
          '<div><a href="https://www.cepyme500.com" target="_blank">www.cepyme500.com</a> | <a href="https://twitter.com/cepyme_" target="_blank">@cepyme_</a></div>';
        vm.composeMail.mail.body = cepymeBottomSign;
      }
      vm.composeMail.selectAll = function (remove) {
        if (remove) vm.composeMail.mail.to = [];
        else {
          /*
          CompaniesFactory.getCompanies( false, false, true ).then( function ( companies ) {
            vm.composeMail.mail.to = companies;
          } );
           */
          vm.composeMail.mail.to = 'All companies';
        }
      };
      vm.composeMail.submit = function (form) {
        if (form.$valid) {
          vm.composeMail.loading = true;
          MailboxFactory.send(vm.composeMail.mail, vm.composeMail.filters).then(function () {
            vm.close(vm.type);
          }).finally(function () {
            vm.composeMail.loading = false;
          });
        }
      }
      vm.composeMail.removeFile = function (index) {
        vm.composeMail.mail.files.splice(index, 1);
      }
    }

    function loadPressRelease(id, data) {
      vm.pReleaseComment = '';
      vm.loadingComment = false;
      if (data) {
        vm.pReleease = angular.copy(data);
        getCommentsPRelease(data.id);
      } else if (id) {
        vm.loading = true;
        PressReleaseFactory.get(false, false, id).then(function (dataPR) {
          vm.pReleease = angular.copy(dataPR);
          getCommentsPRelease(id);
        }, function () {

        }).finally(function () {
          vm.loading = false;
        });
      }
    }

    function getCommentsPRelease(id) {
      PressReleaseFactory.getComments(id).then(function (data) {
        vm.pReleease.comments = data;
      }, function () {
        vm.pReleease.comments = [];
      });
    }

    vm.pReleeaseSendComment = function () {
      vm.loadingComment = true;
      PressReleaseFactory.sendComment(vm.pReleease.id, vm.pReleaseComment).then(function (data) {
        vm.pReleaseComment = '';
        vm.pReleease.comments.push(data);
      }).finally(function () {
        vm.loadingComment = false;
      })
    }

    function loadComposePressRelease(idPressRelease, dataPressRelease) {
      vm.pReleease = {};

      vm.pReleease.config = SUMMERNOTE;
      vm.pReleease.update = true;

      vm.pReleease.handleCompanySelection = function (companyId) {
        vm.pReleease.article.company_id = companyId;
        vm.pReleease.changeCompany();
      };
      if (typeof dataPressRelease !== "undefined" && dataPressRelease) {
        vm.pReleease.article = angular.copy(dataPressRelease);
        vm.pReleease.article.company_id = dataPressRelease.company.id;
        vm.pReleease.article.documents = angular.copy(dataPressRelease.files);
      } else if (typeof idPressRelease !== "undefined" && idPressRelease && idPressRelease !== "compose") {
        loadPressRelease(idPressRelease);
        vm.pReleease.article.documents = angular.copy(vm.pReleease.article.files);
      } else {
        vm.pReleease.update = false;
        vm.pReleease.article = {
          title: '',
          subtitle: '',
          content: '',
          company_id: $rootScope.myUser.company.id,
          contact_person: $rootScope.myUser.name,
          contact_email: $rootScope.myUser.email,
          contact_phone: $rootScope.myUser.company.principal_address.phone_number,
          contact_web: $rootScope.myUser.company.web,
          images: [],
          image: {},
          documents: []
        };
      }
      vm.pReleease.article.files_remove = [];
      vm.pReleease.pasteSummernote = function () {
        timeoutPaste = $timeout(function () {
          vm.pReleease.article.content = vm.pReleease.article.content.replace(/style="[^"]*"/g, "");
        }, 500);
      };
      vm.pReleease.changeCompany = function () {
        if ($rootScope.myUser.group !== "admin" && $rootScope.myUser.group !== "superadmin") return;
        DirectoryFactory.getCompany(vm.pReleease.article.company_id).then(function (company) {
          for (var iConmpanyChange = 0; iConmpanyChange < company.contacts.length; iConmpanyChange++) {
            if (company.contacts[iConmpanyChange].default) {
              vm.pReleease.article.contact_person = company.contacts[iConmpanyChange].name;
              vm.pReleease.article.contact_email = company.contacts[iConmpanyChange].email;
              break;
            }
          }
          if (company.hasOwnProperty('principal_address') && company.principal_address.hasOwnProperty('phone_number') && company.principal_address.phone_number) {
            vm.pReleease.article.contact_phone = company.principal_address.phone_number;
          } else vm.pReleease.article.contact_phone = "";
          if (company.hasOwnProperty('web') && company.web) {
            vm.pReleease.article.contact_web = company.web;
          } else vm.pReleease.article.contact_web = "";
          vm.pReleease.article.company_id = company.id;
        });
      };


      vm.pReleease.submit = function (form, update) {
        if (form.$valid) {
          vm.pReleease.loading = true;
          if (!update) {
            delete vm.pReleease.article.files_remove;
          } else {
            var imageOld = {};
            var imagesOld = [];
            var documentsOld = [];
            if (vm.pReleease.article.image instanceof File !== true) {
              imageOld = vm.pReleease.article.image;
              delete vm.pReleease.article.image;
            }
            if (vm.pReleease.article.images.length) {
              var imagesNew = [];
              for (var updatePRIndex = 0; updatePRIndex < vm.pReleease.article.images.length; updatePRIndex++) {
                if (vm.pReleease.article.images[updatePRIndex] instanceof File) {
                  imagesNew.push(vm.pReleease.article.images[updatePRIndex]);
                } else {
                  imagesOld.push(vm.pReleease.article.images[updatePRIndex]);
                }
              }
              vm.pReleease.article.images = imagesNew;
            }
            if (vm.pReleease.article.documents.length) {
              var documentsNew = [];
              for (var updatePRIndex = 0; updatePRIndex < vm.pReleease.article.documents.length; updatePRIndex++) {
                if (vm.pReleease.article.documents[updatePRIndex] instanceof File) {
                  documentsNew.push(vm.pReleease.article.documents[updatePRIndex]);
                } else {
                  documentsOld.push(vm.pReleease.article.documents[updatePRIndex]);
                }
              }
              vm.pReleease.article.documents = documentsNew;
            }
          }

          PressReleaseFactory.send(vm.pReleease.article, vm.pReleease.update).then(function () {
            vm.close(6);
          }, function () {
            if (!vm.pReleease.article.hasOwnProperty("image")) {
              vm.pReleease.article.image = imageOld;
            }
            if (typeof imagesOld !== 'undefined' && imagesOld.length) {
              vm.pReleease.article.images = vm.pReleease.article.images.concat(imagesOld);
            }
            if (typeof imagesOld !== 'undefined' && documentsOld.length) {
              vm.pReleease.article.documents = vm.pReleease.article.documents.concat(documentsOld);
            }
            //  console.log( vm.pReleease.article );
          }).finally(function () {
            vm.pReleease.loading = false;
          });
        }
      }
      vm.pReleease.removeFile = function (name, index, id) {
        if (name == 'images' || name == 'documents') {
          if (id && vm.pReleease.article.files_remove.indexOf(id) < 0) {
            vm.pReleease.article.files_remove.push(id);
            vm.pReleease.article[name].splice(index, 1);
          } else if (!id) {
            vm.pReleease.article[name].splice(index, 1);
          }
        }
        if (name == 'image') {
          if (id && vm.pReleease.article.files_remove.indexOf(id) < 0) {
            vm.pReleease.article.files_remove.push(id);
          }
          vm.pReleease.article.image = {};
        }
      }
    }

    function loadEvent(id, data) {
      $scope.$apply(function () {
        vm.event = {
          data: {},
          loading: false
        };
      });

      if (data) {
        vm.event.data = data;
        vm.event.map = {id: 1, center: {latitude: vm.event.data.lat, longitude: vm.event.data.lng}, zoom: 11};
        vm.event.markerOptions = {icon: 'https://d3cbxno87ymraz.cloudfront.net/app/assets/images/marker-event.png'};
      } else {
        vm.event.loading = true;
        EventsFactory.get({}, id).then(function (event) {
          vm.event.data = event;
          vm.event.map = {id: 1, center: {latitude: event.lat, longitude: event.lng}, zoom: 11};
          vm.event.markerOptions = {icon: 'https://d3cbxno87ymraz.cloudfront.net/app/assets/images/marker-event.png'};
        }).finally(function () {
          vm.event.loading = false;
        });
      }
    }

    function loadComposeEvent(id, data) {
      vm.event = {
        loading: false,
        data: {
          planner: $rootScope.myUser.company.name,
          image_ng: {},
          category: 'event'
        },
        categories: [
          {id: 'event', name: $translate.instant('event.sidebar.category.event')},
          {id: 'cepyme500', name: $translate.instant('event.sidebar.category.cepyme500')},
          {id: 'cepyme', name: $translate.instant('event.sidebar.category.cepyme')},
          {id: 'direct', name: $translate.instant('event.sidebar.category.direct')},
          {id: 'bme', name: $translate.instant('event.sidebar.category.bme')},
          {id: 'bankinter', name: $translate.instant('event.sidebar.category.bankinter')},
          {id: 'santander', name: $translate.instant('event.sidebar.category.santander')}
        ],
        config: SUMMERNOTE,
        pasteSummernote: function (index) {
          timeoutPaste = $timeout(function () {
            vm.event.data[index] = vm.event.data[index].replace(/style="[^"]*"/g, "");
          }, 500);
        }
      };
      if (typeof id !== 'undefined' && id) {
        if (data) {
          if (typeof data.company !== 'undefined' && (data.company.id !== $rootScope.myUser.company.id && $rootScope.myUser.group !== 'superadmin')) vm.close(8);
          else vm.event.data = data;
        } else {
          vm.event.loading = true;
          EventsFactory.get({}, id).then(function (event) {
            vm.event.data = event;
          }).finally(function () {
            vm.event.loading = false;
          });
        }
      }

      vm.event.eventsSubmit = function (form) {
        if (form.$valid) {
          vm.event.data.image = vm.event.data.image_ng;
          vm.event.data.date_to = moment(vm.event.data.date_to).format("YYYY-MM-DD HH:mm:ss").toString();
          if (vm.event.data.date_from) vm.event.data.date_from = moment(vm.event.data.date_from).format("YYYY-MM-DD HH:mm:ss").toString();
          /*
           console.log('vm.event.data.category', vm.event.data.category);
           vm.event.data.category = vm.event.data.category.id;
           */
          if (!vm.event.data.web) delete vm.event.data.web;
          if (!vm.event.data.link_register) delete vm.event.data.link_register;
          if (!vm.event.data.description) delete vm.event.data.description;
          if (!vm.event.data.comment) delete vm.event.data.comment;
          vm.event.loading = true;
          EventsFactory.send(vm.event.data, id).then(function () {
            vm.close(8);
          })
            .finally(function () {
              vm.event.loading = false;
            });
        }
      };
      vm.event.removeImg = function () {
        vm.event.data.image = null;
      }
    }

    function loadEmploy(id, data) {
      vm.employ = {
        id: id
      }
      if (data) {
        vm.employ = data.data;
      }
    }

    function loadComposeEmploy(id, data) {
      /*
       console.log(id)
       console.log(data)
       console.log($rootScope.myUser)
       */
      var method = 'PUT';
      vm.loadingEmploy = false;
      vm.employCompose = {
        jobType: jobType,
        provinces: ProvincesFactory.getProvinces()
      }

      if (id == 'compose') {
        method = 'POST';
        var today = new Date();
        var todayTo = new Date();
        vm.employCompose.employ = {
          title: '',
          type: $filter('translate')(jobType[0]),
          date_from: today,
          date_to: todayTo.setMonth(todayTo.getMonth() + 2),
          salary_from: '',
          salary_to: '',
          description: '',
          minimun_requirements: '',
          desired_requirements: '',
          email: ($rootScope.myUser.company.email_job) ? $rootScope.myUser.company.email_job : $rootScope.myUser.contact.email,
          city: $rootScope.myUser.company.principal_address.town,
          province_id: $rootScope.myUser.company.principal_address.province.id,
          sector: $rootScope.myUser.company.cnae.name,
          active: true
        }
      } else if (data) {
        // getRequestsEmploy(id)
        if (data.type == 'Undefined' || data.type == 'Indefinido') data.type = 'general.jobType.undefined';
        else if (data.type == 'Work' || data.type == 'Obra') data.type = 'general.jobType.work';
        else if (data.type == 'scholarship' || data.type == 'Beca') data.type = 'general.jobType.scholarship';
        else if (data.type == 'replacement' || data.type == 'Sustitución') data.type = 'general.jobType.replacement';
        data.type = $filter('translate')(data.type);
        vm.employCompose.employ = data;
        vm.employCompose.employ.email = ($rootScope.myUser.company.email_job) ? $rootScope.myUser.company.email_job : $rootScope.myUser.contact.email;
      } else if (id) {
        vm.loadingEmploy = true;
        getRequestsEmploy(id)
        EmploymentFactory.get({}, id).then(function (job) {
          if (job.type == 'Undefined' || job.type == 'Indefinido') job.type = 'general.jobType.undefined';
          else if (job.type == 'Work' || job.type == 'Obra') job.type = 'general.jobType.work';
          else if (job.type == 'scholarship' || job.type == 'Beca') job.type = 'general.jobType.scholarship';
          else if (job.type == 'replacement' || job.type == 'Sustitución') job.type = 'general.jobType.replacement';
          job.type = $filter('translate')(job.type);
          vm.employCompose.employ = job;
        }).finally(function () {
          vm.loadingEmploy = false;
        })
      }

      function getRequestsEmploy(id) {
        EmploymentFactory.getRequests(id).then(function (data) {
          if (typeof data === 'undefined' || angular.isArray(data)) vm.employCompose.requests;
          else vm.employCompose.requests = data;
        });
      }

      vm.employCompose.submit = function (form) {
        if (form.$valid) {
          vm.employCompose.loadingSend = true;
          vm.employCompose.employ.date_from = moment(vm.employCompose.employ.date_from).format("YYYY-MM-DD").toString();
          vm.employCompose.employ.date_to = moment(vm.employCompose.employ.date_to).format("YYYY-MM-DD").toString();
          EmploymentFactory.send(vm.employCompose.employ, method).then(function () {
            $rootScope.myUser.company.email_job = vm.employCompose.employ.email;
            vm.close(10);
          }, function () {

          }).finally(function () {
            vm.employCompose.loadingSend = false;
          })
        }
      }
    }

    function loadComposeTv(id, data) {
      vm.tv = {};
      vm.tv.video = {};
      vm.tv.video.live = 0;
      if (data) vm.tv.video = data;
      if (id == 'compose') id = false;
      if (id == 'direct') {
        vm.tv.video.live = 1;
        id = false
      } else if (!data && id) {
        vm.tv.loading = true;
        TVFactory.get({}, id).then(function (video) {
          vm.tv.video = video;
        }).finally(function () {
          vm.tv.loading = false;
        });
      }

      vm.tv.submit = function (form) {
        if (form.$valid) {
          vm.tv.loading = true;
          TVFactory.send(vm.tv.video, id).then(function () {
            vm.close(11);
          }).finally(function () {
            vm.tv.loading = false;
          })
        }
      }
    }

    function loadStartup(id, data) {
      vm.startup = {
        data: data
      }
      if (!data) {
        vm.startup.loading = true;
        StartupsFactory.get({}, id).then(function (startup) {
          vm.startup.data = startup;
        }).finally(function () {
          vm.startup.loading = false;
        })
      }
    }

    function loadComposeOffer() {
      vm.composeOffer = {};

      vm.composeOffer.handleCompanySelection = function (companyId) {
        vm.composeOffer.mail.to = companyId;
        //vm.changeCompany();
      };
      vm.composeOffer.mail = {
        to: [],
        title: '',
        description: '',
        file: {},
        image: {},
        discount: '',
        price: '',
        url: '',
        date_to: ''
      };
      vm.composeOffer.config = SUMMERNOTE;
      vm.composeOffer.pasteSummernote = function () {
        timeoutPaste = $timeout(function () {
          vm.composeOffer.mail.description = vm.composeOffer.mail.description.replace(/style="[^"]*"/g, "");
        }, 500);
      }

      vm.composeOffer.selectAll = function (remove) {
        if (remove) vm.composeOffer.mail.to = [];
        else {
          /*
          vm.composeOffer.mail.to = CompaniesFactory.getCompanies( false, false, true ).then( function ( companies ) {
            vm.composeOffer.mail.to = companies;
          } );
          */
          vm.composeOffer.mail.to = [-1];
        }
      };
      vm.composeOffer.submit = function (form) {
        if (form.$valid) {
          vm.composeOffer.loading = true;
          if (vm.composeOffer.mail.date_to) vm.composeOffer.mail.date_to = moment(vm.composeOffer.mail.date_to).format("YYYY-MM-DD").toString();
          OffersFactory.send(vm.composeOffer.mail).then(function () {
            vm.close(vm.type);
          }).finally(function () {
            vm.composeOffer.loading = false;
          })
        }
      }
      vm.composeOffer.removeFile = function (index, type) {
        vm.composeOffer.mail[type] = {};
      }
    }

    function loadProject(id, data) {
      vm.project = {
        loading: false,
        data: {}
      };
      if (data) {
        vm.project.data = data;
      } else if (id) {
        vm.project.loading = true;
        ProjetcsFactory.get(false, id)
          .then(function (project) {
            vm.project.data = project;
          }).finally(function () {
          vm.project.loading = false;
        });
      }
      vm.project.removeUser = function (id, company_id, index) {
        vm.loadingAdd = true;
        ProjetcsFactory.removeUser(id, company_id)
          .then(function () {
            vm.project.data.participants.splice(index, 1);
          })
          .finally(function () {
            vm.loadingAdd = false;
          });
      };
    }

    function loadComposeProject() {
      vm.project = {
        loading: false,
        data: {
          scope: 'Nacional',
          phone: '',
          email: ''
        },
        config: SUMMERNOTE,
        pasteSummernote: function (index) {
          timeoutPaste = $timeout(function () {
            vm.project.data[index] = vm.project.data[index].replace(/style="[^"]*"/g, "");
          }, 500);
        }
      };
      vm.project.data.person_contact = $rootScope.myUser.contact.name + $rootScope.myUser.contact.surname;
      if (typeof $rootScope.myUser.contact.phone !== 'undefined') vm.project.data.phone = $rootScope.myUser.contact.phone;
      else if (typeof $rootScope.myUser.company.principal_address.phone_number !== 'undefined') vm.project.data.phone = $rootScope.myUser.company.principal_address.phone_number;
      if (typeof $rootScope.myUser.contact.email !== 'undefined') vm.project.data.email = $rootScope.myUser.contact.email;
      vm.project.projectSubmit = function (form) {
        if (form.$valid) {
          vm.project.loading = true;
          ProjetcsFactory.send(vm.project.data)
            .then(function () {
              vm.close(vm.type);
            }).finally(function () {
            vm.project.loading = false;
          });
        }
      }
    }

    function loadAdvertiser(id, data) {
      vm.advertiser = {
        data: {}
      };
      if (data) {
        vm.advertiser = {
          data: data
        };
      } else if (id) {
        vm.advertiser.loading = true;
        AdvertisersFactory.getAdvertisers({}, id).then(function (advertiser) {
          vm.advertiser.data = advertiser;
        }).finally(function () {
          vm.advertiser.loading = false;
        });
      }
    }

    function loadComposeAdvertiser(id, data) {
      vm.advertiser = {
        data: {
          scope: 'national'
        },
        config: SUMMERNOTE,
        provinces: ProvincesFactory.getProvinces(),
        pasteSummernote: function () {
          timeoutPaste = $timeout(function () {
            vm.advertiser.data.description = vm.advertiser.data.description.replace(/style="[^"]*"/g, "");
          }, 500);
        }
      }
      if (id) {
        if ($rootScope.myUser.group !== 'superadmin') vm.close(vm.type);
        if (data) {
          data.province_id = data.province.id;
          vm.advertiser.data = data;
        } else {
          vm.advertiser.loading = true;
          AdvertisersFactory.getAdvertisers({}, id).then(function (advertiser) {
            advertiser.province_id = advertiser.province.id;
            vm.advertiser.data = advertiser;
          }).finally(function () {
            vm.advertiser.loading = false;
          });
        }
      }

      vm.advertiser.sendAdvertiser = function (form) {
        if (form.$valid) {
          vm.advertiser.loading = true;
          AdvertisersFactory.addAdvertiser(vm.advertiser.data, id).then(function () {
            vm.close(vm.type);
          }).finally(function () {
            vm.advertiser.loading = false;
          })
        }
      };

    }

    vm.printSidebar = function (id) {

      var printContents = $document[0].getElementById(id).innerHTML;
      //var originalContents = $document[0].body.innerHTML;
      //$document[0].body.innerHTML = printContents;
      var printWindow = $window.open('', '', 'width=800,height=600');
      printWindow.document.write('<html>');
      printWindow.document.write('<head><style>*, *:before, *:after {color: #000 !important;text-shadow: none !important;background: transparent !important;box-shadow: none !important;box-sizing: border-box;}a, a:visited {text-decoration: underline;}a[href]:after {content: " (" attr(href) ")";}abbr[title]:after {content: " (" attr(title) ")";}a[href^="#"]:after, a[href^="javascript:"]:after {content: "";}pre, blockquote {border: 1px solid #999;page-break-inside: avoid;}thead {display: table-header-group;}tr, img {page-break-inside: avoid;}img {max-width: 100% !important;}p, h2, h3 {orphans: 3;widows: 3;}h2, h3 {page-break-after: avoid;}.navbar {display: none;}.btn > .caret, .dropup > .btn > .caret {border-top-color: #000 !important;}.label {border: 1px solid #000;}.table {border-collapse: collapse !important;}.table td, .table th {background-color: #fff !important;border-bottom: 1px solid #ccc;padding: 5px;}.table-bordered th, .table-bordered td {border: 1px solid #ddd !important;}nav.navbar-static-side {display: none;}body {overflow: visible !important;}#page-wrapper {margin: 0;}.ibox-title {-moz-border-bottom-colors: none;-moz-border-left-colors: none;-moz-border-right-colors: none;-moz-border-top-colors: none;background-color: #fff;border-image: none;color: inherit;margin-bottom: 0;}.ibox {clear: both;margin-bottom: 25px;margin-top: 0;padding: 0;background-color: #fff;}.ibox-content {clear: both;}.hidden-print {display: none;}.ibox-title h5 {display: inline-block;font-size: 20px;margin-bottom: 20px;padding: 0;text-overflow: ellipsis;color: #046240;}label{font-weight: 700;margin: 0;padding: 0;line-height: 0;display:block;margin-bottom: 10px;}.form-group{margin-bottom: 20px;}span{margin-right:10px;}h4{margin-top:20px;margin-bottom:0;}p{margin:0 0 5px 0;}div {margin-bottom:5px;}</style></head>');
      printWindow.document.write(printContents);
      printWindow.document.write('</html>');
      printWindow.print();
      printWindow.close();
      //$document[0].body.innerHTML = originalContents;
    }

    $scope.$on('$destroy', function () {
      sideBarEventListener();
      if (timeoutPaste) $timeout.cancel(timeoutPaste);
    });
  }

})();

(function () {
  'use strict'

  angular.module('app.logged')
    .service('LoggedService', LoggedService);

  LoggedService.$inject = [
    '$q',
    '$http',
    'URLS'
  ];

  /** @ngInject */
  function LoggedService($q, $http, URLS) {
    var service = {
      notifications: notifications,
      notificationsRead: notificationsRead
    };
    return service;

    function notificationsRead(id) {
      var url = URLS.API + 'notifications/'+id;
      var settings = {
        url: url,
        method: 'PATCH',
        data: {
          notification: id
        },
        // withCredentials: true,
        cache: false
      }
      return http();

      function http() {
        $http(settings);
      }
    }

    /*
    NoticeCreate
    EventCreate
    OfferCreate
    ProjectJoin
    SupplierActivate
    */
    function notifications(cepyme500) {
      var deferred = $q.defer();
      var url = URLS.API + 'notifications'
      if (cepyme500) url = url + '/cepyme500';
      var settings = {
        method: 'GET',
        url: url,
        cache: false
        //  timeout: deferred.promise,
      };
      return http();

      function http() {
        $http(settings)
          .then(httpOk, httpError)
          .catch(function (catchReponse) {
            deferred.reject(catchReponse);
          });
        return deferred.promise
      }
      function httpOk(notifications) {
        if (typeof notifications !== 'undefined' &&  notifications && typeof notifications.data !== 'undefined') {
          deferred.resolve(notifications.data)
        } else {
          httpError();
        }
      }
      function httpError() {
        deferred.reject('error');
      }
    }
  }
}());

(function () {
  'use strict';

  angular.module('app.logged')
    .controller('LoggedController', LoggedController);

  LoggedController.$inject = ['$scope', '$rootScope', '$translate', '$timeout', 'amMoment', 'MailboxFactory', 'store', '$state', '$interval', 'LoggedService', 'UsersService'];


  /** @ngInject */
  function LoggedController($scope, $rootScope, $translate, $timeout, amMoment, MailboxFactory, store, $state, $interval, LoggedService, UsersService) {
    var timeout;
    var year = new Date();
    var vm = this;
    vm.lan = $translate.use();

    vm.today = year.getFullYear();

    vm.changeLanguage = function (langKey) {
      if (langKey !== vm.lan) {
        $translate.use(langKey);
        timeout = $timeout(function () {
          vm.lan = $translate.use();
          amMoment.changeLocale(langKey)
        }, 250)
      }
    }

    function checkUnread() {
      MailboxFactory.getFolderUnread().then(function (messages) {
        vm.unreadMessagesFolder = messages;
        var unreadMessages = 0;
        if (!angular.equals(messages, {})) {
          for (var folder in messages) {
            unreadMessages = unreadMessages + messages[folder].unread;
          }
          vm.unreadMessagesFoldersTotal = unreadMessages;
        }
      });
      MailboxFactory.getTagUnread().then(function (messages) {
        vm.unreadMessagesTag = messages;
        var unreadMessages = 0;
        if (!angular.equals(messages, {})) {
          for (var folder in messages) {
            unreadMessages = unreadMessages + messages[folder].unread;
          }
          vm.unreadMessagesTagsTotal = unreadMessages;
        }
      });
      /*
      NoticeCreate
      EventCreate
      OfferCreate
      ProjectJoin
      SupplierActivate
      */
      LoggedService.notifications().then(function (data) {
        vm.unreadNotifications = data;
      });
      LoggedService.notifications(true).then(function (data) {
        vm.unreadNotificationsCP500 = data;
      });
    }
    checkUnread();
    /*
    var mailboxInterval = $interval(function () {
      checkUnread()
    }, 60000);
    */

    vm.logout = function () {
      UsersService.logout().then().finally(function () {
        $rootScope.token = '';
        /*store.storage.clear();*/
        store.remove('news');
        store.remove('cnaesV1');
        $state.go('app.login');
      });
    };

    var topNavBarListener = $scope.$on('topNavBar', function (element, data){
      if(typeof data !== 'undefined' && data) vm.unreadNotificationsCP500.total = vm.unreadNotificationsCP500.total - 1;
      else vm.unreadNotifications.total = vm.unreadNotifications.total = vm.unreadNotifications.total - 1;
    });

    var topNavBarMailListener = $scope.$on('topNavBarMail', function (element, data){
      if(typeof data !== 'undefined') {
        if(typeof data.folder !== 'undefined' && data.folder) {
          if( typeof vm.unreadMessagesTag[data.folder] === 'undefined' || typeof vm.unreadMessagesTag[data.folder].unread === 'undefined') {
            vm.unreadMessagesFolder[data.folder] = {
              unread: 0
            }
          }
          if(data.is_read){
            if( vm.unreadMessagesFolder[data.folder].unread ) {
              vm.unreadMessagesFolder[data.folder].unread--;
            } else {
              vm.unreadMessagesFolder[data.folder].unread = null;
            }

          } else {
            vm.unreadMessagesFolder[data.folder].unread++;
          }
        }
        if(typeof data.tag !== 'undefined' && data.tag){
          if( typeof vm.unreadMessagesTag[data.tag] === 'undefined' || typeof vm.unreadMessagesTag[data.tag].unread === 'undefined') {
            vm.unreadMessagesTag[data.tag] = {
              unread: 0
            }
          }
          if(data.is_read){
            if( vm.unreadMessagesFolder[data.folder].unread ) {
              vm.unreadMessagesTag[ data.tag ].unread--;
            } else {
              vm.unreadMessagesTag[ data.tag ].unread = null;
            }
          } else {
            vm.unreadMessagesTag[data.tag].unread++;
          }

        }
        if(data.is_read){
          if(vm.unreadMessagesFoldersTotal) {
            vm.unreadMessagesFoldersTotal--;
          } else {
            vm.unreadMessagesFoldersTotal = null;
          }

        } else {
          vm.unreadMessagesFoldersTotal++;
        }

      }
    });



    $scope.$on('$destroy', function () {
      if(timeout) $timeout.cancel(timeout);
      //$interval.cancel(mailboxInterval);
      topNavBarListener();
      topNavBarMailListener();
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('app.pay_advertiser', ['credit-cards']);
})();

(function () {
  'use strict';

  angular.module('app.pay_advertiser')
    .controller('payAdvertiserController', payAdvertiserController);

  payAdvertiserController.$inject = ['AdvertisersFactory', '$stateParams'];

  function payAdvertiserController(AdvertisersFactory, $stateParams) {
    var vm = this;
    vm.complete = false;
    vm.card = {
      card_number: '',
      card_exp_month: '',
      card_exp_year: '',
      card_cv: ''
    };
    vm.loading = false;
    if ($stateParams.code) vm.code = $stateParams.code;

    vm.submit = function () {
      vm.loading = true;
      var pay = angular.copy(vm.card);
      pay.need_pay = true;
      pay.code = $stateParams.code;
      pay.card_exp_year = pay.card_exp_year - 2000;
      AdvertisersFactory.activateByCode($stateParams.code, pay).then(function () {
        vm.card = {
          card_number: '',
          card_exp_month: '',
          card_exp_year: '',
          card_cv: ''
        };
        vm.complete = true;
      }).finally(function () {
        vm.loading = false;
      });
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('app.login', []);

})();

(function () {
  'use strict'

  angular.module('app.login')
    .controller('PasswordRecoveryController', PasswordRecoveryController);

    PasswordRecoveryController.$inject = ['UsersService', '$translate', '$state', 'toaster', '$stateParams'];

  function PasswordRecoveryController(UsersService, $translate, $state, toaster, $stateParams) {
    var vm = this
    vm.recovery = {
      email: '',
      token: '',
      password: '',
      password_confirmation: ''
    };
    vm.message = '';
    init();

    function init() {
      if($stateParams.token && $stateParams.email) {
        vm.recovery = {
          email: $stateParams.email.replace(/#/g, '.'),
          token: $stateParams.token
        }
      }
      vm.recoverySubmit = function (form, reset) {
        if (form.$valid) {
          vm.loading = true;
          UsersService.recovery(vm.recovery, reset).then(function () {
            toaster.pop({
              type: 'success',
              title: 'OK',
              body: 'Contraseña enviada',
              showCloseButton: true,
              timeout: 2000
            });
            if(reset) {
              vm.loading = true;
              UsersService.login({email: vm.recovery.email, password: vm.recovery.password}).then(function () {
                $state.go('app.logged.home');
              }).finally(function () {
                vm.loading = false;
              });
            } else vm.message = 'Se te ha enviado un mail con las instrucciones para recuperar la contraseña'

          }, function (erorData) {
            console.log('errorData', erorData);
            var message = 'Revise los campos, las contraseñas deben coincidir y ser mínimo 9 caracteres';
            if(typeof erorData !== 'undefined' && typeof erorData.data !== 'undefined' && typeof erorData.data.message !== 'undefined' && erorData.data.message) {
              message = erorData.data.message;
            }
            toaster.pop({
              type: 'error',
              title: 'ERRORR',
              body: message,
              showCloseButton: true,
              timeout: 2000
            });
          }).finally(function () {
            vm.loading = false;
          })
        }
      }
    }
  }
}());

(function () {
  'use strict'

  angular.module('app.login')
    .controller('LoginController', LoginController);

  LoginController.$inject = ['$rootScope', 'UsersService', '$translate', '$state', 'toaster'];

  function LoginController($rootScope, UsersService, $translate, $state, toaster) {
    var vm = this
    vm.user = {
      username: '',
      password: ''
    }
    init();

    function init() {
      $rootScope.token = '';
      vm.loginSubmit = function (form) {
        if (form.$valid) {
          vm.loading = true;
          UsersService.login(vm.user).then(function () {
            toaster.pop({
              type: 'success',
              title: 'OK',
              body: 'Bienvenido!!',
              showCloseButton: true,
              timeout: 2000
            });
            $state.go('app.logged.home');
          }, function (error) {
            var response = 'No hay ningún usuario con ese email y contraseña';
            if(error == 'many_attemps') response = 'Usuario bloqueado';
            toaster.pop({
              type: 'error',
              title: 'ERRORR',
              body: response,
              showCloseButton: true,
              timeout: 2000
            });
          }).finally(function () {
            vm.loading = false;
          })
        }
      }
    }
  }
}());

(function () {
  'use strict';

  //Directive used to set metisMenu and minimalize button
  angular.module('app')
    .value('jobType',
      ['general.jobType.undefined', 'general.jobType.work', 'general.jobType.scholarship', 'general.jobType.replacement']
    );
})();

(function () {
    'use strict';

    angular
      .module('app')
      .run(runBlock);

    runBlock.$inject = [
      '$rootScope',
      '$translate',
      'amMoment',
      '$translatePartialLoader',
      '$state',
      'store',
      'UsersService',
      'authManager',
      '$http'
    ];

    /** @ngInject */
    function runBlock($rootScope, $translate, amMoment, $translatePartialLoader, $state, store, UsersService, authManager, $http) {

      $http.defaults.headers.common['Accept-Language'] = $translate.use();
      $rootScope.actualState = '';

      $rootScope.$state = $state;

      /*
       nothing important stored in local
       store.storage.clear();
       * */
      /*
       PRODCUTION MODE
*/

      $rootScope.myUser = '';
      $rootScope.token = '';

      /*
      DEV MODE

     $rootScope.myUser = {
       "id"        : 2,
       "name"      : "Cristobal Valera",
       "email"     : "cterceiro@upthemedia.com",
       "status"    : 1,
       "created_at": "2017-06-19 08:27:09",
       "updated_at": "2019-02-05 10:13:40",
       "group"     : "superadmin",
       "company"   : {
         "id"                : 1,
         "name"              : "CEPYME",
         "web"               : "http:\/\/www.cepyme.es",
         "active"            : 1,
         "email"             : "cepyme500@cepyme.es",
         "email_job"         : null,
         "customer_id"       : null,
         "interview_image_id": null,
         "slug"              : "cepyme-1",
         "cnae"              : {
           "id"   : 9411,
           "name" : "Actividades de organizaciones empresariales y patronales",
           "group": "S"
         },
         "logo"              : {
           "id"           : 209,
           "name"         : "563fd4440c52000192f49034c0ae8231.JPG",
           "original_name": "cepime_pantone3425C.JPG",
           "type"         : "JPG",
           "url"          : "https:\/\/cepyme500.s3.eu-west-1.amazonaws.com\/563fd4440c52000192f49034c0ae8231.JPG"
         },
         "principal_address" : {
           "id"          : 2247,
           "title"       : null,
           "phone_number": 914116161,
           "street"      : "C\/Diego de Le\u00f3n, 50",
           "postal_code" : "28006",
           "town"        : "Madrid",
           "lng"         : "-3.67886040",
           "lat"         : "40.43456190",
           "fax"         : null,
           "province"    : {
             "id"  : 28,
             "name": "Madrid"
           }
         },
         "years"             : [
           {
             "id"        : 1,
             "company_id": 1,
             "year"      : 2017,
             "created_at": "2018-10-08 09:27:11",
             "updated_at": "2018-10-08 09:27:11"
           }
         ]
       },
       "contact"   : {
         "id"              : 8233,
         "company_id"      : 1,
         "name"            : "TANIA",
         "surname"         : "MART\u00cd MOYA",
         "email"           : "cepyme500@cepyme.es",
         "phone_number"    : 914116161,
         "departament"     : "ECONOM\u00cdA E INNOVACI\u00d3N",
         "job_title"       : "RESPONSABLE T\u00c9CNICO DE CEPYME500",
         "linkedin"        : null,
         "default"         : 1,
         "job"             : 0,
         "linkedin_contacs": null,
         "image"           : {
           "id"           : 717,
           "name"         : "0bb4ed1e34aec13ea282ddfc5c949178.jpg",
           "original_name": "IMG_1736.jpg",
           "type"         : "jpg",
           "url"          : "https:\/\/cepyme500.s3.eu-west-1.amazonaws.com\/0bb4ed1e34aec13ea282ddfc5c949178.jpg"
         }
       }
     };

     $rootScope.token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjIsImlzcyI6Imh0dHA6Ly9sb2NhbGhvc3QvYXBpL2xvZ2luIiwiaWF0IjoxNzU3OTMyNDE3LCJleHAiOjE3NTc5MzYwMTcsIm5iZiI6MTc1NzkzMjQxNywianRpIjoibVliYmVjd2Y3ZEpFM2hHTiJ9.2HaEeK5FY1l3t98KbvGkH7Dyyv53VXCm-lFvn79k0Ro";
*/
      if ($translate.use() !== 'en') amMoment.changeLocale('es');

      /*
       Impossible to run with refreshToken
       authManager.redirectWhenUnauthenticated();
       */
      authManager.checkAuthOnRefresh();


      var translateLoadingSuccessListener = $rootScope.$on('$translateLoadingSuccess', function (e, data) {
        $rootScope.language = data.language;
        $http.defaults.headers.common['Accept-Language'] = data.language;
      });
      /*
       var translatePartialLoaderStructureChangedListener = $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
       $translate.refresh();
       });
       */

      var unauthorizedListener = $rootScope.$on('unauthorized', function () {
        $state.go('app.login');
      });

      $rootScope.$on('$destroy', function () {
        //translatePartialLoaderStructureChangedListener();
        unauthorizedListener();
        translateLoadingSuccessListener();
      });
    }

  }

)();

(function () {
  'use strict'

  angular
    .module('app')
    .provider('RefreshToken', RefreshToken)
    .provider('TwiceCallApi', TwiceCallApi)

  /** @ngInject */
  function RefreshToken() {
    this.getRefreshToken = function (URLS, $rootScope) {
      var initInjector = angular.injector(['ng'])
      var $http = initInjector.get('$http')
      var $q = initInjector.get('$q')
      var deferred = $q.defer()
      var settings = {
        method: 'GET',
        url: URLS.API + 'refreshToken',
        headers: {
          'Authorization': 'Bearer ' + $rootScope.token
        },
        timeout: deferred.promise,
        cache: false
      }
      var request = $http(settings)
      var promise = request.then(function (response) {
        return (response.data);
      }, function () {
        return ($q.reject("Something went wrong"));
      })

      promise.abort = function () {
        deferred.resolve();
      };
      promise.finally(
        function () {
          promise.abort = angular.noop;
          deferred = request = promise = null;
        }
      );
      return (promise);
    }
    this.$get = function () {
      return this;
    }
  }

  /** @ngInject */
  function TwiceCallApi() {
    return {
      $get: function ($rootScope, callData) {
        var initInjector = angular.injector(['ng'])
        var $http = initInjector.get('$http')
        var $q = initInjector.get('$q')
        var deferred = $q.defer()
        var settings = {
          method: callData.method,
          url: callData.url,
          headers: {
            'Authorization': 'Bearer ' + $rootScope.token
          },
          cache: false
        }
        return http(settings)

        function http(settings) {
          $http(settings)
            .then(httpOk)
            .catch(httpError)
          return deferred.promise
        }
        function httpOk(data) {
          deferred.resolve(data)
        }
        function httpError(data) {
          deferred.reject(data)
        }
      }
    }
  }
}());

( function () {
  'use strict';

  angular
    .module( 'app' )
    .filter( 'ProvinceFilter', ProvinceFilter )
    .filter( 'limitCaracters', limitCaracters )
    .filter( 'urlFilter', urlFilter )
    .filter( 'decodeHtml', decodeHtml )
    .filter('trustUrl', trustUrl);

  ProvinceFilter.$inject = [ 'ProvincesFactory' ];
  limitCaracters.$inject = [];
  urlFilter.$inject = [];
  decodeHtml.$inject = ['$sce'];
  trustUrl.$inject = ['$sce'];

  function decodeHtml ($sce) {
    return function ( s, checkImgOk ) {
      var out = '';
      if ( s == null ) return;
      var l = s.length;
      for ( var i = 0; i < l; i++ ) {
        var ch = s.charAt( i );
        if ( ch == '&' ) {
          var semicolonIndex = s.indexOf( ';', i + 1 );
          if ( semicolonIndex > 0 ) {
            var entity = s.substring( i + 1, semicolonIndex );
            if ( entity.length > 1 && entity.charAt( 0 ) == '#' ) {
              if ( !( entity.charAt( 1 ) == 'x' || entity.charAt( 1 ) == 'X' ) ) {
                ch = String.fromCharCode( entity.substring( 1 ) );
              } else {
                ch = String.fromCharCode(  '0' + entity.substring( 1 ) );
              }
            } else {
              switch ( entity ) {
                case 'quot':
                  ch = String.fromCharCode( 0x0022 );
                  break;
                case 'amp':
                  ch = String.fromCharCode( 0x0026 );
                  break;
                case 'lt':
                  ch = String.fromCharCode( 0x003c );
                  break;
                case 'gt':
                  ch = String.fromCharCode( 0x003e );
                  break;
                case 'nbsp':
                  ch = String.fromCharCode( 0x00a0 );
                  break;
                case 'iexcl':
                  ch = String.fromCharCode( 0x00a1 );
                  break;
                case 'cent':
                  ch = String.fromCharCode( 0x00a2 );
                  break;
                case 'pound':
                  ch = String.fromCharCode( 0x00a3 );
                  break;
                case 'curren':
                  ch = String.fromCharCode( 0x00a4 );
                  break;
                case 'yen':
                  ch = String.fromCharCode( 0x00a5 );
                  break;
                case 'brvbar':
                  ch = String.fromCharCode( 0x00a6 );
                  break;
                case 'sect':
                  ch = String.fromCharCode( 0x00a7 );
                  break;
                case 'uml':
                  ch = String.fromCharCode( 0x00a8 );
                  break;
                case 'copy':
                  ch = String.fromCharCode( 0x00a9 );
                  break;
                case 'ordf':
                  ch = String.fromCharCode( 0x00aa );
                  break;
                case 'laquo':
                  ch = String.fromCharCode( 0x00ab );
                  break;
                case 'not':
                  ch = String.fromCharCode( 0x00ac );
                  break;
                case 'shy':
                  ch = String.fromCharCode( 0x00ad );
                  break;
                case 'reg':
                  ch = String.fromCharCode( 0x00ae );
                  break;
                case 'macr':
                  ch = String.fromCharCode( 0x00af );
                  break;
                case 'deg':
                  ch = String.fromCharCode( 0x00b0 );
                  break;
                case 'plusmn':
                  ch = String.fromCharCode( 0x00b1 );
                  break;
                case 'sup2':
                  ch = String.fromCharCode( 0x00b2 );
                  break;
                case 'sup3':
                  ch = String.fromCharCode( 0x00b3 );
                  break;
                case 'acute':
                  ch = String.fromCharCode( 0x00b4 );
                  break;
                case 'micro':
                  ch = String.fromCharCode( 0x00b5 );
                  break;
                case 'para':
                  ch = String.fromCharCode( 0x00b6 );
                  break;
                case 'middot':
                  ch = String.fromCharCode( 0x00b7 );
                  break;
                case 'cedil':
                  ch = String.fromCharCode( 0x00b8 );
                  break;
                case 'sup1':
                  ch = String.fromCharCode( 0x00b9 );
                  break;
                case 'ordm':
                  ch = String.fromCharCode( 0x00ba );
                  break;
                case 'raquo':
                  ch = String.fromCharCode( 0x00bb );
                  break;
                case 'frac14':
                  ch = String.fromCharCode( 0x00bc );
                  break;
                case 'frac12':
                  ch = String.fromCharCode( 0x00bd );
                  break;
                case 'frac34':
                  ch = String.fromCharCode( 0x00be );
                  break;
                case 'iquest':
                  ch = String.fromCharCode( 0x00bf );
                  break;
                case 'Agrave':
                  ch = String.fromCharCode( 0x00c0 );
                  break;
                case 'Aacute':
                  ch = String.fromCharCode( 0x00c1 );
                  break;
                case 'Acirc':
                  ch = String.fromCharCode( 0x00c2 );
                  break;
                case 'Atilde':
                  ch = String.fromCharCode( 0x00c3 );
                  break;
                case 'Auml':
                  ch = String.fromCharCode( 0x00c4 );
                  break;
                case 'Aring':
                  ch = String.fromCharCode( 0x00c5 );
                  break;
                case 'AElig':
                  ch = String.fromCharCode( 0x00c6 );
                  break;
                case 'Ccedil':
                  ch = String.fromCharCode( 0x00c7 );
                  break;
                case 'Egrave':
                  ch = String.fromCharCode( 0x00c8 );
                  break;
                case 'Eacute':
                  ch = String.fromCharCode( 0x00c9 );
                  break;
                case 'Ecirc':
                  ch = String.fromCharCode( 0x00ca );
                  break;
                case 'Euml':
                  ch = String.fromCharCode( 0x00cb );
                  break;
                case 'Igrave':
                  ch = String.fromCharCode( 0x00cc );
                  break;
                case 'Iacute':
                  ch = String.fromCharCode( 0x00cd );
                  break;
                case 'Icirc':
                  ch = String.fromCharCode( 0x00ce );
                  break;
                case 'Iuml':
                  ch = String.fromCharCode( 0x00cf );
                  break;
                case 'ETH':
                  ch = String.fromCharCode( 0x00d0 );
                  break;
                case 'Ntilde':
                  ch = String.fromCharCode( 0x00d1 );
                  break;
                case 'Ograve':
                  ch = String.fromCharCode( 0x00d2 );
                  break;
                case 'Oacute':
                  ch = String.fromCharCode( 0x00d3 );
                  break;
                case 'Ocirc':
                  ch = String.fromCharCode( 0x00d4 );
                  break;
                case 'Otilde':
                  ch = String.fromCharCode( 0x00d5 );
                  break;
                case 'Ouml':
                  ch = String.fromCharCode( 0x00d6 );
                  break;
                case 'times':
                  ch = String.fromCharCode( 0x00d7 );
                  break;
                case 'Oslash':
                  ch = String.fromCharCode( 0x00d8 );
                  break;
                case 'Ugrave':
                  ch = String.fromCharCode( 0x00d9 );
                  break;
                case 'Uacute':
                  ch = String.fromCharCode( 0x00da );
                  break;
                case 'Ucirc':
                  ch = String.fromCharCode( 0x00db );
                  break;
                case 'Uuml':
                  ch = String.fromCharCode( 0x00dc );
                  break;
                case 'Yacute':
                  ch = String.fromCharCode( 0x00dd );
                  break;
                case 'THORN':
                  ch = String.fromCharCode( 0x00de );
                  break;
                case 'szlig':
                  ch = String.fromCharCode( 0x00df );
                  break;
                case 'agrave':
                  ch = String.fromCharCode( 0x00e0 );
                  break;
                case 'aacute':
                  ch = String.fromCharCode( 0x00e1 );
                  break;
                case 'acirc':
                  ch = String.fromCharCode( 0x00e2 );
                  break;
                case 'atilde':
                  ch = String.fromCharCode( 0x00e3 );
                  break;
                case 'auml':
                  ch = String.fromCharCode( 0x00e4 );
                  break;
                case 'aring':
                  ch = String.fromCharCode( 0x00e5 );
                  break;
                case 'aelig':
                  ch = String.fromCharCode( 0x00e6 );
                  break;
                case 'ccedil':
                  ch = String.fromCharCode( 0x00e7 );
                  break;
                case 'egrave':
                  ch = String.fromCharCode( 0x00e8 );
                  break;
                case 'eacute':
                  ch = String.fromCharCode( 0x00e9 );
                  break;
                case 'ecirc':
                  ch = String.fromCharCode( 0x00ea );
                  break;
                case 'euml':
                  ch = String.fromCharCode( 0x00eb );
                  break;
                case 'igrave':
                  ch = String.fromCharCode( 0x00ec );
                  break;
                case 'iacute':
                  ch = String.fromCharCode( 0x00ed );
                  break;
                case 'icirc':
                  ch = String.fromCharCode( 0x00ee );
                  break;
                case 'iuml':
                  ch = String.fromCharCode( 0x00ef );
                  break;
                case 'eth':
                  ch = String.fromCharCode( 0x00f0 );
                  break;
                case 'ntilde':
                  ch = String.fromCharCode( 0x00f1 );
                  break;
                case 'ograve':
                  ch = String.fromCharCode( 0x00f2 );
                  break;
                case 'oacute':
                  ch = String.fromCharCode( 0x00f3 );
                  break;
                case 'ocirc':
                  ch = String.fromCharCode( 0x00f4 );
                  break;
                case 'otilde':
                  ch = String.fromCharCode( 0x00f5 );
                  break;
                case 'ouml':
                  ch = String.fromCharCode( 0x00f6 );
                  break;
                case 'divide':
                  ch = String.fromCharCode( 0x00f7 );
                  break;
                case 'oslash':
                  ch = String.fromCharCode( 0x00f8 );
                  break;
                case 'ugrave':
                  ch = String.fromCharCode( 0x00f9 );
                  break;
                case 'uacute':
                  ch = String.fromCharCode( 0x00fa );
                  break;
                case 'ucirc':
                  ch = String.fromCharCode( 0x00fb );
                  break;
                case 'uuml':
                  ch = String.fromCharCode( 0x00fc );
                  break;
                case 'yacute':
                  ch = String.fromCharCode( 0x00fd );
                  break;
                case 'thorn':
                  ch = String.fromCharCode( 0x00fe );
                  break;
                case 'yuml':
                  ch = String.fromCharCode( 0x00ff );
                  break;
                case 'OElig':
                  ch = String.fromCharCode( 0x0152 );
                  break;
                case 'oelig':
                  ch = String.fromCharCode( 0x0153 );
                  break;
                case 'Scaron':
                  ch = String.fromCharCode( 0x0160 );
                  break;
                case 'scaron':
                  ch = String.fromCharCode( 0x0161 );
                  break;
                case 'Yuml':
                  ch = String.fromCharCode( 0x0178 );
                  break;
                case 'fnof':
                  ch = String.fromCharCode( 0x0192 );
                  break;
                case 'circ':
                  ch = String.fromCharCode( 0x02c6 );
                  break;
                case 'tilde':
                  ch = String.fromCharCode( 0x02dc );
                  break;
                case 'Alpha':
                  ch = String.fromCharCode( 0x0391 );
                  break;
                case 'Beta':
                  ch = String.fromCharCode( 0x0392 );
                  break;
                case 'Gamma':
                  ch = String.fromCharCode( 0x0393 );
                  break;
                case 'Delta':
                  ch = String.fromCharCode( 0x0394 );
                  break;
                case 'Epsilon':
                  ch = String.fromCharCode( 0x0395 );
                  break;
                case 'Zeta':
                  ch = String.fromCharCode( 0x0396 );
                  break;
                case 'Eta':
                  ch = String.fromCharCode( 0x0397 );
                  break;
                case 'Theta':
                  ch = String.fromCharCode( 0x0398 );
                  break;
                case 'Iota':
                  ch = String.fromCharCode( 0x0399 );
                  break;
                case 'Kappa':
                  ch = String.fromCharCode( 0x039a );
                  break;
                case 'Lambda':
                  ch = String.fromCharCode( 0x039b );
                  break;
                case 'Mu':
                  ch = String.fromCharCode( 0x039c );
                  break;
                case 'Nu':
                  ch = String.fromCharCode( 0x039d );
                  break;
                case 'Xi':
                  ch = String.fromCharCode( 0x039e );
                  break;
                case 'Omicron':
                  ch = String.fromCharCode( 0x039f );
                  break;
                case 'Pi':
                  ch = String.fromCharCode( 0x03a0 );
                  break;
                case ' Rho ':
                  ch = String.fromCharCode( 0x03a1 );
                  break;
                case 'Sigma':
                  ch = String.fromCharCode( 0x03a3 );
                  break;
                case 'Tau':
                  ch = String.fromCharCode( 0x03a4 );
                  break;
                case 'Upsilon':
                  ch = String.fromCharCode( 0x03a5 );
                  break;
                case 'Phi':
                  ch = String.fromCharCode( 0x03a6 );
                  break;
                case 'Chi':
                  ch = String.fromCharCode( 0x03a7 );
                  break;
                case 'Psi':
                  ch = String.fromCharCode( 0x03a8 );
                  break;
                case 'Omega':
                  ch = String.fromCharCode( 0x03a9 );
                  break;
                case 'alpha':
                  ch = String.fromCharCode( 0x03b1 );
                  break;
                case 'beta':
                  ch = String.fromCharCode( 0x03b2 );
                  break;
                case 'gamma':
                  ch = String.fromCharCode( 0x03b3 );
                  break;
                case 'delta':
                  ch = String.fromCharCode( 0x03b4 );
                  break;
                case 'epsilon':
                  ch = String.fromCharCode( 0x03b5 );
                  break;
                case 'zeta':
                  ch = String.fromCharCode( 0x03b6 );
                  break;
                case 'eta':
                  ch = String.fromCharCode( 0x03b7 );
                  break;
                case 'theta':
                  ch = String.fromCharCode( 0x03b8 );
                  break;
                case 'iota':
                  ch = String.fromCharCode( 0x03b9 );
                  break;
                case 'kappa':
                  ch = String.fromCharCode( 0x03ba );
                  break;
                case 'lambda':
                  ch = String.fromCharCode( 0x03bb );
                  break;
                case 'mu':
                  ch = String.fromCharCode( 0x03bc );
                  break;
                case 'nu':
                  ch = String.fromCharCode( 0x03bd );
                  break;
                case 'xi':
                  ch = String.fromCharCode( 0x03be );
                  break;
                case 'omicron':
                  ch = String.fromCharCode( 0x03bf );
                  break;
                case 'pi':
                  ch = String.fromCharCode( 0x03c0 );
                  break;
                case 'rho':
                  ch = String.fromCharCode( 0x03c1 );
                  break;
                case 'sigmaf':
                  ch = String.fromCharCode( 0x03c2 );
                  break;
                case 'sigma':
                  ch = String.fromCharCode( 0x03c3 );
                  break;
                case 'tau':
                  ch = String.fromCharCode( 0x03c4 );
                  break;
                case 'upsilon':
                  ch = String.fromCharCode( 0x03c5 );
                  break;
                case 'phi':
                  ch = String.fromCharCode( 0x03c6 );
                  break;
                case 'chi':
                  ch = String.fromCharCode( 0x03c7 );
                  break;
                case 'psi':
                  ch = String.fromCharCode( 0x03c8 );
                  break;
                case 'omega':
                  ch = String.fromCharCode( 0x03c9 );
                  break;
                case 'thetasym':
                  ch = String.fromCharCode( 0x03d1 );
                  break;
                case 'upsih':
                  ch = String.fromCharCode( 0x03d2 );
                  break;
                case 'piv':
                  ch = String.fromCharCode( 0x03d6 );
                  break;
                case 'ensp':
                  ch = String.fromCharCode( 0x2002 );
                  break;
                case 'emsp':
                  ch = String.fromCharCode( 0x2003 );
                  break;
                case 'thinsp':
                  ch = String.fromCharCode( 0x2009 );
                  break;
                case 'zwnj':
                  ch = String.fromCharCode( 0x200c );
                  break;
                case 'zwj':
                  ch = String.fromCharCode( 0x200d );
                  break;
                case 'lrm':
                  ch = String.fromCharCode( 0x200e );
                  break;
                case 'rlm':
                  ch = String.fromCharCode( 0x200f );
                  break;
                case 'ndash':
                  ch = String.fromCharCode( 0x2013 );
                  break;
                case 'mdash':
                  ch = String.fromCharCode( 0x2014 );
                  break;
                case 'lsquo':
                  ch = String.fromCharCode( 0x2018 );
                  break;
                case 'rsquo':
                  ch = String.fromCharCode( 0x2019 );
                  break;
                case 'sbquo':
                  ch = String.fromCharCode( 0x201a );
                  break;
                case 'ldquo':
                  ch = String.fromCharCode( 0x201c );
                  break;
                case 'rdquo':
                  ch = String.fromCharCode( 0x201d );
                  break;
                case 'bdquo':
                  ch = String.fromCharCode( 0x201e );
                  break;
                case 'dagger':
                  ch = String.fromCharCode( 0x2020 );
                  break;
                case 'Dagger':
                  ch = String.fromCharCode( 0x2021 );
                  break;
                case 'bull':
                  ch = String.fromCharCode( 0x2022 );
                  break;
                case 'hellip':
                  ch = String.fromCharCode( 0x2026 );
                  break;
                case 'permil':
                  ch = String.fromCharCode( 0x2030 );
                  break;
                case 'prime':
                  ch = String.fromCharCode( 0x2032 );
                  break;
                case 'Prime':
                  ch = String.fromCharCode( 0x2033 );
                  break;
                case 'lsaquo':
                  ch = String.fromCharCode( 0x2039 );
                  break;
                case 'rsaquo':
                  ch = String.fromCharCode( 0x203a );
                  break;
                case 'oline':
                  ch = String.fromCharCode( 0x203e );
                  break;
                case 'frasl':
                  ch = String.fromCharCode( 0x2044 );
                  break;
                case 'euro':
                  ch = String.fromCharCode( 0x20ac );
                  break;
                case 'image':
                  ch = String.fromCharCode( 0x2111 );
                  break;
                case 'weierp':
                  ch = String.fromCharCode( 0x2118 );
                  break;
                case 'real':
                  ch = String.fromCharCode( 0x211c );
                  break;
                case 'trade':
                  ch = String.fromCharCode( 0x2122 );
                  break;
                case 'alefsym':
                  ch = String.fromCharCode( 0x2135 );
                  break;
                case 'larr':
                  ch = String.fromCharCode( 0x2190 );
                  break;
                case 'uarr':
                  ch = String.fromCharCode( 0x2191 );
                  break;
                case 'rarr':
                  ch = String.fromCharCode( 0x2192 );
                  break;
                case 'darr':
                  ch = String.fromCharCode( 0x2193 );
                  break;
                case 'harr':
                  ch = String.fromCharCode( 0x2194 );
                  break;
                case 'crarr':
                  ch = String.fromCharCode( 0x21b5 );
                  break;
                case 'lArr':
                  ch = String.fromCharCode( 0x21d0 );
                  break;
                case 'uArr':
                  ch = String.fromCharCode( 0x21d1 );
                  break;
                case 'rArr':
                  ch = String.fromCharCode( 0x21d2 );
                  break;
                case 'dArr':
                  ch = String.fromCharCode( 0x21d3 );
                  break;
                case 'hArr':
                  ch = String.fromCharCode( 0x21d4 );
                  break;
                case 'forall':
                  ch = String.fromCharCode( 0x2200 );
                  break;
                case 'part':
                  ch = String.fromCharCode( 0x2202 );
                  break;
                case 'exist':
                  ch = String.fromCharCode( 0x2203 );
                  break;
                case 'empty':
                  ch = String.fromCharCode( 0x2205 );
                  break;
                case 'nabla':
                  ch = String.fromCharCode( 0x2207 );
                  break;
                case 'isin':
                  ch = String.fromCharCode( 0x2208 );
                  break;
                case 'notin':
                  ch = String.fromCharCode( 0x2209 );
                  break;
                case 'ni':
                  ch = String.fromCharCode( 0x220b );
                  break;
                case 'prod':
                  ch = String.fromCharCode( 0x220f );
                  break;
                case 'sum':
                  ch = String.fromCharCode( 0x2211 );
                  break;
                case 'minus':
                  ch = String.fromCharCode( 0x2212 );
                  break;
                case 'lowast':
                  ch = String.fromCharCode( 0x2217 );
                  break;
                case 'radic':
                  ch = String.fromCharCode( 0x221a );
                  break;
                case 'prop':
                  ch = String.fromCharCode( 0x221d );
                  break;
                case 'infin':
                  ch = String.fromCharCode( 0x221e );
                  break;
                case 'ang':
                  ch = String.fromCharCode( 0x2220 );
                  break;
                case 'and':
                  ch = String.fromCharCode( 0x2227 );
                  break;
                case 'or':
                  ch = String.fromCharCode( 0x2228 );
                  break;
                case 'cap':
                  ch = String.fromCharCode( 0x2229 );
                  break;
                case 'cup':
                  ch = String.fromCharCode( 0x222a );
                  break;
                case 'int':
                  ch = String.fromCharCode( 0x222b );
                  break;
                case 'there4':
                  ch = String.fromCharCode( 0x2234 );
                  break;
                case 'sim':
                  ch = String.fromCharCode( 0x223c );
                  break;
                case 'cong':
                  ch = String.fromCharCode( 0x2245 );
                  break;
                case 'asymp':
                  ch = String.fromCharCode( 0x2248 );
                  break;
                case 'ne':
                  ch = String.fromCharCode( 0x2260 );
                  break;
                case 'equiv':
                  ch = String.fromCharCode( 0x2261 );
                  break;
                case 'le':
                  ch = String.fromCharCode( 0x2264 );
                  break;
                case 'ge':
                  ch = String.fromCharCode( 0x2265 );
                  break;
                case 'sub':
                  ch = String.fromCharCode( 0x2282 );
                  break;
                case 'sup':
                  ch = String.fromCharCode( 0x2283 );
                  break;
                case 'nsub':
                  ch = String.fromCharCode( 0x2284 );
                  break;
                case 'sube':
                  ch = String.fromCharCode( 0x2286 );
                  break;
                case 'supe':
                  ch = String.fromCharCode( 0x2287 );
                  break;
                case 'oplus':
                  ch = String.fromCharCode( 0x2295 );
                  break;
                case 'otimes':
                  ch = String.fromCharCode( 0x2297 );
                  break;
                case 'perp':
                  ch = String.fromCharCode( 0x22a5 );
                  break;
                case 'sdot':
                  ch = String.fromCharCode( 0x22c5 );
                  break;
                case 'lceil':
                  ch = String.fromCharCode( 0x2308 );
                  break;
                case 'rceil':
                  ch = String.fromCharCode( 0x2309 );
                  break;
                case 'lfloor':
                  ch = String.fromCharCode( 0x230a );
                  break;
                case 'rfloor':
                  ch = String.fromCharCode( 0x230b );
                  break;
                case 'lang':
                  ch = String.fromCharCode( 0x2329 );
                  break;
                case 'rang':
                  ch = String.fromCharCode( 0x232a );
                  break;
                case 'loz':
                  ch = String.fromCharCode( 0x25ca );
                  break;
                case 'spades':
                  ch = String.fromCharCode( 0x2660 );
                  break;
                case 'clubs':
                  ch = String.fromCharCode( 0x2663 );
                  break;
                case 'hearts':
                  ch = String.fromCharCode( 0x2665 );
                  break;
                case 'diams':
                  ch = String.fromCharCode( 0x2666 );
                  break;
                default:
                  ch = '';
                  break;
              }
            }
            i = semicolonIndex;
          }
        }
        out += ch;
      }
      if ( checkImgOk ) {
        var matches = out.match( /<img([^>]+)src="[/]?([^"]+)"([^>]*)>|<( *)img( *)[/>|>]/g );
        var matchesF;
        var jsonMatches;
        if ( matches ) {
          for ( var i = 0; i < matches.length; i++ ) {
            matchesF = matches[ i ].replace( '<img src="', '' );
            matchesF = matchesF.replace( '" class="img-responsive">', '' );
            try {
              jsonMatches = JSON.parse( matchesF );
              if ( typeof jsonMatches == 'object' ) {
                out = out.replace( matchesF, jsonMatches.url );
              }
            } catch ( e ) {
              console.log( 'log: images inside' );
            }

          }

        }
      }
      return $sce.trustAsHtml(out);
    }
  }

  function ProvinceFilter ( ProvincesFactory ) {
    return function ( input, from ) {
      var to = 'id'
      if ( from == 'id' ) to = 'name';
      var provinces = ProvincesFactory.getProvinces();
      for ( var index = 0; index < provinces.length; index++ ) {
        if ( provinces[ index ][ from ] == input ) {
          input = provinces[ index ][ to ];
          return input;
        }
      }
      return input;
    };
  }

  function urlFilter () {
    return function ( url ) {
      if ( url ) {
        if ( url.substr( 0, 7 ) !== 'http://' && url.substr( 0, 8 ) !== 'https://' ) url = 'http://' + url;
      }
      return url;
    }
  }

  function limitCaracters () {
    return function ( input, max, plainText ) {
      if ( plainText ) {
        input = input ? String( input ).replace( /<[^>]+>/gm, '' ) : '';
      }
      return input;
    };
  }

  function trustUrl($sce) {
    return function ( input ) {
      return $sce.trustAsResourceUrl( input );
    };
  }

} )();

( function () {
  'use strict';

  angular
    .module( 'app' )
    .factory( 'ProvincesFactory', ProvincesFactory )
    .factory( 'CommunitiesFactory', CommunitiesFactory )
    .factory( 'BroadcastFactory', BroadcastFactory )
    .factory( 'CompaniesFactory', CompaniesFactory )
    .factory( 'CnaesFactory', CnaesFactory )
    .factory( 'ContactFactory', ContactFactory );

  ProvincesFactory.$inject = [];
  CommunitiesFactory.$inject = [];
  BroadcastFactory.$inject = [ '$rootScope', '$timeout' ];
  CompaniesFactory.$inject = [ 'DirectoryFactory', '$q' ];
  CnaesFactory.$inject = [ '$q', '$http', 'URLS', 'store' ];
  ContactFactory.$inject = [ '$q', '$http', 'URLS', 'toaster' ];


  /*
   name
   email
   company
   phone
   description
   */
  function ContactFactory ( $q, $http, URLS, toaster ) {
    var factory = {
      sendMessage: sendMessage
    };
    return factory;

    function sendMessage ( email ) {
      var deferred = $q.defer();
      var url = URLS.API + 'information';
      var settings = {
        url   : url,
        data  : email,
        method: 'POST',
        // withCredentials: true,
        cache : false
      }
      return http()

      function http () {
        $http( settings )
          .then( httpOk, httpError );
        return deferred.promise
      }

      function httpOk ( data ) {
        if ( typeof data !== 'undefined' ) {
          toaster.pop( {
                         type           : 'success',
                         title          : 'OK',
                         body           : 'Mensaje enviado correctamente',
                         showCloseButton: true,
                         timeout        : 2000
                       } );
          deferred.resolve( data );
        } else httpError();
      }

      function httpError () {
        toaster.pop( {
                       type           : 'error',
                       title          : 'Error',
                       body           : 'No ha sido posible enviar el mensaje',
                       showCloseButton: true,
                       timeout        : 2000
                     } );
        deferred.reject( 'error' );
      }
    }
  }

  /** @ngInject */
  function ProvincesFactory () {
    var factory = {
      getProvinces: getProvinces
    };
    return factory;

    ////////////////
    function getProvinces () {
      return [ { id: 2, name: "Albacete" }, { id: 3, name: "Alicante" }, { id: 4, name: "Almería" }, {
        id  : 1,
        name: "Alava"
      }, { id: 33, name: "Asturias" }, { id: 5, name: "Ávila" }, { id: 6, name: "Badajoz" }, {
        id  : 7,
        name: "Baleares"
      }, { id: 8, name: "Barcelona" }, { id: 48, name: "Vizcaya" }, { id: 9, name: "Burgos" }, {
        id  : 10,
        name: "Cáceres"
      }, { id: 11, name: "Cádiz" }, { id: 39, name: "Cantabria" }, { id: 12, name: "Castellón/Castelló" }, {
        id  : 13,
        name: "Ciudad Real"
      }, { id: 14, name: "Córdoba" }, { id: 15, name: "A Coruña" }, { id: 16, name: "Cuenca" }, {
        id  : 20,
        name: "Guipuzcoa"
      }, { id: 17, name: "Girona" }, { id: 18, name: "Granada" }, { id: 19, name: "Guadalajara" }, {
        id  : 21,
        name: "Huelva"
      }, { id: 22, name: "Huesca" }, { id: 23, name: "Jaén" }, { id: 24, name: "León" }, {
        id  : 25,
        name: "Lleida"
      }, { id: 27, name: "Lugo" }, { id: 28, name: "Madrid" }, { id: 29, name: "Málaga" }, {
        id  : 30,
        name: "Murcia"
      }, { id: 31, name: "Navarra" }, { id: 32, name: "Ourense" }, { id: 34, name: "Palencia" }, {
        id  : 35,
        name: "Las Palmas de Gran Canaria"
      }, { id: 36, name: "Pontevedra" }, { id: 26, name: "La Rioja" }, { id: 37, name: "Salamanca" }, {
        id  : 38,
        name: "Santa Cruz de Tenerife"
      }, { id: 40, name: "Segovia" }, { id: 41, name: "Sevilla" }, { id: 42, name: "Soria" }, {
        id  : 43,
        name: "Tarragona"
      }, { id: 44, name: "Teruel" }, { id: 45, name: "Toledo" }, { id: 46, name: "Valencia" }, {
        id  : 47,
        name: "Valladolid"
      }, { id: 49, name: "Zamora" }, { id: 50, name: "Zaragoza" }, { id: 51, name: "Ceuta" }, {
        id  : 52,
        name: "Melilla"
      } ];
    }
  }

  /** @ngInject */
  function CommunitiesFactory () {
    var factory = {
      getCommunities: getCommunities
    };
    return factory;

    ////////////////
    function getCommunities () {
      return [
        {
          'name'     : 'Andalucía',
          'provinces': [
            4, 11, 14, 18, 21, 23, 29, 41
          ]
        },
        {
          'name'     : 'Aragón',
          'provinces': [
            22,44,50
          ]
        },
        {
          'name'     : 'Asturias',
          'provinces': [
            33
          ]
        },
        {
          'name'     : 'Baleares',
          'provinces': [
            7
          ]
        },
        {
          'name'     : 'Castilla y León',
          'provinces': [
            5,9,24,34,37,40,42,47,49
          ]
        },
        {
          'name'     : 'Cantabria',
          'provinces': [
            39
          ]
        },
        {
          'name'     : 'Canarias',
          'provinces': [
            38,35
          ]
        },
        {
          'name'     : 'Castilla La Mancha',
          'provinces': [
            2,13,16,19,45
          ]
        },
        {
          'name'     : 'Cataluña',
          'provinces': [
            8,17,25,43
          ]
        },
        {
          'name'     : 'C. Valenciana',
          'provinces': [
            3,12,46
          ]
        },
        {
          'name'     : 'Extremadura',
          'provinces': [
            10,6
          ]
        },
        {
          'name'     : 'Galicia',
          'provinces': [
            15,27,32,36
          ]
        },
        {
          'name'     : 'La Rioja',
          'provinces': [
            26
          ]
        },
        {
          'name'     : 'Madrid',
          'provinces': [
            28
          ]
        },
        {
          'name'     : 'Murcia',
          'provinces': [
            30
          ]
        },
        {
          'name'     : 'Navarra',
          'provinces': [
            31
          ]
        },
        {
          'name'     : 'País Vasco',
          'provinces': [
            1,48,20
          ]
        }
      ];
    }
  }

  /** @ngInject */
  function CnaesFactory ( $q, $http, URLS, store ) {
    var factory = {
      getCnaes: getCnaes
    };
    return factory;

    ////////////////
    function getCnaes () {
      var deferred = $q.defer();
      var cnaes = store.get( 'cnaesV1' ) || [];
      if ( !cnaes.length ) {
        var settings = {
          method: 'GET',
          url   : URLS.API + 'cnaes',
          cache : false
        }
        $http( settings )
          .then( function ( data ) {
            deferred.resolve( data.data );
            store.set( 'cnaesV1', data.data )
          }, function () {
            deferred.reject();
          } );
      } else deferred.resolve( cnaes );
      return deferred.promise;
    }
  }

  function CompaniesFactory ( DirectoryFactory, $q ) {
    var companies = [];
    var factory = {
      getCompanies: getCompanies
    };
    return factory;


    function getCompanies ( id, name, onlyId ) {
      var deferred = $q.defer();
      if ( !companies.length ) {
        DirectoryFactory.getCompanies( { fields: 'id,name', limit: 9000, active: 1 } ).then( function ( data ) {
          companies = data.data;
          var specialCompanies = [
            { id: 1, name: 'CEPYME' },
            { id: 508, name: 'BANKINTER' },
            { id: 509, name: 'BME' },
            { id: 510, name: 'KAP' },
            { id: 1246, name: 'ICO - INSTITUTO DE CRÉDITO OFICIAL' }
          ];
          companies = companies.concat( specialCompanies );
          deferred.resolve( proccess() );
        } );
      } else {
        deferred.resolve( proccess() );
      }
      return deferred.promise;

      function proccess () {
        if ( name ) name = name.toUpperCase();
        var companiesResult = [];
        if ( id || name || onlyId ) {
          for ( var index = 0; index < companies.length; index++ ) {
            if ( id && companies[ index ].id == id ) break;
            if ( name && companies[ index ].name.search( name ) > -1 ) companiesResult.push( companies[ index ] );
            if ( onlyId ) companiesResult.push( companies[ index ].id );
          }
          if ( name || onlyId ) return companiesResult;
          else return companies[ index ];
        } else {
          return companies;
        }
      }
    }
  }

  /** @ngInject */
  function BroadcastFactory ( $rootScope, $timeout ) {
    return {
      send: function ( name, data ) {
        var timeout = $timeout( function () {
          $rootScope.$broadcast( name, data );
          $timeout.cancel( timeout );
        } );
      }
    }
  }
} )();

(function () {
    'use strict';

    angular.module('app')
      .directive('sideNavigation', sideNavigation)
      .directive('minimalizaSidebar', minimalizaSidebar)
      .directive('vectorMap', vectorMap)
      .directive('fullScroll', fullScroll)
      .directive('linkSidebar', linkSidebar)
      .directive('buttonLinkedin', buttonLinkedin)
      .directive('heightEqual', heightEqual)
      .directive('printBanner', printBanner)
      .directive('notification', notification)
      .directive('starRating', starRating)
      .directive('chosenCompanies', chosenCompanies);

    sideNavigation.$inject = ['$timeout'];
    minimalizaSidebar.$inject = ['$timeout'];
    vectorMap.$inject = ['$window', 'ISO3166', '$timeout', '$state'];
    fullScroll.$inject = ['$timeout'];
    linkSidebar.$inject = ['BroadcastFactory'];
    buttonLinkedin.$inject = ['$window', '$log', 'toaster'];
    heightEqual.$inject = ['$document', '$timeout', '$window'];
    printBanner.$inject = ['AdsFactory', '$window'];
    notification.$inject = ['LoggedService', 'BroadcastFactory'];
    chosenCompanies.$inject = ['DirectoryFactory', '$timeout', '$log'];


    function chosenCompanies(DirectoryFactory, $timeout, $log) {
      return {
        restrict: 'E',
        scope: {
          selectedCompany: '=',
          onCompanyChange: '&'
        },
        templateUrl: 'app/templates/chosen-companies.html',
        link: function (scope, element) {
          // ✅ Configuración inicial
          scope.isSearching = false;

          DirectoryFactory.searchCompanies('')
            .then(function (companies) {
              scope.companies = companies
            });

          // ✅ Función de búsqueda
          scope.searchCompanies = function (searchTerm) {
            /*
            // Validar longitud mínima
            if (!searchTerm || searchTerm.length < 3) {
              console.log('❌ Término muy corto, mínimo:', 3);
              return;
            }
            */
            scope.isSearching = true;

            DirectoryFactory.searchCompanies(searchTerm)
              .then(function (response) {

                // ✅ Actualizar la lista de empresas
                if (response && angular.isArray(response)) {
                  scope.companies = response;
                } else if (response && response.data && angular.isArray(response.data)) {
                  scope.companies = response.data;
                }

                // ✅ Forzar actualización del chosen
                $timeout(function () {
                  element.find('select').trigger('chosen:updated');
                  // Mantener el texto de búsqueda
                  element.find('.chosen-search input').val(searchTerm);
                }, 100);

              })
              .catch(function (error) {
                $log.error('❌ Error buscando empresas:', error);
                // Mantener empresas actuales en caso de error
              })
              .finally(function () {
                scope.isSearching = false;
              });
          };

          // ✅ Función de selección (sin cambios)
          scope.handleChange = function () {


            if (scope.selectedCompany) {
              var selectedCompany = scope.companies.find(function (c) {
                return c.id == scope.selectedCompany;
              });

              if (selectedCompany) {
                scope.onCompanyChange({
                  companyId: parseInt(scope.selectedCompany),
                  company: selectedCompany
                });
              }
            } else {
              scope.onCompanyChange();
            }
          };

          var searchTimeout;

          // ✅ Detectar escritura en el campo de búsqueda de Chosen
          element.on('keyup', '.chosen-search input', function (e) {
            if (e.which === 13) {
                return;
            }
            var searchTerm = e.target.value;

            // ✅ Debounce para evitar muchas llamadas
            if (searchTimeout) {
              $timeout.cancel(searchTimeout);
            }

            searchTimeout = $timeout(function () {
              scope.searchCompanies(searchTerm);
            }, 300);
          });

          // Evita que la tecla Enter haga un submit del formulario o recargue la página
          element.on('keydown', '.chosen-search input', function(e) {
              if (e.which === 13) {
                  e.preventDefault();
              }
          });

          // ✅ Cleanup
          scope.$on('$destroy', function () {
            if (searchTimeout) {
              $timeout.cancel(searchTimeout);
            }
          });
        }
      }
    }

    function notification(LoggedService, BroadcastFactory) {
      return {
        restrict: 'A',
        scope: {
          id: '=',
          notify: '=',
          type: '=',
          company: '=',
          date: '=',
          cepyme500: '@?'
        },
        templateUrl: 'app/templates/notification.html',
        link: function (scope, element) {
          scope.typeSidebar = 0;
          scope.icon = '';
          scope.text = '';
          if (scope.type == 'NoticeCreate') {
            scope.icon = 'fa fa-newspaper-o';
            scope.text = 'ha publicado una noticia';
            scope.typeSidebar = 5;
          } else if (scope.type == 'EventCreate') {
            scope.icon = 'fa fa-calendar';
            scope.text = 'ha publicado un evento';
            scope.typeSidebar = 7;
          } else if (scope.type == 'OfferCreate') {
            scope.icon = 'fa fa-tags';
            scope.text = 'ha publicado una oferta';
            scope.typeSidebar = 3;
          } else if (scope.type == 'ProjectNotification') {
            scope.icon = 'fa fa-handshake-o';
            scope.text = 'ha publicado un proyecto';
            scope.typeSidebar = 14;
          } else if (scope.type == 'SupplierActivate') {
            scope.icon = 'fa fa-check-square';
            scope.text = 'Hay un nuevo anunciante';
            scope.typeSidebar = 16;
          }
          element.on('click', function () {
            element.remove();
            BroadcastFactory.send('topNavBar', scope.cepyme500);
            LoggedService.notificationsRead(scope.notify);
          });
        }
      };
    }


    function printBanner(AdsFactory, $window) {
      return {
        restrict: 'A',
        scope: {
          id: '=',
          main: '@?'
        },
        templateUrl: 'app/templates/banner.html',
        link: function (scope, element) {
          AdsFactory.getPositions({}, scope.id).then(function (position) {
            scope.banner = position;
            $window.gtag('send', 'event', 'banner', 'impression', scope.banner.block.title, 2, {'nonInteraction': 1});
          }, function () {
            AdsFactory.getPositions({}, 1).then(function (positionFallback) {
              scope.banner = positionFallback;
            });
          });
          element.bind('click', function () {
            $window.gtag('send', 'event', 'banner', 'click', scope.banner.block.title, 1, {'nonInteraction': 1});
          })
        }
      };
    }

    function sideNavigation($timeout) {
      return {
        restrict: 'A',
        link: function (scope, element) {
          var timeout = $timeout(function () {
            element.metisMenu();
          });
          var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
          menuElement.click(function () {
            if (angular.element(window).width() < 769) {
              angular.element("body").toggleClass("mini-navbar");
            }
          });

          scope.$on('$destroy', function () {
            $timeout.cancel(timeout);
          });

        }
      };
    }

    function minimalizaSidebar($timeout) {
      return {
        restrict: 'A',
        template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="javascript:void(0);" ng-click="minimalize()"><em class="fa fa-bars"></em></a>',
        controller: function ($scope) {
          $scope.minimalize = function () {
            angular.element('body').toggleClass('mini-navbar');
            if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
              angular.element('#side-menu').hide();
              var timeout = $timeout(function () {
                angular.element('#side-menu').fadeIn(400);
              }, 200);

              $scope.$on('$destroy', function () {
                $timeout.cancel(timeout);
              })
            } else {
              angular.element('#side-menu').removeAttr('style');
            }
          };
        }
      };
    }

    function vectorMap($window, ISO3166, $timeout, $state) {
      return {
        restrict: 'E',
        scope: {
          emit: '@?',
          fillSelected: '@?',
          countries: '=?',
          noClickleabe: '@?',
          inHome: '@?',
          selectableOne: '@?'
        },
        templateUrl: 'app/templates/vector-map.html',
        link: function (scope, element) {
          var map;
          var timeout2;
          var timeout = $timeout(function () {
            if (!scope.fillSelected) scope.fillSelected = '#2184be';
            var regionsSelectableVar = true;
            if (scope.noClickleabe) regionsSelectableVar = false;
            if (!scope.countries) scope.countries = [];
            if (!scope.inHome && !scope.countries.length) scope.countries = ['ES'];
            if (scope.inHome) scope.selectableOne = true;
            map = new $window.jvm.Map({
              map: 'world_mill_en',
              backgroundColor: "transparent",
              container: element.find('div'),
              regionsSelectable: regionsSelectableVar,
              regionStyle: {
                initial: {
                  fill: '#666666',
                  stroke: 'none',
                  "stroke-width": 0,
                  "stroke-opacity": 0
                },
                hover: {
                  fill: '#000000',
                  cursor: 'pointer'
                },
                selected: {
                  fill: scope.fillSelected
                }
              },
              regionsSelectableOne: scope.selectableOne,
              selectedRegions: scope.countries,
              onRegionTipShow: function (event, label, code) {
                label.html(ISO3166.getCountryName(code))
              },
              onRegionSelected: function (event, code) {
                if (scope.inHome) $state.go('app.logged.home.countries', {code: code});
                timeout2 = $timeout(function () {
                  if (scope.emit) scope.$emit(scope.emit, map.getSelectedRegions());
                  if (scope.inHome) map.updateSize();
                }, 250);
              }
            });

            var watchListener = scope.$watch('countries', function (newVal, oldVal) {
              if (!angular.equals(newVal, oldVal)) {
                map.clearSelectedRegions();
                map.setSelectedRegions(newVal);
                scope.countries = newVal;
              }
            });

            scope.resset = function () {
              map.clearSelectedRegions()
            }
            scope.selectAll = function () {
              map.clearSelectedRegions();
              var all = ['AE', 'AF', 'AL', 'AM', 'AO', 'AR', 'AT', 'AU', 'AZ', 'BA', 'BD', 'BE', 'BF', 'BG', 'BI', 'BJ', 'BN', 'BO', 'BR', 'BS', 'BT', 'BW', 'BY', 'BZ', 'CA', 'CD', 'CF', 'CG', 'CH', 'CI', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DO', 'DZ', 'EC', 'EE', 'EG', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FR', 'GA', 'GB', 'GE', 'GH', 'GL', 'GM', 'GN', 'GQ', 'GR', 'GT', 'GW', 'GY', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IN', 'IQ', 'IR', 'IS', 'IT', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KP', 'KR', 'KW', 'KZ', 'LA', 'LB', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MD', 'ME', 'MG', 'MK', 'ML', 'MM', 'MN', 'MR', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NG', 'NI', 'NL', 'NO', 'NP', 'NZ', 'OM', 'PA', 'PE', 'PG', 'PH', 'PK', 'PL', 'PR', 'PS', 'PT', 'PY', 'QA', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SD', 'SE', 'SI', 'SK', 'SL', 'SN', 'SO', 'SR', 'SS', 'SV', 'SY', 'SZ', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TL', 'TM', 'TN', 'TR', 'TT', 'TW', 'TZ', 'UA', 'UG', 'US', 'UY', 'UZ', 'VE', 'VN', 'VU', 'YE', 'ZA', 'ZM', 'ZW', 'WS', 'XK', 'NY'];
              map.setSelectedRegions(all);
            }

            var mapRegionSelectedListener = scope.$on('mapRegionSelected', function (event, data) {
              event.preventDefault();
              map.setSelectedRegions(data.code);
            })

            var destroyMap = function () {
              element.remove();
            };

            scope.$on('$destroy', function () {
              destroyMap();
              mapRegionSelectedListener();
              $timeout.cancel(timeout);
              if (timeout2) $timeout.cancel(timeout2);
              watchListener();
            });

          }, 250)


        }
      }
    }

    function fullScroll($timeout) {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $timeout(function () {
            element.slimscroll({
              height: '100%',
              railOpacity: 0.9,
              alwaysVisible: true
            });
          });
        }
      };
    }

    function linkSidebar(BroadcastFactory) {
      return {
        restrict: 'A',
        scope: {
          data: '=?',
          id: '@?',
          type: '@'
        },
        link: function (scope, element) {
          if (typeof scope.data == 'undefined') scope.data = false;
          if (typeof scope.id == 'undefined') scope.id = false;
          /*
           var ang_element = angular.element(element);
           var raw_element = ang_element[0];
           */
          element.on('click', function () {
            BroadcastFactory.send('sideBarEvent', {
              data: scope.data,
              id: scope.id,
              type: scope.type
            });
          })
        }
      }
    }

    function buttonLinkedin($window, $log, toaster) {
      return {
        restrict: 'E',
        template: '',
        link: function (scope, element) {
          $window.IN = {};
          var scriptLinkedin = $window.document.createElement('script');
          scriptLinkedin.src = '//platform.linkedin.com/in.js';
          scriptLinkedin.textContent = '\napi_key: 77uj27wxhxolgw\nonLoad: linkedinInit\nlang: es_ES\n';
          $window.document.body.appendChild(scriptLinkedin);

          $window.linkedinInit = function () {
            element.bind('click', function () {
              element.parent('div').children('div').removeClass('hidden');
              if (!$window.IN.User.isAuthorized()) $window.IN.User.authorize(callbackFunction, callbackScope);
              else $log.log('Ya estás autorizado');
              $window.IN.Event.on($window.IN, "auth", getProfileData);
            });
          };

          function callbackFunction() {
            /*$log.log('callbackFunction', data)*/
            $window.IN.Event.on($window.IN, "auth", getProfileData);
          }

          function callbackScope() {
            $log.log('callbackScope')
          }

          function getProfileData() {
            /*$log.log('getProfileData')*/
            $window.IN.API.Raw("/people/~:(id,num-connections,picture-url,first-name,last-name,positions,public-profile-url,email-address)?format=json").result(onSuccess).error(onError);
          }

          function onSuccess(data) {
            /*$log.log('linkedinUser', data);*/
            if (typeof data !== 'undefined' && !angular.equals({}, data)) {
              toaster.pop({
                type: 'success',
                title: 'OK',
                body: 'Datos de usuario importados desde Linkedin',
                showCloseButton: true,
                timeout: 2000
              });
              scope.$emit('linkedinDataUser', {user: data});
              element.parent('div').parent('div').remove();
              if (typeof data.positions !== 'undefined' && !angular.equals({}, data.positions) && typeof data.positions.values !== 'undefined' && data.positions.values.length > 0 && typeof data.positions.values[0].company !== 'undefined' && typeof data.positions.values[0].company.id !== 'undefined' && data.positions.values[0].company.id) {
                $window.IN.API.Raw("/companies/" + data.positions.values[0].company.id + ":(name,universal-name,email-domains,ticker,website-url,industries,logo-url,square-logo-url,twitter-id,locations,description,num-followers)?format=json").result(onSuccessCompany).error(onErrorComapny);
              }
            } else {
              toaster.pop({
                type: 'error',
                title: 'Error',
                body: 'Error al importar los datos de usuario desde Linkedin',
                showCloseButton: true,
                timeout: 2000
              });
              element.parent('div').children('div').addClass('hidden');
            }
          }

          function onError(data) {
            toaster.pop({
              type: 'error',
              title: 'Error',
              body: 'Error al importar los datos de usuario desde Linkedin',
              showCloseButton: true,
              timeout: 2000
            });
            element.parent('div').children('div').addClass('hidden');
            $log.log('onError', data)
          }

          function onSuccessCompany(data) {
            /*$log.log('onSuccessCompany', data)*/
            toaster.pop({
              type: 'success',
              title: 'OK',
              body: 'Datos de empresa importados desde Linkedin',
              showCloseButton: true,
              timeout: 2000
            });
            scope.$emit('linkedinDataCompany', {company: data});
          }

          function onErrorComapny(data) {
            toaster.pop({
              type: 'error',
              title: 'Error',
              body: 'Error al importar los datos de empresa desde Linkedin',
              showCloseButton: true,
              timeout: 2000
            });
            $log.log('onErrorComapny', data)
          }
        }
      };
    }

    function heightEqual($document, $timeout, $window) {
      return {
        restrict: 'A',
        link: function () {
          var boxContents = $document[0].getElementsByClassName('height-equal-child');
          var boxHeight = 0;

          $timeout(function () {
            equalize();
          }, 250);

          angular.element($window).bind('resize', function () {
            equalize();
          })

          function equalize() {
            for (var index = 0; index < boxContents.length; index++) {
              if (boxContents[index].clientHeight > boxHeight) boxHeight = boxContents[index].clientHeight;
            }
            for (index = 0; index < boxContents.length; index++) {

              boxContents[index].style.minHeight = boxHeight + 'px';
            }
          }
        }
      }
    }

    function starRating() {
      return {
        restrict: 'E',
        template: '<ul class="rating">' + '  <li ng-repeat="star in stars" ng-class="star" ng-click="toggle($index)">' + '<i class="fa fa-star"></i>' + '</li>' + '</ul>',
        scope: {
          ratingValue: '=',
          max: '=',
          noUpdate: '=',
          onRatingSelected: '&',
          ratingDefault: ' = '
        },
        link: function (scope) {
          var updateStars = function () {
            scope.stars = [];
            for (var i = 0; i < scope.max; i++) {
              scope.stars.push({
                filled: i < scope.ratingValue
              });
            }
          };
          //alert(scope.ratingValue);
          scope.toggle = function (index) {
            if (!scope.noUpdate) {
              scope.ratingValue = index + 1;
              scope.onRatingSelected({
                rating: index + 1
              });
            }
          };

          scope.$watch('ratingValue',
            function () {
              updateStars();
            }
          );
        }
      };
    }

  }

)
();

(function () {
  'use strict';

  angular.module('app')
    .controller('IndexController', IndexController)

  IndexController.$inject = ['$scope', '$rootScope', '$timeout', 'ContactFactory', 'SUMMERNOTE'];

  /** @ngInject */
  function IndexController($scope, $rootScope, $timeout, ContactFactory, SUMMERNOTE) {
    var vm = this;
    var timeoutPaste = null;

    vm.messageModule = {
      message: {
        name: '',
        company: '',
        email: '',
        phone: '',
        description: ''
      }
    }
    vm.messageModule.config = SUMMERNOTE;
    vm.messageModule.loading = false;

    // Full height of sidebar
    function fix_height() {
      var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
      angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

      var navbarHeight = angular.element('nav.navbar-default').height();
      var wrapperHeight = angular.element('#page-wrapper').height();

      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
      } else if (navbarHeight < wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() + "px");
      }

      if (angular.element('body').hasClass('fixed-nav')) {
        if (navbarHeight > wrapperHeight) {
          angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
        } else {
          angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
        }
      }
    }

    angular.element(window).bind("load resize scroll", function () {
      if (!angular.element("body").hasClass('body-small')) {
        fix_height();
      }
    });

    // Move right sidebar top after scroll
    angular.element(window).scroll(function () {
      if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav')) {
        angular.element('#right-sidebar').addClass('sidebar-top');
      } else {
        angular.element('#right-sidebar').removeClass('sidebar-top');
      }
    });

    var timeout = $timeout(function () {
      fix_height();
    });

    vm.messageModule.senMessage = function (form) {
      if (form.$valid) {
        if ($rootScope.myUser) {
          vm.messageModule.message.name = $rootScope.myUser.contact.name + ' ' + $rootScope.myUser.contact.surname;
          vm.messageModule.message.company = $rootScope.myUser.company.name;
          vm.messageModule.message.email = $rootScope.myUser.contact.email;
          vm.messageModule.message.phone = $rootScope.myUser.contact.phone_number;
        }
        vm.messageModule.loading = true;
        ContactFactory.sendMessage(vm.messageModule.message).then(function () {
          vm.messageModule.message.description = '';
          form.description.$dirty = false;
          form.$submitted = false;
        }).finally(function () {
          vm.messageModule.loading = false;
        });
      }

    };

    $scope.$on('$timeout', function () {
      $timeout.cancel(timeout);
      if (timeoutPaste) $timeout.cancel(timeoutPaste);
    });

    vm.pasteSummernote = function () {
      timeoutPaste = $timeout(function () {
        vm.messageModule.message.description = vm.messageModule.message.description.replace(/style="[^"]*"/g, "");
      }, 500);
    };

  }

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function () {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  });

})();


( function () {
  'use strict';


  angular.module( 'app' )
         .constant( 'SUMMERNOTE', {
           height            : 300,
           disableDragAndDrop: true,
           toolbar           : [
             [ 'edit', [ 'undo', 'redo' ] ],
             [ 'headline', [ 'style' ] ],
             [ 'style', [ 'bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough' ] ],
             [ 'textsize', [ 'fontsize' ] ],
             [ 'fontclr', [ 'color' ] ],
             [ 'alignment', [ 'ul', 'ol', 'paragraph', 'lineheight' ] ],
             [ 'height', [ 'height' ] ],
             [ 'table', [ 'table' ] ],
             [ 'insert', [ 'link', 'hr' ] ],
             [ 'view', [ 'codeview' ] ]
           ]
         } )
         .constant( 'LANGUAGES', {
           'LOCALES'          : [ {
             'code': 'es',
             'name': 'Español'
           },
                                  {
                                    'code': 'en',
                                    'name': 'English'
                                  }
           ],
           'PREFERREDLANGUAGE': 'es',
           'FALLBACKLANGUAGE' : 'es'
         } )
         .constant( 'URLS', {
/*
           'API'   : 'http://localhost/api/',
           'API_WL': [ 'localhost' ]

 */
            'API'   : 'https://www.cepyme500.com/api/',
            'API_WL': [ 'cepyme500.com' ]


         } )
         .constant( 'YEARS', {
           'FINANCIALSINIT': 2013,
           'ACTUAL'        : 2025,
           'ALL'           : [
             {
               'name' : 'Edición 2025',
               'value': 2025
             },
             {
               'name' : 'Edición 2024',
               'value': 2024
             },
             {
               'name' : 'Edición 2023',
               'value': 2023
             },
             {
               'name' : 'Edición 2022',
               'value': 2022
             },
             {
               'name' : 'Edición 2021',
               'value': 2021
             },
             {
               'name' : 'Edición 2020',
               'value': 2020
             },
             {
               'name' : 'Edición 2019',
               'value': 2019
             },
             {
               'name' : 'Edición 2018',
               'value': 2018
             },
             {
               'name' : 'Edición 2017',
               'value': 2017
             },
             {
               'name' : 'Todas',
               'value': 'all'
             }
           ]
         } )
         .constant( 'STRIPE', {
           'key': 'pk_live_v4hUQAzFeyszawy9oqXVW92K'
           //'key': 'pk_test_5jwhRyJoJPdDjuVAbgeai6kl00ZeQESAdf'
         } );
} )();

( function () {
  'use strict';

  angular.module( 'app' )
         .config( routerConfig );

  routerConfig.$inject = [
    '$httpProvider',
    '$stateProvider',
    '$urlRouterProvider',
    '$translateProvider',
    '$translatePartialLoaderProvider',
    'LANGUAGES',
    '$locationProvider',
    'jwtOptionsProvider',
    'URLS',
    'RefreshTokenProvider',
    '$provide'
  ];

  /** @ngInject */
  function routerConfig ( $httpProvider, $stateProvider, $urlRouterProvider, $translateProvider, $translatePartialLoaderProvider, LANGUAGES, $locationProvider, jwtOptionsProvider, URLS, RefreshTokenProvider, $provide ) {
    var cancelRefresh = false;
    $locationProvider
      .html5Mode( true )
      .hashPrefix( '!' );

    $httpProvider.useApplyAsync( true );
    $httpProvider.defaults.headers.common[ 'Content-Type' ] = 'application/json';
    $httpProvider.defaults.headers.common[ 'Accept' ] = 'application/json';
    /*
     $translatePartialLoaderProvider.addPart('general');
     $translatePartialLoaderProvider.addPart('directives');
     $translatePartialLoaderProvider.addPart('login');
     $translatePartialLoaderProvider.addPart('home');
     */

    $translateProvider
      .registerAvailableLanguageKeys( [ 'en', 'es' ], {
        'en_*': 'en',
        'es_*': 'es'
      } )
      .determinePreferredLanguage()
      /*.useLoader('$translatePartialLoader', {
       urlTemplate: 'i18n/{part}-{lang}.json'
       })*/
      .useStaticFilesLoader( {
                              prefix: 'https://d1ctjvbswpi1h9.cloudfront.net/app_dist/i18n/locale-',
                               // old prefix: 'https://s3-eu-west-1.amazonaws.com/staticcepyme500/app_dist/i18n/locale-',
                               //prefix: '../i18n/locale-',
                               suffix: '-v11.json'
                             } )
      .useMissingTranslationHandlerLog()
      .preferredLanguage( LANGUAGES.FALLBACKLANGUAGE )
      .fallbackLanguage( LANGUAGES.FALLBACKLANGUAGE )
      .useLocalStorage()
      .useLoaderCache( true )
      .useSanitizeValueStrategy( 'escaped' );


    $provide.decorator( 'mFormatFilter', [ 'moment', function ( moment ) {
      return function newFilter ( m, format, tz ) {
        //if (!(moment.isMoment(m))) {
        if ( !m ) {
          return '';
        }
        return tz ? moment.tz( m, tz ).format( format ) : moment( m ).format( format );
      };
    } ] );


    jwtOptionsProvider.config( {
                                 whiteListedDomains: URLS.API_WL,
                                 //whiteListedDomains: ['http://127.0.0.1:8000'],
                                 /*
                                  Impossible to run with refreshToken
                                  unauthenticatedRedirectPath: '/login',
                                  unauthenticatedRedirector: ['$state', function($state) {
                                  $state.go('app.login');
                                  }],
                                  */
                                 tokenGetter       : [ 'options', '$rootScope', function ( options, $rootScope ) {
                                   if ( options && ( options.url.substr( options.url.length - 5 ) === '.html' || options.url.substr( options.url.length - 5 ) === '.json' || options.url.substr( options.url.length - 3 ) === '.js' ) ) return null;
                                   else if ( !options ) return null;
                                   else {
                                     return $rootScope.token;
                                   }
                                 } ]
                               } );
    $httpProvider.interceptors.push( 'jwtInterceptor' );

    function responseHttpInterceptor ( $rootScope, $injector, $timeout ) {
      return {
        'responseError': function ( responseError ) {
          var $state = $injector.get( '$state' );
          if ( typeof responseError === 'undefined' ) responseError = { data: { error: 'Bad Request | URL' } }
          else if ( $state.current.name == 'app.logged.mailbox' ||   $state.current.name == 'app.logged.mailbox.compose') {
            return responseError;
          } else if ( $state.current.name != 'app.password_recovery' && $state.current.name != 'app.password_recovery_first' && $state.current.name != 'app.login' && typeof responseError.config !== 'undefined' && typeof responseError.config.url !== 'undefined' && responseError.config.url !== URLS.API + 'login' && responseError.status === 401 && responseError.config.url.substr( responseError.config.url.length - 12 ) !== 'refreshToken' ) {
            if ( !cancelRefresh ) {
              cancelRefresh = true;
              RefreshTokenProvider.getRefreshToken( URLS, $rootScope ).then( function ( data ) {
                $timeout( function () {
                  cancelRefresh = false;
                }, 30000 );
                $rootScope.token = data.token;

                $timeout( function () {
                  if ( $state.current.name == 'app.login' ) $state.go( 'app.logged.home' );
                  else {
                    console.log( 'refresh ok' );
                    $state.reload();
                  }
                } );
              }, function () {
                console.log( '403' );
                $rootScope.$broadcast( 'unauthorized' );
              } )
            }
            return null;
          } else if ( $state.current.name == 'app.logged.shop' && ( (typeof responseError.statusText !== 'undefined' && responseError.statusText == 'Payment Required') || responseError.status === 400 )  ) {
            console.log( responseError );
            return responseError;
          } else if ( $state.current.name == 'app.logged.premium' ) {
            return responseError;
          } else if ( $state.current.name == 'app.login' ) {
            return responseError;
          }
          //  return responseError;
        }
      }
    }

    $httpProvider.interceptors.push( responseHttpInterceptor )

    $stateProvider
      .state( 'app', {
        abstract    : true,
        templateUrl : "app/templates/app.html",
        controller  : "IndexController",
        controllerAs: "Index"
      } )
      .state( 'app.pay_advertiser', {
        url         : "/pay_advertiser/{code}",
        templateUrl : "app/pay_advertiser/pay.html",
        controller  : "payAdvertiserController",
        controllerAs: "payAdvertiser"
      } )
      .state( 'app.login', {
        url         : "/login",
        templateUrl : "app/login/login.html",
        controller  : "LoginController",
        controllerAs: "Login"
      } )
      .state( 'app.password_recovery_first', {
        url         : "/password_recovery",
        templateUrl : "app/login/password_recovery_first.html",
        controller  : "PasswordRecoveryController",
        controllerAs: "PasswordRecovery"
      } )
      .state( 'app.password_recovery', {
        url         : "/password_recovery/{token}/{email}",
        templateUrl : "app/login/password_recovery.html",
        controller  : "PasswordRecoveryController",
        controllerAs: "PasswordRecovery"
      } )
      .state( 'app.logged', {
        abstract: true,
        views   : {
          ""                  : {
            templateUrl : "app/templates/logged.html",
            controller  : "LoggedController",
            controllerAs: "Logged"
          },
          "sidebar@app.logged": {
            templateUrl : "app/templates/logged_sidebar.html",
            controller  : "SidebarController",
            controllerAs: "Sidebar"
          }
        }
      } )
      .state( 'app.logged.map', {
        url         : "/map",
        templateUrl : "app/logged/map/map.html",
        controller  : "MapController",
        controllerAs: "Map",
        data        : {
          languageTemplate: 'map'
        }
      } )
      .state( 'app.logged.home', {
        url         : "/",
        templateUrl : "app/logged/home/home.html",
        controller  : "HomeController",
        controllerAs: "Home",
        data        : {
          languageTemplate: 'home'
          /*
           Impossible to run with refreshToken
           ,requiresLogin: true
           */
        }
      } )
      .state( 'app.logged.home.countries', {
        url  : 'countries/{code}',
        views: {
          'vmapcountries@app.logged.home': {
            templateUrl : "app/logged/home/countries.html",
            controller  : "CountriesController",
            controllerAs: "Countries"
          }
        }
      } )
      .state( 'app.logged.users', {
        url         : "/users",
        templateUrl : "app/logged/users/users.html",
        controller  : "UsersController",
        controllerAs: "Users",
        data        : {
          languageTemplate: 'users'
        }
      } )
      .state( 'app.logged.profile', {
        url         : "/profile",
        templateUrl : "app/logged/profile/profile.html",
        controller  : "ProfileController",
        controllerAs: "Profile",
        data        : {
          languageTemplate: 'profile'
        }
      } )
      .state( 'app.logged.profile.step_one', {
        url         : "/step_one/{id}",
        templateUrl : "app/logged/profile/step_one.html",
        controller  : "ProfileStep1Controller",
        controllerAs: "ProfileStep1"
      } )
      .state( 'app.logged.profile.step_two_financials', {
        url         : "/step_two_financials",
        templateUrl : "app/logged/profile/step_two_financials.html",
        controller  : "ProfileStep2FinancialsController",
        controllerAs: "ProfileStep2Financials"
      } )
      .state( 'app.logged.profile.step_three', {
        url         : "/step_three",
        templateUrl : "app/logged/profile/step_three.html",
        controller  : "ProfileStep3Controller",
        controllerAs: "ProfileStep3"
      } )
      .state( 'app.logged.profile.step_four', {
        url         : "/step_four",
        templateUrl : "app/logged/profile/step_four.html",
        controller  : "ProfileStep4Controller",
        controllerAs: "ProfileStep4"
      } )
      .state( 'app.logged.profile.step_five', {
        url         : "/step_five/{id}",
        templateUrl : "app/logged/profile/step_five.html",
        controller  : "ProfileStep5Controller",
        controllerAs: "ProfileStep5"
      } )
      .state( 'app.logged.profile.step_six', {
        url         : "/step_six/{id}",
        templateUrl : "app/logged/profile/step_six.html",
        controller  : "ProfileStep6Controller",
        controllerAs: "ProfileStep6"
      } )
      .state( 'app.logged.myweb', {
        url         : "/myweb/{id}",
        templateUrl : "app/logged/myweb/myweb.html",
        controller  : "MyWebController",
        controllerAs: "MyWeb",
        data        : {
          languageTemplate: 'myweb'
        }
      } )
      .state( 'app.logged.directory', {
        url         : "/directory",
        templateUrl : "app/logged/directory/directory.html",
        controller  : "DirectoryController",
        controllerAs: "Directory",
        data        : {
          languageTemplate: 'directory'
        }
      } )
      .state( 'app.logged.directory.companies', {
        url         : "/companies/{id}",
        templateUrl : "app/logged/directory/companies.html",
        controller  : "CompaniesController",
        controllerAs: "Companies"
      } )
      .state( 'app.logged.directory.contacts', {
        url         : "/contacts/{id}",
        templateUrl : "app/logged/directory/contacts.html",
        controller  : "ContactsController",
        controllerAs: "Contacts"
      } )
      .state( 'app.logged.mailbox', {
        url         : "/mailbox",
        templateUrl : "app/logged/mailbox/mailbox.html",
        controller  : "MailboxController",
        controllerAs: "Mailbox",
        data        : {
          languageTemplate: 'mailbox'
        }
      } )
      .state( 'app.logged.mailbox.compose', {
        url: "/compose/{id}"
      } )
      .state( 'app.logged.mailbox.email_view', {
        url: "/email_view/{id}"
      } )
      /*
      .state( 'app.logged.offers', {
        url         : "/offers/{id}",
        templateUrl : "app/logged/offers/offers.html",
        controller  : "OffersController",
        controllerAs: "Offers",
        data        : {
          languageTemplate: 'offers'
        }
      } )
       */
      .state( 'app.logged.press_releases', {
        url         : "/press_releases/{id}",
        templateUrl : "app/logged/press.releases/press.releases.html",
        controller  : "PressReleasesListController",
        controllerAs: "PressReleasesList",
        data        : {
          languageTemplate: 'press_releases'
        }
      } )
      /*
      .state( 'app.logged.employment', {
        url         : "/employment/{id}",
        templateUrl : "app/logged/employment/employment.html",
        controller  : "EmploymentController",
        controllerAs: "Employment",
        data        : {
          languageTemplate: 'employment'
        }
      } )
      .state( 'app.logged.projects', {
        url         : "/projects/{id}",
        templateUrl : "app/logged/projects/projects.html",
        controller  : "ProjectsController",
        controllerAs: "Projects",
        data        : {
          languageTemplate: 'projects'
        }
      } )
      .state( 'app.logged.advertisers', {
        url         : "/advertisers",
        templateUrl : "app/logged/advertisers/advertisers.html",
        controller  : "AdvertisersController",
        controllerAs: "Advertisers",
        data        : {
          languageTemplate: 'advertisers'
        }
      } )
      .state( 'app.logged.advertisers.advertiser', {
        url: "/advertiser/{id}"
      } )
      .state( 'app.logged.advertisers.compose', {
        url: "/compose/{id}"
      } )
      .state( 'app.logged.startups', {
        url         : "/startups/{id}",
        templateUrl : "app/logged/startups/startups.html",
        controller  : "StartupsController",
        controllerAs: "Startups",
        data        : {
          languageTemplate: 'startups'
        }
      } )
       */
      .state( 'app.logged.cepyme500tv', {
        url         : "/cepyme500tv/{id}",
        templateUrl : "app/logged/cepyme500tv/cepyme500tv.html",
        controller  : "TvController",
        controllerAs: "TV",
        data        : {
          languageTemplate: 'cepyme500tv'
        }
      } )
      .state( 'app.logged.news', {
        url         : "/news",
        templateUrl : "app/logged/news/news.html",
        controller  : "NewsController",
        controllerAs: "News",
        data        : {
          languageTemplate: 'news'
        }
      } )
      .state( 'app.logged.events', {
        url         : "/events",
        params      : {
          "date": null
        },
        templateUrl : "app/logged/events/events.html",
        controller  : "EventsController",
        controllerAs: "Events",
        data        : {
          languageTemplate: 'events'
        }
      } )
      .state( 'app.logged.events.event', {
        url: "/event/{id}"
      } )
      .state( 'app.logged.events.compose', {
        url: "/compose/{id}"
      } )
      /*
      .state( 'app.logged.shop', {
        url         : "/shop/{id}",
        templateUrl : "app/logged/shop/shop.html",
        controller  : "ShopController",
        controllerAs: "Shop",
        data        : {
          languageTemplate: 'shop'
        },
        params      : {
          id: '0'
        }
      } )
      .state( 'app.logged.shop.edit', {
        url   : "/edit/{id}",
        views : {
          '': {
            templateUrl : "app/logged/shop/edit.html",
            controller  : "ShopEditController",
            controllerAs: "ShopEdit"
          }
        },
        params: {
          id: '0'
        }
      } )
       */
      .state( 'app.logged.faqs', {
        url        : "/faqs",
        templateUrl: "app/views/faqs.html",
        data       : {
          languageTemplate: 'faqs'
        }
      } )
      /*
      .state( 'app.logged.ads', {
        url         : "/ads",
        abstract    : true,
        templateUrl : "app/logged/ads/ads.html",
        controller  : "AdsController",
        controllerAs: "Ads",
        data        : {
          languageTemplate: 'ads'
        }
      } )
      .state( 'app.logged.ads.banners', {
        url        : "/banners",
        templateUrl: "app/logged/ads/banners.html"
      } )
      .state( 'app.logged.ads.banners.edit', {
        url        : "/edit/{id}/{index}",
        templateUrl: "app/logged/ads/edit_banner.html",
        params     : {
          id   : '0',
          index: '0'
        }
      } )
      .state( 'app.logged.ads.positions', {
        url        : "/positions",
        templateUrl: "app/logged/ads/positions.html"
      } )
      .state( 'app.logged.ads.positions.edit', {
        url        : "/edit/{id}/{index}",
        templateUrl: "app/logged/ads/edit_position.html",
        params     : {
          id   : '0',
          index: '0'
        }
      } )
       */
      .state( 'app.logged.magazine', {
        url         : "/magazine",
        templateUrl : "app/logged/magazine/magazine.html",
        controller  : "MagazineController",
        controllerAs: "Magazine",
        data        : {
          languageTemplate: 'magazine'
        }
      } )
      .state( 'app.logged.stats', {
        url         : "/stats",
        templateUrl : "app/logged/stats/stats.html",
        controller  : "StatsController",
        controllerAs: "Stats",
        data        : {
          languageTemplate: 'stats'
        }
      } )
      .state( 'app.logged.contactCepyme', {
        url        : "/contact_cepyme",
        templateUrl: "app/views/contact.html",
        data       : {
          languageTemplate: 'contact'
        }
      } )
      .state( 'app.logged.legal_advice', {
        url        : '/legal_advice',
        templateUrl: "app/views/legal_advice.html",
        data       : {
          languageTemplate: 'legal_advice'
        }
      } )
      .state( 'app.logged.privacy_policy', {
        url        : '/privacy_policy',
        templateUrl: "app/views/privacy_policy.html"
      } )
      .state( 'app.logged.partners_training', {
        url         : "/partners_training/{id}",
        templateUrl : "app/logged/partners_training/partners_training.html",
        controller  : "PartnersTrainingController",
        controllerAs: "PartnersTraining",
        data        : {
          languageTemplate: 'partnersTraining'
        }
      } )
      .state( 'app.logged.patrons', {
        url         : "/patrons/{id}",
        templateUrl : "app/logged/patrons/patrons.html",
        controller  : "PatronsController",
        controllerAs: "Patrons",
        data        : {
          languageTemplate: 'patrons'
        }
      } )
      /*
      .state( 'app.logged.bankinter', {
        url        : '/bankinter',
        templateUrl: "app/views/bankinter.html"
      } )
      .state( 'app.logged.santander', {
        url        : '/santander',
        templateUrl: "app/views/santander.html"
      } )
      .state( 'app.logged.ico', {
        url        : '/ico',
        templateUrl: "app/views/ico.html"
      } )
      .state( 'app.logged.bme', {
        url        : '/bme',
        templateUrl: "app/views/bme.html"
      } )
       */
      .state( 'app.logged.premium', {
        url        : '/premium',
        templateUrl: "app/logged/premium/premium.html"
      } )
      /*
       .state('app.logged.premium', {
       url: '/premium',
       templateUrl: "app/logged/premium/premium.html",
       controller: "PremiumController",
       controllerAs: "Premium"
       })
       */
      .state( 'app.logged.guide', {
        url        : '/guide',
        templateUrl: "app/views/guide.html"
      } )
      .state( 'app.logged.certificate', {
        url        : '/certificate',
        templateUrl: "app/views/certificate.html"
      } )
      /*
      .state( 'app.logged.worldpact', {
        url         : '/worldpact',
        templateUrl : "app/logged/world.pact/worldpact.html",
        controller  : "WorldPactController",
        controllerAs: "WorldPact"
      } )
      .state( 'app.logged.worldpact.module', {
        url        : '/module/{id}',
        params     : {
          id: '1'
        },
        templateUrl: "app/logged/world.pact/worldpact.module.html"
      } )
      .state( 'app.logged.wpact_stats', {
        url         : '/wpact_stats',
        templateUrl : "app/logged/world.pact/worldpact.stats.html",
        controller  : "WorldPactStatsController",
        controllerAs: "WorldPactStats"
      } );
    */
    $urlRouterProvider.otherwise( '/login' );
  }
} )();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/pay_advertiser/pay.html","<div class=\"top-navigation\"><div id=\"page-wrapper\" class=\"gray-bg dashboards_top\"><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"m-b-md\"><img alt=\"Logo CEPYME500\" src=\"https://d3cbxno87ymraz.cloudfront.net/app/assets/images/logo_semi_transparent.png\" class=\"img-responsive center-block\"></div><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\">Pago alta anunciante <img alt=\"Tarjetas de crédito\" class=\"m-l-sm\" src=\"https://d3cbxno87ymraz.cloudfront.net/app/assets/images/credit_cards/credit.png\"></h3></div><div class=\"ibox-content\" ng-if=\"payAdvertiser.code && !payAdvertiser.complete\" ng-class=\"{\'sk-loading\': payAdvertiser.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><p class=\"m-b-md\">Introduce los datos de tu tarjeta de crédito para validar el pago para participar como anunciante en el proyecto CEPYME500</p><form class=\"form-inline advertiser-form-pay\" name=\"formPay\" ng-submit=\"payAdvertiser.submit(formPay)\" novalidate=\"\"><div class=\"form-group block m-b-md\" ng-class=\"{\'has-error\': (formPay.card_number.$dirty || formPay.$submitted) && formPay.card_number.$invalid}\"><label class=\"control-label\">Número Tarjeta:</label> <input class=\"form-control\" type=\"text\" name=\"card_number\" ng-model=\"payAdvertiser.card.card_number\" cc-format=\"\" cc-number=\"\" cc-eager-type=\"\" ng-required=\"true\"> <img alt=\"Tarjetas de crédito\" ng-src=\"https://d3cbxno87ymraz.cloudfront.net/app/assets/images/credit_cards/{{formPay.card_number.$ccEagerType}}.png\"><p ng-show=\"(formPay.card_number.$dirty || formPay.$submitted) && formPay.card_number.$invalid\" class=\"text-danger\" translate-cloak=\"\">Revisa este campo</p></div><div class=\"form-group m-r-md\" ng-class=\"{\'has-error\': (formPay.card_exp_month.$dirty || formPay.$submitted) && formPay.card_exp_month.$invalid}\"><label class=\"control-label\">Mes Caducidad:</label> <input class=\"form-control min-card-input\" name=\"card_exp_month\" ng-model=\"payAdvertiser.card.card_exp_month\" cc-exp-month=\"\" ng-required=\"true\"><p>&nbsp;<span ng-show=\"(formPay.card_exp_month.$dirty || formPay.$submitted) && formPay.card_exp_month.$invalid\" class=\"text-danger\" translate-cloak=\"\">Revisa este campo</span></p></div><div class=\"form-group m-r-md\" ng-class=\"{\'has-error\': (formPay.card_exp_year.$dirty || formPay.$submitted) && formPay.card_exp_year.$invalid}\"><label class=\"control-label\">Año Caducidad:</label> <input class=\"form-control min-card-input\" name=\"card_exp_year\" ng-model=\"payAdvertiser.card.card_exp_year\" cc-exp-year=\"\" ng-required=\"true\"><p>&nbsp;<span ng-show=\"(formPay.card_exp_year.$dirty || formPay.$submitted) && formPay.card_exp_year.$invalid\" class=\"text-danger\" translate-cloak=\"\">Revisa este campo</span></p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (formPay.card_cvc.$dirty || formPay.$submitted) && formPay.card_cvc.$invalid}\"><label class=\"control-label\">CVC:</label> <input class=\"form-control min-card-input\" type=\"text\" name=\"card_cvc\" ng-model=\"payAdvertiser.card.card_cvc\" cc-cvc=\"\" ng-required=\"true\"><p>&nbsp;<span ng-show=\"(formPay.card_cvc.$dirty || formPay.$submitted) && formPay.card_cvc.$invalid\" class=\"text-danger\" translate-cloak=\"\">Revisa este campo</span></p></div><div class=\"block\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"!formPay.$valid\">Pagar 19,90€</button></div></form></div><div class=\"ibox-content\" ng-if=\"!payAdvertiser.code\">Necesitas un número de referencia, por favor ponte en contacto con CEPYME (cepyme500@cepyme.es) para solicitar uno</div><div class=\"ibox-content\" ng-if=\"payAdvertiser.complete\"><p class=\"text-success\">Pago realizado, muchas gracias</p></div></div></div></div></div>");
$templateCache.put("app/login/login.html","<div class=\"top-navigation\"><div id=\"page-wrapper\" class=\"gray-bg dashboards_top\"><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"middle-box text-center loginscreen\" style=\"margin-top: 0\"><div><img alt=\"Logo CEPYME500\" src=\"https://d3cbxno87ymraz.cloudfront.net/certificate/2025/certificate_cepyme500_2025_original_solid_back.png\" class=\"img-responsive center-block m-b-lg\"><h3 translate-cloak=\"\">{{\'login.title\' | translate}}</h3><form class=\"m-t\" name=\"loginForm\" role=\"form\" ng-submit=\"Login.loginSubmit(loginForm)\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': (loginForm.email.$dirty || loginForm.$submitted) && loginForm.email.$invalid}\"><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"Login.user.email\" placeholder=\"{{\'login.email\' | translate}}\" required=\"\"><p ng-show=\"(loginForm.email.$dirty || loginForm.$submitted) && loginForm.email.$invalid\" class=\"help-block text-danger\">Revisa este campo</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (loginForm.password.$dirty || loginForm.password.$submitted) && loginForm.password.$invalid}\"><input type=\"password\" class=\"form-control\" name=\"password\" ng-model=\"Login.user.password\" placeholder=\"{{\'login.password\' | translate}}\" required=\"\"><p ng-show=\"(loginForm.password.$dirty || loginForm.$submitted) && loginForm.password.$invalid\" class=\"help-block text-danger\">Revisa este campo</p></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\" ng-disabled=\"Login.loading\" translate-cloak=\"\"><em class=\"fa fa-spinner\" ng-if=\"Login.loading\"></em>{{\'login.btn\' | translate}}</button><p class=\"m-t-lg\"><a ui-sref=\"^.password_recovery_first\"><small translate-cloak=\"\">{{\'login.recovery\' | translate}}</small></a></p><p class=\"m-t-lg\" translate=\"login.asesor\"></p></form></div></div></div></div></div>");
$templateCache.put("app/login/password_recovery.html","<div class=\"top-navigation\"><div id=\"page-wrapper\" class=\"gray-bg dashboards_top\"><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"middle-box text-center loginscreen\" style=\"margin-top: 0\"><div><img alt=\"Logo CEPYME500\" src=\"https://d3cbxno87ymraz.cloudfront.net/certificate/2024/certificate_cepyme500_2024_original_solid_back.png\" class=\"img-responsive center-block m-b-lg\"><h3 translate-cloak=\"\">{{\'recovery.title2\' | translate}}</h3><div ng-if=\"!PasswordRecovery.message\"><form class=\"m-t\" name=\"RecoveryForm\" role=\"form\" ng-submit=\"PasswordRecovery.recoverySubmit(RecoveryForm, true)\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': (RecoveryForm.email.$dirty || RecoveryForm.$submitted) && RecoveryForm.email.$invalid}\"><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"PasswordRecovery.recovery.email\" disabled=\"\" placeholder=\"{{\'login.email\' | translate}}\" required=\"\"><p ng-show=\"(RecoveryForm.email.$dirty || RecoveryForm.$submitted) && RecoveryForm.email.$invalid\" class=\"help-block text-danger\">Revisa este campo</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (RecoveryForm.password.$dirty || RecoveryForm.$submitted) && RecoveryForm.password.$invalid}\"><input type=\"password\" class=\"form-control\" name=\"password\" ng-model=\"PasswordRecovery.recovery.password\" placeholder=\"{{\'login.password\' | translate}}\" ng-minlength=\"9\" required=\"\"><p ng-show=\"(RecoveryForm.password.$dirty || RecoveryForm.$submitted) && RecoveryForm.password.$invalid\" class=\"help-block text-danger\">Revisa este campo, mínimo 9 caracteres</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (RecoveryForm.password_confirmation.$dirty || RecoveryForm.$submitted) && RecoveryForm.password_confirmation.$invalid}\"><input type=\"password\" class=\"form-control\" name=\"password_confirmation\" ng-model=\"PasswordRecovery.recovery.password_confirmation\" placeholder=\"{{\'recovery.password_confirmation\' | translate}}\" ng-minlength=\"9\" required=\"\"><p ng-show=\"(RecoveryForm.password_confirmation.$dirty || RecoveryForm.$submitted) && ((PasswordRecovery.recovery.password_confirmation != PasswordRecovery.recovery.password) || RecoveryForm.password_confirmation.$invalid)\" class=\"help-block text-danger\">Revisa este campo, debe coincidir con el campo contraseña</p></div><div class=\"sk-spinner sk-spinner-double-bounce\" ng-if=\"PasswordRecovery.loading\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><button ng-disabled=\"PasswordRecovery.loading || (PasswordRecovery.recovery.password_confirmation != PasswordRecovery.recovery.password) || RecoveryForm.password.$invalid\" type=\"submit\" class=\"btn btn-primary block full-width m-b\" translate-cloak=\"\">{{\'recovery.btn2\' | translate}}</button></form></div><div class=\"m-t-md\"><a href=\"javascript:void(0);\" ui-sref=\"^.login\">Ir al login</a></div></div></div></div></div></div>");
$templateCache.put("app/login/password_recovery_first.html","<div class=\"top-navigation\"><div id=\"page-wrapper\" class=\"gray-bg dashboards_top\"><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"middle-box text-center loginscreen\" style=\"margin-top: 0\"><div><img alt=\"Logo CEPYME500\" src=\"https://d3cbxno87ymraz.cloudfront.net/certificate/2025/certificate_cepyme500_2025_original_solid_back.png\" class=\"img-responsive center-block m-b-lg\"><h3 translate-cloak=\"\">{{\'recovery.title\' | translate}}</h3><div ng-if=\"!PasswordRecovery.message\"><form class=\"m-t\" name=\"RecoveryForm\" role=\"form\" ng-submit=\"PasswordRecovery.recoverySubmit(RecoveryForm)\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': (RecoveryForm.email.$dirty || RecoveryForm.$submitted) && RecoveryForm.email.$invalid}\"><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"PasswordRecovery.recovery.email\" placeholder=\"{{\'login.email\' | translate}}\" required=\"\"><p ng-show=\"(RecoveryForm.email.$dirty || RecoveryForm.$submitted) && RecoveryForm.email.$invalid\" class=\"help-block text-danger\">Revisa este campo</p></div><div class=\"sk-spinner sk-spinner-double-bounce\" ng-if=\"PasswordRecovery.loading\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><button ng-if=\"!PasswordRecovery.loading\" type=\"submit\" class=\"btn btn-primary block full-width m-b\" translate-cloak=\"\">{{\'recovery.btn\' | translate}}</button></form></div><div ng-if=\"PasswordRecovery.message\" class=\"text-success\">Se te ha enviado un mail con las instrucciones para recuperar tu contraseña</div></div></div></div></div></div>");
$templateCache.put("app/views/bankinter.html","<div class=\"wrapper wrapper-content animated fadeInRight relative\"><div class=\"loading-iframe\"><iframe title=\"Web de Bankinter\" src=\"https://upthemedia.com/cepyme500_partners/bankinter.html\" style=\"position: absolute; width:105%; height: 90vh; border: none\"></iframe></div></div>");
$templateCache.put("app/views/bme.html","<div class=\"wrapper wrapper-content animated fadeInRight relative\"><div class=\"loading-iframe\"><iframe title=\"Web de BME\" src=\"https://upthemedia.com/cepyme500_partners/bme.html\" style=\"position: absolute; width:105%; height: 90vh; border: none\"></iframe></div></div>");
$templateCache.put("app/views/certificate.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\" translate-cloak=\"\">{{\'certificate.web.title\' | translate}}</h3></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-3\"><div class=\"p-sm\"><a href=\"https://www.cepyme500.com/empresa/{{myUser.company.id}}\" target=\"_blank\"><img alt=\"Sello CEPYME500\" src=\"https://d3cbxno87ymraz.cloudfront.net/certificate/general/certificate_cepyme500_original_transparent.png\" style=\"max-width:100%;\"></a></div><div class=\"m-t-md\"><p><strong class=\"text-success\" translate-cloak=\"\">{{\'certificate.web.copy_paste\' | translate}}</strong></p><pre><code>&lta href=\"https://www.cepyme500.com/empresa/{{myUser.company.id}}\" target=\"_blank\">&ltimg src=\"https://d3cbxno87ymraz.cloudfront.net/certificate/general/certificate_cepyme500_original_transparent.png\" style=\"max-width:100%\">&lt/a></code></pre></div></div><div class=\"col-xs-12 col-md-3\"><div class=\"bg-dark p-sm\"><a href=\"https://www.cepyme500.com/empresa/{{myUser.company.id}}\" target=\"_blank\"><img alt=\"Sello CEPYME500\" src=\"https://d3cbxno87ymraz.cloudfront.net/certificate/general/certificate_cepyme500_original_solid_back.png\" style=\"max-width: 100%;\"></a></div><div class=\"m-t-md\"><p><strong class=\"text-success\" translate-cloak=\"\">{{\'certificate.web.copy_paste\' | translate}}</strong></p><pre><code>&lta href=\"https://www.cepyme500.com/empresa/{{myUser.company.id}}\" target=\"_blank\">&ltimg src=\"https://d3cbxno87ymraz.cloudfront.net/certificate/general/certificate_cepyme500_original_solid_back.png\" style=\"max-width:100%\">&lt/a></code></pre></div></div><div class=\"col-xs-12 col-md-3\"><div class=\"bg-dark p-sm\"><a href=\"https://www.cepyme500.com/empresa/{{myUser.company.id}}\" target=\"_blank\"><img alt=\"Sello CEPYME500\" src=\"https://d3cbxno87ymraz.cloudfront.net/certificate/general/certificate_cepyme500_original_inverse_transparent.png\" style=\"max-width:100%;\"></a></div><div class=\"m-t-md\"><p><strong class=\"text-success\" translate-cloak=\"\">{{\'certificate.web.copy_paste\' | translate}}</strong></p><pre><code>&lta href=\"https://www.cepyme500.com/empresa/{{myUser.company.id}}\" target=\"_blank\">&ltimg src=\"https://d3cbxno87ymraz.cloudfront.net/certificate/general/certificate_cepyme500_original_inverse_transparent.png\" style=\"max-width:100%\">&lt/a></code></pre></div></div></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\" translate-cloak=\"\">{{\'certificate.print.title\' | translate}}</h3></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-md-3\"><div class=\"p-sm\"><a href=\"https://www.cepyme500.com/empresa/{{myUser.company.id}}\" target=\"_blank\"><img alt=\"Sello CEPYME500\" src=\"https://d3cbxno87ymraz.cloudfront.net/certificate/general/certificate_cepyme500_original_transparent.png\" style=\"max-width: 100%;\"></a></div><div class=\"m-t-md\"><p class=\"text-center\"><strong class=\"text-success\"><a href=\"https://d3cbxno87ymraz.cloudfront.net/certificate/general/logo_cepyme500_curvas.eps\" target=\"_blank\"><span translate-cloak=\"\">{{\'certificate.print.download\' | translate}}</span> <em class=\"fa fa-cloud-download\"></em></a></strong></p></div></div></div></div></div></div>");
$templateCache.put("app/views/contact.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\" translate-cloak=\"\">{{\'contact_module.title\'| translate}}</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\':Index.messageModule.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><form name=\"ContactForm\" ng-submit=\"Index.messageModule.senMessage(ContactForm)\"><div class=\"form-group\" ng-class=\"{\'has-error\': (ContactForm.description.$dirty || ContactForm.$submitted) && ContactForm.description.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'contact_module.message\'| translate}}</label><div class=\"form-group-summernote\"><summernote on-paste=\"Index.pasteSummernote()\" ng-if=\"Index.messageModule.config\" name=\"description\" id=\"description\" config=\"Index.messageModule.config\" ng-model=\"Index.messageModule.message.description\" required=\"\"></summernote></div><p ng-show=\"(ContactForm.description.$dirty || ContactForm.$submitted) && ContactForm.description.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'contact_module.review\'| translate}}</p><div class=\"m-t-md\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"Index.messageModule.loading\" translate-cloak=\"\">{{\'contact_module.btn.send\'| translate}}</button></div></div></form></div><div class=\"col-md-5 col-md-offset-1 col-xs-12\"><div class=\"m-t-md\"><img alt=\"Logo CEPYME\" src=\"https://d3cbxno87ymraz.cloudfront.net/app/assets/images/cepyme.png\" class=\"img-responsive\"></div><div class=\"m-t-md\"><address><div><strong>CEPYME</strong></div><div>C.I.F. G-28511897</div><div class=\"m-t-md\">C/Diego de León, 50</div><div>28006 MADRID</div><div><em class=\"fa fa-phone\"></em> +34 91 411 61 61<br><em class=\"fa fa-envelope\"></em> cepyme500@cepyme.es</div></address></div></div></div></div></div></div>");
$templateCache.put("app/views/faqs.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><h1 translate-cloak=\"\">{{\'faqs.title\' | translate}}</h1><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq1 = !faq1\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.1.title\' | translate}}</a></div></div><div uib-collapse=\"faq1\"><div class=\"faq-answer\"><p translate-cloak=\"\" translate=\"faqs.1.text\"></p></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq2 = !faq2\" ng-init=\"faq2 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.2.title\' | translate}}</a></div></div><div uib-collapse=\"faq2\"><div class=\"faq-answer\"><p translate-cloak=\"\" translate=\"faqs.2.text\"></p></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq3 = !faq3\" ng-init=\"faq3 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.3.title\' | translate}}</a></div></div><div uib-collapse=\"faq3\"><div class=\"faq-answer\"><p translate-cloak=\"\" translate=\"faqs.3.text\"></p></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq4 = !faq4\" ng-init=\"faq4 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.4.title\' | translate}}</a></div></div><div uib-collapse=\"faq4\"><div class=\"faq-answer\"><p translate-cloak=\"\" translate=\"faqs.4.text\"></p></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq5 = !faq5\" ng-init=\"faq5 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.5.title\' | translate}}</a></div></div><div uib-collapse=\"faq5\"><div class=\"faq-answer\"><div translate-cloak=\"\" translate=\"faqs.5.text\"></div></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq6 = !faq6\" ng-init=\"faq6 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.6.title\' | translate}}</a></div></div><div uib-collapse=\"faq6\"><div class=\"faq-answer\"><div translate-cloak=\"\" translate=\"faqs.6.text\"></div></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq7 = !faq7\" ng-init=\"faq7 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.7.title\' | translate}}</a></div></div><div uib-collapse=\"faq7\"><div class=\"faq-answer\"><div translate-cloak=\"\" translate=\"faqs.7.text\"></div></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq8 = !faq8\" ng-init=\"faq8 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.8.title\' | translate}}</a></div></div><div uib-collapse=\"faq8\"><div class=\"faq-answer\"><div translate-cloak=\"\" translate=\"faqs.8.text\"></div></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq9 = !faq9\" ng-init=\"faq9 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.9.title\' | translate}}</a></div></div><div uib-collapse=\"faq9\"><div class=\"faq-answer\"><p translate-cloak=\"\" translate=\"faqs.9.text\"></p></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq10 = !faq10\" ng-init=\"faq10 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.10.title\' | translate}}</a></div></div><div uib-collapse=\"faq10\"><div class=\"faq-answer\"><div translate-cloak=\"\" translate=\"faqs.10.text\"></div></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq11 = !faq11\" ng-init=\"faq11 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.11.title\' | translate}}</a></div></div><div uib-collapse=\"faq11\"><div class=\"faq-answer\"><div translate-cloak=\"\" translate=\"faqs.11.text\"></div></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq12 = !faq12\" ng-init=\"faq12 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.12.title\' | translate}}</a></div></div><div uib-collapse=\"faq12\"><div class=\"faq-answer\"><div translate-cloak=\"\" translate=\"faqs.12.text\"></div></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq15 = !faq15\" ng-init=\"faq15 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.15.title\' | translate}}</a></div></div><div uib-collapse=\"faq15\"><div class=\"faq-answer\"><p translate-cloak=\"\" translate=\"faqs.15.text\"></p></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq16 = !faq16\" ng-init=\"faq16 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.16.title\' | translate}}</a></div></div><div uib-collapse=\"faq16\"><div class=\"faq-answer\"><p translate-cloak=\"\" translate=\"faqs.16.text\"></p></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq17 = !faq17\" ng-init=\"faq17 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.17.title\' | translate}}</a></div></div><div uib-collapse=\"faq17\"><div class=\"faq-answer\"><p translate-cloak=\"\" translate=\"faqs.17.text\"></p></div></div></div><div class=\"faq-item\"><div class=\"row\"><div class=\"col-xs-10\"><a ng-click=\"faq19 = !faq19\" ng-init=\"faq19 = true\" class=\"faq-question\" translate-cloak=\"\">{{\'faqs.19.title\' | translate}}</a></div></div><div uib-collapse=\"faq19\"><div class=\"faq-answer\"><p translate-cloak=\"\" translate=\"faqs.19.text\"></p></div></div></div></div>");
$templateCache.put("app/views/guide.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><iframe title=\"Web de la guía de usuario\" src=\"https://upthemedia.com/cepyme500_partners/guide.html\" style=\"position: absolute; width:100%; height: 90vh; border: none\"></iframe></div>");
$templateCache.put("app/views/ico.html","<div class=\"wrapper wrapper-content animated fadeInRight relative\"><div class=\"loading-iframe\"><iframe title=\"Web de BME\" src=\"https://upthemedia.com/cepyme500_partners/ico.html\" style=\"position: absolute; width:105%; height: 90vh; border: none\"></iframe></div></div>");
$templateCache.put("app/views/legal_advice.html","<div class=\"wrapper wrapper-content animated fadeInRight legal-advice\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\'legal_advice.title\' | translate}}</h5></div><div class=\"ibox-content\"><ul><li><h4 translate-cloak=\"\">{{\'legal_advice.1.title\' | translate}}</h4><p>{{\'legal_advice.1.sentence\' | translate}}</p></li><li><h4 translate-cloak=\"\">{{\'legal_advice.2.title\' | translate}}</h4><p translate-cloak=\"\" translate=\"\">{{\'legal_advice.2.sentence\'}}</p></li><li><h4 translate-cloak=\"\">{{\'legal_advice.3.title\' | translate}}</h4><p translate-cloak=\"\" translate=\"\">{{\'legal_advice.3.sentence\'}}</p></li><li><h4 translate-cloak=\"\">{{\'legal_advice.4.title\' | translate}}</h4><p translate-cloak=\"\" translate=\"\">{{\'legal_advice.4.sentence\'}}</p></li><li><h4 translate-cloak=\"\">{{\'legal_advice.5.title\' | translate}}</h4><p translate-cloak=\"\" translate=\"\">{{\'legal_advice.5.sentence\'}}</p></li><li><h4 translate-cloak=\"\">{{\'legal_advice.6.title\' | translate}}</h4><p translate-cloak=\"\">{{\'legal_advice.6.sentence\' | translate}}</p></li><li><h4 translate-cloak=\"\">{{\'legal_advice.7.title\' | translate}}</h4><p translate-cloak=\"\">{{\'legal_advice.7.sentence\' | translate}}</p></li><li><h4 translate-cloak=\"\">{{\'legal_advice.8.title\' | translate}}</h4><p translate-cloak=\"\" translate=\"\">{{\'legal_advice.8.sentence\'}}</p></li><li><h4 translate-cloak=\"\">{{\'legal_advice.9.title\' | translate}}</h4><p translate-cloak=\"\">{{\'legal_advice.9.sentence\' | translate}}</p></li><li><h4 translate-cloak=\"\">{{\'legal_advice.10.title\' | translate}}</h4><p translate-cloak=\"\">{{\'legal_advice.10.sentence\' | translate}}</p></li><li><h4 translate-cloak=\"\">{{\'legal_advice.11.title\' | translate}}</h4><p translate-cloak=\"\">{{\'legal_advice.11.sentence\' | translate}}</p></li><li><h4 translate-cloak=\"\">{{\'legal_advice.12.title\' | translate}}</h4><p translate-cloak=\"\">{{\'legal_advice.12.sentence\' | translate}}</p></li></ul></div></div></div></div></div>");
$templateCache.put("app/views/privacy_policy.html","<div class=\"wrapper wrapper-content animated fadeInRight legal-advice\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">Política de privacidad</h5></div><div class=\"ibox-content\"><div class=\"politica-privacidad\"><p><strong>1.<u><strong>POLITICA DE PRIVACIDAD. INTRODUCCIÓN.</strong></u></strong></p><p>La presente POLÍTICA DE PRIVACIDAD es parte integrante del Aviso Legal de la Web <a href=\"https://www.cepyme500.com/\">www.cepyme500.com</a></p><p>Las Organizaciones Empresariales que componen <strong>la Confederación Española de la Pequeña y Mediana Empresa (CEPYME)</strong> debemos cumplir rigurosos estándares y políticas a la hora de tratar sus datos personales. Con este fin, implementamos los requisitos contenidos en el Reglamento General de la Unión Europea de Protección de Datos (\"<strong>RGPD</strong>\") así como en otras disposiciones legales que pudiera resultar aplicables.</p><p>Por ello, <strong>CEPYME, Calle Diego de León 50 3ªPlanta , 28006, Madrid</strong>, respeta su privacidad y la de sus datos personales. Con tal fin perseguimos garantizar que sus datos personales estén protegidos al adoptar las medidas de seguridad técnicas y organizativas que satisfagan los estándares de seguridad actuales.</p><p>Dado que <strong>CEPYME</strong>, para el acceso a determinados contenidos o servicios del Sitio Web <a href=\"http://www.cepyme500.com/\">www.cepyme500.com</a> , dispone de formularios que requieran recabar de los usuarios datos de carácter personal, la información facilitada será utilizada por <strong>CEPYME</strong> exclusivamente para las finalidades que se informen en cada caso, solicitando en cada caso su consentimiento expreso, así como, en su caso, a la cesión a destinatarios tales como las Organizaciones que componen <strong>CEPYME</strong> para el envío de información y publicidad mediante correo electrónico o postal.</p><p><strong>2.<u><strong>RESPONSABLE DEL TRATAMIENTO</strong></u></strong></p><p><strong>¿Quién es el responsable de sus datos?</strong></p><ul><li><strong>Titular:</strong><strong></strong>CONFEDERACIÓN ESPAÑOLA DE LA PEQUEÑA Y MEDIANA EMPRESA (en adelante, <strong>“</strong><em><strong>CEPYME</strong></em><strong>”</strong>)</li><li><strong>Domicilio social:</strong><strong></strong>Calle Diego de León 50 3ª Planta 28006 Madrid.</li><li><strong>CIF:</strong><strong></strong>G-28511897</li><li><strong>Teléfono:</strong><strong></strong>91 411 61 61</li><li><strong>E-mail:</strong><strong></strong><a href=\"mailto:cepyme500@cepyme.es\">cepyme500@cepyme.es</a></li></ul><p>Delegado de Protección de Datos o Responsable de Seguridad :</p><p><strong>Correo electrónico:</strong> <a href=\"mailto:rgpd@cepyme.es\">rgpd@cepyme.es</a></p><p><strong>3.</strong><strong></strong><strong><u>FINALIDAD DEL TRATAMIENTO DE LOS DATOS Y CATEGORÍAS DE DATOS TRATADOS</u></strong></p><p><strong><u>¿Con qué finalidad y durante cuánto tiempo trataremos sus datos personales</u></strong><strong>?</strong></p><p><strong>CEPYME</strong>, tratará sus datos como usuario, de manera manual y/o automatizada, para las siguientes finalidades específicas:</p><ul><li><p>El mantenimiento de su condición de usuario para envío de noticias relativas a las 500 empresas medianas que lideran el crecimiento empresarial, la promoción y reconocimiento de la empresa y sus directivos, la selección y retención del personal, información relevante sobre mercados internacionales y la difusión importante en materia de transformación digital en la empresa.</p></li><li><p>La gestión de forma específica de los usuarios de la web</p></li><li><p>La gestión de las consultas, encuestas, opiniones que formule a través de la web dentro de programa <strong>CEPYME500.</strong></p></li><li><p>El envío periódico de información o comunicaciones de utilidad o interés relativa a servicios, blogs de opinión, bolsa de empleo, colaboración en proyectos nacionales y europeos, servicios de mentoring y consultoría, sellos o certificaciones de calidad, canal de inversión, encuestas artículos, actividades, noticias, newsletter, Revista Plan, Cepymenews, Boletín de Morosidad, Cepyme Emprende, eventos organizados por <strong>CEPYME</strong>y sus colaboradores vinculados como <strong>CEOE, CEAT, UEAPME</strong>publicados en medios de comunicación social así como la remisión postal y/o electrónica periódica por nuestra parte de información publicitaria, Informes, Boletines, Premios Cepyme, salvo que se indique lo contrario o el usuario se oponga o revoque su consentimiento.</p></li><li><p>La gestión de la contratación de servicios que realice a través de la Plataforma web, así como la facturación y entrega correspondiente</p></li><li><p>La realización de informes estadísticos anónimos respecto a los hábitos de acceso y la actividad desarrollada por los usuarios en la Plataforma web <strong>CEPYME500.</strong></p></li><li><p>La elaboración de un perfil comercial del usuario y realizar acciones comerciales ajustadas al mismo, utilizando sus datos derivados de la gestión de los productos adquiridos (datos de navegación, hábitos de acceso, tráfico), salvo que se indique lo contrario o el usuario se oponga o revoque su consentimiento.</p></li><li><p>En el caso de que nos remita su curriculum vitae o se inscriba en las diferentes ofertas de trabajo que podamos publicar o promover, trataremos sus datos con el fin de valorar y gestionar su solicitud de empleo y en su caso, llevar a cabo las actuaciones necesarias para la selección y contratación de personal, a fin de ofertarle puestos que se ajusten a tu perfil. Salvo que se indique lo contrario, la aportación de los datos requeridos es necesaria, por lo que su no aportación impedirá la continuidad del proceso de selección.<br><br>Así mismo, le informamos que los datos facilitados podrán ser comunicados a las Entidades vinculadas o colaboradoras que conforman <strong>CEPYME,</strong> cuyas direcciones y actividades puede consultar en el Sitio Web <strong>CEPYME500</strong> , para el cumplimiento de los mismos fines informados.<br><br>Por último le informamos y mediante la aceptación de la presente Política de Privacidad usted consiente, que sus datos personales puedan ser comunicados a terceros colaboradores de <strong>CEPYME,</strong>sean entidades colaboradoras o vinculadas<strong>,</strong> con la finalidad de que éstos puedan efectuar por diferentes medios, incluido el correo electrónico, correo postal, envíos informativos sobre productos y servicios contenidos en la web de actualidad, empleo, financiación, innovación, relacionados con las actividades empresariales y relacionadas con la formación, afines a los ofrecidos por <strong>CEPYME.</strong></p></li><li><p>El cumplimiento a las obligaciones legalmente establecidas, así como verificar el cumplimiento de las obligaciones contractuales, incluida la prevención de fraude.<br><br></p></li></ul><p><strong><u>¿Qué categorías de datos tratamos?</u></strong></p><p>Atendiendo a las finalidades antes mencionadas, <strong>CEPYME</strong> puede tratar las siguientes categorías de datos:</p><ul><li><p>Datos identificativos: nombre, apellidos, denominación social, dirección postal, dirección de correo electrónico, código postal, teléfono de contacto.</p></li><li><p>Datos académicos y profesionales: formación/titulaciones, historial de estudiante, experiencia profesional, pertenencia a colegios o asociaciones profesionales, en el caso de los procesos de selección.</p></li><li><p>Datos de tráfico y localización.</p></li><li><p>Metadatos de comunicaciones electrónicas.</p></li><li><p>Datos de información comercial y publicitaria.</p></li><li>Datos económicos, o financieros, bancarios.</li></ul><p>El usuario garantiza que los datos aportados son verdaderos, exactos, completos y actualizados, siendo responsable de cualquier daño o perjuicio, directo o indirecto, que pudiera ocasionarse como consecuencia del incumplimiento de tal obligación.</p><p>En caso de que el usuario facilite datos de terceros, manifiesta contar con el consentimiento de los mismos y se compromete a trasladarle la información contenida en esta cláusula, eximiendo a <strong>CEPYME</strong> de cualquier responsabilidad en este sentido. No obstante, <strong>CEPYME</strong> podrá llevar a cabo las verificaciones para constatar este hecho, adoptando las medidas de diligencia debida que correspondan, conforme a la normativa de protección de datos.</p><p>Como su datos personales son recabados a través del formulario, será necesario que Usted aporte, al menos, aquellos marcados con un asterisco, ya que, si no se suministraran estos datos considerados necesarios, <strong>CEPYME</strong> no podrá aceptar y gestionar el servicio Web <a href=\"http://www.cepyme500.com/\">www.cepyme500.com</a> o consulta formulada.</p><p><strong><u>¿Cuánto tiempo guardamos sus datos?</u></strong></p><p><strong>CEPYME</strong> conservará los datos personales de los usuarios únicamente durante el tiempo necesario para la realización de las finalidades para las que fueron recogidos, mientras no revoque los consentimientos otorgados. Posteriormente, en caso de ser necesario, mantendrá la información bloqueada los plazos legalmente establecidos. Los datos serán conservados igualmente mientras se mantenga la relación de interés entre usted interesado y <strong>CEPYME,</strong> y durante los plazos legal o contractualmente previstos para el ejercicio de cualquier acción o reclamación a disposición del interesado o de <strong>CEPYME.</strong></p><p>En el caso de los datos que nos facilite en relación con el envío de CV por ofertas de empleo en que quiera suscribirse, serán conservados durante un año, desde la fecha de la última actualización. Transcurrido dicho periodo, sin que hayan sido actualizados, los datos serán suprimidos, salvo que nos indique lo contrario.</p><p><strong><u>¿Qué medidas de seguridad implantamos para cuidar sus datos?</u></strong></p><p>Desde el compromiso de <strong>CEPYME</strong> con la protección de los datos personales y la privacidad de los usuarios, por lo que, para proteger las diferentes tipologías de datos reflejados en esta política de privacidad llevará a cabo las medidas de seguridad técnicas necesarias para evitar su pérdida, manipulación, difusión o alteración.</p><p><strong>CEPYME</strong> tratará sus Datos de acuerdo con los requisitos de seguridad aplicables al tratamiento de datos de conformidad con el art. 32 RGDP.</p><p>Con este fin, contamos con amplias medidas de protección técnicas y organizativas que cumplen estándares informáticos reconocidos a nivel internacional y que son revisadas periódicamente.</p><p>De este modo, garantizamos que sus Datos sean protegidos adecuadamente en todo momento contra el uso indebido o cualquier otra forma de tratamiento prohibida.</p><p><strong>CEPYME</strong> adopta los niveles de seguridad requeridos por el Reglamento de protección de datos aprobado por el REGLAMENTO (UE) 2016/679 DEL PARLAMENTO EUROPEO Y DEL CONSEJO de 27 de abril de 2016 relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (RGPD), habiendo aplicado las medidas técnicas y organizativas apropiadas para garantizar un nivel de seguridad adecuado al riesgo que se deriva del tratamiento de los datos personales, como la destrucción, pérdida o alteración accidental o ilícita de datos personales transmitidos, conservados o tratados de otra forma, o la comunicación o acceso no autorizados a dichos datos, susceptibles en particular de ocasionar daños y perjuicios físicos, materiales o inmateriales. No obstante lo anterior, las medidas de seguridad en Internet no son inexpugnables y pueden existir filtraciones por actuaciones dolosas de terceros.</p><p><strong>CEPYME</strong> bloqueará los datos cuando hayan dejado de ser necesarios o pertinentes para su finalidad para la que han sido recabados, de conformidad con lo previsto en la legislación en materia de protección de datos. Sin embargo, podrá seguir haciendo uso de los datos para los fines de envíos de comunicaciones comerciales antes indicados mientras el usuario no revoque el consentimiento prestado.</p><p>En los formularios de recogida de datos que tenga a bien en cada momento establecer <strong>CEPYME</strong>, a través de la web <a href=\"http://www.cepyme500.com/\">www.cepyme500.com</a>los campos que se señalen con asterisco o “requerido” serán obligatorios por lo que en caso de que el usuario no facilite los datos correspondientes, <strong>CEPYME</strong> podrá denegar el correspondiente servicio y envíos solicitados.</p><p><br></p><p><strong><u>4. COMUNICACIONES DE DATOS</u></strong></p><p><strong><u>¿A qué destinatarios se comunicarán tus datos?</u></strong></p><p><strong>CEPYME</strong> compartirá sus Datos con Entidades vinculadas tales como <strong>CEOE, CEAT, UEAPME</strong> con las finalidades especificadas en esta Nota Informativa sobre protección de datos.</p><p>A la hora de comunicar sus Datos, siempre adoptaremos medidas apropiadas para asegurar que sus Datos son tratados, protegidos y comunicados de acuerdo con las obligaciones legales aplicables.</p><p>Con carácter general, sus Datos personales permanecen en la sede social de <strong>CEPYME</strong> en la medida de lo posible.</p><p>En este sentido, respetamos también el principio de minimización de datos.</p><p><strong>CEPYME</strong> informa al usuario que sus datos podrán ser comunicados al resto de Organizaciones colaboradores o vinculadas que forman parte de <strong>CEPYME</strong> como Confederación Empresarial, con la finalidad de poder atender sus solicitudes, gestionar los servicios que contrata e informarle sobre servicios, eventos y noticias relacionadas con nuestra actividad empresarial.</p><p>También <strong>CEPYME</strong> podrá compartir sus Datos con otros terceros, como proveedores externos de servicios o proveedores de servicios de IT, CRM, consultores externos o socios colaboradores para las finalidades previstas en la presente Política o en el marco de cualquier otro deber de información o reporte legal.</p><p><strong>CEPYME</strong> garantizará que dichos terceros cumplen con sus respectivas obligaciones de confidencialidad.</p><p>Con el fin de garantizar el cumplimiento con los requisitos bajo las normas de protección de datos, <strong>CEPYME</strong> firmará acuerdos con todos aquellos terceros con los que comparta sus Datos.</p><p>Adicionalmente, le informamos que determinados datos, en el marco de la normativa vigente o de la relación contractual que pueda mantener con <strong>CEPYME</strong>, puede ser comunicados a:</p><ul><li>Administraciones públicas con competencia en los sectores de actividad de <strong>CEPYME</strong>, cuando así lo establezca la normativa vigente.</li><li>Las Fuerzas y Cuerpos de Seguridad del Estado y autoridades judiciales en virtud de lo establecido en la Ley.</li><li>Los Bancos y entidades financieras en caso del cobro de los servicios ofrecidos.</li></ul><p><u><strong>¿Que hacemos en caso de transferencia internacional de Datos?</strong></u></p><p>En caso de que en el ámbito de las operaciones del tratamiento descritas en los apartados anteriores, sus Datos sean tratados en países fuera de la UE o del Espacio Económico Europeo (\"EEE\") con respecto de los cuales no exista una decisión de adecuación por parte de la Comisión Europea, <strong>CEPYME</strong> garantizará que sus Datos sean tratados de acuerdo con los estándares europeos de protección de datos.</p><p>En la medida en que sea preciso y para garantizar la seguridad de las transferencias de datos a destinatarios en países fuera de la UE o del EEE, utilizaremos acuerdos de transferencias internacionales sobre la base de las Cláusulas Contractuales Tipo u otros mecanismos que permitan la transferencia de datos bajo la normativa de protección de datos, incluyendo la adopción de medidas de protección técnicas y organizativas apropiadas para la protección de los datos transmitidos.</p><p>Usted puede obtener una copia de dichas garantías contactando con nuestro delegado de protección de datos o responsable de seguridad de <strong>CEPYME</strong>, tal y como se indica más adelante.</p><p>Ciertos países fuera de la UE ya han sido declarados oficialmente por la UE como países con un nivel de protección de datos adecuado y similar al europeo. Esto significa que, de acuerdo con las normas de protección de datos aplicables, cualquier transferencia a esos países no requiere una aprobación oficial independiente o acuerdo separado.</p><p><br></p><p><u><strong>5.</strong></u><u></u><strong><u>LEGITIMACIÓN EN EL TRATAMIENTO</u></strong></p><p><strong><u>¿Cuál es la legitimación para el tratamiento de sus datos?</u></strong></p><p>Dato personal significa toda información sobre una persona física identificada o identificable (\"Datos\").</p><p>Usted como usuario presta su consentimiento una vez cumplimentado el formulario exigido en la web <a href=\"http://www.cepyme500.com/\">www.cepyme500.com</a> para que <strong>CEPYME</strong> pueda realizar el tratamiento de los datos personales para que se le remita información sobre noticias, artículos, entrevistas, Boletines y Revistas propias o ajenas participación en redes sociales, actividades formativas con la finalidad de poder atender y gestionar su concreta petición, siendo estos datos recogidos necesarios para el mantenimiento y cumplimiento de dicha relación.</p><p>Como se indica en el presente formulario a disposición del usuario, la finalidad del tratamiento es el envío de comunicaciones comerciales y publicitarias sobre las actividades en general de <strong>CEPYME</strong> y sus Organizaciones colaboradoras y vinculadas tales como Boletines como Boletín trimestral de Empleo y Boletín de Morosidad, noticias de interés sobre las actividades de <strong>CEPYME</strong> a través de redes sociales y webs que forman parte de CEPYME como Cepyme500, Plan de Apoyo a la Transmisión de Empresas, Cepymenews, Cepyme emprende, notas de prensa sobre <strong>CEPYME</strong> publicadas en medios de comunicación social, gestiones administrativas para envío de newsletter y Publicaciones de <strong>CEPYME</strong>tales como<strong>,</strong>información sobre Eventos como <strong>Premios CEPYME</strong>, investigaciones y estudios de mercado, encuestas, blogs de opinión en su ámbito asociativo, cursos formativos, invitaciones y comunicaciones comerciales de diverso tipo.</p><p>También <strong>CEPYME</strong> realiza tratamientos con el consentimiento de usted previo, expreso y libre como usuario contacto de conformidad con el <strong>consentimiento (art. 6(1) apartado 1(a), art. 7 RGPD, y/o art. 9(2)(a), art. 7 RGPD</strong>, o en base a su interés legítimo de información con el fin de mantener relaciones comerciales así como para enviarles comunicados, invitaciones a eventos, e información de Confederación Empresariales y para enviarles correos electrónicos de diverso tipo que forman parte de su actividad de marketing y promoción de <strong>CEPYME</strong> como Organización Empresarial dentro del Programa <strong>CEPYME500</strong>.</p><p>Usted como usuario podrá revocar dicho consentimiento mediante solicitud escrita dirigida a la siguiente dirección postal: <strong>CEPYME,</strong> Calle Diego de León 50 3ªplanta o a la dirección de correo electrónico <a href=\"mailto:rgpd@cepyme.es\">rgpd@cepyme.es</a></p><p><br></p><p><u><strong>6. SUS DERECHOS COMO INTERESADO Y SU DERECHO A PRESENTAR UNA RECLAMACIÓN ANTE LA AUTORIDAD DE CONTROL</strong></u></p><p>Como usuario /interesado afectado por el tratamiento, usted puede ejercitar ciertos derechos en relación con nosotros conforme al RGDP y otras normas de protección de datos aplicables a través de nuestro servicio de información o de contacto cuyos datos se indican en el apartado 9 del presente documento. La siguiente sección contiene la explicación sobre los derechos que tiene como interesado bajo el RGDP.</p><p><br></p><p><u><strong>6.1 Derechos de los usuarios/ interesados</strong></u></p><p>Como interesado, en particular tiene derecho a ejercitar los siguientes derechos bajo el RGDP frente a <strong>CEPYME</strong>:</p><ol type=\"A\"><li><strong>Derecho de acceso (art. 15 RGDP):</strong>en cualquier momento, usted podrá solicitar que le facilitemos la información sobre sus Datos que tengamos almacenada. Esta información se refiere, entre otros aspectos, a las categorías de datos que tratamos, las finalidades del tratamiento, el origen de los Datos en caso de que no los hayamos recabado directamente de usted, y los destinatarios a los que hayamos podido comunicado sus Datos, en su caso.<br>Puede recibir una copia gratuita de los Datos que sean objeto del contrato. Si desea obtener copias adicionales, nos reservamos el derecho de cobrarle un canon por ellas.</li><li><strong>Derecho de rectificación (art. 16 RGDP):</strong>usted podrá solicitar la rectificación de sus Datos. Nosotros tomaremos las medidas apropiadas para mantener sus Datos, que almacenamos y tratamos continuamente, de manera exacta, completa, actualizada y adecuada según la información más reciente que nos proporcione.</li><li><strong>Derecho de supresión (art. 17 RGDP</strong>): usted puede solicitar la supresión de sus Datos, siempre que se cumplan los requisitos legales de aplicación. Por ejemplo, según el art. 17 RGDP éste puede ser el caso:<ol><li>si los Datos ya no son necesarios en relación con los fines para los que fueron recogidos o tratados de otro modo;</li><li>si usted retira el consentimiento en que se basa el tratamiento y este no se basa en otro fundamento jurídico;</li><li>si usted se opone al tratamiento de sus Datos y no prevalecen otros motivos legítimo para el tratamiento, o si usted se opone al tratamiento con finalidades de mercadotecnia directa;</li><li>si los Datos han sido tratados ilícitamente, a no ser que el tratamiento sea necesario: para el cumplimiento de una obligación legal que requiera el tratamiento de sus Datos; en particular con respecto a los plazos legales de conservación de documentación; para la formulación, el ejercicio o la defensa de reclamaciones.</li></ol></li><li><strong>Derecho a la limitación del tratamiento (art. 18 RGDP):</strong><br>Usted puede obtener la limitación del tratamiento de sus Datos :<ol><li>si impugna la exactitud de los Datos, durante un plazo que nos permita verificar la exactitud de los mismos;</li><li>si el tratamiento es ilícito y usted se opone a la supresión de sus Datos y solicita en su lugar la limitación de su uso;</li><li>si ya no necesitamos sus Datos, pero usted los necesita para la formulación, el ejercicio o la defensa de reclamaciones:</li><li>Si usted se ha opuesto al tratamiento, mientras se verifica si nuestros motivos legítimos prevalecen sobre los suyos.</li></ol></li></ol><ol start=\"5\" type=\"A\"><li><p><strong>Derecho a la portabilidad de los datos (art. 20. RGDP)</strong>:<br>Si usted lo solicita, transmitiremos sus Datos en la medida en que sea técnicamente posible a otro responsable.</p>Sin embargo, solo tendrá este derecho si el tratamiento tiene como base jurídica su consentimiento. En lugar de recibir una copia de sus Datos, puede también solicitar que los transmitamos directamente a otro responsable que usted nos indique.<br><br></li><li><strong>Derecho de oposición (art. 21 RGDP):</strong><br>Usted puede oponerse en cualquier momento, por motivos relacionados con su situación particular, al tratamiento de sus Datos, en caso de que se trate de un tratamiento basado en su consentimiento o en nuestro interés legítimo o en el interés legítimo de un tercero. En este caso, dejaremos de tratar sus Datos.<br>Esto último no es de aplicación si podemos acreditar motivos legítimos imperiosos para el tratamiento que prevalezcan sobre sus intereses, o si precisamos sus Datos para la formulación, el ejercicio o la defensa de reclamaciones o sugerencias.</li></ol><p><u><strong>6.2 Plazo para la atención de los derechos de los interesados</strong></u></p><p>Desde <strong>CEPYME</strong> siempre intentamos dar respuesta a sus solicitudes en un plazo de 30 días.</p><p>Sin embargo, este plazo podrá prorrogarse por motivos relacionados con el derecho del interesado en cuestión o la complejidad de su solicitud.</p><p><u><strong>6.3 Restricciones a la hora de facilitar información cuando se atienden los derechos de los interesados</strong></u></p><p>En ciertas situaciones, es posible que no podamos facilitarle información sobre todos sus Datos debido a previsiones o exigencias legales. En caso de que nos veamos obligados a denegar su solicitud de información en dicho supuesto, también le indicaremos al mismo tiempo los motivos de la denegación.</p><p><u><strong>6.4 Reclamación ante la autoridad de control</strong></u></p><p><strong>CEPYME</strong> se toma muy en serio sus quejas y derechos. Sin embargo, en el supuesto de que usted considere que no hemos atendido de forma completa cualquier reclamación o queja en relación a la protección de sus datos, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos.<br><br></p><p><strong>7.</strong><u><strong>TEXTOS LEGALES</strong></u></p><p>Usted puede consultar el texto del RGDP en la siguiente página web:</p><p>http://www.agpd.es/portalwebAGPD/canaldocumentacion/legislacion/union_europea/reglamentos/common/pdfs/Reglamento_UE_2016 679_Proteccion_datos_DOUE.pdf</p><p><br></p><p><strong>8.</strong><u><strong>MODIFICACIONES A ESTA NOTA INFORMATIVA SOBRE PROTECCIÓN DE DATOS</strong></u></p><p>En caso de que haya cambios significativos en la manera en que tratamos sus Datos, le informaremos de estas modificaciones a su debido tiempo a través de esta web u otro medio a tal efecto establecido con usted<strong>.</strong></p><p><br></p><p><strong>9.</strong><u><strong>POLITICA DE COOKIES</strong></u></p><p>Cookie es un fichero que se descarga en su ordenador al acceder a determinadas páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.</p><p>El navegador del usuario memoriza cookies en el disco duro solamente durante la sesión actual ocupando un espacio de memoria mínimo y no perjudicando al ordenador.</p><p>Las cookies no contienen ninguna clase de información personal específica, y la mayoría de las mismas se borran del disco duro al finalizar la sesión de navegador (las denominadas cookies de sesión).</p><p>La mayoría de los navegadores aceptan como estándar a las cookies y, con independencia de las mismas, permiten o impiden en los ajustes de seguridad las cookies temporales o memorizadas.</p><p>Sin su expreso consentimiento –mediante la activación de las cookies en su navegador no enlazará en las cookies los datos memorizados con sus datos personales proporcionados en el momento del registro o la compra.</p><p>El SITIO WEB de <strong>CEPYME, cepyme500.com</strong> emplea ‘cookies’ con la finalidad de permitir y facilitar la interacción del usuario con el mismo así como la calidad de la página de acuerdo a los hábitos y estilos de navegación de los usuarios. Asimismo le informamos que los servicios de estadísticas –propios o ajenos-, empleados por el SITIO WEB de <strong>CEPYME</strong> pueden emplear ‘cookies’ con la finalidad de establecer métricas y patrones de uso del sitio. El acceso, uso y, en general, la navegación por el SITIO WEB de <strong>CEPYME</strong> suponen necesariamente el consentimiento del USUARIO a la utilización de \"cookies\" por parte de <strong>CEPYME</strong> y/o de sus proveedores de servicios.</p><p><u><strong>¿Qué tipos de cookies utiliza esta página o SITIO WEB?</strong></u></p><ul><li><p><strong>Cookies de sesión:</strong>Mantienen al USUARIO identificado ante el SITIO WEB, permitiendo su interacción con el mismo.</p></li><li><p><strong>Cookies de análisis:</strong> Son aquéllas que bien tratadas por <strong>CEPYME</strong> o por terceros, nos permiten cuantificar el número de usuarios y así realizar la medición y análisis estadístico de la utilización que hacen los usuarios del servicio ofertado. Para ello se analiza su navegación en nuestra página web con el fin de mejorar la oferta de productos o servicios que le ofrecemos.</p></li><li><p><strong>Cookies de redes sociales:</strong> AddThis Es un plugin que permite compartir en diferentes redes sociales el contenido de nuestra web.</p></li><li><p><strong>Cookies de personalización:</strong> Son aquéllas que permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en función de una serie de criterios en el terminal del usuario como por ejemplo serian el idioma, el tipo de navegador a través del cual accede al servicio, la configuración regional desde donde accede al servicio, etc.<br><br></p></li></ul><p></p><table class=\"table table-responsive\"><tbody><tr><td><p><strong>Nombre de cookie</strong></p></td><td><p><strong>Descripción</strong></p></td><td><p><strong>Emisor</strong></p></td><td><p><strong>Web del emisor</strong></p></td><td><p><strong>Tipo de cookie</strong></p></td></tr><tr><td><p>__utmz</p></td><td><p>Google Analytics: Sistema para analizar el trafico en la web.</p></td><td><p>Google Inc.</p></td><td><p>https://www.google.com/analytics/</p></td><td><p>Cookie de análisis</p></td></tr><tr><td><p>__utmz</p></td></tr><tr><td><p>__utmc</p></td></tr><tr><td><p>__utmb</p></td></tr><tr><td><p>PREF</p></td><td><p>YouTube: Plataforma de visualización de video.</p></td><td><p>YouTube.com</p></td><td><p>https://www.youtube.com</p></td><td><p>Cookie de análisis y de personalización.</p></td></tr><tr><td><p>VISITOR_INFO1_LIVE</p></td></tr><tr><td><p>YSC</p></td></tr><tr><td><p>cookieOk</p></td><td><p>Sirve para identificar que el usuario a visualizado el aviso de cookies</p></td><td><p>CEPYME</p></td><td><p><a href=\"https://www.cepyme500.com/\">https://www.cepyme500.com</a></p></td><td><p>Cookie de personalización</p></td></tr></tbody></table><p></p><p><u><strong>Como desactivar o eliminar las Cookies</strong></u></p><p>Puede usted permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su ordenador.</p><p>En la función Ayuda de la mayoría de los navegadores se indica cómo configurar su navegador para que no acepte cookies, para que le notifique cada vez que reciba una nueva cookie, así como para desactivar completamente todas las cookies.</p><p>Con carácter general le informamos que los navegadores ofrecen las siguientes opciones de configuración en relación a la instalación de cookies:</p><ul><li><p>Que el navegador rechace todas las cookies y por lo tanto, que no se instale ninguna cookie de ninguna página web en su terminal.</p></li><li><p>Que el navegador le avise antes de que se produzca la instalación de la cookie para que usted decida si acepta o no la instalación de la misma.</p></li><li><p>Que el navegador únicamente rechace las cookies de terceros de los sitios web que visita, pero no las utilizadas por el sitio web por el que usted navega. Además, puede deshabilitar o eliminar datos similares utilizados por las extensiones (add-on) de los navegadores, como las \"Flash Cookies\", cambiando la configuración de dichas extensiones o visitando el sitio web del fabricante.<br><br></p></li></ul><p><strong>El Usuario acepta expresamente, por la utilización de este Site, el tratamiento de la información recabada en la forma y con los fines anteriormente mencionados.</strong>Y asimismo reconoce conocer la posibilidad de rechazar el tratamiento de tales datos o información rechazando el uso de Cookies mediante la selección de la configuración apropiada a tal fin en su navegador. Si bien esta opción de bloqueo de Cookies en su navegador puede no permitirle el uso pleno de todas las funcionalidades del Website.</p><p>Usted puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su ordenador:</p><ul><li>Chrome</li><li>Explorer</li><li>Firefox</li><li>Safari</li></ul><p><strong>10.</strong><u><strong>CONTACTE CON NOSOTROS</strong></u></p><p>Por favor, envíe cualquier solicitud/petición a:</p><p><strong>CEPYME (CONFEDERACIÓN ESPAÑOLA DE LA PEQUEÑA Y MEDIANA EMPRESA),</strong></p><p><strong>Calle Diego de León 50 3ª Planta , 28006 Madrid</strong></p><p>Por favor, envíe cualquier petición vía email a la siguiente dirección de correo electrónico: <strong><a href=\"mailto:rgpd@cepyme.es\">rgpd@cepyme.es</a></strong></p><p><strong>Más información acerca de <a href=\"https://www.cepyme500.com/\">www.cepyme500.com</a> en:</strong></p><p><a href=\"https://www.cepyme500.com/es/aviso_legal\">https://www.cepyme500.com/es/aviso_legal</a></p></div></div></div></div></div></div>");
$templateCache.put("app/views/santander.html","<div class=\"wrapper wrapper-content animated fadeInRight relative\"><div class=\"loading-iframe\"><iframe title=\"Web de Santander\" src=\"https://upthemedia.com/cepyme500_partners/santander.html\" style=\"position: absolute; width:105%; height: 90vh; border: none\"></iframe></div></div>");
$templateCache.put("app/templates/app.html","<div id=\"wrapper\"><div ui-view=\"\"></div></div>");
$templateCache.put("app/templates/banner.html","<a ng-href=\"{{banner.block.action_url}}\" target=\"_blank\"><img alt=\"Imagen de la creatividad\" ng-src=\"{{banner.block.image}}\" class=\"img-responsive center-block\"></a>");
$templateCache.put("app/templates/chosen-companies.html","<div ng-if=\"isSearching\" class=\"search-loading\"><small><i class=\"fa fa-spinner fa-spin\"></i> Buscando...</small></div><select class=\"form-control chosen-select\" chosen=\"\" ng-model=\"selectedCompany\" ng-change=\"handleChange()\" allow-single-deselect=\"true\" id=\"company\" data-placeholder-text-single=\"\'{{\'general.chosen.company\' | translate}}\'\" ng-options=\"company.id as company.name for company in companies\"><option value=\"\"></option></select>");
$templateCache.put("app/templates/footer.html","<div class=\"footer\"><div class=\"pull-right\"><a ui-sref=\".legal_advice\" class=\"btn-link\">Aviso Legal</a> | <a ui-sref=\".privacy_policy\" class=\"btn-link\">Política Privacidad</a> | <a ui-sref=\".contactCepyme\" class=\"btn-link\">Contacto</a></div><div>&copy; <strong>CEPYME500</strong> {{::Logged.today}}</div></div>");
$templateCache.put("app/templates/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><em class=\"fa fa-chevron-up\"></em></a> <a uib-dropdown-toggle=\"\" href=\"\"><em class=\"fa fa-wrench\"></em></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><em class=\"fa fa-times\"></em></a></div>");
$templateCache.put("app/templates/logged.html","<div class=\"navigation-zindex\" ng-include=\"\'app/templates/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg\"><div ng-include=\"\'app/templates/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/templates/footer.html\'\"></div></div><div ui-view=\"sidebar\"></div>");
$templateCache.put("app/templates/logged_sidebar.html","<div id=\"right-sidebar\" ng-class=\"{\'sidebar-open\': Sidebar.type}\"><div class=\"sidebar-container p-xs bg-muted\" full-scroll=\"\"><div class=\"text-right m-b-sm hidden-print\"><button type=\"button\" class=\"btn btn-outline btn-success btn-sm btn-circle\" ng-click=\"Sidebar.close(false, true);\"><em class=\"fa fa-close\"></em></button></div><div ng-include=\"\'app/templates/sidebar/company.html\'\" ng-if=\"Sidebar.type == 1\"></div><div ng-include=\"\'app/templates/sidebar/contact.html\'\" ng-if=\"Sidebar.type == 2\"></div><div ng-include=\"\'app/templates/sidebar/email.html\'\" ng-if=\"Sidebar.type == 3\"></div><div ng-include=\"\'app/templates/sidebar/compose_email.html\'\" ng-if=\"Sidebar.type == 4\" class=\"summernote_parent\"></div><div ng-include=\"\'app/templates/sidebar/press_release.html\'\" ng-if=\"Sidebar.type == 5\"></div><div ng-include=\"\'app/templates/sidebar/compose_prelease.html\'\" ng-if=\"Sidebar.type == 6\" class=\"summernote_parent\"></div><div ng-include=\"\'app/templates/sidebar/event.html\'\" ng-if=\"Sidebar.type == 7\"></div><div ng-include=\"\'app/templates/sidebar/compose_event.html\'\" ng-if=\"Sidebar.type == 8\" class=\"summernote_parent\"></div><div ng-include=\"\'app/templates/sidebar/employ.html\'\" ng-if=\"Sidebar.type == 9\"></div><div ng-include=\"\'app/templates/sidebar/compose_employ.html\'\" ng-if=\"Sidebar.type == 10\" class=\"summernote_parent\"></div><div ng-include=\"\'app/templates/sidebar/compose_tv.html\'\" ng-if=\"Sidebar.type == 11\"></div><div ng-include=\"\'app/templates/sidebar/startup.html\'\" ng-if=\"Sidebar.type == 12\"></div><div ng-include=\"\'app/templates/sidebar/compose_offer.html\'\" ng-if=\"Sidebar.type == 13\"></div><div ng-include=\"\'app/templates/sidebar/project.html\'\" ng-if=\"Sidebar.type == 14\"></div><div ng-include=\"\'app/templates/sidebar/compose_project.html\'\" ng-if=\"Sidebar.type == 15\"></div><div ng-include=\"\'app/templates/sidebar/advertiser.html\'\" ng-if=\"Sidebar.type == 16\"></div><div ng-include=\"\'app/templates/sidebar/compose_advertiser.html\'\" ng-if=\"Sidebar.type == 17\"></div></div></div>");
$templateCache.put("app/templates/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\"><div class=\"block navigation-logo\"><strong>CEPYME500</strong></div><span class=\"block m-t-xs\"><img alt=\"Imagend el contacto\" ng-if=\"myUser.contact.image.url\" ng-src=\"{{myUser.contact.image.url}}\" class=\"img-responsive img-circle img-md\"></span> <span class=\"block m-t-xs\"><a ui-sref=\".profile.step_one\"><strong>{{myUser.contact.name}} {{myUser.contact.surname}}</strong></a></span> <span class=\"text-xs block\"><a ui-sref=\".profile.step_one\">{{myUser.company.name}}</a></span> <span class=\"block m-t-md\" ng-if=\"myUser.contact.name + \' \' + myUser.contact.surname !== myUser.name\"><a ui-sref=\".profile.step_one\"><em class=\"fa fa-user text-white\"></em> {{myUser.name}}</a></span></div><div class=\"logo-element\">CEPYME<br>500</div></li><li class=\"landing_link m-t-md\"><a ui-sref=\".magazine\"><em class=\"fa fa-book\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.magazine\' | translate}}</span></a></li><li ui-sref-active=\"active\" class=\"\"><a ui-sref=\".home\"><em class=\"fa fa-home\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.home\' | translate}}</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\".certificate\"><em class=\"fa fa-thumbs-o-up\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.certificate\' | translate}}</span></a></li><li ng-class=\"{active: $state.includes(\'app.logged.directory\')}\"><a href=\"#\"><em class=\"fa fa-list\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.directory\' | translate}}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'logged.directory\')}\"><li ui-sref-active=\"active\"><a ui-sref=\".directory.companies\" translate-cloak=\"\">{{\'general.url.companies\' | translate}}</a></li><li ui-sref-active=\"active\"><a ui-sref=\".directory.contacts\" translate-cloak=\"\">{{\'general.url.contacts\' | translate}}</a></li></ul></li><li><a ui-sref-active=\"active\" ui-sref=\".press_releases\"><em class=\"fa fa-newspaper-o\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.press_releases\' | translate}}</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\".cepyme500tv\"><em class=\"fa fa-television\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.cepyme500_tv\' | translate}}</span></a></li><li ng-class=\"{active: $state.includes(\'app.logged.mailbox\')}\"><a href=\"#\"><em class=\"fa fa-envelope\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.mailbox\' | translate}}</span> <span class=\"label label-warning\" ng-if=\"Logged.unreadMessagesFoldersTotal || Logged.unreadMessagestagTotal\">{{Logged.unreadMessagesFoldersTotal + Logged.unreadMessagestagTotal}}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'logged.mailbox\')}\"><li ui-sref-active=\"active\"><a ui-sref=\".mailbox\" translate-cloak=\"\">{{\'general.url.mailbox_view\' | translate}}</a></li><li ui-sref-active=\"active\"><a link-sidebar=\"\" type=\"4\" href=\"javascript:void(0);\" translate-cloak=\"\">{{\'general.url.mailbox_compose\' | translate}}</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\".events\"><em class=\"fa fa-calendar\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.diary\' | translate}}</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\".news\"><em class=\"fa fa-bookmark\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.news\' | translate}}</span></a></li><li class=\"navbar-default header-box-nav header-box-nav__border-x\" translate-cloak=\"\">{{ \'general.url.patronos\' | translate}}</li><li class=\"header-box-nav__border-x\"><a href=\"#\"><span translate-cloak=\"\" class=\"nav-label\">{{\'patronos.toggle.financial\' | translate}}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\"><li><a href=\"https://www.bancosantander.es/empresas/santander-growth\" target=\"_blank\">BANCO SANTANDER</a></li><li><a href=\"https://www.informa.es/\" target=\"_blank\">INFORMA</a></li><li><a href=\"https://www.ico.es/\" target=\"_blank\">ICO</a></li><li><a href=\"https://www.bmegrowth.es/esp/BME-Growth/Que-Es.aspx\" target=\"_blank\">BME</a></li><li><a href=\"https://www.bancsabadell.com/\" target=\"_blank\">BANCO SABADELL</a></li></ul></li><li class=\"header-box-nav__border-x\"><a href=\"#\"><span translate-cloak=\"\" class=\"nav-label\">{{\'patronos.toggle.sustainability\' | translate}}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\"><li><a href=\"https://www.ecoembes.com/es\" target=\"_blank\">ECOEMBES</a></li><li><a href=\"https://www.volvocars.com/es/\" target=\"_blank\">VOLVO</a></li><li><a href=\"https://www.eroski.es/\" target=\"_blank\">EROSKI</a></li></ul></li><li class=\"header-box-nav__border-x\"><a href=\"#\"><span translate-cloak=\"\" class=\"nav-label\">{{\'patronos.toggle.digital\' | translate}}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\"><li><a href=\"https://www.wolterskluwer.com/es-es/know/s-info-c198-pack-emprende?utm_source=colectivos&utm_medium=link&utm_campaign=c198-pack-emprende&utm_content=colectivos-empresas\" target=\"_blank\">WOLTERS KLUWER</a></li><li><a href=\"https://www.orange.es/empresas/PYMES\" target=\"_blank\">ORANGE</a></li><li><a href=\"https://grupotopdigital.es/\" target=\"_blank\">TOP DIGITAL</a></li><li><a href=\"https://seller-es-accounts.tiktok.com/\" target=\"_blank\">TIKTOK SHOP</a></li><li><a href=\"https://extrategia.com/\" target=\"_blank\">EXTRATEGIA</a></li><li><a href=\"https://www.conversia.es/\" target=\"_blank\">CONVERSIA</a></li></ul></li><li class=\"header-box-nav__border-x header-box-nav__border-bottom\"><a href=\"#\"><span translate-cloak=\"\" class=\"nav-label\">{{\'patronos.toggle.talent\' | translate}}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\"><li><a href=\"https://www.mapfre.es/empresas/\" target=\"_blank\">MAPFRE</a></li><li><a href=\"https://www.aenor.com/\" target=\"_blank\">AENOR</a></li><li><a href=\"https://www.sage.com/es-es/\" target=\"_blank\">SAGE</a></li></ul></li><li ui-sref-active=\"active\" ng-if=\"myUser.group == \'superadmin\' || myUser.group == \'admin\'\"><a ui-sref=\".stats\" href=\"javascript:void(0);\"><em class=\"fa fa-area-chart\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.stats\' | translate}}</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\".faqs\"><em class=\"fa fa-question-circle\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.faqs\' | translate}}</span></a></li><li class=\"landing_link landing_link_orange m-t-md\" ui-sref-active=\"active\"><a ui-sref=\".guide\"><em class=\"fa fa fa-graduation-cap\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.guide\' | translate}}</span></a></li><li ui-sref-active=\"active\" ng-if=\"myUser.group == \'superadmin\'\"><a ui-sref=\".users\"><em class=\"fa fa-users\"></em> <span translate-cloak=\"\" class=\"nav-label\">{{\'general.url.users\' | translate}}</span></a></li></ul></div><div class=\"m-md\"><img alt=\"Sello CEPYME500\" src=\"https://d3cbxno87ymraz.cloudfront.net/certificate/2025/certificate_cepyme500_2025_original_inverse_transparent.png\" class=\"img-responsive\"></div></nav>");
$templateCache.put("app/templates/notification.html","<div class=\"notification-topnavbar\" link-sidebar=\"\" type=\"{{typeSidebar}}\" id=\"{{id}}\"><div class=\"dropdown-messages-box\"><div><small class=\"pull-right\" am-time-ago=\"{{date | amUtc | amLocal}}\"></small> <em ng-class=\"icon\"></em> <strong>{{company}}</strong> {{text}}</div></div></div>");
$templateCache.put("app/templates/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span></div><ul class=\"nav navbar-top-links navbar-right\"><li uib-dropdown=\"\"><a class=\"count-info\" href=\"\" uib-dropdown-toggle=\"\"><img alt=\"Icono CEPYME500\" src=\"https://d3cbxno87ymraz.cloudfront.net/app/assets/images/cp500_icon.svg\" height=\"20px;\"></a><ul class=\"dropdown-alerts\" uib-dropdown-menu=\"\"><li notification=\"\" id=\"notify.object\" notify=\"notify.id\" cepyme500=\"1\" date=\"notify.date.date\" company=\"notify.sender.name\" type=\"notify.type\" ng-repeat=\"notify in Logged.unreadNotificationsCP500.data\"></li></ul></li><li uib-dropdown=\"\"><a class=\"count-info\" href=\"\" uib-dropdown-toggle=\"\"><em class=\"fa fa-bell\"></em></a><ul class=\"dropdown-alerts\" uib-dropdown-menu=\"\"><li notification=\"\" id=\"notify.object\" notify=\"notify.id\" date=\"notify.date.date\" company=\"notify.sender.name\" type=\"notify.type\" ng-repeat=\"notify in Logged.unreadNotifications.data\"></li></ul></li><li uib-dropdown=\"\"><a class=\"count-info\" href=\"javascript:void(0);\" ui-sref=\"app.logged.mailbox\"><em class=\"fa fa-envelope\"></em></a></li><li><a href=\"javascript:void(0);\" ui-sref=\".contactCepyme\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'general.topnavbar.tooltipcontactcepyme\' | translate}}\"><em class=\"fa fa-comments\"></em></a></li><li><span ng-class=\"{\'text-muted-disable\': (Logged.lan == \'en\')}\" ng-click=\"Logged.changeLanguage(\'en\')\">EN</span> | <span ng-class=\"{\'text-muted-disable\': (Logged.lan == \'es\')}\" ng-click=\"Logged.changeLanguage(\'es\')\">ES</span></li><li><a ui-sref=\"app.logged.profile.step_one\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'general.topnavbar.tooltipprofile\' | translate}}\"><em class=\"fa fa-cog\"></em></a></li><li><a href=\"javascript:void(0);\" ng-click=\"Logged.logout()\" tooltip-placement=\"bottom\" uib-tooltip=\"{{\'general.topnavbar.tooltiplogout\' | translate}}\"><em class=\"fa fa-sign-out\"></em></a></li></ul></nav></div>");
$templateCache.put("app/templates/vector-map.html","<div style=\"height: 300px;\"></div><button class=\"btn btn-primary btn-circle vector-map-btn\" uib-tooltip=\"Quitar todos\" ng-click=\"resset()\" type=\"button\"><em class=\"fa fa-trash\"></em></button> <button class=\"btn btn-primary btn-circle vector-map-btn\" uib-tooltip=\"Seleccionar todos\" ng-click=\"selectAll()\" type=\"button\"><em class=\"fa fa-globe\"></em></button>");
$templateCache.put("app/logged/ads/ads.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div ui-view=\"\"></div></div>");
$templateCache.put("app/logged/ads/banners.html","<div class=\"m-t-md m-b-sm\"><a href=\"javascript:void(0);\" ui-sref=\".edit({id:0, index:0})\" class=\"btn btn-success\">Añadir banner</a></div><div ui-view=\"\"></div><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\">Banners CEPYME500</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Ads.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div ng-if=\"Ads.banners.data.length\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" width=\"100%\"><thead><tr><th width=\"280\"></th><th>Título</th><th>Posición</th><th>Visionados</th><th>Clicks</th><th>Activo</th><th></th></tr></thead><tbody><tr ng-repeat=\"banner in Ads.banners.data track by $index\"><td><a href=\"javascript:void(0);\" ng-href=\"{{banner.url}}\" target=\"_balnk\"><img alt=\"Imagen de la creatividad\" ng-src=\"{{banner.image}}\" class=\"img-responsive\"></a></td><td class=\"p-sm\">{{banner.title}}</td><td><span ng-repeat=\"position in banner.positions track by $index\"><a href=\"javascript:void(0);\" ui-sref=\"^.positions.edit({id: position.id})\">{{position.title}},</a></span></td><td>{{banner.clicks}}</td><td>{{banner.views}}</td><td><em class=\"fa fa-check\" ng-class=\"{\'text-success\': banner.active}\"></em></td><td><a href=\"javascript:void(0);\" ui-sref=\".edit({id: banner.id, index: $index})\"><em class=\"fa fa-pencil\"></em></a> <a class=\"m-l-sm\" href=\"javascript:void(0);\" ng-click=\"Ads.removeElement(banner.id, $index, \'banners\')\" ng-if=\"!Ads.loadingRemove\" title=\"Eliminar banner\"><em class=\"fa fa-close text-danger\"></em></a></td></tr></tbody></table></div><hr class=\"hr-line-dashed m-xs\"><div class=\"clearfix\"><div class=\"pull-right text-right\"><uib-pagination total-items=\"Ads.banners.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"Ads.getBanners()\" ng-model=\"Ads.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"Ads.params.limit\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div><div ng-if=\"!Ads.banners.data.length\">No hay banners, puedes crear el primero <a href=\"javascript:void(0);\" ui-sref-active=\"hidden\" ui-sref=\".edit({id:0, index:0})\">aquí</a></div></div></div>");
$templateCache.put("app/logged/ads/edit_banner.html","<div class=\"ibox\"><div class=\"ibox-title clearfix\"><h3 class=\"text-success pull-left\">Editar/Añadir banner</h3><div class=\"ibox-tools pull-right\"><a href=\"javascript:void(0);\" ui-sref=\".^\" class=\"btn btn-success btn-circle btn-md btn-outline\" type=\"button\"><em class=\"fa fa-close\"></em></a></div></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Ads.loadingEdit}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><form name=\"AdBannerForm\" ng-submit=\"Ads.bannerSubmit(AdBannerForm)\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': (AdBannerForm.title.$dirty || AdBannerForm.$submitted) && AdBannerForm.title.$invalid}\"><label class=\"control-label text-success\">Título</label><div class=\"\"><input type=\"text\" name=\"title\" ng-model=\"Ads.banner.title\" class=\"form-control\" required=\"\"></div><p ng-show=\"(AdBannerForm.title.$dirty || AdBannerForm.$submitted) && AdBannerForm.title.$invalid\" class=\"help-block text-danger\">Revisa este campo</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdBannerForm.url.$dirty || AdBannerForm.$submitted) && AdBannerForm.url.$invalid}\"><label class=\"control-label\">Link</label><div class=\"\"><input type=\"url\" name=\"url\" ng-model=\"Ads.banner.url\" class=\"form-control\" required=\"\"></div><p ng-show=\"(AdBannerForm.url.$dirty || AdBannerForm.$submitted) && AdBannerForm.url.$invalid\" class=\"help-block text-danger\">Revisa este campo</p></div><hr><label class=\"control-label\">Añadir/cambiar imagen</label><div ng-if=\"Ads.banner.imageOld\" class=\"m-b-sm\"><img alt=\"Imagen de la anterior creatividad\" ng-src=\"{{Ads.banner.imageOld}}\" width=\"300px\"></div><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"\" name=\"image\" ngf-drop=\"\" ng-model=\"Ads.banner.image\" ngf-drop-available=\"true\" ngf-pattern=\"\'.jpeg,.jpg,.png,.bmp,.gif\'\" ngf-max-size=\"10MB\" required=\"\"><h4 class=\"text-center font-bold text-success\">Click o arrastra aquí</h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\"><img alt=\"Imagen de la creatividad\" ngf-size=\"{height: 80}\" ngf-thumbnail=\"Ads.banner.image\" class=\"img-responsive\" ng-click=\"Ads.removeFile()\"></a></div></div><p ng-show=\"(AdBannerForm.image.$dirty || AdBannerForm.$submitted) && AdBannerForm.image.$invalid\" class=\"help-block text-danger\">Revisa este campo</p><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (AdBannerForm.positions.$dirty || AdBannerForm.$submitted) && AdBannerForm.positions.$invalid}\"><label class=\"control-label\">Posiciones</label><div class=\"form-group\" ng-class=\"{\'has-error\': (AdBannerForm.positions.$dirty || AdBannerForm.$submitted) && AdBannerForm.positions.$invalid}\"><select class=\"form-control chosen-select\" chosen=\"\" multiple=\"\" name=\"positions\" id=\"positions\" no-results-text=\"\'No se han encontrado posiciones\'\" placeholder-text-multiple=\"\'Selecciona posiciones\'\" ng-model=\"Ads.banner.positions\" ng-options=\"position.id as position.title for position in Ads.positions.data\"></select><p ng-show=\"(AdBannerForm.positions.$dirty || AdBannerForm.$submitted) && AdBannerForm.positions.$invalid\" class=\"help-block text-danger\">Revisa este campo</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdBannerForm.active.$dirty || AdBannerForm.$submitted) && AdBannerForm.active.$invalid}\"><label class=\"control-label\">Activo</label> <input type=\"checkbox\" name=\"active\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"Ads.banner.active\"><p ng-show=\"(AdBannerForm.active.$dirty || AdBannerForm.$submitted) && AdBannerForm.active.$invalid\" class=\"help-block text-danger\">Revisa este campo</p></div><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-success\">Enviar</button></div></div></form></div></div>");
$templateCache.put("app/logged/ads/edit_position.html","<div class=\"ibox\"><div class=\"ibox-title clearfix\"><h3 class=\"text-success pull-left\">Editar/Añadir posición</h3><div class=\"ibox-tools pull-right\"><a href=\"javascript:void(0);\" ui-sref=\".^\" class=\"btn btn-success btn-circle btn-md btn-outline\" type=\"button\"><em class=\"fa fa-close\"></em></a></div></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Ads.loadingEdit}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><form name=\"AdPositionForm\" ng-submit=\"Ads.positionSubmit(AdPositionForm)\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': (AdPositionForm.title.$dirty || AdPositionForm.$submitted) && AdPositionForm.title.$invalid}\"><label class=\"control-label text-success\">Título</label><div class=\"\"><input type=\"text\" name=\"title\" ng-model=\"Ads.position.title\" class=\"form-control\" required=\"\"></div><p ng-show=\"(AdPositionForm.title.$dirty || AdPositionForm.$submitted) && AdPositionForm.title.$invalid\" class=\"help-block text-danger\">Revisa este campo</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdPositionForm.title.$dirty || AdPositionForm.$submitted) && AdPositionForm.title.$invalid}\"><label class=\"control-label\">Banners</label><div class=\"form-group\" ng-class=\"{\'has-error\': (AdPositionForm.banner.$dirty || AdPositionForm.$submitted) && AdPositionForm.banner.$invalid}\"><select class=\"form-control chosen-select\" chosen=\"\" name=\"banner\" id=\"banner\" no-results-text=\"\'No se han encontrado banners\'\" placeholder-text-single=\"\'Selecciona un banner\'\" ng-model=\"Ads.position.block_id\" ng-options=\"banner.id as banner.title for banner in Ads.banners.data\" allow-single-deselect=\"true\"><option></option></select><p ng-show=\"(AdPositionForm.banner.$dirty || AdPositionForm.$submitted) && AdPositionForm.banner.$invalid\" class=\"help-block text-danger\">Revisa este campo</p></div><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-success\">Enviar</button></div></div></form></div></div>");
$templateCache.put("app/logged/ads/positions.html","<div class=\"m-t-md m-b-sm\"><a href=\"javascript:void(0);\" ui-sref-active=\"hidden\" ui-sref=\".edit({id:0, index:0})\" class=\"btn btn-success\">Añadir posición</a></div><div ui-view=\"\"></div><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\">Posiciones banners CEPYME500</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Ads.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div ng-if=\"Ads.positions.data.length\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" width=\"100%\"><thead><tr><th>Id</th><th>Título</th><th>Título banner</th><th>Banner activo</th><th width=\"280\">Imagen</th><th width=\"80\"></th></tr></thead><tbody><tr ng-repeat=\"position in Ads.positions.data track by $index\"><td>{{position.id}}</td><td class=\"p-sm\">{{position.title}}</td><td><a href=\"javascript:void(0);\" ui-sref=\"^.banners.edit({id: position.block.id})\">{{position.block.title}}</a></td><td><em class=\"fa fa-check\" ng-class=\"{\'text-success\': position.block.active}\"></em></td><td><a href=\"javascript:void(0);\" ng-href=\"{{position.block.url}}\" target=\"_blank\"><img alt=\"Imagen de la creatividad\" ng-src=\"{{position.block.image}}\" class=\"img-responsive\"></a></td><td class=\"text-center\"><a href=\"javascript:void(0);\" ui-sref=\".edit({id: position.id, index: $index})\"><em class=\"fa fa-pencil\"></em></a> <a class=\"m-l-sm\" href=\"javascript:void(0);\" ng-click=\"Ads.removeElement(position.id, $index, \'positions\')\" ng-if=\"!Ads.loadingRemove\" title=\"Eliminar banner\"><em class=\"fa fa-close text-danger\"></em></a></td></tr></tbody></table></div><hr class=\"hr-line-dashed m-xs\"><div class=\"clearfix\"><div class=\"pull-right text-right\"><uib-pagination total-items=\"Ads.positions.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"Ads.getPositions()\" ng-model=\"Ads.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"Ads.params.limit\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div><div ng-if=\"!Ads.positions.data.length\">No hay Posiciones, puedes crear la primera <a href=\"javascript:void(0);\" ui-sref-active=\"hidden\" ui-sref=\".edit({id:0, index:0})\">aquí</a></div></div></div>");
$templateCache.put("app/logged/advertisers/advertisers.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\" translate-cloak=\"\">{{\'advertisers.title\' | translate}}</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Advertisers.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"m-t-sm bg-muted p-sm clearfix\"><div class=\"pull-left\" ng-if=\"myUser.group == \'superadmin\'\"><a href=\"javascript:void(0);\" type=\"17\" link-sidebar=\"\" class=\"btn btn-success\" translate-cloak=\"\">{{\'advertisers.btn.add\' | translate}}</a></div><form name=\"AdvertisersFormSearch\" class=\"form-inline pull-right\" ng-submit=\"Advertisers.getAdvertisers(true)\"><div class=\"form-group m-r-sm\"><input type=\"text\" class=\"form-control\" name=\"search\" id=\"search\" placeholder=\"Buscar...\" ng-model=\"Advertisers.params.search\"></div><div class=\"form-group m-r-sm\"><input type=\"checkbox\" ng-model=\"Advertisers.params.catalog\" ng-true-value=\"1\" ng-false-value=\"0\"> <span translate-cloak=\"\">{{\'advertisers.search.catalog\' | translate}}</span></div><div class=\"form-group m-r-sm\"><input type=\"checkbox\" ng-model=\"Advertisers.params.online\" ng-true-value=\"1\" ng-false-value=\"0\"> <span translate-cloak=\"\">{{\'advertisers.search.online\' | translate}}</span></div><div class=\"form-group m-r-sm\" ng-if=\"myUser.group == \'superadmin\' || myUser.group == \'admin\'\">{{Advertisers.params.status}}<select class=\"form-control\" name=\"status\" id=\"status\" placeholder=\"Estado\" ng-model=\"Advertisers.params.status\"><option ng-value=\"\"></option><option ng-value=\"active\">active</option><option ng-value=\"inactive\">inactive</option><option ng-value=\"pending\">pending</option></select></div><button type=\"submit\" ng-disabled=\"Advertisers.loading\" class=\"btn btn-success\" translate-cloak=\"\">{{\'advertisers.btn.search\' | translate}}</button></form></div><hr class=\"hr-line-dashed\"><div class=\"table-responsive\" ng-if=\"Advertisers.advertisers.length\"><table class=\"table table-striped table-hover\" width=\"100%\"><thead><tr><th translate-cloak=\"\">{{\'advertisers.name\' | translate}}</th><th translate-cloak=\"\">{{\'advertisers.activity\' | translate}}</th><th translate-cloak=\"\">{{\'advertisers.scope\' | translate}}</th><th translate-cloak=\"\">{{\'advertisers.province\' | translate}}</th><th translate-cloak=\"\">{{\'advertisers.web\' | translate}}</th><th translate-cloak=\"\">{{\'advertisers.online\' | translate}}</th><th translate-cloak=\"\">{{\'advertisers.catalog\' | translate}}</th><th ng-if=\"myUser.group == \'superadmin\' || myUser.group == \'admin\'\">Estado</th><th width=\"85\"></th></tr></thead><tbody><tr ng-repeat=\"advertiser in Advertisers.advertisers\" ng-class=\"{\'tr-inactive\': advertiser.status == \'pending\', \'tr-danger\': advertiser.status == \'inactive\' }\"><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"16\" data=\"advertiser\">{{advertiser.social_name}}</a></td><td>{{advertiser.activity}}</td><td translate=\"advertisers.scope.{{advertiser.scope}}\"></td><td>{{advertiser.province.name}}</td><td><a ng-href=\"{{advertiser.web}}\" target=\"_blank\"><em class=\"fa fa-link\"></em></a></td><td><a ng-if=\"advertiser.online\" ng-href=\"{{advertiser.online}}\" target=\"_blank\"><em class=\"fa fa-shopping-cart\"></em></a></td><td><a ng-if=\"advertiser.catalog\" ng-href=\"{{advertiser.catalog}}\" target=\"_blank\"><em class=\"fa fa-link\"></em></a></td><td ng-if=\"myUser.group == \'superadmin\' || myUser.group == \'admin\'\"><em class=\"fa\" ng-class=\"{\'fa-thumbs-down\': advertiser.status == \'inactive\', \'fa-thumbs-up\': advertiser.status == \'active\', \'fa-clock-o\': advertiser.status == \'pending\'}\"></em></td><td><em class=\"fa fa-spinner text-success\" ng-if=\"Advertisers.loadingStatus\"></em><a title=\"Activar\" href=\"javascript:void(0);\" ng-if=\"myUser.group == \'superadmin\'\" link-sidebar=\"\" type=\"17\" data=\"advertiser\"><em class=\"fa fa-pencil\"></em></a><a title=\"Activar\" href=\"javascript:void(0);\" ng-if=\"myUser.group == \'superadmin\' && advertiser.status !== \'active\'\" ng-click=\"Advertisers.changeStatus(advertiser.id, 0, $index)\"><em class=\"fa fa-check\"></em></a><a title=\"Validar / enviar pago\" href=\"javascript:void(0);\" ng-if=\"myUser.group == \'superadmin\' && advertiser.status == \'inactive\'\" ng-click=\"Advertisers.changeStatus(advertiser.id, 1, $index)\"><em class=\"fa fa-credit-card\"></em></a><a title=\"Baja\" href=\"javascript:void(0);\" ng-if=\"myUser.group == \'superadmin\' && (advertiser.status == \'active\' || advertiser.status == \'pending\')\" ng-click=\"Advertisers.changeStatus(advertiser.id, 2, $index)\"><em class=\"fa fa-close\"></em></a> <a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"16\" data=\"advertiser\"><em class=\"fa fa-share\"></em></a></td></tr></tbody></table><hr class=\"hr-line-dashed m-xs\"><div class=\"clearfix\"><div class=\"pull-right text-right\"><uib-pagination total-items=\"Advertisers.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"Advertisers.getAdvertisers()\" ng-model=\"Advertisers.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"20\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div><div ng-if=\"!Advertisers.advertisers.length\" translate-cloak=\"\">{{\'advertisers.noresults\' | translate}}</div></div></div></div>");
$templateCache.put("app/logged/cepyme500tv/cepyme500tv.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': TV.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"m-b-lg m-t-md\"><button link-sidebar=\"\" type=\"11\" id=\"compose\" class=\"btn btn-success\" translate-cloak=\"\">{{\'cepyme500tv.btn.publish\'| translate}}</button> <button link-sidebar=\"\" type=\"11\" id=\"direct\" class=\"btn btn-success\" translate-cloak=\"\">{{\'cepyme500tv.btn.emit\'| translate}}</button></div></div><div class=\"col-xs-12 col-md-6 text-left m-t-md\" ng-fi=\"TV.companies.length\"><chosen-companies selected-company=\"TV.selectedCompanyId\" on-company-change=\"TV.handleCompanySelection(companyId, company)\"></chosen-companies><div class=\"text-right\"><a href=\"javascript:void(0);\" ng-if=\"!Employment.params.company_id\" ng-click=\"TV.viewMore(true, myUser.company.id)\" translate-cloak=\"\">{{\'cepyme500tv.btn.myones\'| translate}}</a> <a href=\"javascript:void(0);\" ng-if=\"Employment.params.company_id\" ng-click=\"TV.viewMore(true)\" translate-cloak=\"\">{{\'cepyme500tv.btn.all\'| translate}}</a></div></div></div></div><div class=\"m-t-lg\" ng-if=\"TV.live\"><iframe title=\"Emisión en directo de una empresa CEPYME500\" width=\"100%\" height=\"500px\" ng-src=\"{{TV.live.yt_id}}\" frameborder=\"0\"></iframe><br><h3 class=\"text-success\"><a ng-href=\"{{TV.live.url}}\" target=\"_blank\">{{TV.live.title}} <em class=\"fa fa-share\"></em></a></h3><div ng-if=\"(TV.live.company.id == myUser.company.id) || myUser.group == \'superadmin\'\"><a class=\"btn btn-success btn-circle btn-outline\" tooltip-placement=\"top\" uib-tooltip=\"{{\'cepyme500tv.edit\' |translate}}\" link-sidebar=\"\" href=\"javascript:void(0);\" id=\"edit\" data=\"TV.live\" type=\"11\"><em class=\"fa fa-pencil\"></em></a> <button class=\"btn btn-danger btn-circle btn-outline\" tooltip-placement=\"top\" uib-tooltip=\"{{\'cepyme500tv.remove\' |translate}}\" ng-click=\"TV.remove(TV.live.id, $index)\" type=\"button\"><em class=\"fa fa-times\"></em></button></div><div ng-if=\"(video.company.id != myUser.company.id) && myUser.group != \'superadmin\'\" class=\"h-30\"></div></div><div ng-if=\"TV.videos.length\" class=\"m-t-lg\"><div class=\"row m-t-md\"><div class=\"col-md-4 col-xs-12 m-t-sm\" ng-repeat=\"video in TV.videos track by $index\"><iframe title=\"Video de una empresa CEPYME500\" width=\"100%\" height=\"350px\" ng-src=\"{{video.yt_id}}\" frameborder=\"0\"></iframe><br><h3 class=\"text-success\"><a ng-href=\"{{video.url}}\" target=\"_blank\">{{video.title}} <em class=\"fa fa-share\"></em></a></h3><div ng-if=\"(video.company.id == myUser.company.id) || myUser.group == \'superadmin\'\"><a class=\"btn btn-success btn-circle btn-outline\" tooltip-placement=\"top\" uib-tooltip=\"{{\'cepyme500tv.edit\' |translate}}\" link-sidebar=\"\" href=\"javascript:void(0);\" id=\"edit\" data=\"video\" type=\"11\"><em class=\"fa fa-pencil\"></em></a> <button class=\"btn btn-danger btn-circle btn-outline\" tooltip-placement=\"top\" uib-tooltip=\"{{\'cepyme500tv.remove\' |translate}}\" ng-click=\"TV.remove(video.id, $index)\" type=\"button\"><em class=\"fa fa-times\"></em></button></div><div ng-if=\"(video.company.id != myUser.company.id) && myUser.group != \'superadmin\'\" class=\"h-30\"></div></div></div><div class=\"clearfix m-r-md\"><div class=\"pull-right\"><uib-pagination total-items=\"Tv.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"TV.viewMore()\" ng-model=\"Tv.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"20\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div><div ng-if=\"!TV.videos.length\" class=\"m-t-md\" translate-cloak=\"\">{{\'cepyme500tv.noresults\' |translate}}</div></div>");
$templateCache.put("app/logged/employment/employment.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"m-b-lg m-t-md\"><button link-sidebar=\"\" type=\"10\" id=\"compose\" class=\"btn btn-success\" translate-cloak=\"\">{{\'employment.publish\' | translate}}</button></div></div><div class=\"col-xs-12 col-md-6 text-right m-t-md\"><a href=\"javascript:void(0);\" ng-if=\"!Employment.params.company_id\" ng-click=\"Employment.viewMore(myUser.company.id)\" translate-cloak=\"\">{{\'employment.btn.myones\'| translate}}</a> <a href=\"javascript:void(0);\" ng-if=\"Employment.params.company_id\" ng-click=\"Employment.viewMore()\" translate-cloak=\"\">{{\'employment.btn.all\'| translate}}</a></div></div><div class=\"ibox\"><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Employment.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div ng-if=\"!Employment.jobs.length && !Employment.loading\" translate-cloak=\"\">{{\'employment.noJobs\' | translate}}</div><div class=\"table-responsive\" ng-if=\"Employment.jobs.length\"><table class=\"table table-striped table-hover\" width=\"100%\"><thead><th translate-cloak=\"\">{{\'employment.position\' | translate}}</th><th translate-cloak=\"\">{{\'employment.company\' | translate}}</th><th translate-cloak=\"\">{{\'employment.date\' | translate}}</th><th translate-cloak=\"\">{{\'employment.active\' | translate}}</th><th class=\"text-center\" translate-cloak=\"\">{{\'employment.salary\' | translate}}</th><th translate-cloak=\"\">{{\'employment.place\' | translate}}</th><th ng-if=\"employment.company.id == myUser.company.id\" class=\"text-right\" translate-cloak=\"\">{{\'employment.requests\' | translate}}</th><th></th></thead><tbody><tr ng-repeat=\"job in Employment.jobs | orderBy: job.active track by $index\"><td ng-if=\"myUser.company.id == job.company.id\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"10\" data=\"job\">{{job.title}}</a></td><td ng-if=\"myUser.company.id != job.company.id\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"9\" data=\"job\">{{job.title}}</a></td><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"1\" data=\"job.company\">{{job.company.name}}</a></td><td><span am-time-ago=\"job.created_at\"></span></td><td><em class=\"fa fa-check\" ng-class=\"{\'text-muted\': !job.active, \'text-success\': job.active}\"></em></td><td class=\"text-center\"><span ng-if=\"job.salary_from\">{{job.salary_from | number : 2}}€</span> / <span ng-if=\"job.salary_to\">{{job.salary_to | number : 2}}€</span></td><td>{{job.city}}</td><td ng-if=\"employment.company.id == myUser.company.id\" class=\"text-right\"><strong ng-class=\"{\'text-success\': job.requests_number, \'text-muted\': !job.requests_number}\">{{job.requests_number}}</strong></td><td width=\"50\"><a ng-if=\"!job.active && myUser.company.id == job.company.id\" ng-click=\"Employment.active(job.id, true, $index)\" href=\"javascript:void(0);\" tooltip-placement=\"top\" uib-tooltip=\"{{\'employment.activated\' | translate}}\"><em class=\"fa fa-check\"></em></a> <a ng-if=\"job.active && myUser.company.id == job.company.id\" ng-click=\"Employment.active(job.id, false, $index)\" href=\"javascript:void(0);\" tooltip-placement=\"top\" uib-tooltip=\"{{\'employment.desactivated\' | translate}}\"><em class=\"fa fa-close\"></em></a> <a ng-if=\"myUser.company.id == job.company.id\" href=\"javascript:void(0);\" link-sidebar=\"\" type=\"10\" data=\"job\" title=\"{{\'employment.goMore\' | translate}}\"><em class=\"fa fa-share\"></em></a> <a ng-if=\"myUser.company.id != job.company.id\" href=\"javascript:void(0);\" link-sidebar=\"\" type=\"9\" data=\"job\" title=\"{{\'employment.goMore\' | translate}}\"><em class=\"fa fa-share\"></em></a></td></tr></tbody></table></div><div class=\"clearfix m-r-md\"><div class=\"pull-right\"><uib-pagination total-items=\"Employment.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"Employment.viewMore()\" ng-model=\"Employment.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"20\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/logged/events/events.html","<div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-3\"><a class=\"btn btn-primary\" href=\"javascript:void(0);\" link-sidebar=\"\" type=\"8\" translate-cloak=\"\">{{\'events.btn.add\' | translate}}</a><div class=\"ibox m-t-md\"><div class=\"ibox-title\"><h5 translate-cloak=\"\">{{\'events.events_today\' | translate}}</h5></div><div class=\"ibox-content\"><div ng-if=\"!Events.today_events.length\" translate-cloak=\"\">{{\'events.no_todayresults\' | translate}}</div><div ng-if=\"Events.today_events.length\"><div ng-repeat=\"event in Events.today_events track by $index\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"7\" data=\"event\">{{event.title}}</a><hr class=\"m-t-xs m-b-xs\"></div></div></div></div><div class=\"ibox m-t-md\"><div class=\"ibox-title\"><h5 translate-cloak=\"\">{{\'events.my_events\' | translate}}</h5></div><div class=\"ibox-content\"><div ng-if=\"!Events.my_events.length\" translate-cloak=\"\">{{\'events.no_myresults\' | translate}}</div><div ng-if=\"Events.my_events.length\"><div ng-repeat=\"event in Events.my_events track by $index\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"8\" data=\"event\">{{event.title}}</a><hr class=\"m-t-xs m-b-xs\"></div></div></div></div></div><div class=\"col-lg-9\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\'events.title\' | translate}}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content ui-calendar\" ng-class=\"{\'sk-loading\': Events.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div ng-if=\"Events.params.date_from\" ui-calendar=\"Events.uiConfig.calendar\" calendar=\"myCalendar\" class=\"calendar\" ng-model=\"Events.calendar_events\"></div><div class=\"text-right m-t-md\"><span translate-cloak=\"\">{{\'events.legend\' | translate}}:</span> <span class=\"label label-event\" translate-cloak=\"\">{{\'event.sidebar.category.event\' | translate}}</span> | <span class=\"label label-cepyme500\" translate-cloak=\"\">{{\'event.sidebar.category.cepyme500\' | translate}}</span> | <span class=\"label label-cepyme\" translate-cloak=\"\">{{\'event.sidebar.category.cepyme\' | translate}}</span> | <span class=\"label label-danger\" translate-cloak=\"\">{{\'event.sidebar.category.direct\' | translate}}</span> | <span class=\"label label-bme\" translate-cloak=\"\">{{\'event.sidebar.category.bme\' | translate}}</span> | <span class=\"label label-santander\" translate-cloak=\"\">{{\'event.sidebar.category.santander\' | translate}}</span></div></div></div><div ui-view=\"event\"></div></div></div></div>");
$templateCache.put("app/logged/directory/companies.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\" translate-cloak=\"\">{{\'directory.companies.title\' | translate}}</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Companies.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"m-t-sm bg-muted p-sm clearfix\"><form name=\"CompaniesFormSearch\" class=\"form-inline pull-right max-w-100p\" ng-submit=\"Companies.getCompanies(true)\"><div class=\"form-group m-r-sm\"><input type=\"text\" class=\"form-control\" name=\"q\" id=\"q\" placeholder=\"{{\'directory.companies.search\' | translate}}...\" ng-model=\"Companies.params.q\"></div><div class=\"form-group m-r-sm\"><chosen-companies selected-company=\"Companies.selectedCompanyId\" on-company-change=\"Companies.handleCompanySelection(companyId, company)\"></chosen-companies></div><div class=\"form-group m-r-sm\"><select class=\"form-control chosen-select\" multiple=\"\" chosen=\"\" name=\"province\" id=\"province\" data-placeholder-text-multiple=\"\'{{\'general.chosen.province\' | translate}}\'\" ng-model=\"Companies.params.province_id\" allow-single-deselect=\"true\" ng-options=\"province.id as province.name for province in Directory.provincesSelect\"><option value=\"\"></option></select></div><div class=\"form-group m-r-sm\"><select class=\"form-control chosen-select\" chosen=\"\" name=\"community\" id=\"community\" data-placeholder-text-single=\"\'Buscar por CCAA\'\" ng-model=\"Companies.params.community_name\" allow-single-deselect=\"true\" ng-options=\"community.name as community.name for community in Directory.comunitiesSelect\"><option value=\"\"></option></select></div><div class=\"form-group m-r-sm\"><select class=\"form-control chosen-select\" chosen=\"\" name=\"sales\" id=\"sales\" data-placeholder-text-single=\"\'{{\'general.chosen.sales\' | translate}}\'\" ng-model=\"Companies.sales\" allow-single-deselect=\"true\" ng-options=\"sales.id as sales.name for sales in Companies.salesSelect\"><option value=\"\"></option></select></div><div class=\"form-group m-r-sm max-w-100p\"><select class=\"form-control chosen-select\" chosen=\"\" name=\"sector\" id=\"sector\" data-placeholder-text-single=\"\'Sector\'\" ng-model=\"Companies.params.sector\"><option value=\"\"></option><option value=\"ECONOMIA DIGITAL\">ECONOMIA DIGITAL</option><option value=\"INDUSTRIA MANUFACTURERA\">INDUSTRIA MANUFACTURERA</option><option value=\"DISTRIBUCION COMERCIAL\">DISTRIBUCION COMERCIAL</option><option value=\"CONSTRUCCION\">CONSTRUCCION</option><option value=\"PRIMARIO\">PRIMARIO</option><option value=\"TRANSPORTE\">TRANSPORTE</option><option value=\"SERVICIOS EMPRESARIALES\">SERVICIOS EMPRESARIALES</option><option value=\"OTROS\">OTROS</option></select></div><div class=\"form-group m-r-sm\" ng-if=\"myUser.group == \'superadmin\' || myUser.group == \'admin\'\"><select name=\"active\" class=\"form-control\" ng-model=\"Companies.params.active\"><option ng-value=\"1\" ng-selected=\"selected\">Activas</option><option ng-value=\"\">Todas</option><option ng-value=\"0\">Inactivas</option></select><span class=\"m-l\"><input type=\"checkbox\" ng-model=\"Companies.params.has_premium\" name=\"has_premium\" ng-true-value=\"1\" ng-false-value=\"\"> Premium</span></div><div class=\"form-group m-r-sm\"><select name=\"year\" class=\"form-control\" ng-model=\"Companies.params.year\" ng-options=\"year.value as year.name for year in Directory.years\"></select></div><button type=\"submit\" class=\"btn btn-success\" translate-cloak=\"\">{{\'directory.companies.search\' | translate}}</button> <button type=\"button\" ng-click=\"Companies.cleanFilters()\" class=\"btn btn-outline btn-primary\">Eliminar filtros</button> <span ng-if=\"myUser.group == \'admin\' || myUser.group == \'superadmin\'\"><button type=\"button\" ng-click=\"Companies.exportSearch()\" class=\"btn btn-info\">Exportar excel</button></span></form></div><hr class=\"hr-line-dashed\"><div ng-if=\"Companies.linkExport\"><a ng-href=\"{{Companies.linkExport}}\" class=\"btn btn-block btn-info\" target=\"_blank\">Descarga el excel pinchando aquí</a><hr class=\"hr-line-dashed\"></div><div class=\"table-responsive\" ng-if=\"Companies.companies.data\"><table class=\"table table-striped table-hover\" width=\"100%\"><thead><tr><th width=\"80\" translate-cloak=\"\">{{\'directory.companies.logo\' | translate}}</th><th translate-cloak=\"\">{{\'directory.companies.name\' | translate}}</th><th translate-cloak=\"\">{{\'directory.companies.activity\' | translate}}</th><th translate-cloak=\"\">{{\'directory.companies.province\' | translate}}</th><th translate-cloak=\"\">{{\'directory.companies.web\' | translate}}</th><th translate-cloak=\"\">{{\'directory.companies.phone\' | translate}}</th><th translate-cloak=\"\">{{\'directory.companies.email\' | translate}}</th><th translate-cloak=\"\">{{\'directory.companies.linkedin\' | translate}}</th><th translate-cloak=\"\">{{\'directory.companies.edition\' | translate}}</th><th width=\"8%\"></th></tr></thead><tbody><tr ng-repeat=\"company in Companies.companies.data\" ng-class=\"{\'tr-danger\': company.active != 1 }\"><td class=\"text-center\"><img alt=\"Logo de la empresa\" ng-if=\"company.logo.url\" ng-src=\"{{company.logo.url}}\" class=\"max-h-30\"> <img alt=\"Placeholder del logo de la empresa\" ng-if=\"!company.logo.url\" src=\"https://d3cbxno87ymraz.cloudfront.net/app/assets/images/no-pictures.png\" class=\"max-w-30\"></td><td width=\"30%\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"1\" data=\"company\">{{company.name}}</a></td><td>{{company.cnae.name}}</td><td><em class=\"text-success fa fa-map-marker\"></em> {{company.principal_address.province.name}}</td><td><a ng-href=\"{{company.web | urlFilter}}\" target=\"_blank\" ng-if=\"company.web\">{{company.web}}</a></td><td>{{company.principal_address.phone_number}}</td><td>{{company.email}}</td><td>{{company.linkedin}}</td><td><span class=\"badge badge-primary\" ng-repeat=\"year in company.years track by $index\">{{year.year}}</span></td><td class=\"text-right\"><a class=\"m-r-sm\" link-sidebar=\"\" type=\"4\" id=\"{{company.id}}\" title=\"{{\'directory.companies.contact\' | translate}}\" href=\"javascript:void(0);\"><em class=\"fa fa-envelope\"></em></a><a class=\"m-r-sm\" ng-if=\"myUser.group == \'superadmin\' || myUser.company.id == company.id\" href=\"javascript:void(0);\" ui-sref=\"^.^.profile.step_one({id: company.id})\" title=\"{{\'directory.companies.edit\' | translate}}\"><em class=\"fa fa-pencil\"></em></a><a class=\"m-r-sm\" ng-if=\"myUser.group == \'superadmin\'\" href=\"javascript:void(0);\" title=\"{{\'directory.companies.tooltip.remove\' | translate}}\" ng-click=\"Companies.remove(company.id, $index)\"><em class=\"fa fa-close\"></em></a><a class=\"m-r-sm\" ng-if=\"myUser.group == \'superadmin\' && !company.active\" title=\"{{\'directory.companies.tooltip.activate\' | translate}}\" href=\"javascript:void(0);\" ng-click=\"Companies.changeStatus(company.id, $index, false)\"><em class=\"fa fa-thumbs-up\"></em></a><a class=\"m-r-sm\" ng-if=\"myUser.group == \'superadmin\' && company.active\" title=\"{{\'directory.companies.tooltip.deactivate\' | translate}}\" href=\"javascript:void(0);\" ng-click=\"Companies.changeStatus(company.id, $index, true)\"><em class=\"fa fa-thumbs-down\"></em></a><a link-sidebar=\"\" type=\"1\" data=\"company\" href=\"javascript:void(0);\" title=\"{{\'directory.companies.view\' | translate}}\"><em class=\"fa fa-share\"></em></a></td></tr></tbody></table></div><hr class=\"hr-line-dashed m-xs\"><div class=\"clearfix\"><div class=\"pull-right text-right\"><uib-pagination total-items=\"Companies.companies.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"Companies.getCompanies()\" ng-model=\"Companies.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"Companies.companies.per_page\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/logged/directory/contacts.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\" translate-cloak=\"\">{{\'directory.contacts.title\' | translate}}</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Contacts.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"m-t-sm bg-muted p-sm clearfix\"><form name=\"ContactFormSearch\" class=\"form-inline pull-right\" ng-submit=\"Contacts.getContacts(true)\"><div class=\"form-group m-r-sm\"><input type=\"text\" class=\"form-control chosen-select\" name=\"q\" id=\"q\" placeholder=\"{{\'directory.companies.search\' | translate}}...\" ng-model=\"Contacts.params.q\"></div><div class=\"form-group m-r-sm\"><chosen-companies selected-company=\"Contacts.selectedCompanyId\" on-company-change=\"Contacts.handleCompanySelection(companyId, company)\"></chosen-companies></div><div class=\"form-group m-t-xs m-r-sm\"><input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"Contacts.params.default\" name=\"default\"> <span translate-cloak=\"\">{{\'directory.contacts.mains\' | translate}}</span></div><button type=\"submit\" class=\"btn btn-success\" translate-cloak=\"\">{{\'directory.companies.search\' | translate}}</button></form></div><hr class=\"hr-line-dashed\"><div class=\"table-responsive\" ng-if=\"Contacts.contacts.data\"><table class=\"table table-striped table-hover\" width=\"100%\"><thead><tr><th width=\"55\" translate-cloak=\"\">{{\'directory.contacts.image\' | translate}}</th><th translate-cloak=\"\">{{\'directory.contacts.name\' | translate}}</th><th translate-cloak=\"\">{{\'directory.contacts.company\' | translate}}</th><th translate-cloak=\"\">{{\'directory.contacts.position\' | translate}}</th><th translate-cloak=\"\">{{\'directory.contacts.phone\' | translate}}</th><th translate-cloak=\"\">Email</th><th translate-cloak=\"\">Linkedin</th><th translate-cloak=\"\">{{\'directory.companies.edition\' | translate}}</th><th width=\"50\"></th></tr></thead><tbody><tr ng-repeat=\"contact in Contacts.contacts.data\"><td><img alt=\"Imagen del contacto\" ng-if=\"contact.image.url\" ng-src=\"{{contact.image.url}}\" class=\"max-h-30\"> <img alt=\"Placeholder de la imagen del contacto\" ng-if=\"!contact.image.url\" src=\"https://d3cbxno87ymraz.cloudfront.net/app/assets/images/no-pictures.png\" class=\"max-w-30\"></td><td width=\"30%\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"2\" data=\"contact\">{{contact.name}} {{contact.surname}}</a> <sup ng-if=\"contact.default\" class=\"text-success fa fa-check-circle\"></sup></td><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"1\" data=\"contact.company\">{{contact.company.name}}</a></td><td>{{contact.job_title}}</td><td>{{contact.phone_number}}</td><td>{{contact.email}}</td><td>{{contact.linkedin}}</td><td><span class=\"badge badge-primary\" ng-repeat=\"year in contact.company.years track by $index\">{{year.year}}</span></td><td class=\"text-right\"><a class=\"m-r-sm\" ng-if=\"contact.default\" link-sidebar=\"\" type=\"4\" id=\"{{contact.company.id}}\" title=\"{{\'directory.contacts.contact\' | translate}}\" href=\"javascript:void(0);\"><em class=\"fa fa-envelope\"></em></a> <a link-sidebar=\"\" type=\"2\" data=\"contact\" href=\"javascript:void(0);\" title=\"{{\'directory.contacts.view\' | translate}}\"><em class=\"fa fa-share\"></em></a></td></tr></tbody></table></div><hr class=\"hr-line-dashed m-xs\"><div class=\"clearfix\"><div class=\"pull-right\"><uib-pagination total-items=\"Contacts.contacts.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"Contacts.getContacts()\" ng-model=\"Contacts.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"Contacts.contacts.per_page\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/logged/directory/directory.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div ui-view=\"\"></div></div>");
$templateCache.put("app/logged/home/countries.html","<div class=\"col-sx-12 col-md-5 animated fadeIn\"><h4>{{Countries.country | isoCountry}}</h4><ul class=\"list-group clear-list m-t\" ng-if=\"Countries.companies.length\"><li class=\"list-group-item fist-item\" ng-repeat=\"company in Countries.companies\"><span class=\"pull-right\"><a link-sidebar=\"\" type=\"4\" id=\"{{company.id}}\" href=\"javascript:void(0);\" class=\"btn btn-outline btn-success btn-xs\" translate-cloak=\"\">{{\'home.btn.contact\' | translate}}</a></span> <a link-sidebar=\"\" type=\"1\" data=\"company\" href=\"javascript:void(0);\">{{company.name}}</a></li></ul><p ng-if=\"!Countries.loading && !Countries.companies.length\">{{\'home.countries.noresult\' | translate}}</p></div>");
$templateCache.put("app/logged/home/home.html","<div class=\"wrapper wrapper-content animated fadeIn home\"><div class=\"row\"><div class=\"col-xs-12 col-md-8\"><div class=\"ibox\" ng-if=\"Home.messages.length\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\'home.messages.title\' | translate}}</h5><a href=\"javascript:void(0);\" ui-sref=\"^.mailbox\" class=\"btn btn-success btn-outline btn-xs pull-right\" translate-cloak=\"\">{{\'home.messsages.view\' | translate}}</a></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Home.loadingEvents}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" width=\"100%\"><tbody><tr ng-repeat=\"message in Home.messages track by $index\"><td class=\"mail-contact\"><a href=\"javascript:void(0);\" class=\"text-success\" link-sidebar=\"\" type=\"1\" data=\"message.recipients[0]\">{{message.sender.name}}</a></td><td class=\"mail-subject\"><a class=\"text-success\" href=\"javascript:void(0);\" link-sidebar=\"\" type=\"3\" id=\"{{message.id}}\">{{message.subject}}</a></td></tr></tbody></table></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\'home.title\' | translate}} ({{::Home.yearActual}})</h5><div class=\"ibox-tools\"><form ng-submit=\"Home.viewMore(Home.activeTab)\"><div class=\"input-group text-right\"><input type=\"text\" ng-model=\"Home.tabsSearch\" placeholder=\"{{\'home.search\' | translate}}\" class=\"form-control input-sm pull-right w150 p-xxs\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-xs btn-primary\"><em class=\"textwhite fa fa-search\"></em></button></span></div></form></div></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': (Home.loadingCompanies || Home.loadingContacts)}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"tabs-container\"><uib-tabset><uib-tab><uib-tab-heading ng-click=\"Home.activeTab = 1\"><em class=\"fa fa-suitcase\"></em> <span translate-cloak=\"\">{{\'home.companies\' | translate}}</span></uib-tab-heading><div class=\"panel-body bg-white animated fadeIn\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" width=\"100%\"><tbody><tr ng-repeat=\"company in Home.companies track by $index\"><td class=\"text-center\"><img alt=\"Logo de la empresa\" ng-if=\"company.logo.url\" ng-src=\"{{company.logo.url}}\" class=\"max-h-30\"> <img alt=\"Placeholder del logo de la empresa\" ng-if=\"!company.logo.url\" src=\"https://d3cbxno87ymraz.cloudfront.net/app/assets/images/no-pictures.png\" class=\"max-w-30\"></td><td><a link-sidebar=\"\" type=\"1\" id=\"{{company.id}}\" href=\"javascript:void(0);\">{{company.name}}</a></td><td>{{company.cnae.name}}</td><td><em class=\"text-success fa fa-map-marker\"></em> {{company.province.name}}</td><td width=\"65\" class=\"text-right\"><a link-sidebar=\"\" type=\"4\" id=\"{{company.id}}\" href=\"javascript:void(0);\" title=\"Enviar email\"><em class=\"fa fa-envelope text-navy\"></em></a> <a link-sidebar=\"\" type=\"1\" id=\"{{company.id}}\" href=\"javascript:void(0);\" title=\"Ver empresa\"><em class=\"fa fa-mail-forward text-navy\"></em></a></td></tr></tbody></table></div><div class=\"text-right\"><a href=\"javascript:void(0);\" ng-click=\"Home.viewMore(1)\" translate-cloak=\"\">{{\'home.btn.viewmore\' | translate}}</a></div></div></uib-tab><uib-tab><uib-tab-heading ng-click=\"Home.activeTab = 2\"><em class=\"fa fa-users\"></em> <span translate-cloak=\"\">{{\'home.contacts\' | translate}}</span></uib-tab-heading><div class=\"panel-body bg-white animated fadeIn\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" width=\"100%\"><tbody><tr ng-repeat=\"contact in Home.contacts track by $index\"><td class=\"text-center\"><img alt=\"Imagen de contacto\" ng-if=\"contact.image\" ng-src=\"{{contact.image.url}}\" class=\"max-h-30\"> <img alt=\"Placeholder de la imagen de contacto\" ng-if=\"!contact.image\" src=\"https://d3cbxno87ymraz.cloudfront.net/app/assets/images/no-pictures.png\" class=\"max-w-30\"></td><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"2\" id=\"{{contact.id}}\">{{contact.name}} {{contact.surname}}</a></td><td>{{contact.job_title}}</td><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"1\" id=\"{{contact.company_id}}\">{{contact.company.name}}</a></td><td class=\"text-right\" width=\"100\"><a href=\"javascript:void(0);\" title=\"Enviar email\" link-sidebar=\"\" type=\"4\" id=\"{{contact.company_id}}\"><em class=\"fa fa-envelope text-navy\"></em></a> <a href=\"javascript:void(0);\" title=\"Ver más\" link-sidebar=\"\" type=\"2\" data=\"contact\"><em class=\"fa fa-share text-navy\"></em></a></td></tr></tbody></table></div><div class=\"text-right\"><a href=\"javascript:void(0);\" ng-click=\"Home.viewMore(2)\">{{\'home.btn.viewmore\' | translate}}</a></div></div></uib-tab></uib-tabset></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\'home.countries_sales\' | translate}} ({{::Home.yearActual}})</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sx-12\" ng-class=\"{\'col-md-7\': Home.countriesActive}\"><vector-map class=\"vector-map-content\" in-home=\"true\" emit=\"mapCountrySelecedSales\"></vector-map></div><div ui-view=\"vmapcountries\"></div></div></div></div></div><div class=\"col-xs-12 col-md-4\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\'home.partners.title\' | translate}}</h5></div><div class=\"ibox-content\"><div><div><strong class=\"\">{{\'patronos.toggle.financial\' | translate}}</strong></div><div class=\"row align-items-center\"><div class=\"col-6 col-md-6\"><div class=\"m-t\"><a href=\"https://www.bancosantander.es/empresas/santander-growth\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/santander.png\" class=\"img-responsive\"></a></div><div class=\"m-t\"><a href=\"https://www.informa.es/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/informa.png\" class=\"img-responsive\"></a></div><div class=\"m-t\"><a href=\"https://www.bancsabadell.com/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/logo_sabadell.png\" class=\"img-responsive\"></a></div></div><div class=\"col-6 col-md-6 m-t\"><div><a href=\"https://www.ico.es/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/ico.png\" class=\"img-responsive\"></a></div><div class=\"m-t\"><a href=\"https://www.bmegrowth.es/esp/BME-Growth/Que-Es.aspx\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/bme.png\" class=\"img-responsive\"></a></div></div></div><div class=\"m-t-lg\"><div><strong class=\"\">{{\'patronos.toggle.sustainability\' | translate}}</strong></div><div class=\"row\"><div class=\"col-6 col-md-6 m-t\"><div><a href=\"https://www.ecoembes.com/es\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/logo_ecoembes.png\" class=\"img-responsive\"></a></div><div class=\"m-t\"><a href=\"https://www.eroski.es/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/logo_eroski.png\" class=\"img-responsive\"></a></div></div><div class=\"col-6 col-md-6 m-t\"><div><a href=\"https://www.volvocars.com/es/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/logo_volvo.png\" class=\"img-responsive\"></a></div></div></div></div><div class=\"m-t-lg\"><div><strong class=\"\">{{\'patronos.toggle.digital\' | translate}}</strong></div><div class=\"row\"><div class=\"col-6 col-md-6 m-t\"><div><a href=\"https://www.wolterskluwer.com/es-es/know/s-info-c198-pack-emprende?utm_source=colectivos&utm_medium=link&utm_campaign=c198-pack-emprende&utm_content=colectivos-empresas\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/wolterskluwer.png\" class=\"img-responsive\"></a></div></div><div class=\"col-6 col-md-6 m-t\"><div><a href=\"https://www.orange.es/empresas/PYMES\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/orange_empresas.png\" class=\"img-responsive\"></a></div></div><div class=\"col-6 col-md-6 m-t\"><div><a href=\"https://seller-es-accounts.tiktok.com/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/logo_tiktokshop_v2.png\" class=\"img-responsive\"></a></div></div><div class=\"col-6 col-md-6 m-t\"><div><a href=\"https://grupotopdigital.es/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/logo_topdigital.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-6 col-md-6 m-t\"><div><a href=\"https://extrategia.com/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/extrategia.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-6 col-md-6 m-t-lg\"><div><a href=\"https://www.conversia.es/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/conversia.png\" class=\"img-responsive\"></a></div></div></div></div><div class=\"m-t-lg\"><div><strong class=\"\">{{\'patronos.toggle.talent\' | translate}}</strong></div><div class=\"row\"><div class=\"col-6 col-md-6 m-t\"><div><a href=\"https://www.mapfre.es/empresas/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/mapfre_2026.png\" class=\"img-responsive\"></a></div><div class=\"m-t\"><a href=\"https://www.sage.com/es-es/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/logo_sage_v2.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-6 col-md-6 m-t\"><div><a href=\"https://www.aenor.com/\" target=\"_blank\"><img src=\"https://cepyme500-web.s3.eu-west-1.amazonaws.com/patronos/logo_aenor.png\" class=\"img-responsive\"></a></div></div></div></div></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\'home.events.title\' | translate}}</h5><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"8\" class=\"btn btn-success btn-outline btn-xs pull-right\" translate-cloak=\"\">{{\'home.events.add_btn\' | translate}}</a></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Home.loadingEvents}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><ul class=\"list-group clear-list m-t\"><li class=\"list-group-item fist-item\" ng-repeat=\"event in Home.events track by $index\"><span class=\"pull-right\">{{event.dateFrom}}</span> <a link-sidebar=\"\" type=\"7\" data=\"event\" href=\"javascript:void(0);\">{{event.title}}</a></li></ul><div class=\"text-right\"><a href=\"javascript:void(0);\" ui-sref=\"^.events\" translate-cloak=\"\">{{\'home.btn.viewall\' | translate}}</a></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><span class=\"pull-right\"><em class=\"text-success fa fa-star\"></em></span><h5 class=\"text-success\" translate-cloak=\"\">{{\'directory.companies.contact\' | translate}}:</h5></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Home.loadingAdvertisers}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div><em class=\"fa fa-envelope text-primary\"></em> <a href=\"mailto:cepyme500@cepyme.es\">cepyme500@cepyme.es</a><br><em class=\"fa fa-phone text-primary\"></em> <a href=\"tel:+34914116161\">+91 411 61 61</a></div></div></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\'home.news\' | translate}}</h5><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"6\" class=\"btn btn-success btn-outline btn-xs pull-right\" translate-cloak=\"\">{{\'home.press_release.add_btn\' | translate}}</a></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Home.loadingPR}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" width=\"100%\"><tbody><tr ng-repeat=\"article in Home.preleases track by $index\"><td class=\"text-center\"><img alt=\"Imagen de la noticia\" ng-if=\"article.image.real_path\" ng-src=\"{{article.image.real_path}}\" class=\"max-h-30\"> <img alt=\"Placeholder de la imagen de la noticia\" ng-if=\"!article.image.real_path\" src=\"https://d3cbxno87ymraz.cloudfront.net/app/assets/images/no-pictures.png\" class=\"max-w-30\"></td><td><a link-sidebar=\"\" type=\"5\" id=\"{{article.id}}\" href=\"javascript:void(0);\">{{article.title}}</a></td><td><a link-sidebar=\"\" type=\"1\" id=\"{{article.company.id}}\" href=\"javascript:void(0);\">{{article.company.name}}</a></td><td width=\"90\"><span am-time-ago=\"{{article.updated_at.date | amUtc | amLocal}}\"></span></td><td class=\"text-right\"><a link-sidebar=\"\" type=\"5\" id=\"{{article.id}}\" href=\"javascript:void(0);\" tooltip-placement=\"top\" uib-tooltip=\"Ir la noticia\"><em class=\"fa fa-mail-forward text-navy\"></em></a></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/logged/magazine/magazine.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><h2 translate-cloak=\"\">{{\'general.url.magazine\' | translate}}</h2><iframe title=\"Anuario CEPYME500 para su visionado online\" src=\"https://www.yumpu.com/es/embed/view/oG5IL9jS6nJiYPA1\" style=\"width:98%; height: 800px; border: none\"></iframe><hr><div class=\"row\"><div ng-repeat=\"magazine in Magazine.magazines track by $index\" class=\"col-12 col-md-4\"><h2 translate-cloak=\"\">Anuario CEPYME500 del año {{Magazine.year - ($index+1)}} para su visionado online</h2><iframe title=\"Anuario CEPYME500 del año pasado para su visionado online\" src=\"{{Magazine.trustSrc(magazine)}}\" style=\"width:98%; height: 400px; border: none\"></iframe></div></div></div>");
$templateCache.put("app/logged/mailbox/mailbox.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content mailbox-content\"><div class=\"file-manager\"><a class=\"btn btn-block btn-primary compose-mail\" link-sidebar=\"\" type=\"4\" translate-cloak=\"\">{{\'mailbox.compose\' | translate}}</a><div class=\"space-25\"></div><h5 translate-cloak=\"\">{{ \'mailbox.folders\' | translate}}</h5><ul class=\"category-list m-b-lg\" style=\"padding: 0\"><li><a href=\"javascript:void(0);\" ng-click=\"Mailbox.changeType(1, \'inbox\')\" translate-cloak=\"\" ng-class=\"{\'active\': Mailbox.folder == \'inbox\'}\"><em class=\"fa fa-inbox\"></em> {{\'mailbox.inbox\' | translate}} <span class=\"label label-warning pull-right\">{{Logged.unreadMessagesFolder.inbox.unread}}</span></a></li><li><a href=\"javascript:void(0);\" ng-click=\"Mailbox.changeType(1, \'send\')\" translate-cloak=\"\" ng-class=\"{\'active\': Mailbox.folder == \'send\'}\"><em class=\"fa fa-envelope-o\"></em> {{\'mailbox.send\' | translate}} <span class=\"label label-warning pull-right\">{{Logged.unreadMessagesFolder.send.unread}}</span></a></li><li><a href=\"javascript:void(0);\" ng-click=\"Mailbox.changeType(1, \'important\')\" translate-cloak=\"\" ng-class=\"{\'active\': Mailbox.folder == \'important\'}\"><em class=\"fa fa-certificate\"></em> {{\'mailbox.important\' | translate}} <span class=\"label label-warning pull-right\">{{Logged.unreadMessagesFolder.important.unread}}</span></a></li><li><a href=\"javascript:void(0);\" ng-click=\"Mailbox.changeType(1, \'trash\')\" translate-cloak=\"\" ng-class=\"{\'active\': Mailbox.folder == \'trash\'}\"><em class=\"fa fa-file-text-o\"></em> {{\'mailbox.trash\' | translate}} <span class=\"label label-danger pull-right\">{{Logged.unreadMessagesFolder.trash.unread}}</span></a></li></ul><h5 translate-cloak=\"\">{{\'mailbox.categories\' | translate}}</h5><ul class=\"category-list\" style=\"padding: 0\"><li><a href=\"javascript:void(0);\" ng-click=\"Mailbox.changeType(2, \'comunication_cepyme500\')\" translate-cloak=\"\" ng-class=\"{\'active\': Mailbox.tag == \'comunication_cepyme500\'}\"><em class=\"fa fa-circle text-primary\"></em> {{\'mailbox.comunication_cepyme500\' | translate}} <span ng-if=\"Logged.unreadMessagesTag.comunication_cepyme500.unread\" class=\"label label-danger pull-right\">{{Logged.unreadMessagesTag.comunication_cepyme500.unread}}</span></a></li><li><a href=\"javascript:void(0);\" ng-click=\"Mailbox.changeType(2, \'special_offer\')\" translate-cloak=\"\" ng-class=\"{\'active\': Mailbox.tag == \'special_offer\'}\"><em class=\"fa fa-circle text-info\"></em> {{\'mailbox.special_offer\' | translate}} <span ng-if=\"Logged.unreadMessagesTag.special_offer.unread\" class=\"label label-danger pull-right\">{{Logged.unreadMessagesTag.special_offer.unread}}</span></a></li><li><a href=\"javascript:void(0);\" ng-click=\"Mailbox.changeType(2, \'collaborative_projects\')\" translate-cloak=\"\" ng-class=\"{\'active\': Mailbox.tag == \'collaborative_projects\'}\"><em class=\"fa fa-circle text-black\"></em> {{\'mailbox.collaborative_projects\' | translate}} <span ng-if=\"Logged.unreadMessagesTag.collaborative_projects.unread\" class=\"label label-danger pull-right\">{{Logged.unreadMessagesTag.collaborative_projects.unread}}</span></a></li><li><a href=\"javascript:void(0);\" ng-click=\"Mailbox.changeType(2, \'event_invitation\')\" translate-cloak=\"\" ng-class=\"{\'active\': Mailbox.tag == \'event_invitation\'}\"><em class=\"fa fa-circle text-danger\"></em> {{\'mailbox.event_invitation\' | translate}} <span ng-if=\"Logged.unreadMessagesTag.event_invitation.unread\" class=\"label label-danger pull-right\">{{Logged.unreadMessagesTag.event_invitation.unread}}</span></a></li></ul><div class=\"clearfix\"></div></div></div></div></div><div class=\"col-lg-9 animated fadeInRight\"><div class=\"mail-box-header\"><form class=\"pull-right mail-search\"><div class=\"input-group\" style=\"position:relative\"><input type=\"text\" class=\"form-control input-sm\" autocomplete=\"off\" ng-model=\"Mailbox.search\" name=\"search\" placeholder=\"{{\'mailbox.search\' | translate}}\"><div class=\"input-group-btn\"><button type=\"button\" ng-click=\"Mailbox.changeSearch()\" class=\"btn btn-sm btn-primary\">{{\'mailbox.search\' | translate}}</button></div></div></form><h2 translate-cloak=\"\" ng-if=\"Mailbox.folder\">{{\'mailbox.\'+Mailbox.folder | translate}}</h2><h2 translate-cloak=\"\" ng-if=\"Mailbox.tag\">{{\'mailbox.\'+Mailbox.tag | translate}}</h2><div class=\"mail-tools tooltip-demo m-t-md\"><button class=\"btn btn-white btn-sm\" type=\"button\" ng-click=\"Mailbox.changeType()\" tooltip-placement=\"top\" uib-tooltip=\"{{\'mailbox.refresh\' | translate}}\"><em class=\"fa fa-refresh\"></em></button> <button ng-if=\"Mailbox.folder !== \'send\'\" class=\"btn btn-white btn-sm\" type=\"button\" ng-click=\"Mailbox.markRead(false, 1, Mailbox.folder)\" tooltip-placement=\"top\" uib-tooltip=\"{{\'mailbox.as_read\' | translate}}\"><em class=\"fa fa-eye\"></em></button> <button ng-if=\"Mailbox.folder !== \'send\'\" class=\"btn btn-white btn-sm\" type=\"button\" ng-click=\"Mailbox.markRead(false, 0, Mailbox.folder)\" tooltip-placement=\"top\" uib-tooltip=\"{{\'mailbox.as_noread\' | translate}}\"><em class=\"fa fa-eye-slash\"></em></button> <button ng-if=\"Mailbox.folder !== \'send\' && Mailbox.folder !== \'inbox\'\" ng-click=\"Mailbox.changeMailFolder(\'inbox\')\" class=\"btn btn-white btn-sm\" type=\"button\" tooltip-placement=\"top\" uib-tooltip=\"{{\'mailbox.to_inbox\' | translate}}\"><em class=\"fa fa-inbox\"></em></button> <button ng-if=\"Mailbox.folder !== \'send\' && Mailbox.folder !== \'important\'\" ng-click=\"Mailbox.changeMailFolder(\'important\')\" class=\"btn btn-white btn-sm\" type=\"button\" tooltip-placement=\"top\" uib-tooltip=\"{{\'mailbox.as_important\' | translate}}\"><em class=\"fa fa-exclamation\"></em></button> <button ng-if=\"Mailbox.folder !== \'trash\'\" class=\"btn btn-white btn-sm\" ng-click=\"Mailbox.changeMailFolder(\'trash\')\" type=\"button\" tooltip-placement=\"top\" uib-tooltip=\"{{\'mailbox.to_trash\' | translate}}\"><em class=\"fa fa-trash-o\"></em></button></div></div><div class=\"mail-box ibox-content\" ng-class=\"{\'sk-loading\': Mailbox.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><p class=\"p-md\" ng-if=\"!Mailbox.messages.length\" translate-cloak=\"\">{{\'mailbox.nomessage\' | translate}}</p><div class=\"table-responsive\" ng-if=\"Mailbox.messages.length\"><table class=\"table table-hover table-mail\"><tbody><tr ng-class=\"{\'unread\': message.unread}\" ng-repeat=\"message in Mailbox.messages track by $index\"><td class=\"check-mail\"><input type=\"checkbox\" ng-model=\"Mailbox.check[message.id]\"></td><td><span ng-class=\"{\'badge badge-primary\': message.tag == \'comunication_cepyme500\', \'badge badge-info\': message.tag == \'special_offer\', \'badge badge-danger\': message.tag == \'event_invitation\', \'badge badge-warning\': message.tag == \'startup_presentation\', \'badge badge-black\': message.tag == \'collaborative_projects\'}\">&nbsp;</span></td><td width=\"30%\" class=\"mail-contact\"><div ng-if=\"Mailbox.folder === \'send\'\"><a ng-repeat=\"recipient in message.recipients|limitTo:3\" href=\"javascript:void(0);\" class=\"text-success\" link-sidebar=\"\" type=\"1\" data=\"recipient\"><span ng-if=\"$index > 0\">|</span> {{recipient.name}} <span ng-if=\"$index > 1\">...</span></a> <a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"1\" data=\"message.last_sender\">{{message.last_sender.name}} <span ng-if=\"message.total > 1\" class=\"\">({{message.total}})</span></a></div><div ng-if=\"Mailbox.folder !== \'send\'\"><a href=\"javascript:void(0);\" class=\"text-success\" link-sidebar=\"\" type=\"1\" data=\"message.sender\">{{message.sender.name}}</a></div></td><td width=\"45%\" class=\"mail-subject ellipsis\"><a class=\"text-success\" href=\"javascript:void(0);\" ng-click=\"Mailbox.markRead($index)\" link-sidebar=\"\" type=\"3\" id=\"{{message.id}}\">{{message.subject}}</a></td><td width=\"5%\"><em ng-if=\"message.attachments\" class=\"fa fa-paperclip\"></em></td><td width=\"15%\" class=\"text-right mail-date\"><span am-time-ago=\"message.created_at.date | amUtc | amLocal\"></span></td><td width=\"5%\" class=\"text-right\"><a href=\"javascript:void(0);\" class=\"text-success\" ng-click=\"Mailbox.markRead($index)\" link-sidebar=\"\" type=\"3\" id=\"{{message.id}}\"><em class=\"fa fa-share\"></em></a></td></tr></tbody></table></div><div class=\"clearfix m-r-md\"><div class=\"pull-right\"><uib-pagination total-items=\"Mailbox.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"Mailbox.getList()\" ng-model=\"Mailbox.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"20\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/logged/map/infowindow.html","<div><h4><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"1\" data=\"parameter.model\">{{parameter.model.name}} <em class=\"fa fa-share\"></em></a></h4><p>{{parameter.model.street}}, {{parameter.model.postal_code}}, {{parameter.model.province.name}}</p></div>");
$templateCache.put("app/logged/map/map.html","<style>\n  .angular-google-map-container {\n    height: 600px;\n  }\n</style><div class=\"ibox m-t-md\"><div class=\"ibox-content clearfix\"><form name=\"CompaniesFormSearch\" class=\"form-inline pull-right\" ng-submit=\"Map.getCompanies(true)\"><div class=\"form-group m-r-sm\"><input type=\"text\" class=\"form-control\" name=\"q\" id=\"q\" placeholder=\"{{\'map.search\' | translate}}...\" ng-model=\"Map.params.q\"></div><div class=\"form-group m-r-sm\"><chosen-companies selected-company=\"Map.selectedCompanyId\" on-company-change=\"Map.handleCompanySelection(companyId, company)\"></chosen-companies></div><div class=\"form-group m-r-sm\"><select class=\"form-control chosen-select\" chosen=\"\" name=\"province\" id=\"province\" data-placeholder-text-single=\"\'{{\'general.chosen.province\' | translate}}\'\" ng-model=\"Map.params.province_id\" allow-single-deselect=\"true\" ng-options=\"province.id as province.name for province in Map.provincesSelect\"><option value=\"\"></option></select></div><div class=\"form-group m-r-sm\" ng-if=\"myUser.group == \'superadmin\' || myUser.group == \'admin\'\"><input type=\"checkbox\" ng-true-value=\"1000\" name=\"limit\" ng-model=\"Map.params.limit\"> <span translate-cloak=\"\">{{\'map.all\' | translate}}</span></div><div class=\"form-group m-r-sm\"><select name=\"year\" class=\"form-control\" ng-model=\"Map.params.year\" ng-options=\"year.value as year.name for year in Map.years\"></select></div><button type=\"submit\" class=\"btn btn-success\" translate-cloak=\"\">{{\'map.search\' | translate}}</button></form></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\" translate-cloak=\"\">{{ \'map.title\' | translate}}</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Map.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><ui-gmap-google-map center=\"Map.mapCenter\" zoom=\"5\" ng-if=\"Map.mapReady\"><ui-gmap-window show=\"Map.window.show\" coords=\"Map.window.model\" options=\"Map.window.options\" closeclick=\"Map.window.closeClick()\" templateurl=\"\'app/logged/map/infowindow.html\'\" templateparameter=\"Map.window\"></ui-gmap-window><ui-gmap-markers models=\"Map.addresses\" coords=\"\'self\'\" docluster=\"false\" events=\"Map.markersEvents\" options=\"Map.markerOptions\"></ui-gmap-markers></ui-gmap-google-map><div class=\"clearfix\"><div class=\"pull-left\"><span translate-cloak=\"\">{{ \'map.showing\' | translate}}</span> {{Map.addresses.length}} | <span translate-cloak=\"\">{{ \'map.total\' | translate}}</span> {{Map.total}}</div><div class=\"pull-right text-right\"><uib-pagination total-items=\"Map.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"Map.getCompanies()\" ng-model=\"Map.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"Map.params.limit\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/logged/myweb/myweb.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>{{MyWeb.text}}</h1><h2 translate-cloak=\"\">{{\'myweb.title\' | translate}}</h2></div></div></div></div>");
$templateCache.put("app/logged/news/news.html","<div class=\"wrapper wrapper-content animated fadeInRight news\"><div masonry=\"{ gutter: 25 }\" load-images=\"true\" preserve-order=\"\" column-width=\"330\" masonry-options=\'{\"isFitWidth\": true}\' reload-on-show=\"\" reload-on-resize=\"\"><div class=\"masonry-brick\" ng-repeat=\"article in News.articles track by $index\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"text-center\" ng-show=\"article.featured_image_thumbnail_url\"><img alt=\"Imagen de la noticia\" ng-src=\"{{article.featured_image_thumbnail_url}}\" class=\"img-responsive\"></div><h3><a ng-href=\"{{article.link}}\" target=\"_blank\"><strong class=\"text-success\" ng-bind-html=\"article.title.rendered\"></strong></a></h3><div ng-bind-html=\"article.excerpt.rendered\"></div><hr><div class=\"clearfix\"><div class=\"pull-left\"><a ng-href=\"{{article.link}}\" target=\"_blank\">Ver más</a></div><div class=\"pull-right\" am-time-ago=\"{{article.date | amUtc | amLocal}}\"></div></div></div></div></div></div><div class=\"m-t-md m-b-md text-center\"><button ng-disabled=\"News.loading\" ng-click=\"News.viewMore();\" class=\"btn btn-primary\"><em ng-show=\"News.loading\" class=\"fa fa-spinner fa-spin\"></em> Más noticias</button></div></div>");
$templateCache.put("app/logged/offers/offers.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"m-t-md m-b-lg\"><a class=\"btn btn-primary\" href=\"javascript:void(0);\" id=\"compose\" link-sidebar=\"\" type=\"13\" translate-cloak=\"\">{{\'offers.btn.send\' | translate}}</a></div><iframe title=\"Creatividad de la oferta\" src=\"https://upthemedia.com/cepyme500_partners/offers.html\" style=\"position: absolute; width:100%; height: 80%; border: none\"></iframe></div>");
$templateCache.put("app/logged/partners_training/partners_training.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div ng-if=\"!PartnersTraining.partner.isEmpty()\" class=\"partners\"><div class=\"row no-gutters\"><div class=\"col-12 col-md-6\"><div class=\"bg-white p-lg rounded--left\"><div ng-if=\"PartnersTraining.partner.logo\"><img ng-src=\"{{PartnersTraining.partner.logo}}\"></div><div ng-if=\"PartnersTraining.partner.description\" class=\"m-t-md\" ng-bind-html=\"PartnersTraining.partner.description\"></div><hr><div class=\"row\"><div class=\"col-12 col-md-3\"><div ng-if=\"PartnersTraining.partner.employee.avatar\"><img ng-src=\"{{PartnersTraining.partner.employee.avatar}}\" class=\"rounded-md img-responsive\"></div></div><div class=\"col-12 col-md-9\"><div ng-if=\"PartnersTraining.partner.employee.name\"><strong>{{PartnersTraining.partner.employee.name}}</strong></div><div ng-if=\"PartnersTraining.partner.employee.position\">{{PartnersTraining.partner.employee.position}}</div><div ng-if=\"PartnersTraining.partner.employee.phone\">{{PartnersTraining.partner.employee.phone}}</div><div ng-if=\"PartnersTraining.partner.employee.email\">{{PartnersTraining.partner.employee.email}}</div><div ng-if=\"PartnersTraining.partner.employee.web\" class=\"text-wrap\"><a ng-href=\"{{PartnersTraining.partner.employee.web}}\" target=\"_blank\">{{PartnersTraining.partner.employee.web}}</a></div></div></div></div></div><div class=\"col-12 col-md-6\"><div class=\"bg-grey p-lg rounded--right\"><div class=\"row\"><div class=\"col-12 col-md-3\"><div ng-if=\"PartnersTraining.partner.presentation.image\"><img ng-src=\"{{PartnersTraining.partner.presentation.image}}\" class=\"img-responsive\"></div></div><div class=\"col-12 col-md-9\"><div class=\"p-b-sm border-bottom--partner\" ng-if=\"PartnersTraining.partner.presentation.title\"><strong class=\"text-partners\">{{PartnersTraining.partner.presentation.title}}</strong></div><div class=\"p-t-sm p-b-sm text-wrap border-bottom--partner\" ng-if=\"PartnersTraining.partner.presentation.url\"><a href=\"{{PartnersTraining.partner.presentation.url}}\" target=\"_blank\"><strong>{{PartnersTraining.partner.presentation.url}}</strong></a></div><div class=\"mt-40\" ng-if=\"PartnersTraining.partner.presentation\"><span class=\"label label-partners m-r-sm\" ng-repeat=\"tag in PartnersTraining.partner.presentation.tags track by $index\">{{tag}}</span></div></div></div><div ng-if=\"PartnersTraining.partner.video.url\"><div class=\"video-partner-label\">Video</div><div class=\"m-t-sm m-b-sm\" ng-if=\"PartnersTraining.partner.video.title\"><strong class=\"text-partners\">{{PartnersTraining.partner.video.title}}</strong></div><div ng-if=\"PartnersTraining.partner.video.url\"><div class=\"embed-responsive embed-responsive-16by9\"><iframe class=\"embed-responsive-item\" ng-src=\"{{PartnersTraining.partner.video.url | trustUrl}}\" allowfullscreen=\"\"></iframe></div><div ng-if=\"PartnersTraining.partner.video.youtubeLink\" class=\"text-wrap m-t-sm\"><a ng-href=\"{{PartnersTraining.partner.video.youtubeLink}}\" target=\"_blank\">{{PartnersTraining.partner.video.youtubeLink}}</a></div></div></div></div></div></div><div ng-if=\"PartnersTraining.partner.isEmpty()\">No se ha encontrado este partner.</div></div></div>");
$templateCache.put("app/logged/patrons/patrons.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"loading-iframe\"><iframe id=\"patron-iframe\" ng-if=\"Patrons.patron\" ng-style=\"{height : Patrons.height}\" width=\"100%\" class=\"no-borders\" ng-src=\"{{Patrons.patron}}\"></iframe></div></div>");
$templateCache.put("app/logged/premium/premium.html","<div class=\"wrapper wrapper-content animated fadeInRight relative\"><div class=\"loading-iframe\"><iframe title=\"Pdf de la oferta CEPYME500 PREMIUM\" src=\"https://upthemedia.com/cepyme500_premium/index.php\" style=\"position: absolute; width:105%; height: 150vh; border: none\"></iframe></div></div>");
$templateCache.put("app/logged/premium/premium_new.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"text-center\"><img alt=\"Imagen de servicios premium\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/premium_header_app.jpg\" class=\"img-responsive center-block\"></div><div ng-if=\"Premium.loading\" class=\"text-primary text-center mt-40\">Cargando...<br><em class=\"fa fa-spinner fa-spin text-center\"></em></div><div class=\"row mt-40\" ng-if=\"! Premium.hasPremium && ! Premium.loading\"><div class=\"col-xs-12 col-md-8\"><p translate=\"premium.no_premium_text1\" translate-values=\"{\'name\': myUser.company.name}\"></p><p><span translate-cloak=\"\">{{\"premium.no_premium_text2\" | translate}}</span> <a href=\"https://d3cbxno87ymraz.cloudfront.net//premium/cepyme500_premium.pdf\" target=\"_blank\"><strong translate-cloak=\"\">{{\"premium.here\" | translate}}</strong></a>.</p><h3 class=\"mt-40\"><strong translate-cloak=\"\">{{\"premium.no_premium_text3\" | translate}}</strong></h3><p translate-cloak=\"\">{{\"premium.no_premium_text4\" | translate}}</p><ol><li translate-cloak=\"\">{{\"premium.no_premium_ol1\" | translate}}</li><li translate-cloak=\"\">{{\"premium.no_premium_ol2\" | translate}}</li><li translate-cloak=\"\">{{\"premium.no_premium_ol3\" | translate}}</li><li translate-cloak=\"\">{{\"premium.no_premium_ol4\" | translate}}</li><li translate-cloak=\"\">{{\"premium.no_premium_ol5\" | translate}}</li><li translate-cloak=\"\">{{\"premium.no_premium_ol6\" | translate}}</li></ol><p class=\"m-t\"><strong translate-cloak=\"\">{{\"premium.no_premium_text5\" | translate}}</strong></p><p translate=\"premium.no_premium_text6\" translate-values=\"{\'name\': myUser.company.name}\">></p><p translate-cloak=\"\">{{\"premium.no_premium_text7\" | translate}}</p><p translate-cloak=\"\">{{\"premium.no_premium_text8\" | translate}}</p></div><div class=\"col-xs-12 col-md-4 text-center\"><div ng-if=\"! Premium.hasPremium && ! Premium.loading\"><div><h1><strong style=\"font-size: 1.7em\">799€</strong> +iva</h1></div><div><button ng-click=\"Premium.toggle = 1\" ng-disabled=\"Premium.toggle\" type=\"button\" class=\"btn btn-primary\" translate=\"premium.contract_btn\"></button></div><div ng-if=\"Premium.toggle\" class=\"mt-40 text-left\"><form ng-if=\"!myUser.company.customer_id\" class=\"form-inline advertiser-form-pay\" name=\"formPay\" ng-submit=\"Premium.submit()\" novalidate=\"\"><p class=\"m-b-md\" translate=\"shop.help_ccard\"></p><div class=\"form-group block m-b-md\" ng-class=\"{\'has-error\': (formPay.card_number.$dirty || formPay.$submitted) && formPay.card_number.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'shop.ccard.number\' | translate}}</label> <input class=\"form-control\" type=\"text\" name=\"card_number\" ng-model=\"Premium.card.card_number\" placeholder=\"................\" cc-format=\"\" cc-number=\"\" cc-eager-type=\"\" ng-required=\"true\"> <img alt=\"Imagen de la tarjeta de crédito\" ng-src=\"https://d3cbxno87ymraz.cloudfront.net//credit_cards/{{formPay.card_number.$ccEagerType | lowercase}}.png\"><p ng-show=\"(formPay.card_number.$dirty || formPay.$submitted) && formPay.card_number.$invalid\" class=\"text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</p></div><div class=\"form-group m-r-md\" ng-class=\"{\'has-error\': (formPay.card_exp_month.$dirty || formPay.$submitted) && formPay.card_exp_month.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'shop.ccard.month\' | translate}}</label> <input class=\"form-control min-card-input\" name=\"card_exp_month\" placeholder=\"..\" ng-model=\"Premium.card.card_exp_month\" cc-exp-month=\"\" ng-required=\"true\"><p>&nbsp;<span ng-show=\"(formPay.card_exp_month.$dirty || formPay.$submitted) && formPay.card_exp_month.$invalid\" class=\"text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</span></p></div><div class=\"form-group m-r-md\" ng-class=\"{\'has-error\': (formPay.card_exp_year.$dirty || formPay.$submitted) && formPay.card_exp_year.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'shop.ccard.year\' | translate}}</label> <input class=\"form-control min-card-input\" name=\"card_exp_year\" placeholder=\"..\" ng-model=\"Premium.card.card_exp_year\" cc-exp-year=\"\" ng-required=\"true\"><p>&nbsp;<span ng-show=\"(formPay.card_exp_year.$dirty || formPay.$submitted) && formPay.card_exp_year.$invalid\" class=\"text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</span></p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (formPay.card_cvc.$dirty || formPay.$submitted) && formPay.card_cvc.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'shop.ccard.cvc\' | translate}}:</label> <input class=\"form-control min-card-input\" type=\"text\" name=\"card_cvc\" ng-model=\"Premium.card.card_cvc\" placeholder=\"...\" cc-cvc=\"\" ng-required=\"true\"><p>&nbsp;<span ng-show=\"(formPay.card_cvc.$dirty || formPay.$submitted) && formPay.card_cvc.$invalid\" class=\"text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</span></p></div><div class=\"block\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"!formPay.$valid || Premium.loadingPay\"><em class=\"fa fa-shopping-cart\"></em> <em ng-show=\"Premium.loadingPay\" class=\"fa fa-spinner fa-spin\"></em> <span translate-cloak=\"\">{{\"premium.pay_btn\" | translate}}</span></button></div></form><div ng-if=\"myUser.company.customer_id\" class=\"text-center m-t\"><p translate=\"premium.pay_text\" translate-values=\"{\'name\': myUser.company.name}\"></p><button type=\"button\" class=\"btn btn-success\" ng-click=\"Premium.submit()\" ng-disabled=\"Premium.loadingPay\"><em class=\"fa fa-shopping-cart\"></em> <em ng-show=\"Premium.loadingPay\" class=\"fa fa-spinner fa-spin\"></em> <span translate-cloak=\"\">{{\"premium.pay_btn\" | translate}}</span></button></div><div ng-if=\"Premium.error\" class=\"alert alert-danger m-t\">{{Premium.error}}</div></div></div></div></div><div class=\"mt-40\" ng-if=\"Premium.hasPremium && ! Premium.loading\"><p translate-cloak=\"\">{{ \"premium.hs_premium_text1\" | translate}}</p><p><span translate=\"premium.hs_premium_text2a\" translate-values=\"{\'name\': myUser.company.name }\"></span> <a href=\"https://d3cbxno87ymraz.cloudfront.net//premium/cepyme500_premium.pdf\" target=\"_blank\"><strong translate-cloak=\"\">{{\"premium.hs_premium_exclusive\" | translate}}</strong></a> <span translate=\"premium.hs_premium_text2b\"></span>.</p><p translate-cloak=\"\">{{ \"premium.hs_premium_text3\" | translate}}</p><p><span translate-cloak=\"\">{{ \"premium.hs_premium_text5\" | translate}}</span> <a href=\"https://d3cbxno87ymraz.cloudfront.net//premium/cepyme500_premium.pdf\" target=\"_blank\"><strong translate-cloak=\"\">{{\"premium.here\" | translate}}</strong></a>.</p><p class=\"mt-40\"><strong translate=\"premium.hs_premium_text5\" translate-values=\"{\'name\': myUser.company.name }\"></strong></p><p>Mikel Eguidazu<br>meguidazu@upthemedia.com<br><img alt=\"Imagen de Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 91 423 09 98 | 671 63 87 25</p><p translate-cloak=\"\">{{ \"premium.hs_premium_text7\" | translate}}</p></div></div></div><div class=\"ibox mt-40\"><div class=\"ibox-title\"><h3 class=\"text-success\" ng-if=\"! Premium.hasPremium\">{{\"premium.services_titleA\"| translate}}</h3><h3 class=\"text-success\" ng-if=\"Premium.hasPremium\" translate=\"premium.services_titleB\" translate-values=\"{\'name\': myUser.company.name}\"></h3></div><div class=\"ibox-content\"><h5 class=\"mt-5\">TRANSFORMACIÓN DIGITAL</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr ng-class=\"{\'hover\': Premium.hasPremium}\"><td>TEST DE DIGITALIZACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">80%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>DESARROLLO / ACTUALIZACIÓN PÁGINA WEB</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>DESARROLLO / PUBLICACIÓN APP</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>DESARROLLO / IMPLEMENTACIÓN E-COMMERCE</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>DESARROLLO DE SOLUCIONES TECNOLÓGICAS Y EXPERIENCIA DE USUARIO: IoT Y AI</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>CONSULTORÍA ESTRATÉGICA EN TRANSFORMACIÓN DIGITAL</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr></tbody></table></div><h5 class=\"mt-5\">MARKETING & COMUNICACIÓN</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr><td>SOCIAL MEDIA MARKETING</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>SEO</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>ESTRATEGIA PLAN DE COMUNICACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>CAMPAÑAS PAID SOCIAL & SEM</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>PLATAFORMA COMUNICACIÓN SOMOS360</td><td class=\"text-right\"><strong class=\"text-cepyme\">20%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>INBOUND & DIGITAL MARKETING: DESARROLLO ESTRATEGIAS DE CONTENIDO Y POSICIONAMIENTO ONLINE</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr></tbody></table></div><h5 class=\"mt-5\">INTERNACIONALIZACIÓN</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr><td>DIAGNÓSTICO BÁSICO Y AVANZADO INTERNACIONALIZACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>PLAN INTERNACIONALIZACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>PREVENCIÓN Y RESOLUCIÓN DE CONFLICTOS INTERNACIONALES</td><td class=\"text-right\"><strong class=\"text-cepyme\">20%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr></tbody></table></div><h5 class=\"mt-5\">I+D+i</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr><td>CONSULTORÍA I+D+I: DEDUCCIONES FISCALES</td><td class=\"text-right\"><strong class=\"text-cepyme\">10%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>CONSULTORÍA I+D+I: FINANCIACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">10%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr></tbody></table></div><h5 class=\"mt-5\">FORMACIÓN</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr><td>ALTERNATIVAS FINANCIACIÓN EMPRESARIAL</td><td class=\"text-right\"><strong class=\"text-cepyme\">20%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>PROGRAMAS DE FORMACIÓN Y TRANSFORMACIÓN CORPORATIVA:<br>NUEVAS TECNOLOGÍAS, METODOLOGÍAS DE INNOVACIÓN Y TRANSFORMACIÓN AGILE</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>PROGRAMA TREND LAB</td><td class=\"text-right\"><strong class=\"text-cepyme\">GRATIS</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>PROGRAMA FORMACIÓN DIRECTIVOS (EXECUTIVE EDUCATION)</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>APLICACIÓN PRÁCTICA DE LA LEY DE PROTECCIÓN DE DATOS (LOPD)</td><td class=\"text-right\"><strong class=\"text-cepyme\">13%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>PROGRAMA EJECUTIVO DATA PROTECTION OFFICER (DPO)</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>TARIFA PLANA CLASS</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr></tbody></table></div><h5 class=\"mt-5\">LEGAL</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr><td>PREVENCIÓN Y RESOLUCIÓN CONFLICTOS NACIONALES E INTERNACIONALES</td><td class=\"text-right\"><strong class=\"text-cepyme\">20%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>RECOBRO DE DEUDAS IMPAGADAS</td><td class=\"text-right\"><strong class=\"text-cepyme\">10%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>INTERPOSICIÓN MONITORIOS ONLINE</td><td class=\"text-right\"><strong class=\"text-cepyme\">10%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>COMPLYLAW PENAL</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>COMPLYLAW PRIVACIDAD</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr></tbody></table></div><h5 class=\"mt-5\">INNOVACIÓN</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr><td>CONSULTORÍA ESTRATÉGICA EN INNOVACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>OPEN INNOVATION: SCOUTING, TECNOLÓGICO Y RELACIÓN CON STARTUPS</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>REALIDAD AUMENTADA</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr></tbody></table></div><h5 class=\"mt-5\">INDUSTRIA 4.0</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr><td>DIGITAL ENTRERPRISE IT TEST</td><td class=\"text-right\"><strong class=\"text-cepyme\">GRATIS</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>DIGITAL ENTRERPRISE SCAN</td><td class=\"text-right\"><strong class=\"text-cepyme\">51%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>DIGITAL ENTRERPRISE SCOPE</td><td class=\"text-right\"><strong class=\"text-cepyme\">34%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>SIT PREACTOR AS STANDARD</td><td class=\"text-right\"><strong class=\"text-cepyme\">Hasta 51%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr></tbody></table></div><h5 class=\"mt-5\">IMAGEN CORPORATIVA</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr><td>MANUAL DE IDENTIDAD VISUAL</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>RENOVACIÓN LOGOTIPO</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>DESARROLLO MATERIAL CORPORATIVO</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>DESARROLLO MATERIAL COMERCIAL</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr><td>DOSSIER CORPORATIVO</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/logged/premium/premium_old.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\">Servicios PREMIUM para las empresas CEPYME500</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Premium.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><h5 class=\"mt-5\">TRANSFORMACIÓN DIGITAL</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr ng-class=\"{\'hover\': Premium.hasPremium}\"><td>TEST DE DIGITALIZACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">80%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen Test Digitales\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/test_digitalizacion.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://upthemedia.com\" target=\"_blank\"><img alt=\"Logo UPMEDIA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_upthemedia.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">80% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Precio final: 100€</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Te ayudamos a preparar tu empresa para el mundo digital</h4><div class=\"\"><p>En un entorno tan complejo y cambiante&nbsp;como el actual, no siempre es f&aacute;cil saber&nbsp;cu&aacute;l es la situaci&oacute;n real en la que se encuentra&nbsp;nuestra empresa o nuestra marca,&nbsp;cu&aacute;l es el diagn&oacute;stico y cu&aacute;l puede ser la&nbsp;forma de responder al desaf&iacute;o digital.</p><p>Con este test, obtendr&aacute; un diagn&oacute;stico preliminar de nivel del nivel de digitalizaci&oacute;n de su empresa, una comparaci&oacute;n con su industria y un informe con recomendaciones&nbsp;espec&iacute;ficas para impulsar su negocio.</p><p>No pierda la oportunidad de conocer las&nbsp;mejores pr&aacute;cticas en desarrollo digital y&nbsp;de obtener propuestas de utilidad para su sector econ&oacute;mico.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>DESARROLLO / ACTUALIZACIÓN PÁGINA WEB</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre desarrollo web\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/desarrollo_web.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://upthemedia.com\" target=\"_blank\"><img alt=\"Logo UPMEDIA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_upthemedia.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">50% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\">Descuento aplicable a presupuesto</div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Si no estás en Internet, no existes</h4><div class=\"\"><p>Somos expertos en el desarrollo y actualizaci&oacute;n&nbsp;de p&aacute;ginas web. No pierdas la oportunidad&nbsp;de disponer de una web profesional que ayude a hacer crecer tu negocio. Si buscas&nbsp;una plataforma online que transmita tus&nbsp;valores corporativos y te ayude a atraer clientes,&nbsp;conf&iacute;a en nuestros profesionales.</p><p>&bull; <strong>Proyecto llave en mano</strong>. Te llamamos o hacemos una videoconferencia,&nbsp;nos cuentas lo que necesitas y te&nbsp;despreocupas de todo lo dem&aacute;s.</p><p>&bull; <strong>Dise&ntilde;o y desarrollo web profesional</strong>.&nbsp;Con la garant&iacute;a y toda la experiencia de UpMedia.</p><p>&bull; <strong>Web optimizada para SEO</strong>. Cuidamos nuestro c&oacute;digo para que tu web se posicione en los buscadores.</p><p>&bull; <strong>Dise&ntilde;o 100% responsive</strong>. Para&nbsp;garantizar que tu web se ve&nbsp;correctamente en un ordenador, una&nbsp;tablet o un m&oacute;vil.</p><p>&bull; <strong>Un equipo de expertos siempre&nbsp;a tu disposici&oacute;n</strong>. Siempre podr&aacute;s comunicarte con tu asesor asignado para cualquier cambio, sugerencia,&nbsp;duda...</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>DESARROLLO / PUBLICACIÓN APP</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen desarrollo de APPs\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/desarrollo_app.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://upthemedia.com\" target=\"_blank\"><img alt=\"Logo UPMEDIA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_upthemedia.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">50% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\">Descuento aplicable a presupuesto</div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Tu empresa, productos y servicios, en la palma de la mano de tus clientes</h4><div class=\"\"><p>Somos pioneros en el desarrollo de apps&nbsp;para iOS y Android.</p><p>Trabajamos en el desarrollo de <strong>aplicaciones a medida para empresas</strong>, buscando la excelencia en la experiencia de usuario&nbsp;UX y el dise&ntilde;o UI, aplicando la innovaci&oacute;n&nbsp;a todas las aplicaciones m&oacute;viles que desarrollamos.</p><p>Te ofrecemos un producto final que cumpla&nbsp;con las necesidades y expectativas de&nbsp;tu negocio.</p><p>Dise&ntilde;o, creatividad, usabilidad, tecnolog&iacute;a,&nbsp;robustez, seguridad&hellip; son solo algunas&nbsp;de las caracter&iacute;sticas que nos definen,&nbsp;siendo la innovaci&oacute;n marca registrada del&nbsp;ADN UpMedia.</p><p><strong>Metodolog&iacute;a</strong>:<br>&bull; Conceptualizaci&oacute;n y an&aacute;lisis<br>&bull; Desarrollo de la estrategia<br>&bull; Dise&ntilde;o UX/UI (Experiencia de usuario e interfaz gr&aacute;fica)<br>&bull; Desarrollo del proyecto<br>&bull; Pruebas y grupos de control<br>&bull; Publicaci&oacute;n en los markets&nbsp;y lanzamiento<br>&bull; Monitorizaci&oacute;n<br>&bull; Asesoramiento y acciones&nbsp;de comunicaci&oacute;n y promoci&oacute;n</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>DESARROLLO / IMPLEMENTACIÓN E-COMMERCE</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen desarrollo de Ecommerce\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/desarrollo_ecommerce.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://upthemedia.com\" target=\"_blank\"><img alt=\"Logo UPMEDIA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_upthemedia.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">50% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\">Descuento aplicable a presupuesto</div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">El principal modelo de Negocio Digital</h4><div class=\"\"><p><strong>&iquest;Necesitas desarrollar un Ecommerce&nbsp;potente con una plataforma completa y&nbsp;funcional que te ofrezca una mayor personalizaci&oacute;n?</strong></p><p>&nbsp;Si has decidido dar el salto a Internet con tu propia tienda Online, o si ya lo hiciste pero ahora quieres mejorar&nbsp;lo que tienes, nosotros podemos ayudarte.</p><p>Desarrollo especializado de tiendas online&nbsp;PRESTASHOP B2C (Business to Consumer)&nbsp;o PRESTASHOP B2B (Business to Business)&nbsp;o proyectos 100% a medida.</p><p>Tambi&eacute;n nos encargamos de que tu equipo&nbsp;reciba la formaci&oacute;n necesaria para que se&aacute;is totalmente aut&oacute;nomos y capaces de&nbsp;gestionar vuestro comercio electr&oacute;nico sin&nbsp;dificultades.</p><p><strong>Metodolog&iacute;a:</strong></p><p>&bull; Comprensi&oacute;n del modelo de negocio&nbsp;del cliente</p><p>&bull; Necesidades de integraci&oacute;n a nivel negocio</p><p>&bull; Modelizaci&oacute;n del negocio en la capadigital</p><p>&bull; Relaci&oacute;n de funcionalidades clave</p><p>&bull; Elecci&oacute;n de la tecnolog&iacute;a de desarrollo</p><p>&bull; Desarrollo de arquitectura de informaci&oacute;n, prototipado y dise&ntilde;o de informaci&oacute;n</p><p>&bull; Visual design</p><p>&bull; Programaci&oacute;n e integraci&oacute;n con backoffice</p><p>&bull; Configuraci&oacute;n y lanzamiento en&nbsp;entorno de preproducci&oacute;n</p><p>&bull; Puesta en producci&oacute;n</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>DESARROLLO DE SOLUCIONES TECNOLÓGICAS Y EXPERIENCIA DE USUARIO: IoT Y AI</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen IOT/AI\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/experiencia_usuario_iot_ai.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://opinno.com/\" target=\"_blank\"><img alt=\"Logo Opinno\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_opinno.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">15% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>15% de descuento sobre las tarifas estándar de la compañía</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Opinno Solutions tiene una amplia experiencia en el desarrollo de soluciones tecnológicas para la industria en temas diversos temas, como IoT e IA.</h4><div class=\"\"><p><strong>Hemos agrupado nuestro portfolio&nbsp;seg&uacute;n las fases de un proyecto +&nbsp;consultor&iacute;a:</strong></p><p>&bull; <strong>Fase de investigaci&oacute;n:</strong>&nbsp;UX Research con usuarios Benchmark de soluciones</p><p>&bull; <strong>Fase de dise&ntilde;o y conceptualizaci&oacute;n:</strong>&nbsp;An&aacute;lisis t&eacute;cnico y dise&ntilde;o de arquitectura de software. Prototipado r&aacute;pido.&nbsp;Dise&ntilde;o UX/UI</p><p>&bull; <strong>Fase de desarrollo:</strong>&nbsp;Desarrollos a medida. Test de autodiagn&oacute;stico .Observatorio digital gamificado.&nbsp;IoT.&nbsp;IA</p><p>&bull; <strong>Testeo:</strong> Testeo de usabilidad.&nbsp;Testeo de calidad de c&oacute;digo.</p><p>&bull; <strong>Consultor&iacute;a:</strong>&nbsp;Auditor&iacute;a de c&oacute;digo.&nbsp;Transformaci&oacute;n DevOps.&nbsp;Transformaci&oacute;n digital</p><p class=\"font-size-sm\">Se ofrece la posibilidad de desarrollar un <strong>workshop de 3 horas sobre&nbsp; tendencias de innovaci&oacute;n, tecnol&oacute;gicas&nbsp;y oportunidades de negocio aplicadas al sector</strong> para el comit&eacute; de direcci&oacute;n de la empresa con un 85%&nbsp;de descuento sobre la tarifa est&aacute;ndar de la empresa (valoraci&oacute;n del workshop: 8.000 euros +&nbsp; IVA, precio CEYPME5000: 1.200 euros + IVA)</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>CONSULTORÍA ESTRATÉGICA EN TRANSFORMACIÓN DIGITAL</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen Transformacioón digital\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/consultoria_estrategica_transformacion_digital.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://opinno.com/\" target=\"_blank\"><img alt=\"Logo Opinno\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_opinno.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">15% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>15% de descuento sobre las tarifas estándar de la compañía</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Acompañamos a nuestros clientes en la definición estratégica y la consecución de objetivos, con resultados medibles.</h4><div class=\"\"><p><strong>Servicios de consultor&iacute;a estrat&eacute;gica&nbsp;y de negocio:</strong></p><p>&bull; Nuevos modelos de negocio</p><p>&bull; Modelo de innovaci&oacute;n de empresa</p><p>&bull; Dise&ntilde;o de nuevos productos y servicios</p><p>&bull; Implantaci&oacute;n de nuevas formas&nbsp;de trabajo (Design Thinking, Agile,&nbsp;SAFe)</p><p>&bull; Dise&ntilde;o de roadmap de innovaci&oacute;n y transformaci&oacute;n digital</p><p>&bull; Benchmark de &aacute;reas de oportunidad,&nbsp;retos estrat&eacute;gicos y competidores</p><p class=\"font-size-sm\">Se ofrece la posibilidad de desarrollar un <strong>workshop de 3 horas sobre&nbsp; tendencias de innovaci&oacute;n, tecnol&oacute;gicas&nbsp;y oportunidades de negocio aplicadas al sector</strong> para el comit&eacute; de direcci&oacute;n de la empresa con un 85%&nbsp;de descuento sobre la tarifa est&aacute;ndar de la empresa (valoraci&oacute;n del workshop: 8.000 euros +&nbsp; IVA, precio CEYPME5000: 1.200 euros + IVA)</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr></tbody></table></div><h5 class=\"mt-5\">MARKETING & COMUNICACIÓN</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr ng-class=\"{hover: Premium.hasPremium}\"><td>SOCIAL MEDIA MARKETING</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre social media\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/social_media_marketing.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"http://www.adesis.com/\" target=\"_blank\"><img alt=\"Logo Adesis\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_adesis.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">25% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>900€/mes (descuento aplicado)</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Los consumidores y su forma de buscar servicios está cambiando</h4><div class=\"\"><p>&bull; Dise&ntilde;o y puesta en marcha de su&nbsp;Plan estrat&eacute;gico de posicionamiento&nbsp;en redes sociales (Facebook, Twitter,<br>Instagram, Linkedin, Youtube) acorde a&nbsp;objetivos de negocio.</p><p>&bull; Generaci&oacute;n de comunidad incluyendo&nbsp;prescriptores de valor, realmente&nbsp;interesados en la actividad del&nbsp;negocio.</p><p>&bull; Difusi&oacute;n y creaci&oacute;n de contenido de&nbsp;valor orientado a crear engagement y&nbsp;establecer contacto usuarios-empresa. Marketing de influencers.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>SEO</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre SEO\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/seo.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"http://www.adesis.com/\" target=\"_blank\"><img alt=\"Logo Adesis\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_adesis.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">25% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>700€/mes</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Es hora de optimizar tus contenidos.</h4><div class=\"\"><p>&bull; Generaci&oacute;n y ejecuci&oacute;n de estrategias de mejora del posicionamiento en buscadores, en base al comportamiento de los usuarios y tendencias en los principales buscadores.</p><p>&bull; Creaci&oacute;n y optimizaci&oacute;n de contenidos orientados a la generaci&oacute;n de tr&aacute;fico cualificado que responda a los objetivos de negocio.</p><p>&bull; Revisi&oacute;n t&eacute;cnica de las webs de cara a mejorar la experiencia de usuario y la visibilidad en Internet, detecci&oacute;n de errores en el desarrollo de los portales y optimizaci&oacute;n de velocidad de carga.</p><p>&bull; Monitorizaci&oacute;n y an&aacute;lisis de los datos de tr&aacute;fico web y rankings en motores de b&uacute;squeda.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>ESTRATEGIA PLAN DE COMUNICACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre estrategias de comunicación\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/estrategia_plan_comunicacion.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"http://www.adesis.com/\" target=\"_blank\"><img alt=\"Logo Adesis\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_adesis.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">25% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>600€/mes</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">La necesidad de marcar una estrategia a seguir</h4><div class=\"\"><p>&bull; Nos involucramos con su compa&ntilde;&iacute;a en la definici&oacute;n de su Estrategia y Plan de Comunicaci&oacute;n, con todas sus acciones.</p><p>&bull; Dise&ntilde;amos y ponemos en marcha la mejor estrategia para la visibilidad en medios de su empresa: relaciones con los periodistas, comunicados, presentaciones, gesti&oacute;n de contenidos de en los medios generalistas o sectoriales.</p><p>&bull; Gestionamos de forma integral su presencia en ferias, eventos corporativos e institucionales. Incorporamos elementos tecnol&oacute;gicos de impacto: realidad virtual, realidad aumentada, advergaming, proyecciones 3D. Hacemos que su acto sea &uacute;nico y especial.</p><p>&bull; Somos creativos, expertos en dise&ntilde;o y producciones audiovisuales de gran impacto: v&iacute;deos cortos, infogr&aacute;ficos, emotivos. Y somos storytellers: trabajamos en content marketing, generando contenidos de valor a&ntilde;adido que transmiten su mensaje, con objetivo de tr&aacute;fico web o de imagen de marca.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>CAMPAÑAS PAID SOCIAL & SEM</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre SEM\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/campana_paid_social_sem.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"http://www.adesis.com/\" target=\"_blank\"><img alt=\"Logo Adesis\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_adesis.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">25% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>3.000€/campaña<br>(25% de descuento sobre la gestión)</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Amplia tus comunicaciones más allá de tus posibilidades orgánicas</h4><div class=\"\"><p>Puesta en marcha de campa&ntilde;as Paid Social (publicidad en plataformas&nbsp;sociales) y SEM (publicidad en motores<br>de b&uacute;squeda y redes display) para&nbsp;aumentar la visibilidad de una p&aacute;gina&nbsp;web y convertir el tr&aacute;fico cualificado<br>en posibles clientes.</p><p>&bull; Creaci&oacute;n de campa&ntilde;as h&iacute;persegmentadas&nbsp;por geolocalizaci&oacute;n,&nbsp;gustos, afinidades e intereses&nbsp;concretos, as&iacute; como con CRM,&nbsp;cruzando la base de clientes de&nbsp;tu empresa con las plataformas&nbsp;socialespara crear anuncios&nbsp;personalizados, enfocados a los&nbsp;intereses reales y concretos de tu&nbsp;audiencia.</p><p>&bull; Dise&ntilde;o, planificaci&oacute;n y gesti&oacute;n&nbsp;de campa&ntilde;as en medios offline&nbsp;(radio, exterior) y online (display,&nbsp;program&aacute;tica, email marketing,&nbsp;contenidos patrocinados&hellip;)</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>PLATAFORMA COMUNICACIÓN SOMOS360</td><td class=\"text-right\"><strong class=\"text-cepyme\">20%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre comunicación 360\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/plataforma_comunicacion_360.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.somos360.com/\" target=\"_blank\"><img alt=\"Logo SOMOS360\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_somos360.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">20% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Servicios desde 9,60€/mes</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Una extensión de la empresa hacia los trabajadores y clientes</h4><div class=\"\"><p>Somos 360 es una plataforma de comunicaci&oacute;n&nbsp;que engloba tanto gesti&oacute;n de archivos,&nbsp;chat, mensajer&iacute;a, agenda y notas&nbsp;para el trabajo diario tanto de trabajadores&nbsp;como clientes de una empresa.</p><p>El concepto es <strong>que todas las comunicaciones&nbsp;est&eacute;n bajo una plataforma &uacute;nica&nbsp;que da visibilidad y aumenta la productividad</strong>.En todo momento tanto la documentaci&oacute;n&nbsp;de cada usuario como sus&nbsp;chat, mensajes y calendarios est&aacute;n a su disposici&oacute;n 24h al tratarse de una herramienta&nbsp;cloud con disponibilidad total v&iacute;a&nbsp;web, aplicaci&oacute;n de escritorio y app tanto&nbsp;Android como Apple.</p><p>La plataforma proporciona una completa&nbsp;visi&oacute;n de las comunicaciones y tanto con&nbsp;empleados de la empresa como con los&nbsp;clientes, pudiendo controlar y darle trazabilidad&nbsp;a toda la operativa ya sea de archivos,&nbsp;chat, mensajes etc.<br>Una herramienta que permite mejorar, organizar&nbsp;y dinamizar todos los contactos e interacciones&nbsp;entre los usuarios.</p><p>Desde Somos 360 proporcionamos cuatro&nbsp;servicios. Para ver m&aacute;s detalles y precios,&nbsp;pinche en el link:</p><p>&bull; Servicio de plataforma de comunicaci&oacute;n&nbsp;o red privada empresarial.</p><p>&bull; Servicio de automatizaci&oacute;n de&nbsp;documentos y servicio de modulos a&nbsp;medida</p><p>&bull; Servicio personalizaci&oacute;n de aplicaci&oacute;n&nbsp;m&oacute;vil y pc, a las imagen corporativa del&nbsp;cliente. Exclusivo para <strong>CEPYME500</strong></p><p>&bull; M&oacute;dulo FTP / SFTP</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>INBOUND & DIGITAL MARKETING: DESARROLLO ESTRATEGIAS DE CONTENIDO Y POSICIONAMIENTO ONLINE</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre marketing digital\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/inbound_digital_marketing.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://opinno.com/\" target=\"_blank\"><img alt=\"Logo Opinno\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_opinno.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">15% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>15% de descuento sobre las tarifas estándar de la compañía</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">El contenido es el rey</h4><div class=\"\"><p>&bull; Organizaci&oacute;n y gesti&oacute;n de eventos</p><p>&bull; Estrategia de comunicaci&oacute;n (RRSS,&nbsp;blog, Inbound marketing&hellip;)</p><p>&bull; Marketing digital (SEO, SEM, Inbound&nbsp;marketing, performance, retargeting,&nbsp;display...)</p><p>&bull; Plan de contenidos</p><p>&bull; Branding</p><p>&bull; Contenidos: programas de&nbsp;posicionamiento a trav&eacute;s de&nbsp;contenidos digitales</p><p class=\"font-size-sm\">Se ofrece la posibilidad de desarrollar un <strong>workshop de 3 horas sobre&nbsp; tendencias de innovaci&oacute;n, tecnol&oacute;gicas&nbsp;y oportunidades de negocio aplicadas al sector</strong> para el comit&eacute; de direcci&oacute;n de la empresa con un 85%&nbsp;de descuento sobre la tarifa est&aacute;ndar de la empresa (valoraci&oacute;n del workshop: 8.000 euros +&nbsp; IVA, precio CEYPME5000: 1.200 euros + IVA)</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr></tbody></table></div><h5 class=\"mt-5\">INTERNACIONALIZACIÓN</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr ng-class=\"{hover: Premium.hasPremium}\"><td>DIAGNÓSTICO BÁSICO Y AVANZADO INTERNACIONALIZACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre internacionalización\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/diagnostico_basico_avanzado_internacionalizacion.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.oftex.es/\" target=\"_blank\"><img alt=\"Logo OFTEX\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_oftex.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">50% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Precio con descuento 15€ (más iva)</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Evaluamos tu potencial exportador</h4><div class=\"\"><p>Realizamos un examen sobre la empresa&nbsp;o el proyecto para saber si cumple con los&nbsp;requisitos m&iacute;nimos para internacionalizarse,&nbsp;as&iacute; como si superar&aacute; los obst&aacute;culos de&nbsp;comercio exterior con los que se encontrar&aacute;&nbsp;en los pr&oacute;ximos 3 a&ntilde;os. La herramienta&nbsp;ofrece una puntuaci&oacute;n sobre cada &aacute;rea&nbsp;relevante as&iacute; como un informe con consejos<br>valiosos, basado en la experiencia con&nbsp;2.000 pymes espa&ntilde;olas.</p><p>&bull; El <strong>Diagn&oacute;stico b&aacute;sico</strong> eval&uacute;a si est&aacute;s preparado para internacionalizarte y si cumples con los requisitos m&iacute;nimos,<br>obteniendo una puntuaci&oacute;n. Conforme&nbsp;vayas superando los requisitos podr&aacute;s&nbsp;actualizar el diagn&oacute;stico y mejorar tu<br>nota. Adem&aacute;s se facilita un informe con&nbsp;los resultados y con consejos pr&aacute;cticos.</p><p>&bull; Con el <strong>Diagn&oacute;stico Avanzado</strong> sabr&aacute;s&nbsp;si est&aacute;s preparado para afrontar los obst&aacute;culos con los que te encontrar&aacute;s<br>en los pr&oacute;ximos 3 a&ntilde;os. La aplicaci&oacute;n&nbsp;incluye consejos pr&aacute;cticos y formaci&oacute;n&nbsp;espec&iacute;fica. Esto te permitir&aacute; conocer<br>de forma anticipada estas barreras&nbsp;y prepararte. Se facilita un informe&nbsp;con consejos &uacute;tiles e informaci&oacute;n&nbsp;sobre medios de cobro, contrataci&oacute;n&nbsp;internacional, c&oacute;mo construir una&nbsp;tarifa export, c&oacute;mo calcular el pago de&nbsp;impuestos de importaci&oacute;n y una gu&iacute;a&nbsp;sobre el uso de Incoterms 2010.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>PLAN INTERNACIONALIZACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre internacionalización\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/plan_internacionalizacion.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.oftex.es/\" target=\"_blank\"><img alt=\"Logo OFTEX\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_oftex.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">50% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Precio con descuento 35€ (más iva)</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Te ayudamos a elaborar tu plan de internacionalización personalizado</h4><div class=\"\"><p><strong>La aplicaci&oacute;n te ayudar&aacute; a identificar&nbsp;tus fortalezas, debilidades, amenazas y&nbsp;oportunidades as&iacute; como a realizar una&nbsp;</strong><strong>selecci&oacute;n de mercados para 14 sectores&nbsp;industriales identificando los pa&iacute;ses &oacute;ptimos&nbsp;a los que empezar a dirigirte. La&nbsp;</strong><strong>herramienta ofrece un informe con consejos&nbsp;valiosos, basado en la experiencia&nbsp;con 2.000 pymes espa&ntilde;olas</strong>.</p><p>La aplicaci&oacute;n te ayudar&aacute; a redactar un Plan&nbsp;de Internacionalizaci&oacute;n que te servir&aacute; de&nbsp;gu&iacute;a o faro. Exportest te ayudar&aacute; a identificar tus fortalezas,&nbsp;debilidades, amenazas y oportunidades&nbsp;as&iacute; como a realizar una selecci&oacute;n&nbsp;de mercados para 14 sectores industriales,&nbsp;analizando un algoritmo de 29 variables&nbsp;objetivas para elegir los pa&iacute;ses &oacute;ptimos&nbsp;por los que empezar a dirigirte. El plan se&nbsp;personaliza teniendo en cuenta tu sector,&nbsp;si tu producto es innovador, si ya has exportado&nbsp;previamente, tus expectativas de ventas, tus competidores nacionales e&nbsp; internacionales,&nbsp;tus canales de distribuci&oacute;n,&nbsp;etc&hellip;</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>PREVENCIÓN Y RESOLUCIÓN DE CONFLICTOS INTERNACIONALES</td><td class=\"text-right\"><strong class=\"text-cepyme\">20%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre abogados y derecho\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/prevencion.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.rocajunyent.com/\" target=\"_blank\"><img alt=\"Logo Roca y Yunyet\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_rocayunyet.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">20% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>1 hora de asesoramiento gratuita y un descuento del 20% sobre nuestros ratios</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">La mejor solución. Integración y neutralidad</h4><div class=\"\"><p><strong>ROCA JUNYENT</strong> cuenta con un equipo&nbsp;de profesionales expertos en litigaci&oacute;n y&nbsp;en los distintos sistemas alternativos de&nbsp;resoluci&oacute;n de conflictos, tales como <strong>arbitraje&nbsp;</strong>o <strong>mediaci&oacute;n</strong>, capaz de prestar un&nbsp;asesoramiento integral, completo y eficaz,&nbsp;orientado a entender las preocupaciones y a satisfacer las necesidades del cliente.</p><p><strong>Tenemos experiencia en la defensa e interposici&oacute;n&nbsp;del siguiente tipo de acciones</strong>:&nbsp;responsabilidad contractual y extracontractual,&nbsp;contratos de obra y derecho&nbsp;de la construcci&oacute;n, conflictos societarios,&nbsp;acciones de competencia desleal y publicidad,&nbsp;contratos de agencia, distribuci&oacute;n,&nbsp;concesi&oacute;n y franquicia, seguros, arrendamientos&nbsp;urbanos y r&uacute;sticos, propiedad&nbsp;horizontal, procedimientos sobre validez,&nbsp;ejecuci&oacute;n e interpretaci&oacute;n de contratos,&nbsp;procedimientos sobre resoluci&oacute;n y rescisi&oacute;n&nbsp;de contratos, conflictos en materia&nbsp;financiera, derecho del Consumo, garant&iacute;as&nbsp;reales y personales, ejecuciones provisionales&nbsp;y definitivas de resoluciones&nbsp;judiciales, responsabilidad por producto,&nbsp;responsabilidad profesional, responsabilidad&nbsp;patrimonial.&nbsp;Y todo ello lo podemos hacer tanto a nivel&nbsp; nacional como internacional ya que pertenecemos a <strong>TERRALEX</strong>, una red internacional&nbsp;de firmas de abogados integrada por&nbsp;m&aacute;s de <strong>150 bufetes de abogados independientes&nbsp;de los cinco continentes</strong>.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr></tbody></table></div><h5 class=\"mt-5\">I+D+i</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr ng-class=\"{hover: Premium.hasPremium}\"><td>CONSULTORÍA I+D+I: DEDUCCIONES FISCALES</td><td class=\"text-right\"><strong class=\"text-cepyme\">10%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre consultoría de I+D+I\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/consultoria_idi.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"http://www.avsconsulting.es/\" target=\"_blank\"><img alt=\"Logo AVS\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_avs.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">10% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Trabajamos 100% a éxito, en función de las ayudas conseguidas para la empresa</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Servicio integral y personalizado</h4><div class=\"\"><p>Entre las herramientas de las que disponen&nbsp;las empresas para impulsar la innovaci&oacute;n,&nbsp;se encuentra la deducci&oacute;n por proyectos&nbsp;de Investigaci&oacute;n y Desarrollo e Innovaci&oacute;n&nbsp;Tecnol&oacute;gica a trav&eacute;s del Impuesto de&nbsp;Sociedades. El sistema espa&ntilde;ol permite&nbsp;obtener hasta un 42% de deducci&oacute;n&nbsp;sobre los gastos directos a trav&eacute;s de&nbsp;este instrumento, y puede aplicarse&nbsp;sobre cualquier tipolog&iacute;a de empresa, independientemente de su tama&ntilde;o o CNAE.</p><p>Son, por tanto, ayudas no sujetas a los&nbsp;presupuestos p&uacute;blicos e independientes&nbsp;del ciclo econ&oacute;mico, de la cuenta de&nbsp;resultados actual de la empresa (pues se&nbsp;dispone de 18 a&ntilde;os para su aplicaci&oacute;n) y&nbsp;puede transformase en cash de forma&nbsp;inmediata. AVS cuenta con convenios de aplicaci&oacute;n inmediata con las principales&nbsp;entidades financieras con instrumentos de&nbsp;Monetizaci&oacute;n Bancaria.</p><p>Desde AVS Consulting ofrecemos un&nbsp;servicio integral y personalizado a medida&nbsp;de nuestros clientes. Identificamos y&nbsp;potenciamos sus proyectos innovadores y aportamos una soluci&oacute;n global, estando&nbsp;presentes en todo el proceso, desde el&nbsp;reconocimiento de la oportunidad hasta la declaraci&oacute;n del incentivo. El resultado es una mejora visible en la cuenta de&nbsp;resultados gracias a las deducciones fiscales de las que la empresa puede&nbsp;beneficiarse.</p><p>Adem&aacute;s, el modelo de gesti&oacute;n de AVS&nbsp;Consulting permite acotar totalmente&nbsp;los riesgos, documentando t&eacute;cnica y econ&oacute;micamente las actividades de I+D+i&nbsp;de acuerdo a la normativa, tanto en el&nbsp;&aacute;mbito nacional como internacional.</p><p>Asimismo, trabajamos con las m&aacute;s&nbsp;destacadas entidades acreditadas por&nbsp;ENAC (Entidad Nacional de Acreditaci&oacute;n) para la certificaci&oacute;n de I+D+i (proyectos,&nbsp;personal y sistemas).</p><p><strong>EL M&Eacute;TODO AVS</strong></p><p>&bull; Identificamos los proyectos y&nbsp;actividades de I+D+i</p><p>&bull; Valoramos y cuantificamos los&nbsp;proyectos</p><p>&bull; Llevamos a cabo la justificaci&oacute;n&nbsp;t&eacute;cnico-econ&oacute;mica de los proyectos</p><p>&bull; Obtenemos la certificaci&oacute;n de los&nbsp;proyectos seg&uacute;n su tipolog&iacute;a</p><p>&bull; Gestionamos el Informe Motivado&nbsp;Vinculante</p><p>&bull; Acompa&ntilde;amos a nuestros clientes en caso de inspecci&oacute;n</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>CONSULTORÍA I+D+I: FINANCIACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">10%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre financiación de I+D+I\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/new/idi_financiacion.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"http://www.avsconsulting.es/\" target=\"_blank\"><img alt=\"Logo AVS\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_avs.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">10% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Trabajamos 100% a éxito, en función de las ayudas conseguidas para la empresa</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Servicio integral y personalizado</h4><div class=\"\"><p>Ofrecemos un servicio integral que va&nbsp;desde la identificaci&oacute;n de oportunidades,&nbsp;pasando por la elaboraci&oacute;n de los expedientes&nbsp;t&eacute;cnicos hasta su presentaci&oacute;n y&nbsp;justificaci&oacute;n. Adem&aacute;s, nuestra labor de&nbsp;vigilancia es global, buscando financiaciones&nbsp;e incentivos regionales, nacionales y&nbsp;europeos.</p><p>El resultado es una estrategia personalizada&nbsp;con una atenci&oacute;n y asesoramiento a&nbsp;medida, proporcionados por nuestro multidisciplinar&nbsp;equipo que cuenta con amplia&nbsp;experiencia en la preparaci&oacute;n y ejecuci&oacute;n&nbsp;de este tipo de proyectos.</p><p><strong>AYUDAS NACIONALES, REGIONALES Y&nbsp;AUTON&Oacute;MICAS</strong></p><p>AVS cuenta con una amplia experiencia en&nbsp;la presentaci&oacute;n de expedientes a los distintos&nbsp;organismos p&uacute;blicos nacionales y&nbsp;regionales (CDTI, Ministerios, IVACE, IDAE,&nbsp;ICEX, etc.)</p><p>Trabajamos a diario para identificar nuevas&nbsp;oportunidades de financiaci&oacute;n por actividades&nbsp;de I+D+i, as&iacute; como para proyectos&nbsp;de inversi&oacute;n; y mantenemos una activa&nbsp;vigilancia para estar al d&iacute;a de las &uacute;ltimas&nbsp;convocatorias.</p><p><strong>AYUDAS EUROPEAS</strong><br>AVS Europe es nuestra empresa para la&nbsp;Gesti&oacute;n de Proyectos Europeos. Cuenta con personal especializado, formado en&nbsp;Bruselas, con amplia experiencia en los&nbsp;diferentes programas de canalizaci&oacute;n de&nbsp;fondos europeos:</p><p>Horizonte 2020 es la herramienta de la&nbsp;Uni&oacute;n Europea que persigue alcanzar el&nbsp;liderazgo industrial en Europa y reforzar la&nbsp;excelencia de su base cient&iacute;fica en el a&ntilde;o&nbsp;2020. La Comisi&oacute;n Europea busca lograr&nbsp;este objetivo a trav&eacute;s de ayudas a la investigaci&oacute;n&nbsp;e innovaci&oacute;n basadas en tres&nbsp;pilares:</p><p>&bull; Ciencia excelente, para hacer&nbsp;m&aacute;s competitivo el sistema de&nbsp;investigaci&oacute;n europeo a escala global.</p><p>&bull; Liderazgo industrial, para mejorar la&nbsp;competitividad de las empresas a nivel&nbsp;mundial.</p><p>&bull; Retos sociales, para afrontar los problemas que m&aacute;s preocupan y afectan a los ciudadanos.</p><p>En AVS Consulting acompa&ntilde;amos a las&nbsp;empresas a lo largo de todo el proceso&nbsp;para facilitar su participaci&oacute;n en estas iniciativas europeas en las que est&aacute;n cobrando&nbsp;especial protagonismo las PYMES,&nbsp;con partidas espec&iacute;ficas del presupuesto&nbsp;reservadas para ellas.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr></tbody></table></div><h5 class=\"mt-5\">FORMACIÓN</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr ng-class=\"{hover: Premium.hasPremium}\"><td>ALTERNATIVAS FINANCIACIÓN EMPRESARIAL</td><td class=\"text-right\"><strong class=\"text-cepyme\">20%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre la bolsa de mercados\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/alternativas.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.bolsasymercados.es/esp/Home\" target=\"_blank\"><img alt=\"Logo BME\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_bme.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">20% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Precio 900€<br>El descuento se aplicará sobre este precio</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Solvencia - Imparcialidad - Transparencia - Innovación - Vanguardia - Protección</h4><div class=\"\"><p>En los &uacute;ltimos a&ntilde;os se han impulsado diferentes&nbsp;iniciativas para revertir esta situaci&oacute;n&nbsp;como son el Mercado Alternativo&nbsp;Burs&aacute;til (Mab) o el Mercado Alternativo de&nbsp;Renta Fija (Marf). Sin embargo todav&iacute;a siguen&nbsp;siendo desconocidas para muchos&nbsp;de los profesionales del mundo financiero.</p><p>Por ello, Instituto BME ha dise&ntilde;ado este&nbsp;curso con la finalidad de dar a conocer las&nbsp;diferentes alternativas de financiaci&oacute;n que&nbsp;ofrecen los mercados de capitales, qu&eacute;&nbsp;papel desempe&ntilde;an y c&oacute;mo introducirse en&nbsp;el manejo de estas fuentes de financiaci&oacute;n&nbsp;no bancarias.</p><p><strong>OBJETIVO</strong></p><p>Analizar diferentes alternativas de financiaci&oacute;n&nbsp;empresarial no bancaria mediante&nbsp;la emisi&oacute;n de instrumentos negociados&nbsp;en mercados de valores familiarizando al&nbsp;alumno con las diferentes opciones para&nbsp;construir un modelo de financiaci&oacute;n menos&nbsp;vulnerable en un contexto de contracci&oacute;n&nbsp;del cr&eacute;dito.</p><p><strong>PROGRAMA</strong><br>&bull; Presentaci&oacute;n, antecedentes y&nbsp;situaci&oacute;n actual</p><p>&bull; Mercado de Renta Variable: Bolsa&nbsp;y MAB</p><p>&bull; Mercado de Renta Fija: MARF</p><p>&bull; Relaciones con inversores</p><p>&bull; Taller 1: MAB. La empresa,&nbsp;el mercado y los inversores.</p><p>&bull; Taller 2: MARF. La emisi&oacute;n,&nbsp;el mercado y los inversores.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>PROGRAMAS DE FORMACIÓN Y TRANSFORMACIÓN CORPORATIVA:<br>NUEVAS TECNOLOGÍAS, METODOLOGÍAS DE INNOVACIÓN Y TRANSFORMACIÓN AGILE</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre formación\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/formacion.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://opinno.com/\" target=\"_blank\"><img alt=\"Logo Opinno\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_opinno.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">15% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>15% de descuento sobre las tarifas estándar de la compañía</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Opinno tiene una amplia experiencia en la implementación de grandes programas de transformación corporativa para la implementación de nuevas formas de trabajo</h4><div class=\"\"><p>Programas de transformaci&oacute;n digital&nbsp;y cultural en empresas:</p><p>&bull; Programas de formaci&oacute;n en&nbsp;metodolog&iacute;as de innovaci&oacute;n (Design&nbsp;Thinking, Lean Startup)</p><p>&bull; Programas de transformaci&oacute;n agile</p><p>&bull; Programas de intra-emprendimiento</p><p>&bull; Programas de formaci&oacute;n en&nbsp;tecnolog&iacute;as emergentes (IoT,&nbsp;Blockchain)&nbsp;</p><p>&bull; Programas de re-skilling y up-skilling&nbsp;en nuevas tecnolog&iacute;as para el&nbsp;negocio, marketing digital, hard skills tecnol&oacute;gicos (JIRA, Confluence)&nbsp;</p><p class=\"font-size-sm\">Se ofrece la posibilidad de desarrollar un <strong>workshop de 3 horas sobre&nbsp; tendencias de innovaci&oacute;n, tecnol&oacute;gicas&nbsp;y oportunidades de negocio aplicadas al sector</strong> para el comit&eacute; de direcci&oacute;n de la empresa con un 85%&nbsp;de descuento sobre la tarifa est&aacute;ndar de la empresa (valoraci&oacute;n del workshop: 8.000 euros +&nbsp; IVA, precio CEYPME5000: 1.200 euros + IVA)</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>PROGRAMA TREND LAB</td><td class=\"text-right\"><strong class=\"text-cepyme\">GRATIS</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre TrendLab\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/trend-lab.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.eada.edu/es\" target=\"_blank\"><img alt=\"Logo EADA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_eada.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">GRATIS</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>2 invitaciones por empresa</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Impulsa el desarrollo profesional y el aprendizaje continuo</h4><div class=\"\"><p>Programas de corto formato que ofrecen&nbsp;una constante actualizaci&oacute;n en competencias,&nbsp;habilidades y conocimientos necesarios&nbsp;para afrontar los retos de negocio que&nbsp;presentan los actuales escenarios. Hoy&nbsp;m&aacute;s que nunca, los equipos de direcci&oacute;n&nbsp;y responsables de &aacute;reas de negocio y sus&nbsp;colaboradores necesitan conocer las nuevas&nbsp;maneras de hacer y responder a las&nbsp;necesidades actuales y futuras del mercado. Una forma de seguir impulsando&nbsp;el desarrollo profesional y el aprendizaje&nbsp;continuo.</p><p><strong>Programas disponibles:</strong></p><p>&bull; Crisis reputacional en canales&nbsp;tradicionales y digitales</p><p>&bull; Liderazgo estrat&eacute;gico</p><p>&bull; Project leadership experience&nbsp;simulation</p><p>&bull; Gesti&oacute;n de conflictos en las&nbsp;organizaciones</p><p>&bull; Cryptocurrencies</p><p>&bull; Crear equipos de alto rendimiento</p><p>&bull; Fast prototyping for business</p><p>&bull; Toma de decisiones inteligentes:&nbsp;data in - decisions out</p><p>&bull; Boosting your potential and leadership skills</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>PROGRAMA FORMACIÓN DIRECTIVOS (EXECUTIVE EDUCATION)</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre formación para directivos\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/formacion-directivos.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.eada.edu/es\" target=\"_blank\"><img alt=\"Logo EADA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_eada.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">25% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Descuento aplicable al precio de los diferentes programas</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Impulsa el desarrollo profesional y el aprendizaje continuo</h4><div class=\"\"><p><strong>MASTERS EJECUTIVOS&nbsp;PRESENCIALES</strong></p><p>Programas dirigidos a desarrollar y adquirir&nbsp;las competencias clave que permitan al&nbsp;participante consolidar su posici&oacute;n de Liderazgo&nbsp;en la Direcci&oacute;n de un &aacute;rea funcional.&nbsp;Adem&aacute;s de la especializaci&oacute;n, contempla&nbsp;un programa de Desarrollo Directivo y&nbsp;un conocimiento del Negocio que habilita para la toma de decisiones estrat&eacute;gicas.</p><p>&bull; Master en direcci&oacute;n de marketing&nbsp;y comercial</p><p>&bull; Master en direcci&oacute;n de recursos&nbsp;humanos</p><p>&bull; Master en direcci&oacute;n financiera</p><p>&bull; Master en direcci&oacute;n de operaciones&nbsp;y supply chain management</p><p>&bull; Master en marketing farmac&eacute;utico</p><p>&bull; Master en liderazgo de alto&nbsp;rendimiento</p><p>&bull; Master en gesti&oacute;n de la industria farmac&eacute;utica y afines</p><p><strong>PREMIUM FORMACI&Oacute;N&nbsp;MASTERS EJECUTIVOS&nbsp;SEMIPRESENCIALES</strong></p><p>Fruto de una alianza con la UOC, se trata&nbsp;de programas en formato blended que&nbsp;permiten desarrollar las competencias&nbsp;propias para la Direcci&oacute;n de &aacute;rea funcional&nbsp;en un entorno multicultural diverso. Las&nbsp;dos semanas presenciales en el Campus&nbsp;EADACollbat&oacute; favorecen el networking y&nbsp;el intercambio de experiencias entre participantes de diferentes disciplinas.</p><p>&bull; Master en direcci&oacute;n de log&iacute;stica,&nbsp;operaciones y scm online</p><p>&bull; Master en direcci&oacute;n de recursos&nbsp;humanos online</p><p><strong>PROGRAMAS DE DIRECCI&Oacute;N GENERAL&nbsp;Y LIDERAZGO</strong></p><p>Gracias a su enfoque hol&iacute;stico e integral,&nbsp;se trata de programas que permiten desarrollar&nbsp;las competencias de Management&nbsp;y/o de Liderazgo necesarias para posicionarse&nbsp;con &eacute;xito en la Direcci&oacute;n General&nbsp;o en la Direcci&oacute;n y/o Responsabilidad de&nbsp;&aacute;rea funcional o negocio. Potencian la visi&oacute;n&nbsp;global y estrat&eacute;gica de la empresa as&iacute;&nbsp;como el autoconocimiento para un adecuado&nbsp;Liderazgo de equipos y organizaciones.</p><p>&bull; Direcci&oacute;n general - PDG</p><p>&bull; Programa de desarrollo&nbsp;del liderazgo - PDL</p><p>&bull; Automobile retail innovation&nbsp;programme</p><p>&bull; Posgrado en transformaci&oacute;n digital</p><p><strong>PROGRAMAS DE DIRECCI&Oacute;N&nbsp;FUNCIONAL Y GESTI&Oacute;N</strong></p><p>El participante adquiere las principales herramientas&nbsp;de gesti&oacute;n que le habilitan para&nbsp;tomar decisiones y desarrollar proyectos&nbsp;en sus &aacute;reas de especializaci&oacute;n. Desarrolla&nbsp;tambi&eacute;n las principales habilidades&nbsp;para consolidar su rol y mejorar su posicionamiento&nbsp;en la organizaci&oacute;n.</p><p><strong>MARKETING Y VENTAS</strong></p><p>&bull; Direcci&oacute;n comercial y de ventas</p><p>&bull; Postgrado en marketing - product manager</p><p>&bull; Marketing b2b</p><p>&bull; Marketing digital y ecommerce</p><p>&bull; Key account management</p><p>&bull; Retail leadership programme</p><p>&bull; Market access</p><p>&bull; Direcci&oacute;n consumer healthcare</p><p><strong>RECURSOS HUMANOS</strong></p><p>&bull; Gesti&oacute;n de recursos humanos</p><p>&bull; Hr business partner</p><p>&bull; Relaciones laborales estrat&eacute;gicas</p><p>&bull; Compensaci&oacute;n integral</p><p><strong>FINANZAS Y FISCALIDAD</strong></p><p>&bull; Control de gesti&oacute;n y reporting</p><p>&bull; Finanzas para directivos no financieros</p><p>&bull; Certificado de asesor financiero</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>APLICACIÓN PRÁCTICA DE LA LEY DE PROTECCIÓN DE DATOS (LOPD)</td><td class=\"text-right\"><strong class=\"text-cepyme\">13%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.randstad.es/empresas\" target=\"_blank\"><img alt=\"Logo RANDSTAD\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_randstad.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">13% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>225€ precio por alumno/licencia<br>(260€ precio catálogo Randstad)</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">35 horas de e-learning para conocer más sobre la LOPD</h4><div class=\"\"><p>Alta de los participantes en la plataforma,&nbsp;impartici&oacute;n, tutorizaci&oacute;n, dinamizaci&oacute;n,&nbsp;contacto con los participantes, y tracking&nbsp;para el seguimiento de la acci&oacute;n formativa. Acceso a la plataforma on line por tiempo&nbsp;limitado. Cada curso tendr&aacute; una fecha de&nbsp;finalizaci&oacute;n que se indicar&aacute; en el momento&nbsp;de entrega de contrase&ntilde;as a los participantes.Siempre que el cliente haya seleccionado&nbsp;esta opci&oacute;n en &ldquo;Opci&oacute;n para&nbsp;la Gesti&oacute;n&rdquo;, el presupuesto incluir&aacute; el encargo a Randstad de actuar como Usuario&nbsp;Externo del CLIENTE en la aplicaci&oacute;n de la Fundaci&oacute;n Estatal para la Formaci&oacute;n en el&nbsp;Empleo (FEFE) para realizar las funciones de gesti&oacute;n administrativas del cr&eacute;dito de formaci&oacute;n de 2018, en relaci&oacute;n con la presente&nbsp;acci&oacute;n formativa, en caso de tener&nbsp;derecho y cumplir los requerimientos y condiciones legales</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>PROGRAMA EJECUTIVO DATA PROTECTION OFFICER (DPO)</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.wolterskluwer.es/\" target=\"_blank\"><img alt=\"Logo WOLTERS KLUWER\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_wolters-kluwer.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">15% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Descuento especial</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Protege los datos de tu organización</h4><div class=\"\"><p>Una formaci&oacute;n global e integral para implementar&nbsp;y desempe&ntilde;ar la figura del Data&nbsp;Protection Officer. Programa Ejecutivo y&nbsp;Actualizaci&oacute;n hasta la entrada en vigor de la ley. Programa Formativo dado de alta en el Registro Oficial de Programas Formativos&nbsp;reconocidos seg&uacute;n el esquema AEPDDPD&nbsp;que permitir&aacute; presentarse al examen&nbsp;de cualquier entidad certificadora debidamente&nbsp;acreditada por la Agencia Espa&ntilde;ola&nbsp;de Protecci&oacute;n de Datos.</p><p>&bull; Con el contenido por <strong>Dominios</strong>&nbsp;recomendados por la AEPD.</p><p>&bull;<u>+ Tras la finalizaci&oacute;n del curso</u>tendr&aacute;s&nbsp;acceso a materiales actualizados y&nbsp;Encuentros Digitales peri&oacute;dicos sobre el avance de la reforma de la Ley&nbsp;Org&aacute;nica de Protecci&oacute;n de Datos, mantente al d&iacute;a de las novedades&nbsp;hasta su entrada en vigor.&nbsp;</p><p>&bull; Con el apoyo docente de <strong>expertos de&nbsp;reconocido prestigio</strong> en la materia y&nbsp;experiencia docente.</p><p>&bull; Con acceso durante el programa a&nbsp;<strong>Laleydigital360</strong>.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>TARIFA PLANA CLASS</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre evento de formación\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/plana-class.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.wolterskluwer.es/\" target=\"_blank\"><img alt=\"Logo Wolters Kluwer\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_wolters-kluwer.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">25% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Precio especial de 99€<br>(a aplicar descuento especial del 25%)</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Elige | Aprende | Aplica. La formación que construyes según tus necesidades.</h4><div class=\"\"><p><strong>Tarifa Plana Class es una soluci&oacute;n formativa&nbsp;que te permite acceder a trav&eacute;s de&nbsp;un campus virtual de una manera sencilla&nbsp;y flexible a m&aacute;s de 100 cursos audiovisuales&nbsp;online impartidos por especialistas&nbsp;en cada materia.</strong></p><p>Son cursos dirigidos a dar respuesta inmediata&nbsp;a tus necesidades profesionales concretas&nbsp;en una amplia variedad de tem&aacute;ticas,&nbsp;para que siempre puedas escoger el&nbsp;curso que necesitas en ese momento.</p><p>Y al ser cursos online audiovisuales, &iexcl;Estudia&nbsp;donde y cuando quieras! Con total&nbsp;flexibilidad.</p><p>Estrategia empresarial | Habilidades | Marketing&nbsp;| Idiomas | Transformaci&oacute;n digital |&nbsp;Ofim&aacute;tica | Legal-Fiscal | Herramientas 2.0&nbsp;| Finanzas | Redes sociales&nbsp;</p><p><strong>Empleabilidad 360&ordm;</strong></p><p>Una experiencia multimedia que incluye&nbsp;todo lo necesario para tu formaci&oacute;n y la de&nbsp;tus trabajadores.</p><p>&bull; Con Tarifa Plana CLASS tendr&aacute;s&nbsp;acceso ilimitado a m&aacute;s de 100 CLASS, organizadas en las &aacute;reas tem&aacute;ticas esenciales para un profesional.</p><p>&bull; Planifica tu formaci&oacute;n, elige las CLASS&nbsp;que m&aacute;s te interesen y puedan&nbsp;enriquecer tu desarrollo profesional.&nbsp;En el momento que t&uacute; quieras.</p><p>&bull; Practica, aprende y descubre c&oacute;mo la&nbsp;formaci&oacute;n continua puede aumentar tu&nbsp;empleabilidad.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr></tbody></table></div><h5 class=\"mt-5\">LEGAL</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr ng-class=\"{hover: Premium.hasPremium}\"><td>PREVENCIÓN Y RESOLUCIÓN CONFLICTOS NACIONALES E INTERNACIONALES</td><td class=\"text-right\"><strong class=\"text-cepyme\">20%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre derecho\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/conflictos.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.rocajunyent.com/\" target=\"_blank\"><img alt=\"Logo Roca y Yunyet\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_rocayunyet.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">20% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>1 hora de asesoramiento gratuita y un descuento del 20% sobre nuestros ratios</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Nuestra virtud está en la labor que desarrollamos de concienciación y asesoramiento preventivo.</h4><div class=\"\"><p><strong>ROCA JUNYENT</strong> cuenta con un equipo&nbsp;de profesionales expertos en litigaci&oacute;n y&nbsp;en los distintos sistemas alternativos de&nbsp;resoluci&oacute;n de conflictos, tales como <strong>arbitraje&nbsp;</strong> o <strong>mediaci&oacute;n</strong>, capaz de prestar un&nbsp;asesoramiento integral, completo y eficaz,&nbsp;orientado a entender las preocupaciones&nbsp;y a satisfacer las necesidades del cliente.</p><p><strong>Tenemos experiencia en la defensa e interposici&oacute;n&nbsp;del siguiente tipo de acciones:</strong>&nbsp;responsabilidad contractual y extracontractual,&nbsp;contratos de obra y derecho&nbsp;de la construcci&oacute;n, conflictos societarios,&nbsp;acciones de competencia desleal y publicidad,&nbsp;contratos de agencia, distribuci&oacute;n,&nbsp;concesi&oacute;n y franquicia, seguros, arrendamientos urbanos y r&uacute;sticos, propiedad&nbsp;horizontal, procedimientos sobre validez,&nbsp;ejecuci&oacute;n e interpretaci&oacute;n de contratos, procedimientos sobre resoluci&oacute;n y rescisi&oacute;n&nbsp;de contratos, conflictos en materia&nbsp;financiera, derecho del Consumo, garant&iacute;as&nbsp;reales y personales, ejecuciones provisionales y definitivas de resoluciones&nbsp;judiciales, responsabilidad por producto,&nbsp;responsabilidad profesional, responsabilidad&nbsp;patrimonial.</p><p>Y todo ello lo podemos hacer tanto a nivel&nbsp;nacional como internacional ya que pertenecemos&nbsp;a <strong>TERRALEX</strong>, una red internacional&nbsp;de firmas de abogados integrada por m&aacute;s de <strong>150 bufetes de abogados independientes&nbsp;de los cinco continentes</strong>.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>RECOBRO DE DEUDAS IMPAGADAS</td><td class=\"text-right\"><strong class=\"text-cepyme\">10%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.mapfre.es/seguros/empresas/\" target=\"_blank\"><img alt=\"Logo MAPFRE\" src=\"https://d3cbxno87ymraz.cloudfront.net/premium/mapfre_2026.png\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">10% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Tarifa basada en el éxito del recobro</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">SOLUNION, red experta de agentes y abogados</h4><div class=\"\"><p>Mediante un contrato sin coste inicial ni&nbsp;gastos de mantenimiento, <strong>SOLUNION</strong> se&nbsp;hace cargo de la reclamaci&oacute;n de deuda impagada&nbsp;de empresas, tanto en v&iacute;a amistosa,&nbsp;como judicial o concursal. Tambi&eacute;n deuda&nbsp;de empresas espa&ntilde;olas o en el extranjero.&nbsp;</p><p>Se pone a disposici&oacute;n del cliente una <strong>red&nbsp;experta de agentes y abogados especializados&nbsp;en reclamaci&oacute;n de deuda</strong> que dan&nbsp;cobertura a todos los pa&iacute;ses.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>INTERPOSICIÓN MONITORIOS ONLINE</td><td class=\"text-right\"><strong class=\"text-cepyme\">10%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"http://recuperadeudas.com/\" target=\"_blank\"><img alt=\"Logo Recuperadeudas\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_recuperadeudas.png\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">10% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Precio 99 euros<br>El descuento se aplicará sobre este precio</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">¿No te pagan? Con RD® te pagarán lo que te deben</h4><div class=\"\"><p>El monitorio es un procedimiento judicial que se caracteriza por ser una v&iacute;a r&aacute;pida y &aacute;gil para la reclamaci&oacute;n de deudas de car&aacute;cter&nbsp;dinerario de cualquier importe, en la que &uacute;nicamente ser&aacute; necesaria la celebraci&oacute;n&nbsp;de una vista o comparecencia ante el&nbsp;Juez si el deudor se opone a la reclamaci&oacute;n presentada.</p><p><strong>C&oacute;mo trabajamos</strong></p><p><strong>Sencillez</strong>. Comienza ya a judicializar tus&nbsp;deudas sin visitas ni reuniones &iexcl;Con un&nbsp;solo CLICK! Desde tu ordenador o tu smartphone,&nbsp;as&iacute; de sencillo&hellip;</p><p><strong>Ahorro</strong>. Con RD&reg; tienes a tu alcance el mejor&nbsp;servicio de Recuperaci&oacute;n de Impagados al precio m&aacute;s competitivo del mercado.&nbsp;</p><p><strong>Comunicaci&oacute;n</strong>. RD&reg; se ocupar&aacute; de los tr&aacute;mites&nbsp;judiciales y de mantenerte informado&nbsp;sobre la marcha de tus reclamaciones&nbsp;en todo momento.</p><p><strong>Tecnolog&iacute;a</strong>. RD&reg; es #LawTech. Un sistema&nbsp;de Recuperaci&oacute;n de Facturas Impagadas 100% automatizado dirigido por expertos.&nbsp;</p><p><strong>Qu&eacute; incluye el servicio</strong>:</p><p>&bull; Abogado y procurador</p><p>&bull; Demanda 100% online</p><p>&bull; Tu monitorio interpuesto en 48 horas</p><p>&bull; En cualquier punto de Espa&ntilde;a</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>COMPLYLAW PENAL</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre pacto\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/penal.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.wolterskluwer.es/\" target=\"_blank\"><img alt=\"Logo Wolters Kluwer\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_wolters-kluwer.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">25% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Pro (31,26€/mes) | Advanced (52,03€/mes)</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Identifica y gestiona los riesgos penales de tu organización</h4><div class=\"\"><p><strong>Complylaw Penal</strong> es la herramienta definitiva&nbsp;para identificar y gestionar los riesgos&nbsp;penales de una organizaci&oacute;n. Minimiza el&nbsp;impacto de los riesgos penales derivados del incumplimiento ante inspecciones o&nbsp;denuncias, sirviendo como prueba atenuante&nbsp;o, incluso, eximente. &iexcl;Adaptada a&nbsp;la norma UNE 19601!</p><p>Es un completo sistema de gesti&oacute;n de&nbsp;cumplimiento y evaluaci&oacute;n del riesgo legal&nbsp;penal, asegurando un nivel de cumplimiento&nbsp;constante en el tiempo.</p><p>&bull; Permite elaborar f&aacute;cilmente el <strong>mapa&nbsp;de riesgos penales</strong> de tu empresa.</p><p>&bull; Dispone de un sistema de evidencias&nbsp;en las fases de <strong>identificaci&oacute;n y&nbsp;gesti&oacute;n de riesgos</strong>, para que quede&nbsp;constancia de las acciones realizadas.</p><p>&bull; Utiliza una metodolog&iacute;a uniforme y&nbsp;contrastada con est&aacute;ndares y criterios homog&eacute;neos de cumplimiento.</p><p>&bull; Gestiona de <strong>forma continua los&nbsp;riesgos</strong> en funci&oacute;n de acciones realizadas derivadas de la aplicaci&oacute;n&nbsp;de controles y medidas.</p><p>&bull; Completo <strong>sistema de reporting</strong> con&nbsp;un cuadro de mando con indicadores sencillos.</p><p>&bull; Genera de forma autom&aacute;tica un&nbsp;<strong>informe completo</strong> con el mapa de&nbsp;riesgos y el estado de situaci&oacute;n.</p><p>&bull; <strong>Acceso a los textos legales</strong>, casos&nbsp;pr&aacute;cticos y otros contenidos de&nbsp;inter&eacute;s.</p><p>Herramienta desarrollada en colaboraci&oacute;n&nbsp;con ECIX que cuenta con profesionales&nbsp;especialistas en materia de Compliance,&nbsp;Derecho IT y seguridad de la informaci&oacute;n.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>COMPLYLAW PRIVACIDAD</td><td class=\"text-right\"><strong class=\"text-cepyme\">25%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre Privacidad\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/privacidad.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://www.wolterskluwer.es/\" target=\"_blank\"><img alt=\"Imagen sobre Wolters Kluwer\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_wolters-kluwer.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">25% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Pro (629,20€) | Advanced (847,00€)</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Cumple con las obligaciones sobre protección de datos</h4><div class=\"\"><p><strong>Adaptada al nuevo Reglamento Europeo&nbsp;de Protecci&oacute;n de Datos, Complylaw Privacidad&nbsp;es la herramienta definitiva para&nbsp;cumplir con las obligaciones sobre protecci&oacute;n&nbsp;de datos</strong>.</p><p>Permite analizar el grado de nivel de riesgo&nbsp;de los diferentes tratamientos de los datos personales, automatiza la generaci&oacute;n&nbsp;del informe PIA (Evaluaci&oacute;n de impacto en la protecci&oacute;n de datos personales),&nbsp;gestiona los resultados del informe PIA, incorporando&nbsp;controles y tareas para mitigar los riesgos y controlar la evoluci&oacute;n de los&nbsp;riesgos detectados. Es una herramienta&nbsp;que permite cumplir con las obligaciones&nbsp;derivadas del GDPR, de las directrices de la AEPD y de las autoridades europeas en&nbsp;esta materia (GT29) y de la ISO/29134 para&nbsp;las evaluaciones de impacto.</p><p>&bull; Permite realizar f&aacute;cilmente la&nbsp;valoraci&oacute;n de los diferentes tratamientos de protecci&oacute;n de datos personales.</p><p>&bull; Genera autom&aacute;ticamente los&nbsp;informes PIAS y todos los elementos relacionados con el mismo.</p><p>&bull; Utiliza una metodolog&iacute;a uniforme&nbsp;y contrastada con est&aacute;ndares y criterios homog&eacute;neos de cumplimiento&nbsp;(PDCA).</p><p>&bull; Gestiona de forma continua los riesgos&nbsp;identificados en el informe mediante controles y tareas.</p><p>&bull; Completo sistema de reporting con&nbsp;un cuadro de mando con indicadores sencillos.</p><p>&bull; Almacena de forma segura y siempre&nbsp;disponible toda la documentaci&oacute;n.</p><p>&bull; Acceso a los textos legales, casos&nbsp;pr&aacute;cticos y otros contenidos de inter&eacute;s.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr></tbody></table></div><h5 class=\"mt-5\">INNOVACIÓN</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr ng-class=\"{hover: Premium.hasPremium}\"><td>CONSULTORÍA ESTRATÉGICA EN INNOVACIÓN</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre innovación\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/innovacion.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://opinno.com/\" target=\"_blank\"><img alt=\"Logo Opinno\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_opinno.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">15% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Descuento sobre las tarifas estándar de la compañía</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Acompañamos a nuestros clientes en la definición estratégica y la consecución de objetivos, con resultados medibles.</h4><div class=\"\"><p><strong>Servicios de consultor&iacute;a estrat&eacute;gica&nbsp;y de negocio:</strong></p><p>&bull; Nuevos modelos de negocio</p><p>&bull; Modelo de innovaci&oacute;n de empresa</p><p>&bull; Dise&ntilde;o de nuevos productos&nbsp;y servicios</p><p>&bull; Implantaci&oacute;n de nuevas formas&nbsp;de trabajo (Design Thinking, Agile, SAFe)</p><p>&bull; Dise&ntilde;o de roadmap de innovaci&oacute;n&nbsp;y transformaci&oacute;n digital</p><p>&bull; Benchmark de &aacute;reas de oportunidad,&nbsp;retos estrat&eacute;gicos y competidores</p><p class=\"font-size-sm\">Se ofrece la posibilidad de desarrollar un <strong>workshop de 3 horas sobre&nbsp; tendencias de innovaci&oacute;n, tecnol&oacute;gicas&nbsp;y oportunidades de negocio aplicadas al sector</strong> para el comit&eacute; de direcci&oacute;n de la empresa con un 85%&nbsp;de descuento sobre la tarifa est&aacute;ndar de la empresa (valoraci&oacute;n del workshop: 8.000 euros +&nbsp; IVA, precio CEYPME5000: 1.200 euros + IVA)</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>OPEN INNOVATION: SCOUTING, TECNOLÓGICO Y RELACIÓN CON STARTUPS</td><td class=\"text-right\"><strong class=\"text-cepyme\">15%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre Open Innovation\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/open-innovation.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://opinno.com/\" target=\"_blank\"><img alt=\"Logo Opinno\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_opinno.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">15% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Descuento sobre las tarifas estándar de la compañía</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Opinno es experto en el desarrollo de servicios de Open Innovation y scouting tecnológicos.</h4><div class=\"\"><p><strong>Open Innovation &amp; Scouting tecnol&oacute;gico:</strong></p><p>&bull; Desarrollo de plataformas de&nbsp;innovaci&oacute;n abierta</p><p>&bull; Implementaci&oacute;n de programas&nbsp;Open Innovation (concursos, hubs, lanzaderas, hackatones, &hellip;)</p><p>&bull; Scouting tecnol&oacute;gico con el apoyo&nbsp;de MIT tech review en espa&ntilde;ol</p><p>&bull; Implementaci&oacute;n de programas&nbsp;de corporate venture building (Aceleradoras e incubadoras&nbsp;corporativas)</p><p>&bull; Programas de integraci&oacute;n de startups&nbsp;en el modelo de negocio de las&nbsp;empresas</p><p class=\"font-size-sm\">Se ofrece la posibilidad de desarrollar un <strong>workshop de 3 horas sobre&nbsp; tendencias de innovaci&oacute;n, tecnol&oacute;gicas&nbsp;y oportunidades de negocio aplicadas al sector</strong> para el comit&eacute; de direcci&oacute;n de la empresa con un 85%&nbsp;de descuento sobre la tarifa est&aacute;ndar de la empresa (valoraci&oacute;n del workshop: 8.000 euros +&nbsp; IVA, precio CEYPME5000: 1.200 euros + IVA)</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>REALIDAD AUMENTADA</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre Realidad Aumentada\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/realidad-aumentada.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://upthemedia.com\" target=\"_blank\"><img alt=\"Logo UPMEDIA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_upthemedia.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">50% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\">Descuento aplicable a presupuesto</div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Experiencia de cliente más allá de la realidad</h4><div class=\"\"><p>El entorno que nos rodea ofrece una gran&nbsp;cantidad de informaci&oacute;n que es dif&iacute;cil de&nbsp;reproducir en un smartphone.<br>Un sistema de realidad aumentada genera&nbsp;una vista compuesta, una combinaci&oacute;n de&nbsp;la escena real vista por el usuario y una escena&nbsp;virtual generada por el equipo que aumenta&nbsp;la escena con informaci&oacute;n adicional.</p><p>En todas las aplicaciones de la realidad&nbsp;aumentada se presenta al usuario una mejora de la percepci&oacute;n del entorno donde&nbsp;se encuentra.</p><p>Trabajamos con Wikitude, l&iacute;der mundial&nbsp;en tecnolog&iacute;a AR, en dispositivos iPhone&nbsp;y Android, y nos basamos en la tecnolog&iacute;a&nbsp;marker-less para mezclar el mundo real y&nbsp;virtual a trav&eacute;s de la c&aacute;mara de fotos de&nbsp;los dispositivos.</p><p>Con la Realidad Aumentada ofrecemos un&nbsp;amplio abanico de nuevas aplicaciones&nbsp;en dispositivos m&oacute;viles smartphone, tanto&nbsp;para ios (iphone, ipad) como para android,&nbsp;en las que su cliente puede interactuar&nbsp;con la aplicaci&oacute;n y analizar el producto&nbsp;o el proyecto de forma m&aacute;s real.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr></tbody></table></div><h5 class=\"mt-5\">INDUSTRIA 4.0</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr ng-class=\"{hover: Premium.hasPremium}\"><td>DIGITAL ENTRERPRISE IT TEST</td><td class=\"text-right\"><strong class=\"text-cepyme\">GRATIS</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen de ingenieros\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/enterprise.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"http://digitalenterprise.es/\" target=\"_blank\"><img alt=\"Logo Denterprise\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_denterprise.png\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">GRATIS</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Servicios sin coste<br>(Valor de mercado de 1.000€)</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Analiza tu estructura empresarial y procesos para comenzar la digitalización</h4><div class=\"\"><p><strong>Ayudamos a los clientes industriales a&nbsp;mejorar su competitividad a trav&eacute;s de la&nbsp;transformaci&oacute;n digital, analizando sus&nbsp;necesidades reales y su nivel de madurez, y con ello definir e implantar un plan&nbsp;de digitalizaci&oacute;n ajustado a la realidad de&nbsp;cada empresa para conseguir sus objetivos de negocio.</strong></p><p>Esta metodolog&iacute;a permite responder a los&nbsp;interrogantes sobre los costes asociados a digitalizar la f&aacute;brica, sobre la preparaci&oacute;n&nbsp;del equipo de personas y sobre si la empresa posee toda la infraestructura tecnol&oacute;gica&nbsp;e informaci&oacute;n necesaria.</p><p><strong>IT Test</strong></p><p>Servicio que le ayudar&aacute; a conocer el actual grado de digitalizaci&oacute;n o de los sistemas&nbsp;de informaci&oacute;n de su empresa, y lo m&aacute;s&nbsp;importante, este test le ayuda a identificar las &aacute;reas o departamentos con mas potencial&nbsp;de mejora en los sistemas de informaci&oacute;n&nbsp;o mejora de su nivel de digitalizaci&oacute;n. El test se realiza con una metodolog&iacute;a&nbsp;propia,&nbsp; desarrollada por Digital Enterprise, que requiere muy poco tiempo por parte de la empresa interesada y le supone adem&aacute;s&nbsp;un bajo coste.</p><p>A trav&eacute;s de ella, la persona asignada por&nbsp;la organizaci&oacute;n rellena un cuestionario y posteriormente mantiene una entrevista&nbsp;telef&oacute;nica con un consultor experto de Digital Enterprise; con el resultado, se presenta&nbsp;en resultado del Test y las conclusiones&nbsp;en una reuni&oacute;n a trav&eacute;s de Internet.</p><p>De esta forma su empresa conocer&aacute; el nivel&nbsp;de cada &aacute;rea y las &aacute;reas en donde se&nbsp;pueden conseguir una mejorar de productividad&nbsp;con su digitalizaci&oacute;n.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>DIGITAL ENTRERPRISE SCAN</td><td class=\"text-right\"><strong class=\"text-cepyme\">51%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"http://digitalenterprise.es/\" target=\"_blank\"><img alt=\"Logo Denterprise\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_denterprise.png\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">51% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Precio especial de 1.900€<br>(Valor de mercado de 3.900€)</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">¿Quieres saber cómo de digitalizado está tu negocio?</h4><div class=\"\"><p><strong>Antes de iniciar un proyecto de digitalizaci&oacute;n,&nbsp;resulta fundamental conocer si&nbsp;la empresa est&aacute; preparada para llevarlo a cabo</strong>.</p><p>Digital Enterprise aplica su metodolog&iacute;a,&nbsp;<strong>Digital Enterprise Scan</strong>, para analizar la estructura empresarial y los procesos en&nbsp;f&aacute;brica, y as&iacute; identifica tanto las &aacute;reas que es m&aacute;s urgente digitalizar como aqu&eacute;llas&nbsp;que est&aacute;n m&aacute;s preparadas para ello.&nbsp;</p><p>Esta metodolog&iacute;a permite responder a los&nbsp;interrogantes sobre los costes asociados&nbsp;a digitalizar la f&aacute;brica, as&iacute; como los beneficios&nbsp;esperados, el ROI (retorno de la inversi&oacute;n) y el PAYBACK (Tiempo en el que se&nbsp;retorna la inversi&oacute;n) sobre la preparaci&oacute;n&nbsp;del equipo de personas y sobre si la empresa posee toda la infraestructura tecnol&oacute;gica&nbsp;e informaci&oacute;n necesaria.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>DIGITAL ENTRERPRISE SCOPE</td><td class=\"text-right\"><strong class=\"text-cepyme\">34%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"http://digitalenterprise.es/\" target=\"_blank\"><img alt=\"Logo Denterprise\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_denterprise.png\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">34% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Precio especial de 3.900€<br>(Valor de mercado de 5.900€)</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">¿Quieres saber cuáles son los costes de digitalización de tu empresa?</h4><div class=\"\"><p>Informe de requerimientos para la implantaci&oacute;n&nbsp;de una nueva tecnolog&iacute;a digital en&nbsp;una &aacute;rea concreta, se realiza con la metodolog&iacute;a&nbsp;Digital Enterprise Scope, adem&aacute;s incluye un plan de implantaci&oacute;n de la tecnolog&iacute;a, la estimaci&oacute;n de los costes, los&nbsp;beneficios, del ROI y el Payback.</p><p>Este informe se pude realizar para tener&nbsp;los requerimientos que ha de cumplir la&nbsp;tecnolog&iacute;a para su caso, plan de implantaci&oacute;n&nbsp;y ROI, para tecnolog&iacute;as que se apliques a &aacute;reas como por ejemplo:</p><p>&bull; Planificaci&oacute;n de la cadena de&nbsp;suministro: Planificaci&oacute;n demanda, producci&oacute;n y aprovisionamientos.</p><p>&bull; Gesti&oacute;n de Operaciones: Producci&oacute;n,&nbsp;Mantenimiento y calidad.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>SIT PREACTOR AS STANDARD</td><td class=\"text-right\"><strong class=\"text-cepyme\">Hasta 51%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen Verificación de procesos\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/sit-preactor.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"http://planningmanufacturing.com/\" target=\"_blank\"><img alt=\"Logo Planing\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_planing.png\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">Hasta 51% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Precios desde 1.900€</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Aprovecha los beneficios de la Revolución Industrial / Industry 4.0</h4><div class=\"\"><p><strong>Hemos detectado que el &aacute;rea que menos&nbsp;digitalizada est&aacute; en las empresas es la&nbsp;planificaci&oacute;n de la cadena de suministros,&nbsp;en concreto la planificaci&oacute;n y programaci&oacute;n de la producci&oacute;n y los aprovisionamientos</strong>.</p><p>Por ello queremos ofrecer a los miembros&nbsp;de <strong>CEPYME500</strong> unos servicios excluivos para mejorar su competitividad con la digitalizaci&oacute;n&nbsp;de la planificaci&oacute;n de la Supply Chain.</p><p>Los beneficios de implantar un sistema de&nbsp;Planificaci&oacute;n son entre otros:</p><p>&bull; Dar plazo de entrega m&aacute;s competitivo.</p><p>&bull; Cumplir plazos y costes estimados.</p><p>&bull; Optimizar aprovisionamientos y stocks</p><p>&bull; Optimizar carga de trabajo del&nbsp;personal propio y subcontratado.</p><p>&bull; Reaccionar mejor ante imprevistos&nbsp;productivos o proveedores.</p><p>&bull; Saber en todo momento si vamos en&nbsp;plazo y coste.&nbsp;</p><p><strong>Ventajas para miembros CEPYME500</strong></p><p>&bull; <strong>Informe necesidades Planning&nbsp;para CEPYME 500</strong>. Valor de mercado&nbsp;de 3.900&euro;, al que se realizar&aacute; un descuento de 2.000&euro;.</p><p>&bull; <strong>Plan de implantaci&oacute;n Planning y su ROI&nbsp;para CEPYME 500</strong>. Valor de mercado&nbsp;de 5.900 &euro;, al que se realizar&aacute; un&nbsp;descuento de 2.000&euro;.&nbsp;</p><p>&bull; <strong>Sistema de Planning para CEPYME 500</strong>.&nbsp;Valor de mercado de 5.900 &euro;, al que se&nbsp;realizar&aacute; un descuento de 1.248&euro;.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr></tbody></table></div><h5 class=\"mt-5\">IMAGEN CORPORATIVA</h5><div class=\"table-responsive\"><table class=\"table table-hover\"><tbody><tr ng-class=\"{hover: Premium.hasPremium}\"><td>MANUAL DE IDENTIDAD VISUAL</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen sobre imagen corporativa\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/identidad.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://upthemedia.com\" target=\"_blank\"><img alt=\"Logo UPMEDIA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_upthemedia.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">50% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Precio 2.900€<br>Se le aplicará el 50% de descuento</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Expresa tu diferencial gráficamente</h4><div class=\"\"><p>Hoy en d&iacute;a contar con un manual de identidad&nbsp;corporativa, es una prioridad. Gracias&nbsp;a ello lograremos que los clientes se sientan&nbsp;identificados con nosotros. Adem&aacute;s identificar&aacute;n y utilizar&aacute;n nuestra marca, tal&nbsp;y como nosotros queremos, y en cualquier&nbsp;tipo de soporte (online y offline). Esto nos&nbsp;aportar&aacute; grandes beneficios y ahorro de&nbsp;tiempo.</p><p>El mercado actualmente es tan competitivo,&nbsp;que debemos buscar nuestra marca&nbsp;y peculiaridades para diferenciarnos de la&nbsp;competencia. As&iacute; captaremos la atenci&oacute;n del usuario. Tener un buen branding y un Manual de Identidad visual corporativa, es&nbsp;esencial para que todos los engranajes encajen y se pongan en funcionamiento.</p><p>La IVC viene definida por una serie de elementos&nbsp;clave, que determinan la percepci&oacute;n de nuestros usuarios, sobre nuestra&nbsp;marca, productos y/o servicios:</p><p>&bull; Creaci&oacute;n de logotipo/marca,&nbsp;tipograf&iacute;as, gama crom&aacute;tica, usos,&nbsp;ret&iacute;culas,...</p><p>&bull; Aplicaciones de papeler&iacute;a: Papel de&nbsp;carta, Tarjetas, Carpeta, Block de notas, Sobres, Libreta,...</p><p>&bull; Otras aplicaciones: RollUp, Taza,&nbsp;Bol&iacute;grafo, Camiseta, memoria USB,&nbsp;tarjeta identificaci&oacute;n + Lanyard,&nbsp;Agenda,...</p><p>&bull; Aplicaciones online: Logos y&nbsp;Cabeceras para RRSS, banners,... Se trata de reflejar la filosof&iacute;a y los valores como marca. Con lo que lograremos un&nbsp;posicionamiento estrat&eacute;gico en nuestro&nbsp;mercado.</p><p class=\"font-size-xs\">En el Manual de identidad visual, se describir&aacute;n los usos y aplicaciones de cada uno de los materiales dise&ntilde;ados. Se entregar&aacute;n todas las piezas en PDF y formato editable/vectorial (.indd .eps, .ai,...) para su posterior&nbsp;uso, modificaciones y env&iacute;o a imprenta. Y si necesitas servicio de imprenta, tambi&eacute;n podemos ayudarte.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>RENOVACIÓN LOGOTIPO</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://upthemedia.com\" target=\"_blank\"><img alt=\"Logo UPMEDIA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_upthemedia.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">50% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\"><strong>Precio 2.900€<br>Se le aplicará el 50% de descuento</strong></div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Modernizar sin perder la esencia</h4><div class=\"\"><p>Echas un vistazo a tu alrededor y ves que&nbsp;todo se moderniza. No quieres ser menos&nbsp;que el resto, pero&hellip;</p><p>No te atreves a dar el paso y perder tu&nbsp;se&ntilde;a de identidad. Ese logotipo que lleva tanto tiempo contigo, y le tienes tanto&nbsp;aprecio y respeto.</p><p>Para Upmedia, innovar una identidad, es&nbsp;restaurar conservando la esencia y la diferenciaci&oacute;n&nbsp;de tu empresa. Resaltando mucho&nbsp;m&aacute;s, esos valores y ese sentimiento de pertenencia, que le has querido aportar&nbsp;a tu negocio desde sus inicios.&nbsp;</p><p>La Renovaci&oacute;n incluye las mismas piezas&nbsp;que el manual de identidad Visual</p><p class=\"font-size-xs\">En el Manual de identidad visual, se describir&aacute;n los usos y aplicaciones de cada uno de los materiales dise&ntilde;ados. Se entregar&aacute;n todas las piezas en PDF y formato editable/vectorial (.indd .eps, .ai,...) para su posterior&nbsp;uso, modificaciones y env&iacute;o a imprenta. Y si necesitas servicio de imprenta, tambi&eacute;n podemos ayudarte.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>DESARROLLO MATERIAL CORPORATIVO</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://upthemedia.com\" target=\"_blank\"><img alt=\"Logo UPMEDIA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_upthemedia.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">50% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\">Descuento aplicable a presupuesto</div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Sincronía en cada uno de los elementos gráficos de tu empresa</h4><div class=\"\"><p>Una identidad corporativa bien reflejada,&nbsp;es sin&oacute;nimo de elegancia, planificaci&oacute;n y&nbsp;buen hacer.</p><p>Cuidar las piezas corporativas de tu empresa&nbsp;har&aacute; que los usuarios, identifiquen&nbsp;tu marca con m&aacute;s facilidad.Enriquecemos tu identidad, dise&ntilde;ando y&nbsp;fortaleciendo los valores de marca.</p><p>Aplicaciones online y offline a concretar&nbsp;con el cliente (carpetas, blocks, papel de carta, tarjetas, parque m&oacute;vil, r&oacute;tulos, cabeceras&nbsp;para RRSS,...)</p><p class=\"font-size-xs\">Todas las piezas dise&ntilde;adas se entregar&aacute;n formato en PDF y formato editable/vectorial (.indd .eps, .ai,...) para su posterior uso, modificaciones y env&iacute;o a imprenta. Adem&aacute;s, si necesitas servicio de imprenta, tambi&eacute;n podemos ayudarte</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>DESARROLLO MATERIAL COMERCIAL</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://upthemedia.com\" target=\"_blank\"><img alt=\"Logo UPMEDIA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_upthemedia.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">50% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\">Descuento aplicable a presupuesto</div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">El mejor apoyo para las ventas. Resalta lo importante.</h4><div class=\"\"><p>Una presentaci&oacute;n de tus productos/servicios&nbsp;simplificada y esquem&aacute;tica, ser&aacute;&nbsp;el mejor canal de venta para llegar a tus&nbsp;usuarios.</p><p>La claridad en la descripciones, la disposici&oacute;n&nbsp;de los elementos, las im&aacute;genes que&nbsp;reflejan fielmente los servicios/productos&nbsp;de tu empresa y un lenguaje adaptado a cada tipo de usuario.</p><p>Seleccionamos y dise&ntilde;amos el material&nbsp;m&aacute;s adecuado para la distribuci&oacute;n de los art&iacute;culos o servicios de tus empresa.</p><p>Cat&aacute;logos de producto, Carteles, Tr&iacute;pticos,&nbsp;Flyers, banners,&hellip;</p><p class=\"font-size-xs\">Adem&aacute;s, si necesitas servicio de imprenta, fotograf&iacute;as corporativas o de producto, o cualquier otro tipo de servicio complementario para la producci&oacute;n del material comercial, tambi&eacute;n podemos ayudarte.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr><tr ng-class=\"{hover: Premium.hasPremium}\"><td>DOSSIER CORPORATIVO</td><td class=\"text-right\"><strong class=\"text-cepyme\">50%</strong></td><td style=\"width: 35px\"><em class=\"fa fa-check text-primary\"></em></td></tr><tr class=\"collapse\"><td colspan=\"2\"><div class=\"mb-5 windowWidth\"><div class=\"row\"><div class=\"col-xs-12 col-md-4\"><img alt=\"Imagen de un dossier\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/dossier.jpg\" class=\"img-responsive\"><div class=\"row\"><div class=\"col-xs-5 p-xxs bg-white\"><div class=\"text-center\"><a href=\"https://upthemedia.com\" target=\"_blank\"><img alt=\"Logo UPMEDIA\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/logo_upthemedia.jpg\" class=\"img-responsive\"></a></div></div><div class=\"col-xs-7 bg-white text-center text-cepyme font-weight-bold\"><div class=\"d\">50% dto.</div></div></div><div class=\"bg-primary text-white text-center p-xxs\">Descuento aplicable a presupuesto</div></div><div class=\"col-xs-12 col-md-8 mt-3 mt-md-0\"><h4 class=\"d mb-3 font-weight-bold\">Trasladar todo el carácter de tu empresa a una publicación</h4><div class=\"\"><p>Extraer y plasmar las cualidades de tu&nbsp;entidad, de un modo corporativo y visual.</p><p>Crear un dossier &uacute;nico, con el que te sientas&nbsp;c&oacute;modo. Que puedas anexar a cualquier&nbsp;tipo de documentaci&oacute;n. Entregar en&nbsp;reuniones, ferias/congresos, presentaciones, networking,&hellip;</p><p>En UpMedia, estructuramos y dise&ntilde;amos&nbsp;publicaciones adhoc, en formato digital o impreso. Cuidando todos los detalles, gr&aacute;ficos,&nbsp;infograf&iacute;as, im&aacute;genes, papeles,&hellip;</p><p class=\"font-size-xs\">Adem&aacute;s, si necesitas servicio de imprenta, fotograf&iacute;as&nbsp;corporativas o de producto, o cualquier otro tipo de servicio complementario para la producci&oacute;n del&nbsp;dossier, tambi&eacute;n podemos ayudarte.</p></div></div></div><hr><div class=\"font-size-sm\">Para más información contacta con:<br><strong>Natalia Aguirre | natalia@upthemedia.com | <img alt=\"Logo Whatsapp\" src=\"https://d3cbxno87ymraz.cloudfront.net//premium/whatsapp.svg\" style=\"vertical-align: baseline; width: 13px; height: 13px;\"> 681 605 340</strong></div></div></td></tr></tbody></table></div><hr><div ng-if=\"! Premium.hasPremium && ! Premium.loading\"><div class=\"text-center\"><a href=\"https://d3cbxno87ymraz.cloudfront.net//premium/cepyme500_premium.pdf\" target=\"_blank\">Más información</a> | <button ng-click=\"toggle = 1\" ng-disabled=\"toggle\" type=\"button\" class=\"btn btn-primary\">CONTRATAR</button></div><div ng-if=\"toggle\"><form ng-if=\"!myUser.company.customer_id\" class=\"form-inline advertiser-form-pay\" name=\"formPay\" ng-submit=\"Premium.submit()\" novalidate=\"\"><hr><p class=\"m-b-md\" translate=\"shop.help_ccard\"></p><div class=\"form-group block m-b-md\" ng-class=\"{\'has-error\': (formPay.card_number.$dirty || formPay.$submitted) && formPay.card_number.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'shop.ccard.number\' | translate}}</label> <input class=\"form-control\" type=\"text\" name=\"card_number\" ng-model=\"Premium.card.card_number\" placeholder=\"................\" cc-format=\"\" cc-number=\"\" cc-eager-type=\"\" ng-required=\"true\"> <img alt=\"Tarjetas de crédito\" ng-src=\"https://d3cbxno87ymraz.cloudfront.net//credit_cards/{{formPay.card_number.$ccEagerType | lowercase}}.png\"><p ng-show=\"(formPay.card_number.$dirty || formPay.$submitted) && formPay.card_number.$invalid\" class=\"text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</p></div><div class=\"form-group m-r-md\" ng-class=\"{\'has-error\': (formPay.card_exp_month.$dirty || formPay.$submitted) && formPay.card_exp_month.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'shop.ccard.month\' | translate}}</label> <input class=\"form-control min-card-input\" name=\"card_exp_month\" placeholder=\"..\" ng-model=\"Premium.card.card_exp_month\" cc-exp-month=\"\" ng-required=\"true\"><p>&nbsp;<span ng-show=\"(formPay.card_exp_month.$dirty || formPay.$submitted) && formPay.card_exp_month.$invalid\" class=\"text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</span></p></div><div class=\"form-group m-r-md\" ng-class=\"{\'has-error\': (formPay.card_exp_year.$dirty || formPay.$submitted) && formPay.card_exp_year.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'shop.ccard.year\' | translate}}</label> <input class=\"form-control min-card-input\" name=\"card_exp_year\" placeholder=\"..\" ng-model=\"Premium.card.card_exp_year\" cc-exp-year=\"\" ng-required=\"true\"><p>&nbsp;<span ng-show=\"(formPay.card_exp_year.$dirty || formPay.$submitted) && formPay.card_exp_year.$invalid\" class=\"text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</span></p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (formPay.card_cvc.$dirty || formPay.$submitted) && formPay.card_cvc.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'shop.ccard.cvc\' | translate}}:</label> <input class=\"form-control min-card-input\" type=\"text\" name=\"card_cvc\" ng-model=\"Premium.card.card_cvc\" placeholder=\"...\" cc-cvc=\"\" ng-required=\"true\"><p>&nbsp;<span ng-show=\"(formPay.card_cvc.$dirty || formPay.$submitted) && formPay.card_cvc.$invalid\" class=\"text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</span></p></div><div class=\"block\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"!formPay.$valid || Premium.loading\"><em class=\"fa fa-shopping-cart\"></em> <span translate-cloak=\"\">{{\'shop.btn.buy\' | translate}}</span></button></div></form><div ng-if=\"myUser.company.customer_id\" class=\"text-center m-t\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"Premium.submit()\" ng-disabled=\"Premium.loading\"><em class=\"fa fa-shopping-cart\"></em> <span translate-cloak=\"\">Pagar</span></button></div></div></div></div></div></div>");
$templateCache.put("app/logged/press.releases/press.releases.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"m-t m-b row\"><div class=\"col-xs-12 col-md-6\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"6\" id=\"compose\" class=\"btn btn-sm btn-primary\" translate-cloak=\"\">{{\'press_releases.btn.publish\'|translate}}</a></div><div class=\"col-xs-12 col-md-6 text-right\"><a href=\"javascript:void(0);\" ng-if=\"!PressReleasesList.id\" ng-click=\"PressReleasesList.getListById(myUser.company.id, true)\" translate-cloak=\"\">{{\'press_releases.btn.myones\'|translate}}</a> <a href=\"javascript:void(0);\" ng-if=\"PressReleasesList.id\" ng-click=\"PressReleasesList.getListById(false, true)\" translate-cloak=\"\">{{\'press_releases.btn.all\'|translate}}</a></div></div><div masonry=\"{ gutter: 25 }\" load-images=\"true\" preserve-order=\"\" column-width=\"330\" masonry-options=\'{\"isFitWidth\": true}\' reload-on-show=\"\" reload-on-resize=\"\"><div class=\"masonry-brick\" ng-repeat=\"news in PressReleasesList.news track by $index\"><div class=\"ibox\"><div class=\"ibox-content\"><div ng-show=\"news.image.real_path\" class=\"m-b-sm\"><img alt=\"Imagen de la noticia\" ng-src=\"{{news.image.real_path}}\" class=\"img-responsive center-block\"></div><h3 class=\"font-bold\"><a link-sidebar=\"\" type=\"5\" data=\"news\" href=\"javascript:void(0);\">{{news.title}}</a></h3><div ng-bind-html=\"news.subtitle\"></div><hr><div class=\"clearfix\"><div class=\"pull-left\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"1\" data=\"news.company\">{{news.company.name}}</a></div><div class=\"pull-right\" am-time-ago=\"news.updated_at.date | amUtc | amLocal\"></div></div><div class=\"text-right m-t\" ng-if=\"myUser.group === \'superadmin\' || myUser.group === \'superadmin\' || news.company.id == myUser.company.id\"><hr><a link-sidebar=\"\" href=\"javascript:void(0);\" id=\"edit\" data=\"news\" type=\"6\" class=\"btn btn-primary btn-xs btn-outline\"><em class=\"fa fa-pencil\"></em> Editar</a></div></div></div></div></div><p class=\"text-success text-center m-b-md\" ng-if=\"!PressReleasesList.news.length && PressReleasesList.run\">No tienes notas de prensa</p><div class=\"text-center m-b-md\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"!PressReleasesList.viewMoreAvailable || PressReleasesList.loading\" ng-click=\"PressReleasesList.viewMore()\" translate-cloak=\"\">{{\'press_releases.btn.viewmore\'|translate}}</button></div></div>");
$templateCache.put("app/logged/projects/projects.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-3 col-xs-12\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"15\" id=\"compose\" class=\"btn btn-success\">Publicar proyecto</a></div><div class=\"col-md-9 col-xs-12\"><form name=\"projectFormSearch\" class=\"form-inline pull-right\" ng-submit=\"Projects.getList()\"><div class=\"form-group m-r-sm\" ng-if=\"Projects.companies.length\"><chosen-companies selected-company=\"Projects.selectedCompanyId\" on-company-change=\"Projects.handleCompanySelection(companyId, company)\"></chosen-companies></div><button type=\"submit\" class=\"btn btn-success\" translate-cloak=\"\">Filtrar</button><div class=\"form-group m-l-sm\">| <a href=\"javascript:void(0);\" ng-click=\"Projects.params.company_id = myUser.company.id; Projects.getList()\">Ver mis proyectos</a></div></form></div></div></div><div class=\"ibox m-t-md\"><div class=\"ibox-title\"><h3 class=\"text-success\" translate-cloak=\"\">{{\'projects.title\' | translate}}</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Projects.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"\" ng-if=\"!Projects.projects.length\" translate-cloak=\"\">{{\'projects.noresults\' | translate}}</div><div class=\"\" ng-if=\"Projects.projects.length\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\"><thead><tr><th translate-cloak=\"\">{{\'projects.table.title\' | translate}}</th><th translate-cloak=\"\">{{\'projects.table.company\' | translate}}</th><th translate-cloak=\"\">{{\'projects.table.scope\' | translate}}</th><th class=\"text-right\" translate-cloak=\"\">{{\'projects.table.aproach\' | translate}}</th><th class=\"text-right\" translate-cloak=\"\">{{\'projects.table.from\' | translate}}</th><th class=\"text-right\" translate-cloak=\"\">{{\'projects.table.to\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"project in Projects.projects track by $index\"><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"14\" data=\"project\">{{project.title}}</a></td><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"1\" data=\"project.company\">{{project.company.name}}</a></td><td>{{project.scope}}</td><td class=\"text-right\">{{project.aproach | number:2}}€</td><td class=\"text-right\">{{project.date_from | date:\'dd-MM-yyyy\'}}</td><td class=\"text-right\">{{project.date_to | date:\'dd-MM-yyyy\'}}</td><td><em class=\"fa fa-spinner text-success\" ng-if=\"Projects.loadingAdd\"></em> <a href=\"javascript:void(0);\" ng-click=\"Projects.addUser(project.id, $index)\" ng-if=\"!Projects.loadingAdd && !project.added && (project.company.id != myUser.company.id)\" title=\"Unirse\"><em class=\"fa fa-plus\"></em></a> <a href=\"javascript:void(0);\" ng-click=\"Projects.removeUser(project.id, $index)\" ng-if=\"!Projects.loadingAdd && project.added && (project.company.id != myUser.company.id )\" title=\"Desligarse\"><em class=\"fa fa-close text-warning\"></em></a> <a href=\"javascript:void(0);\" class=\"m-r-sm\" link-sidebar=\"\" type=\"14\" data=\"project\"><em class=\"fa fa-share\" title=\"Ver proyecto\"></em></a></td></tr></tbody></table></div><div class=\"clearfix m-r-md\"><div class=\"pull-right\"><uib-pagination total-items=\"Projects.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"Projects.getList()\" ng-model=\"Projects.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"20\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div></div></div></div>");
$templateCache.put("app/logged/profile/profile.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"summernote_parent\"><div class=\"ibox\" ng-if=\"myUser.group == \'superadmin\'\"><div class=\"ibox-content text-right\"><form role=\"form\" class=\"form-inline\"><div class=\"form-group m-r-sm text-left\" translate-cloak=\"\">{{\'profile.main.change_company\' | translate}}</div><div class=\"form-group m-r-sm text-left\" ng-if=\"myUser.group == \'superadmin\' || myUser.group == \'admin\'\"><chosen-companies selected-company=\"Profile.selectedCompanyId\" on-company-change=\"Profile.handleCompanySelection(companyId, company)\"></chosen-companies></div><button class=\"btn btn-success\" ng-disabled=\"Profile.loading\" ng-click=\"Profile.changeCompany();\" type=\"submit\" translate-cloak=\"\">{{\'profile.main.change\' | translate}}</button></form></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\">{{Profile.company.name}}</h5></div><div class=\"ibox-content wizard\" ng-class=\"{\'sk-loading\': Profile.loading}\"><div class=\"sk-spinner sk-spinner-wave\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div><div class=\"steps clearfix\"><ul><li ui-sref-active=\"current\"><a ui-sref=\".step_one\" ui-sref-opts=\"{reload:true}\" class=\"btn-default\"><span translate-cloak=\"\">{{\'profile.main.contact\' | translate}}</span></a></li><li ui-sref-active=\"current\"><a ui-sref=\".step_two_financials\" class=\"btn-default\"><span translate-cloak=\"\">{{\'profile.main.economic\' | translate}}</span></a></li><li ui-sref-active=\"current\"><a ui-sref=\".step_three\" class=\"btn-default\"><span translate-cloak=\"\">{{\'profile.main.images\' | translate}}</span></a></li><li ui-sref-active=\"current\"><a ui-sref=\".step_four\" class=\"btn-default\"><span translate-cloak=\"\">{{\'profile.main.result\' | translate}}</span></a></li><li ui-sref-active=\"current\"><a ui-sref=\".step_five\" class=\"btn-default\"><span translate-cloak=\"\">{{\'profile.main.access\' | translate}}</span></a></li><li ui-sref-active=\"current\" ng-if=\"myUser.group == \'superadmin\' || myUser.group == \'admin\'\"><a ui-sref=\".step_six\" class=\"btn-default\"><span translate-cloak=\"\">{{\'profile.main.interview\' | translate}}</span></a></li></ul></div><div class=\"wizard\"><div class=\"content\"><div id=\"form-views\" class=\"p-lg\" ui-view=\"\"></div></div></div><p class=\"m-sm fs-sm\" translate-cloak=\"\">{{\'profile.main.law\' | translate}}</p></div></div></div></div>");
$templateCache.put("app/logged/profile/step_five.html","<fieldset class=\"animated fadeIn\"><legend class=\"hidden\">Datos de acceso</legend><div class=\"ibox-content m-b-md\" ng-if=\"ProfileStep5.users.length > 1\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\"><thead><tr><th>Nombre</th><th>Email</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in ProfileStep5.users track by user.id\"><td>{{user.name}}</td><td>{{user.email}}</td><td><a href=\"javascript:void(0);\" ng-click=\"ProfileStep5.editUser($index)\">Editar</a></td></tr></tbody></table></div></div><form name=\"ProfileStep5From\" ng-submit=\"ProfileStep5.submit(ProfileStep5From)\"><div class=\"ibox-content\"><div class=\"form-group\"><label>Email:</label> <input type=\"email\" disabled=\"\" ng-model=\"ProfileStep5.user.email\" placeholder=\"Enter email\" class=\"form-control\" required=\"\"></div><div class=\"form-group m-b-none\"><label translate-cloak=\"\">{{\'profile.step5.pass\' | translate}}</label> <input type=\"password\" placeholder=\"Password\" name=\"password\" ng-minlength=\"9\" ng-model=\"ProfileStep5.user.password\" class=\"form-control\" required=\"\"></div><p ng-class=\"{\'text-danger\': ProfileStep5From.password.$invalid && ProfileStep5From.password.$dirty}\" translate-cloak=\"\">{{\'profile.review.carateres9_short\' | translate}}</p><div class=\"form-group m-b-none\"><label translate-cloak=\"\">{{\'profile.step5.pass_repeat\' | translate}}</label> <input type=\"password\" placeholder=\"Repeat password\" name=\"password_repeat\" ng-model=\"ProfileStep5.user.password_repeat\" ng-minlength=\"9\" class=\"form-control\" required=\"\"></div><p ng-show=\"(ProfileStep5From.password.$dirty && ProfileStep5From.password_repeat.$dirty) && (ProfileStep5.user.password !== ProfileStep5.user.password_repeat)\" class=\"text-danger\" translate-cloak=\"\">{{\'profile.review.repeat_password\' | translate}}</p><div class=\"m-t-md\"><button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"!ProfileStep5.available || ProfileStep5From.$invalid || (ProfileStep5.user.password !== ProfileStep5.user.password_repeat)\" translate-cloak=\"\">{{\'profile.step5.update\' | translate}}</button></div><p class=\"m-t-md\" ng-if=\"!ProfileStep5.user.id && ProfileStep5.user.email\" translate-cloak=\"\">{{\'profile.step5.no_user\' | translate}}</p><p ng-if=\"!ProfileStep5.user.email\" class=\"text-danger m-t-md\" translate-cloak=\"\">{{\'profile.step5.no_email\' | translate}}</p><p class=\"m-t-md\"><a ui-sref=\"^.step_one({id: ProfileStep5.user.company_id})\" translate-cloak=\"\">{{\'profile.step5.go_1\' | translate}}</a></p></div></form></fieldset>");
$templateCache.put("app/logged/profile/step_four.html","<fieldset class=\"animated fadeIn\"><legend class=\"hidden\">Comprobación de la ficha</legend><div class=\"row\" height-equal=\"\" ng-if=\"Profile.company.name\"><div class=\"col-lg-8\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step4.data\' | translate}}</h5></div><div class=\"ibox-content form-horizontal height-equal-child\"><div class=\"m-md\" ng-if=\"Profile.company.logo.url\"><img alt=\"Logo de la empresa\" ng-src=\"{{Profile.company.logo.url}}\" class=\"img-responsive center-block\"></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\" translate-cloak=\"\">{{\'profile.step1.name\' | translate}}:</label><div class=\"col-lg-8\"><p class=\"form-control-static\">{{Profile.company.name}}</p></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">CNAE:</label><div class=\"col-lg-8\"><p class=\"form-control-static\">{{Profile.company.cnae.id}} / {{Profile.company.cnae.name}}</p></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-6 control-label\" translate-cloak=\"\">{{\'profile.step2.employees\' | translate}}:</label><div class=\"col-lg-6\"><p class=\"form-control-static\" ng-if=\"Profile.company.financials[0].employees\">{{Profile.company.financials[0].employees}}</p><p class=\"form-control-static\" ng-if=\"!Profile.company.financials[0].employees\">{{Profile.company.employees}}</p></div></div><div class=\"form-group\"><label class=\"col-lg-6 control-label\" translate-cloak=\"\">Imp./Exp.:</label><div class=\"col-lg-6\"><p class=\"form-control-static\">{{Profile.company.import_export}}</p></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\" translate-cloak=\"\">{{\'profile.step4.description_long\' | translate}}:</label><div class=\"col-lg-10\"><p class=\"form-control-static\" ng-bind-html=\"Profile.company.description\"></p></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Web:</label><div class=\"col-lg-10\"><p class=\"form-control-static ellipsis\"><a ng-href=\"{{Profile.company.web}}\" target=\"_blank\">{{Profile.company.web}}</a></p></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\" ng-if=\"Profile.company.linkedin\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\"><em class=\"fa fa-linkedin\"></em>:</label><div class=\"col-lg-8\"><p class=\"form-control-static ellipsis\"><a href=\"{{Profile.company.linkedin}}\" targte=\"_blank\">{{Profile.company.linkedin}}</a></p></div></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"Profile.company.twitter\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\"><em class=\"fa fa-twitter\"></em>:</label><div class=\"col-lg-8\"><p class=\"form-control-static ellipsis\"><a href=\"{{Profile.company.twitter}}\" targte=\"_blank\">{{Profile.company.twitter}}</a></p></div></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"Profile.company.facebook\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\"><em class=\"fa fa-facebook\"></em>:</label><div class=\"col-lg-8\"><p class=\"form-control-static ellipsis\"><a href=\"{{Profile.company.facebook}}\" targte=\"_blank\"></a>{{Profile.company.facebook}}</p></div></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"Profile.company.google\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\"><em class=\"fa fa-google\"></em>:</label><div class=\"col-lg-8\"><p class=\"form-control-static ellipsis\"><a href=\"{{Profile.company.google}}\" targte=\"_blank\"></a>{{Profile.company.google}}</p></div></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"Profile.company.youtube\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\"><em class=\"fa fa-youtube\"></em>:</label><div class=\"col-lg-8\"><p class=\"form-control-static ellipsis\"><a href=\"{{Profile.company.youtube}}\" targte=\"_blank\"></a>{{Profile.company.youtube}}</p></div></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"Profile.company.linkedin_contacts\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\" translate-cloak=\"\">{{\'profile.step4.linkedin\' | translate}}:</label><div class=\"col-lg-8\"><p class=\"form-control-static\">{{Profile.company.linkedin_contacts}}</p></div></div></div></div><div class=\"row\" ng-if=\"ProfileStep4.mapReady\"><div class=\"col-xs-12\"><ui-gmap-google-map center=\"ProfileStep4.map.center\" zoom=\"ProfileStep4.map.zoom\"><ui-gmap-marker ng-repeat=\"address in Profile.company.addresses track by $index\" idkey=\"address.id\" coords=\"{\'latitude\': address.lat, \'longitude\': address.lng}\" options=\"ProfileStep4.markerOptions\"><ui-gmap-window><p><strong>{{address.street}}</strong><br>{{address.postal_code}}, {{address.town}}, {{address.province_id | ProvinceFilter : \'id\'}}<br><em class=\"fa fa-envelope\"></em> {{Profile.company.email}} | <em class=\"fa fa-phone\"></em> {{address.phone_number}}</p></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map></div></div><div class=\"row m-t-lg\"><div class=\"col-xs-12\"><h4 class=\"text-primary\"><span translate-cloak=\"\">{{\'profile.step4.economic_data\' | translate}}</span> {{Profile.company.financials[0].year}}</h4><div class=\"table-responsive\"><table class=\"table table-striped table-hover\"><tr><td translate-cloak=\"\">{{\'profile.step4.sells_tax\' | translate}}</td><td class=\"text-right\"><strong class=\"text-primary\"><span ng-if=\"Profile.company.financials[0].cagr\">{{Profile.company.financials[0].cagr | number: 2}}%</span></strong><span ng-if=\"!Profile.company.financials[0].cagr\">-</span></td></tr><tr><td translate-cloak=\"\">{{\'profile.step2.development\' | translate}}</td><td class=\"text-right\"><strong class=\"text-primary\"><span ng-if=\"Profile.company.financials[0].development\">{{Profile.company.financials[0].development | number : 2}} €</span></strong><span ng-if=\"!Profile.company.financials[0].development\">-</span></td></tr><tr><td translate-cloak=\"\">EBITDA</td><td class=\"text-right\"><strong class=\"text-primary\"><span ng-if=\"Profile.company.financials[0].ebitda\">{{Profile.company.financials[0].ebitda | number : 2}} €</span></strong><span ng-if=\"!Profile.company.financials[0].ebitda\">-</span></td></tr><tr><td translate-cloak=\"\">{{\'profile.step2.foreign\' | translate}}</td><td class=\"text-right\"><strong class=\"text-primary\"><span ng-if=\"Profile.company.financials[0].foreign_investiments\">{{Profile.company.financials[0].foreign_investiments}}</span></strong><span ng-if=\"!Profile.company.financials[0].foreign_investiments\">-</span></td></tr><tr><td translate-cloak=\"\">{{\'profile.step2.investigation\' | translate}}</td><td class=\"text-right\"><strong class=\"text-primary\"><span ng-if=\"Profile.company.financials[0].investigation\">{{Profile.company.financials[0].investigation | number : 2}} €</span></strong><span ng-if=\"!Profile.company.financials[0].investigation\">-</span></td></tr><tr><td translate-cloak=\"\">{{\'profile.step2.patents\' | translate}}</td><td class=\"text-right\"><strong class=\"text-primary\"><span ng-if=\"Profile.company.financials[0].patents\">{{Profile.company.financials[0].patents}}</span></strong><span ng-if=\"!Profile.company.financials[0].patents\">-</span></td></tr><tr><td translate-cloak=\"\">{{\'profile.step2.roa\' | translate}}</td><td class=\"text-right\"><strong class=\"text-primary\"><span ng-if=\"Profile.company.financials[0].roa\">{{Profile.company.financials[0].roa | number : 2}}%</span></strong><span ng-if=\"!Profile.company.financials[0].roa\">-</span></td></tr><tr><td translate-cloak=\"\">{{\'profile.step4.sells\' | translate}}</td><td class=\"text-right\"><strong class=\"text-primary\"><span ng-if=\"Profile.company.financials[0].sales\">{{Profile.company.financials[0].sales | number : 2}} €</span></strong><span ng-if=\"!Profile.company.financials[0].sales\">-</span></td></tr><tr><td translate-cloak=\"\">{{\'profile.step2.employees\' | translate}}</td><td class=\"text-right\"><strong class=\"text-primary\"><span ng-if=\"Profile.company.financials[0].employees\">{{Profile.company.financials[0].employees | number}}</span></strong><span ng-if=\"!Profile.company.financials[0].employees\">-</span></td></tr></table></div></div></div></div></div></div><div class=\"col-lg-4\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step4.contacts\' | translate}}</h5></div><div class=\"ibox-content height-equal-child\"><div class=\"contact-box center-version\" ng-repeat=\"contact in Profile.company.contacts track by $index\"><div class=\"text-center p-lg\"><p class=\"m-b-md\" ng-if=\"contact.image.url\"><img alt=\"Imagen del contacto\" class=\"img-circle img-lg center-block\" ng-src=\"{{contact.image.url}}\"></p><h3 class=\"m-b-xs\"><strong ng-class=\"{\'text-primary\': contact.default}\">{{contact.name}} {{contact.surname}}</strong></h3><div class=\"font-bold\">{{contact.job_title}} <span ng-if=\"contact.departament && contact.job_title\">/</span> {{contact.departament}}</div><address class=\"m-t-md\"><p ng-if=\"contact.phone_number\"><a ng-href=\"tel:{{contact.phone_number}}\"><em class=\"fa fa-phone text-success\"></em></a> (+34) {{contact.phone_number}}</p><p ng-if=\"contact.email\"><a ng-href=\"mailto:{{contact.email}}\"><em class=\"fa fa-envelope text-success\"></em></a> {{contact.email}}</p><span ng-if=\"contact.linkedin\"><a ng-href=\"{{contact.linkedin}}\" target=\"_blank\"><em class=\"fa fa-linkedin text-success\"></em> Visitar</a> <span ng-if=\"contact.linkedin_contacts\">+ {{contact.linkedin_contacts}}</span></span></address></div></div></div></div></div></div><div class=\"row mTop20\"><div class=\"col-md-6 col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step1.countries_market\' | translate}}</h5></div><div class=\"ibox-content\"><div ng-if=\"ProfileStep4.vectorMapReady\"><vector-map class=\"vector-map-no-clickleabe\" no-clickleabe=\"1\" countries=\"ProfileStep4.countriesMarketIds\" emit=\"mapCountrySelecedSales\"></vector-map></div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step1.select_country\' | translate}}</h5></div><div class=\"ibox-content\"><div ng-if=\"ProfileStep4.vectorMapReady\"><vector-map class=\"vector-map-no-clickleabe\" no-clickleabe=\"1\" countries=\"ProfileStep4.countriesOfficeIds\" fill-selected=\"#1abc9c\" emit=\"mapCountrySelecedOffice\"></vector-map></div></div></div></div></div><div class=\"row mTop20\" ng-if=\"Profile.company.interview\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step4.interview\' | translate}}</h5></div><div class=\"ibox-content\"><div ng-if=\"Profile.company.interview.image.url\"><img alt=\"Imagen de la entrevista\" ng-src=\"{{Profile.company.interview.image.url}}\" class=\"max-h-150\"></div><h4>{{Profile.company.interview.name}}</h4><div>{{Profile.company.interview.job_title}} <span ng-if=\"Profile.company.interview.departament\">| {{Profile.company.interview.departament}}</span></div><hr><div ng-bind-html=\"Profile.company.interview.interview\"></div></div></div></div></fieldset>");
$templateCache.put("app/logged/profile/step_one.html","<form name=\"ProfileStep1Form\" ng-submit=\"ProfileStep1.step1Submit(ProfileStep1Form);\" novalidate=\"\" height-equal=\"\"><div class=\"row m-t-sm height-equal\"><div class=\"col-lg-4 col-md-6 col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step1.address\' | translate}}</h5></div><div class=\"ibox-content height-equal-child\"><div ng-repeat=\"address in Profile.company.addresses track by $index\"><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.street_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.street_{{$index}}.$invalid}\"><label translate-cloak=\"\">{{\'profile.step1.street\' | translate}} *</label> <input type=\"text\" id=\"street_{{$index}}\" ng-model=\"Profile.company.addresses[$index].street\" name=\"street_{{$index}}\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" required=\"\" ng-trim=\"true\"><p ng-show=\"(ProfileStep1Form.street_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.street_{{$index}}.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.postal_code_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.postal_code_{{$index}}.$invalid}\"><label translate-cloak=\"\">{{\'profile.step1.postal_code\' | translate}} *</label> <input type=\"tel\" id=\"postal_code_{{$index}}\" name=\"postal_code_{{$index}}\" ng-model=\"Profile.company.addresses[$index].postal_code\" class=\"form-control\" ng-minlength=\"5\" ng-maxlength=\"5\" required=\"\" ng-trim=\"true\"><p ng-show=\"(ProfileStep1Form.postal_code_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.postal_code_{{$index}}.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review.carateres5\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.town_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.town_{{$index}}.$invalid}\"><label translate-cloak=\"\">{{\'profile.step1.town\' | translate}} *</label> <input type=\"text\" id=\"town_{{$index}}\" ng-model=\"Profile.company.addresses[$index].town\" name=\"town_{{$index}}\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" required=\"\" ng-trim=\"true\"><p ng-show=\"(ProfileStep1Form.town_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.town_{{$index}}.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.province_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.province_{{$index}}.$invalid}\"><label translate-cloak=\"\">{{\'profile.step1.province\' | translate}} *</label><div><select chosen=\"\" name=\"province_{{$index}}\" id=\"province_{{$index}}\" data-placeholder-text-single=\"\'Escoge provincia\'\" ng-model=\"Profile.company.addresses[$index].province_id\" ng-options=\"province.id as province.name for province in ProfileStep1.provinces\" ng-model-options=\"{ allowInvalid: true }\" required=\"\"></select></div><p ng-show=\"(ProfileStep1Form.province_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.province_{{$index}}.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.phone_address_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.phone_address_{{$index}}.$invalid}\"><label translate-cloak=\"\">{{\'profile.step1.phone\' | translate}} *</label><div class=\"input-group m-b\"><span class=\"input-group-addon\">+34</span> <input type=\"int\" id=\"phone_address_{{$index}}\" ng-model=\"Profile.company.addresses[$index].phone_number\" name=\"phone_address_{{$index}}\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" ng-minlength=\"9\" ng-maxlength=\"20\" required=\"\" ng-trim=\"true\"></div><p ng-show=\"(ProfileStep1Form.phone_address_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.phone_address_{{$index}}.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review.carateres9\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.fax_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.fax_{{$index}}.$invalid}\"><label translate-cloak=\"\">{{\'profile.step1.fax\' | translate}}</label><div class=\"input-group m-b\"><span class=\"input-group-addon\">+34</span> <input type=\"int\" id=\"fax_{{$index}}\" ng-model=\"Profile.company.addresses[$index].fax\" name=\"fax_{{$index}}\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" ng-minlength=\"9\" ng-maxlength=\"20\" ng-trim=\"true\"></div><p ng-show=\"(ProfileStep1Form.fax_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.fax_{{$index}}.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review.carateres9\' | translate}}</p></div></div></div></div></div><div class=\"col-lg-4 col-md-6 col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step1.another_data\' | translate}}</h5></div><div class=\"ibox-content height-equal-child\"><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.activity.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.activity.$invalid}\"><label translate-cloak=\"\">{{\'profile.step1.activity\' | translate}} *</label> <textarea id=\"activity\" ng-model=\"Profile.company.activity\" ng-disabled=\"Profile.company.activity\" name=\"activity\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" required=\"\" ng-trim=\"true\" rows=\"9\"></textarea><p ng-show=\"(ProfileStep1Form.activity.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.activity.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.cif.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.cif.$invalid}\"><label>CIF *</label> <input type=\"text\" id=\"cif\" ng-model=\"Profile.company.cif\" ng-disabled=\"Profile.company.cif\" name=\"cif\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" required=\"\" ng-trim=\"true\"><p ng-show=\"(ProfileStep1Form.cif.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.cif.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.web.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.web.$invalid}\"><label>Web *</label> <input type=\"url\" id=\"web\" ng-model=\"Profile.company.web\" name=\"web\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" required=\"\" ng-trim=\"true\"><p ng-show=\"(ProfileStep1Form.web.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.web.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review\' | translate}}</p><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.url_valid\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.email.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.email.$invalid}\"><label>Email *</label> <input type=\"email\" id=\"web\" ng-model=\"Profile.company.email\" name=\"email\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" required=\"\" ng-trim=\"true\"><p ng-show=\"(ProfileStep1Form.email.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.email.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review.email\' | translate}}</p></div></div></div></div><div class=\"col-lg-4 col-md-6 col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step1.rrss\' | translate}}</h5></div><div class=\"ibox-content height-equal-child\"><div class=\"form-group\"><div class=\"input-group m-b\"><span class=\"input-group-addon\"><em class=\"fa fa-linkedin\"></em></span><input type=\"text\" id=\"linkedin\" ng-model=\"Profile.company.linkedin\" name=\"linkedin\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" ng-trim=\"true\"></div></div><div class=\"form-group\"><div class=\"input-group m-b\"><span class=\"input-group-addon\"><em class=\"fa fa-twitter\"></em></span><input type=\"text\" id=\"twitter\" ng-model=\"Profile.company.twitter\" name=\"twitter\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" ng-trim=\"true\"></div></div><div class=\"form-group\"><div class=\"input-group m-b\"><span class=\"input-group-addon\"><em class=\"fa fa-facebook\"></em></span><input type=\"text\" id=\"facebook\" ng-model=\"Profile.company.facebook\" name=\"facebook\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" ng-trim=\"true\"></div></div><div class=\"form-group\"><div class=\"input-group m-b\"><span class=\"input-group-addon\"><em class=\"fa fa-google-plus\"></em></span><input type=\"text\" id=\"google\" ng-model=\"Profile.company.google\" name=\"google\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" ng-trim=\"true\"></div></div><div class=\"form-group\"><div class=\"input-group m-b\"><span class=\"input-group-addon\"><em class=\"fa fa-youtube\"></em></span><input type=\"text\" id=\"youtube\" ng-model=\"Profile.company.youtube\" name=\"youtube\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" ng-trim=\"true\"></div></div><p><span class=\"help-block fs-sm\">* <span translate-cloak=\"\">{{\'profile.step1.url\' | translate}}</span><br>(https://www.linkedin.com/company/cepyme)</span></p></div></div></div></div><div class=\"row mTop20\"><div class=\"col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step1.description\' | translate}}</h5></div><div class=\"ibox-content\"><div class=\"form-group form-group-summernote\" ng-class=\"{\'has-error\': (ProfileStep1Form.$submitted) && ProfileStep1Form.description.$invalid}\"><div><summernote on-paste=\"ProfileStep1.pasteSummernote()\" ng-if=\"ProfileStep1.config\" name=\"description\" id=\"description\" config=\"ProfileStep1.config\" ng-model=\"Profile.company.description\" required=\"\"></summernote></div><p><span class=\"help-block m-b-none text-black fs-sm\"><u>({{Profile.company.description.length}} <span translate-cloak=\"\">{{\'profile.step1.caracteres\' | translate}}</span>)</u><span translate-cloak=\"\" translate=\"{{\'profile.step1.recomendation_web\'}}\"></span><br><a ng-href=\"{{Profile.company.web}}\" target=\"_blank\"><span translate-cloak=\"\">{{\'profile.step1.recomendation_web_go\' | translate}} {{Profile.company.web}}</span></a></span></p><p ng-show=\"Profile.company.description.length > 500\" class=\"fs-sm help-block text-danger\" translate-cloak=\"\">{{\'profile.review.description\' | translate}}</p></div></div></div></div></div><div class=\"row mTop20\"><div class=\"col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step1.people\' | translate}}</h5></div><div class=\"ibox-content\"><div class=\"row\"><div ng-repeat=\"contact in Profile.company.contacts track by $index\" class=\"col-lg-4 col-md-6 col-xs-12\"><div class=\"clearfix m-t-md\"><strong class=\"pull-left\" translate-cloak=\"\">{{\'profile.step1.main_contact\' | translate}}</strong><div class=\"switch pull-left m-l-sm\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"contact_default_{{$index}}\" ng-model=\"Profile.company.contacts[$index].default\" ng-change=\"Profile.contactDefault($index)\" class=\"onoffswitch-checkbox\" id=\"example_{{$index}}\"> <label class=\"onoffswitch-label\" for=\"example_{{$index}}\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"form-group m-t-sm\" ng-class=\"{\'has-error\': (ProfileStep1Form.contacts_name_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.contacts_name_{{$index}}.$invalid}\"><label translate-cloak=\"\">{{\'profile.step1.name\' | translate}} *</label> <input type=\"Text\" id=\"name_{{$index}}\" ng-model=\"Profile.company.contacts[$index].name\" name=\"contacts_name_{{$index}}\" class=\"form-control\" ng-minlength=\"2\" ng-model-options=\"{ allowInvalid: true }\" ng-required=\"Profile.company.contacts[$index].default\" ng-trim=\"true\"><p ng-show=\"(ProfileStep1Form.contacts_name_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.contacts_name_{{$index}}.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review.carateres2\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.contacts_surname_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.contacts_surname_{{$index}}.$invalid}\"><label translate-cloak=\"\">{{\'profile.step1.surname\' | translate}} *</label> <input type=\"Text\" id=\"surname_{{$index}}\" ng-model=\"Profile.company.contacts[$index].surname\" name=\"contacts_surname_{{$index}}\" class=\"form-control\" ng-minlength=\"2\" ng-model-options=\"{ allowInvalid: true }\" ng-required=\"Profile.company.contacts[$index].default\" ng-trim=\"true\"><p ng-show=\"(ProfileStep1Form.contacts_surname_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.contacts_surname_{{$index}}.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review.carateres2\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.contacts_job_title_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.contacts_job_title_{{$index}}.$invalid}\"><label translate-cloak=\"\">{{\'profile.step1.position\' | translate}} *</label> <input type=\"text\" id=\"job_title_{{$index}}\" ng-model=\"Profile.company.contacts[$index].job_title\" name=\"contacts_job_title_{{$index}}\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" ng-required=\"Profile.company.contacts[$index].default\" ng-trim=\"true\"><p ng-show=\"(ProfileStep1Form.contacts_job_title_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.contacts_job_title_{{$index}}.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.contacts_email_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.contacts_email_{{$index}}.$invalid}\"><label>Email <span ng-if=\"Profile.company.contacts[$index].default\">*</span></label> <input type=\"email\" id=\"email_{{$index}}\" ng-model=\"Profile.company.contacts[$index].email\" name=\"contacts_email_{{$index}}\" class=\"form-control\" ng-minlength=\"3\" ng-model-options=\"{ allowInvalid: true }\" ng-required=\"Profile.company.contacts[$index].default\" ng-trim=\"true\"><p ng-show=\"(ProfileStep1Form.contacts_email_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.contacts_email_{{$index}}.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review.email\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (ProfileStep1Form.contacts_phone_number_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.contacts_phone_number_{{$index}}.$invalid}\"><label translate-cloak=\"\">{{\'profile.step1.phone\' | translate}} <span ng-if=\"Profile.company.contacts[$index].default\">*</span></label><div class=\"input-group m-b\"><span class=\"input-group-addon\">+34</span> <input type=\"text\" id=\"phone_number_{{$index}}\" ng-model=\"Profile.company.contacts[$index].phone_number\" name=\"contacts_phone_number_{{$index}}\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" ng-minlength=\"9\" ng-required=\"Profile.company.contacts[$index].default\" ng-trim=\"true\"></div><p ng-show=\"(ProfileStep1Form.contacts_phone_number_{{$index}}.$dirty || ProfileStep1Form.$submitted) && ProfileStep1Form.contacts_phone_number_{{$index}}.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.review.carateres9\' | translate}}</p></div><div class=\"form-group\"><label translate-cloak=\"\">{{\'profile.step1.department\' | translate}}</label> <input type=\"text\" id=\"departament_{{$index}}\" ng-model=\"Profile.company.contacts[$index].departament\" name=\"contacts_departament_{{$index}}\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" ng-trim=\"true\"></div><div class=\"form-group\"><label>Linkedin</label> <input type=\"TEXT\" id=\"linkedin_{{$index}}\" ng-model=\"Profile.company.contacts[$index].linkedin\" name=\"contacts_linkedin_{{$index}}\" class=\"form-control\" ng-model-options=\"{ allowInvalid: true }\" ng-trim=\"true\"></div><div class=\"text-center h-50\"><button ng-if=\"$index == (Profile.company.contacts.length - 1)\" class=\"btn btn-primary btn-circle height-equal-btn\" uib-tooltip=\"Añadir más contactos\" ng-click=\"Profile.more(\'contacts\')\" type=\"button\"><em class=\"fa fa-plus\"></em></button> <button ng-disabled=\"Profile.loadingContactsRemove\" ng-if=\"!Profile.company.contacts[$index].default\" class=\"btn btn-circle btn-danger height-equal-btn\" uib-tooltip=\"Eliminar contacto\" ng-click=\"Profile.less(\'contacts\', $index)\" type=\"button\"><em class=\"fa fa-close\"></em></button></div><div class=\"hr-line-dashed primary\" ng-if=\"$index < Profile.company.contacts.length -1\"></div></div></div></div></div></div></div><div class=\"row mTop20\"><div class=\"col-md-6 col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary block clearfix\" translate-cloak=\"\">{{\'profile.step1.countries_market\' | translate}}</h5><p class=\"block\" translate-cloak=\"\">{{\'profile.step1.select_country\' | translate}}</p></div><div class=\"ibox-content\"><div ng-if=\"Profile.ready\"><vector-map countries=\"Profile.countriesMarketIds\" class=\"vector-map-content\" emit=\"mapCountrySelecedSales\"></vector-map></div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary block clearfix\" translate-cloak=\"\">{{\'profile.step1.countries_office\' | translate}}</h5><p class=\"block\" translate-cloak=\"\">{{\'profile.step1.select_country\' | translate}}</p></div><div class=\"ibox-content\"><div ng-if=\"Profile.ready\"><vector-map countries=\"Profile.countriesOfficeIds\" fill-selected=\"#1abc9c\" class=\"vector-map-content\" emit=\"mapCountrySelecedOffice\"></vector-map></div></div></div></div></div><p class=\"text-right mTop20\"><button ng-disabled=\"Profile.loading\" type=\"submit\" class=\"btn btn-primary\" translate-cloak=\"\">{{\'profile.step2b.btn\' | translate}}</button></p></form>");
$templateCache.put("app/logged/profile/step_six.html","<fieldset class=\"animated fadeIn\"><legend class=\"hidden\">Entrevista</legend><form name=\"ProfileStep6From\" ng-submit=\"ProfileStep6.submit(ProfileStep6From)\"><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': ProfileStep6.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"form-group\"><label translate-cloak=\"\">{{\'profile.step6.name\' | translate}}</label> <input type=\"text\" name=\"name\" ng-model=\"Profile.company.interview.name\" placeholder=\"{{\'profile.step6.name\' | translate}}\" class=\"form-control\"></div><div class=\"form-group\"><label translate-cloak=\"\">{{\'profile.step6.position\' | translate}}</label> <input type=\"text\" placeholder=\"{{\'profile.step6.position\' | translate}}\" name=\"job_title\" ng-model=\"Profile.company.interview.job_title\" class=\"form-control\"></div><div class=\"form-group\"><label translate-cloak=\"\">{{\'profile.step6.departament\' | translate}}</label> <input type=\"text\" placeholder=\"{{\'profile.step6.departament\' | translate}}\" name=\"departament\" ng-model=\"Profile.company.interview.departament\" class=\"form-control\"></div><div class=\"form-group form-group-summernote\" ng-class=\"{\'has-error\': (ProfileStep6From.$submitted) && ProfileStep6From.interview.$invalid}\"><label translate-cloak=\"\">{{\'profile.step6.interview\' | translate}}</label><div><summernote on-paste=\"ProfileStep6.pasteSummernote()\" ng-if=\"ProfileStep6.config\" name=\"interview\" id=\"interview\" config=\"ProfileStep6.config\" ng-model=\"Profile.company.interview.interview\" required=\"\"></summernote></div><p ng-show=\"(ProfileStep6From.interview.$dirty || ProfileStep6From.$submitted) && ProfileStep6From.interview.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'profile.step6.interview\' | translate}}</p></div><hr><label translate-cloak=\"\">{{\'profile.step6.image\' | translate}}</label> <img ng-if=\"Profile.company.interview && Profile.company.interview.image\" alt=\"Imagen de la entrevista\" ng-src=\"{{Profile.company.interview.image.url}}\"><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"\" name=\"image\" ngf-drop=\"\" ng-model=\"ProfileStep6.image\" ngf-drop-available=\"true\" ngf-pattern=\"\'.jpeg,.jpg,.png,.bmp,.gif\'\" ngf-max-size=\"10MB\"><h4 class=\"text-center font-bold text-success\" translate-cloak=\"\" translate=\"press_releases.form.drag_drop\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\"><img alt=\"Imagen a subir\" ngf-size=\"{height: 80}\" ngf-thumbnail=\"ProfileStep6.image\" ng-click=\"ProfileStep6.removeFile()\"></a></div></div><p ng-show=\"(PressReleaseFrom.image.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.image.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'press_releases.form.review\' | translate}}</p><p class=\"m-t-md\" translate-cloak=\"\">{{\'mailbox.help.main_image\' | translate}}</p><div class=\"m-t-md\"><button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"ProfileStep6From.$invalid || ProfileStep6.loading\" translate-cloak=\"\">{{\'profile.step5.update\' | translate}}</button></div></div></form></fieldset>");
$templateCache.put("app/logged/profile/step_three.html","<fieldset class=\"animated fadeIn\"><legend class=\"hidden\">Añadir imágenes</legend><div class=\"row\" height-equal=\"\"><div class=\"col-lg-6 col-xs-12 height-equal-child\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step3.logo\' | translate}}</h5></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': ProfileStep3.loading.logo}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"m-b-md\" ng-if=\"Profile.company.logo.url\"><img alt=\"Logo de la empresa\" ng-src=\"{{Profile.company.logo.url}}\" class=\"img-responsive center-block\"></div><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"ProfileStep3.upload($file, \'logo\')\" ngf-drop=\"ProfileStep3.upload($file, \'logo\')\" ng-model=\"ProfileStep3.logo\" ngf-drop-available=\"true\" ngf-pattern=\"\'.jpeg,.jpg,.png,.bmp,.gif\'\" ngf-max-size=\"10MB\"><h4 class=\"text-center font-bold text-success\" translate-cloak=\"\" translate=\"{{\'profile.step3.drag_drop\'}}\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\"><img alt=\"Logo a enviar\" ngf-size=\"{height: 80}\" ngf-thumbnail=\"ProfileStep3.logo\" ng-click=\"ProfileStep3.removeFile(\'logo\')\"></a></div></div><p class=\"m-t-md\" translate-cloak=\"\">{{\'profile.step3.max_image\' | translate}}</p></div></div></div><div class=\"col-lg-6 col-xs-12 height-equal-child\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary pull-none\" translate-cloak=\"\">{{\'profile.step3.image_contacts\' | translate}}</h5></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': ProfileStep3.loading.image}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div ng-repeat=\"contact in Profile.company.contacts track by $index\"><hr ng-if=\"$index > 0\"><div class=\"text-center\"><p ng-if=\"contact.image.url\"><img alt=\"Imagen del contacto\" ng-src=\"{{contact.image.url}}\" class=\"img-responsive center-block\"></p><p><strong>{{contact.name}} {{contact.surname}}</strong></p><div>{{contact.job_title}} <span ng-if=\"contact.departament && contact.job_title\">/</span> {{contact.departament}}</div></div><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"ProfileStep3.upload($file, \'image\', contact.id, $index)\" ngf-drop=\"ProfileStep3.upload($file, \'image\', contact.id, $index)\" ng-model=\"ProfileStep3.image\" ngf-drop-available=\"true\" ngf-pattern=\"\'.jpeg,.jpg,.png,.bmp,.gif\'\" ngf-max-size=\"10MB\"><h4 class=\"text-center font-bold text-success\" translate-cloak=\"\" translate=\"{{\'profile.step3.drag_drop\'}}\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\"><img alt=\"Imagen a enviar\" ngf-size=\"{height: 80}\" ngf-thumbnail=\"ProfileStep3.image[$index]\" ng-click=\"ProfileStep3.removeFile(\'image\', $index)\" class=\"img-responsive\"></a></div></div><p class=\"m-t-md\" translate-cloak=\"\">{{\'profile.step3.max_image\' | translate}}</p></div></div></div></div></div><p class=\"text-right\"><a ui-sref=\"^.step_four\" class=\"btn btn-primary\" translate-cloak=\"\">{{\'profile.next\' | translate}}</a></p></fieldset>");
$templateCache.put("app/logged/profile/step_two.html","<fieldset class=\"animated fadeIn\"><legend class=\"hidden\">Datos económicos</legend><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step2.verify\' | translate}} (<span ng-if=\"Profile.company.financials[0].year < Profile.year - 1\">{{Profile.company.financials[0].year}}</span><span ng-if=\"Profile.company.financials[0].year >= Profile.year - 1\">{{Profile.company.financials[1].year}}</span>)</h5></div><div class=\"ibox-content form-horizontal\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-5 control-label\">CNAE:</label><div class=\"col-lg-7\"><p class=\"form-control-static\"><span translate-cloak=\"\">{{\'profile.step2.group\' | translate}}</span> {{Profile.company.cnae.group}} / {{Profile.company.cnae.id}} / {{Profile.company.cnae.name}}</p></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-8 control-label\" translate-cloak=\"\">{{\'profile.step2.employees\' | translate}}</label><div class=\"col-lg-4\"><p class=\"form-control-static\"><span ng-if=\"Profile.company.financials[0].year < Profile.year - 1\">{{Profile.company.financials[0].employees}}</span><span ng-if=\"Profile.company.financials[0].year >= Profile.year - 1\">{{Profile.company.financials[1].employees}}</span></p></div></div></div></div><div class=\"row\"><div class=\"col-12 col-md-6\"><div class=\"form-group\"><label class=\"col-lg-5 control-label\" translate-cloak=\"\">{{\'profile.step2.import_export\' | translate}}</label><div class=\"col-lg-7\"><p class=\"form-control-static\">{{Profile.company.import_export}}</p></div></div></div></div><hr><div ng-if=\"Profile.company.financials[0].year < Profile.year - 1\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-8 control-label\" translate-cloak=\"\">{{\'profile.step2.sells\' | translate}}</label><div class=\"col-lg-4\"><p class=\"form-control-static\"><span class=\"text-primary\">{{Profile.company.financials[0].cagr | number : 2}}%</span></p></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-5 control-label\"><span translate-cloak=\"\">{{\'profile.step2.ebitda\' | translate}}</span> {{Profile.company.financials[0].year}}:</label><div class=\"col-lg-7\"><p class=\"form-control-static\"><span class=\"text-primary\">{{Profile.company.financials[0].ebitda * 1000 | number : 2}}€</span></p></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-8 control-label\"><span translate-cloak=\"\">{{\'profile.step2.neto\' | translate}}</span> {{Profile.company.financials[0].year}}:</label><div class=\"col-lg-4\"><p class=\"form-control-static\"><span class=\"text-primary\">{{Profile.company.financials[0].sales | number}}€</span></p></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-5 control-label\" translate-cloak=\"\">{{\'profile.step2.patents\' | translate}}</label><div class=\"col-lg-7\"><p class=\"form-control-static\"><span class=\"text-primary\">{{Profile.company.financials[0].patents | number}}</span></p></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-8 control-label\" translate-cloak=\"\">{{\'profile.step2.roa\' | translate}}</label><div class=\"col-lg-4\"><p class=\"form-control-static\"><span class=\"text-primary\">{{Profile.company.financials[0].roa | number: 2}}%</span></p></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-5 control-label\" translate-cloak=\"\">{{\'profile.step2.foreign\' | translate}}</label><div class=\"col-lg-7\"><p class=\"form-control-static\"><span class=\"text-primary\" ng-if=\"Profile.company.financials[0].foreign_investiments\">{{Profile.company.financials[0].foreign_investiments | number}}</span><span class=\"text-primary\" ng-if=\"!Profile.company.financials[0].foreign_investiments\">0</span></p></div></div></div></div></div><div ng-if=\"Profile.company.financials[0].year >= Profile.year - 1\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-8 control-label\" translate-cloak=\"\">{{\'profile.step2.sells\' | translate}}</label><div class=\"col-lg-4\"><p class=\"form-control-static\"><span class=\"text-primary\">{{Profile.company.financials[1].cagr | number : 2}}%</span></p></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-5 control-label\"><span translate-cloak=\"\">{{\'profile.step2.ebitda\' | translate}}</span> {{Profile.company.financials[1].year}}:</label><div class=\"col-lg-7\"><p class=\"form-control-static\"><span class=\"text-primary\">{{Profile.company.financials[1].ebitda * 1000 | number : 2}}€</span></p></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-8 control-label\"><span translate-cloak=\"\">{{\'profile.step2.neto\' | translate}}</span> {{Profile.company.financials[1].year}}:</label><div class=\"col-lg-4\"><p class=\"form-control-static\"><span class=\"text-primary\">{{Profile.company.financials[1].sales | number}}€</span></p></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-5 control-label\" translate-cloak=\"\">{{\'profile.step2.patents\' | translate}}</label><div class=\"col-lg-7\"><p class=\"form-control-static\"><span class=\"text-primary\">{{Profile.company.financials[1].patents}}</span></p></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-8 control-label\" translate-cloak=\"\">{{\'profile.step2.roa\' | translate}}</label><div class=\"col-lg-4\"><p class=\"form-control-static\"><span class=\"text-primary\">{{Profile.company.financials[1].roa | number: 2}}%</span></p></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-5 control-label\" translate-cloak=\"\">{{\'profile.step2.foreign\' | translate}}</label><div class=\"col-lg-7\"><p class=\"form-control-static\"><span class=\"text-primary\" ng-if=\"Profile.company.financials[1].foreign_investiments\">{{Profile.company.financials[1].foreign_investiments | number}}</span><span class=\"text-primary\" ng-if=\"!Profile.company.financials[1].foreign_investiments\">0</span></p></div></div></div></div></div><hr class=\"mTop0\"><div class=\"row\"><div ng-repeat=\"item in Profile.company.financials\" class=\"col-md-4\"><h4 class=\"text-primary text-center\">{{item.year}}</h4><div class=\"table-responsive\"><table class=\"table table-striped table-hover\"><tr><td translate-cloak=\"\">{{\'profile.step2.development\' | translate}}</td><td class=\"text-right\"><strong class=\"text-primary\"><span ng-if=\"item.development\">{{item.development | number}} €</span></strong><span ng-if=\"!item.development\">-</span></td></tr><tr><td translate-cloak=\"\">{{\'profile.step2.investigation\' | translate}}</td><td class=\"text-right\"><strong class=\"text-primary\"><span ng-if=\"item.investigation\">{{item.investigation | number}} €</span></strong><span ng-if=\"!item.investigation\">-</span></td></tr></table></div></div></div></div></div></div></div><p class=\"text-right\"><a ui-sref=\"^.step_two_b\" class=\"btn btn-primary\" translate-cloak=\"\">{{\'profile.next\' | translate}}</a></p></fieldset>");
$templateCache.put("app/logged/profile/step_two_b.html","<form name=\"ProfileStep2Form\" ng-submit=\"ProfileStep2.update()\" novalidate=\"\"><fieldset class=\"animated fadeIn\"><legend class=\"hidden\">Datos económicos último año</legend><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-primary\" translate-cloak=\"\">{{\'profile.step2b.title\' | translate}} {{Profile.year - 1}}</h5></div><div class=\"ibox-content form-horizontal\" ng-class=\"{\'sk-loading\': ProfileStep2.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><p class=\"m-t-lg m-b-lg text-muted\" translate-cloak=\"\">*** {{ \'general.form.miles_point\' | translate}}</p><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.employees\' | translate}}</label> <input type=\"number\" id=\"employees\" ng-model=\"Profile.company.financials[0].employees\" name=\"employees\" class=\"form-control\" ng-trim=\"true\"></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.sells\' | translate}}</label><div class=\"input-group m-b\"><input type=\"number\" step=\"any\" id=\"cagr\" ng-model=\"Profile.company.financials[0].cagr\" name=\"cagr\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">%</span></div></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.ebitda\' | translate}} x1.000</label><div class=\"input-group m-b\"><input type=\"number\" step=\"any\" id=\"ebitda\" ng-model=\"Profile.company.financials[0].ebitda\" name=\"ebitda\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">€</span></div><p class=\"text-muted\">{{\'profile.step2b.ebitda_help\' | translate}}</p></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.development\' | translate}}</label><div class=\"input-group m-b\"><input type=\"number\" id=\"development\" ng-model=\"Profile.company.financials[0].development\" name=\"development\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">€</span></div></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.foreign\' | translate}}</label> <input type=\"number\" id=\"foreign_investiments\" ng-model=\"Profile.company.financials[0].foreign_investiments\" name=\"foreign_investiments\" class=\"form-control\" ng-trim=\"true\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.neto\' | translate}}</label><div class=\"input-group m-b\"><input type=\"number\" id=\"sales\" ng-model=\"Profile.company.financials[0].sales\" name=\"sales\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">€</span></div></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.roa\' | translate}}</label><div class=\"input-group m-b\"><input type=\"number\" step=\"any\" id=\"roa\" ng-model=\"Profile.company.financials[0].roa\" name=\"roa\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">%</span></div></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.investigation\' | translate}}</label><div class=\"input-group m-b\"><input type=\"number\" id=\"investigation\" ng-model=\"Profile.company.financials[0].investigation\" name=\"investigation\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">€</span></div></div><div class=\"m-t-sm\"><label>{{\'profile.step2b.patents\' | translate}}</label> <input type=\"number\" id=\"patents\" ng-model=\"Profile.company.financials[0].patents\" name=\"patents\" class=\"form-control\" ng-trim=\"true\"></div></div></div></div></div></div></div><p class=\"text-right\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"ProfileStep2.loading || (!Profile.company.financials[0].patents && !Profile.company.financials[0].investigation && !Profile.company.financials[0].roa && !Profile.company.financials[0].sales && !Profile.company.financials[0].foreign_investiments && !Profile.company.financials[0].development && !Profile.company.financials[0].ebitda && !Profile.company.financials[0].cagr && !Profile.company.financials[0].employees)\" translate-cloak=\"\">{{\'profile.step2b.btn\' | translate}}</button></p></fieldset></form>");
$templateCache.put("app/logged/profile/step_two_financials.html","<form name=\"ProfileStep2Form\" ng-submit=\"ProfileStep2Financials.update()\" novalidate=\"\"><fieldset class=\"animated fadeIn\"><legend class=\"hidden\">Datos económicos</legend><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title form-horizontal\"><div class=\"form-group text-left\"><label class=\"col-lg-5 control-label\" translate-cloak=\"\">{{\'profile.step2b.title\' | translate}}:</label><div class=\"col-lg-7\"><select class=\"form-control\" name=\"year_financial\" id=\"year_financial\" ng-change=\"ProfileStep2Financials.updateYear()\" ng-model=\"ProfileStep2Financials.year\" ng-options=\"year for year in ProfileStep2Financials.years\"></select></div></div></div><div class=\"ibox-content form-horizontal\" ng-class=\"{\'sk-loading\': ProfileStep2Financials.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-5 control-label\">CNAE:</label><div class=\"col-lg-7\"><p class=\"form-control-static\"><span translate-cloak=\"\">{{\'profile.step2.group\' | translate}}</span> {{Profile.company.cnae.group}} / {{Profile.company.cnae.id}} / {{Profile.company.cnae.name}}</p></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-5 control-label\" translate-cloak=\"\">{{\'profile.step2.import_export\' | translate}}</label><div class=\"col-lg-7\"><p class=\"form-control-static\">{{Profile.company.import_export}}</p></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><p class=\"m-t-lg m-b-lg text-muted\" translate-cloak=\"\">*** {{ \'general.form.miles_point\' | translate}}</p><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.employees\' | translate}}</label> <input type=\"number\" id=\"employees\" step=\"0.01\" ng-model=\"ProfileStep2Financials.financialsNew.employees\" name=\"employees\" class=\"form-control\" ng-trim=\"true\"></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.sells\' | translate}}</label><div class=\"input-group m-b\"><input type=\"number\" step=\"0.01\" id=\"cagr\" ng-model=\"ProfileStep2Financials.financialsNew.cagr\" name=\"cagr\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">%</span></div></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.ebitda\' | translate}}</label><div class=\"input-group m-b\"><input type=\"number\" step=\"0.01\" id=\"ebitda\" ng-model=\"ProfileStep2Financials.financialsNew.ebitda\" name=\"ebitda\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">€</span></div></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.development\' | translate}}</label><div class=\"input-group m-b\"><input type=\"number\" id=\"development\" step=\"0.01\" ng-model=\"ProfileStep2Financials.financialsNew.development\" name=\"development\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">€</span></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.neto\' | translate}}</label><div class=\"input-group m-b\"><input type=\"number\" step=\"0.01\" id=\"sales\" ng-model=\"ProfileStep2Financials.financialsNew.sales\" name=\"sales\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">€</span></div></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.roa\' | translate}}</label><div class=\"input-group m-b\"><input type=\"number\" step=\"0.01\" id=\"roa\" ng-model=\"ProfileStep2Financials.financialsNew.roa\" name=\"roa\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">%</span></div></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.investigation\' | translate}}</label><div class=\"input-group m-b\"><input type=\"number\" step=\"0.01\" id=\"investigation\" ng-model=\"ProfileStep2Financials.financialsNew.investigation\" name=\"investigation\" class=\"form-control\" ng-trim=\"true\"><span class=\"input-group-addon\">€</span></div></div><div class=\"m-t-sm\"><label translate-cloak=\"\">{{\'profile.step2b.foreign\' | translate}}</label> <input type=\"number\" id=\"foreign_investiments\" step=\"0.01\" ng-model=\"ProfileStep2Financials.financialsNew.foreign_investiments\" name=\"foreign_investiments\" class=\"form-control\" ng-trim=\"true\"></div><div class=\"m-t-sm\"><label>{{\'profile.step2b.patents\' | translate}}</label> <input type=\"number\" id=\"patents\" step=\"0.01\" ng-model=\"ProfileStep2Financials.financialsNew.patents\" name=\"patents\" class=\"form-control\" ng-trim=\"true\"></div></div></div></div></div></div></div><p class=\"text-right\"><button type=\"submit\" ng-disabled=\"ProfileStep2Financials.loading || ( !ProfileStep2Financials.loading && !ProfileStep2Financials.financialsNew.patents && !ProfileStep2Financials.financialsNew.investigation && !ProfileStep2Financials.financialsNew.roa && !ProfileStep2Financials.financialsNew.sales && !ProfileStep2Financials.financialsNew.foreign_investiments && !ProfileStep2Financials.financialsNew.development && !ProfileStep2Financials.financialsNew.ebitda && !ProfileStep2Financials.financialsNew.cagr && !ProfileStep2Financials.financialsNew.employees)\" class=\"btn btn-primary\" translate-cloak=\"\">{{\'profile.step2b.btn\' | translate}} {{ProfileStep2Financials.year}}</button> <a class=\"btn btn-outline btn-primary\" ui-sref=\"^.step_three\" translate-cloak=\"\">{{\'profile.next\' | translate}}</a></p></fieldset></form>");
$templateCache.put("app/logged/shop/edit.html","<div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\" translate-cloak=\"\">{{\'shop.edit.title\' | translate}}</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': ShopEdit.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><form name=\"productForm\" ng-submit=\"ShopEdit.submit(productForm)\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': (productForm.title.$dirty || productForm.$submitted) && productForm.title.$invalid}\"><label class=\"control-label text-success\" translate-cloak=\"\">{{\'shop.edit.product\' | translate}}</label><div class=\"\"><input type=\"text\" name=\"title\" ng-model=\"ShopEdit.product.title\" class=\"form-control\" required=\"\"></div><p ng-show=\"(productForm.title.$dirty || productForm.$submitted) && productForm.title.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (productForm.price.$dirty || productForm.$submitted) && productForm.price.$invalid}\"><label class=\"control-label text-success\" translate-cloak=\"\">{{\'shop.edit.price\' | translate}}</label><div class=\"\"><input type=\"number\" name=\"price\" ng-model=\"ShopEdit.product.price\" class=\"form-control\"></div><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.miles_point\' | translate}}</p><p ng-show=\"(productForm.price.$dirty || productForm.$submitted) && productForm.price.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</p></div><div class=\"form-check form-check-inline\"><label class=\"form-check-label\"><input type=\"radio\" name=\"type\" ng-model=\"ShopEdit.product.type\" value=\"direct\" class=\"form-check-input\"> Compra directa</label></div><div class=\"form-check form-check-inline\"><label class=\"form-check-label\"><input type=\"radio\" name=\"type\" ng-model=\"ShopEdit.product.type\" value=\"redirect\" class=\"form-check-input\"> Compra externa</label></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (productForm.description.$dirty || productForm.$submitted) && productForm.description.$invalid}\"><label class=\"control-label text-success\" translate-cloak=\"\">{{\'shop.edit.description\' | translate}}</label><div class=\"form-group-summernote\"><summernote on-paste=\"ShopEdit.pasteSummernote()\" ng-if=\"ShopEdit.config\" name=\"description\" id=\"description\" config=\"ShopEdit.config\" ng-model=\"ShopEdit.product.description\" required=\"\"></summernote></div><p ng-show=\"(productForm.description.$dirty || productForm.$submitted) && productForm.description.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</p></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (productForm.url.$dirty || productForm.$submitted) && productForm.url.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'shop.edit.link\' | translate}} <span ng-if=\"ShopEdit.product.type == \'redirect\'\">*</span></label><div class=\"\"><input type=\"url\" name=\"url\" ng-model=\"ShopEdit.product.url\" class=\"form-control\" ng-required=\"ShopEdit.product.type == \'redirect\'\"></div><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.url_valid\' | translate}}</p><p ng-show=\"(productForm.url.$dirty || productForm.$submitted) && productForm.url.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</p></div><hr><label class=\"control-label\" translate-cloak=\"\">{{\'shop.edit.image\' | translate}}</label><div class=\"m-b-md\" ng-if=\"ShopEdit.copyFile\"><img alt=\"Imagen anterior\" ng-src=\"{{ShopEdit.copyFile}}\" class=\"img-responsive max-h-80\"></div><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"\" name=\"image\" ngf-keep=\"false\" ngf-drop=\"\" ng-model=\"ShopEdit.product.image\" ngf-pattern=\"\'.jpeg,.jpg,.png,.bmp,.gif\'\" ngf-multiple=\"false\" ngf-max-files=\"1\" ngf-max-size=\"10MB\" ngf-drop-available=\"true\"><h4 class=\"text-center font-bold text-success\" translate=\"shop.edit.drag_drop\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\" ng-click=\"ShopEdit.removeFile()\"><img alt=\"Imagen a enviar\" ngf-size=\"{height: 80}\" ngf-thumbnail=\"ShopEdit.product.image\"></a></div></div><p class=\"m-t-sm\" translate-cloak=\"\">{{\'shop.edit.image_help\' | translate}}</p><p ng-show=\"(productForm.image.$dirty || productForm.$submitted) && productForm.image.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'shop.review\' | translate}}</p><hr><div class=\"form-group\"><input type=\"checkbox\" ng-true-value=\"\'active\'\" ng-false-value=\"\'inactive\'\" ng-model=\"ShopEdit.product.status\"> <strong translate-cloak=\"\">{{\'shop.edit.active\' | translate}}</strong></div><div class=\"m-t-md\"><button class=\"btn btn-success\" translate-cloak=\"\">{{\'shop.edit.send\' | translate}}</button></div></form></div></div>");
$templateCache.put("app/logged/shop/product.html","<div class=\"ibox\"><div class=\"ibox-content\"><div class=\"m-b-sm\" ng-show=\"product.files.real_path\"><a href=\"javascript:void(0);\" ui-sref=\".({id:product.id})\"><img alt=\"Imagen del producto/servicio\" ng-src=\"{{product.files.real_path}}\" class=\"img-responsive max-h-200 center-block\"></a></div><h3><a href=\"javascript:void(0);\" ng-if=\"product.type != \'redirect\'\" ui-sref=\".({id:product.id})\"><strong class=\"text-success\"></strong>{{product.title}}</a> <a ng-href=\"{{product.url}}\" ng-if=\"product.type == \'redirect\'\" target=\"_blank\"><strong class=\"text-success\"></strong>{{product.title}}</a></h3><h4 class=\"m-t-md\"><span class=\"bg-primary p-xxs\">{{product.price | number}}€</span> <a href=\"javascript:void(0);\" ui-sref=\".({id:product.id})\" class=\"btn btn-outline btn-success btn-sm\" ng-if=\"product.type != \'redirect\'\" ng-disabled=\"product.status != \'active\'\"><em class=\"fa fa-shopping-cart\"></em></a> <a ng-href=\"{{product.url}}\" target=\"_blank\" class=\"btn btn-outline btn-success btn-sm\" ng-if=\"product.type == \'redirect\'\" ng-disabled=\"product.status != \'active\'\"><em class=\"fa fa-shopping-cart\"></em></a></h4><div ng-bind-html=\"product.description | filter:limitCaracters:70\"></div><hr><div class=\"clearfix\"><div class=\"pull-left\" ng-if=\"product.url && product.url !== \'null\'\"><a ng-href=\"{{product.url}}\" target=\"_blank\" translate-cloak=\"\">{{\'shop.gotoweb\' | translate}}</a></div><div class=\"pull-right\" am-time-ago=\"{{product.updated_at.date | amUtc | amLocal}}\"></div></div><div class=\"m-t-md\"><a ng-if=\"myUser.group == \'superadmin\'\" class=\"btn btn-block btn-success btn-outline\" href=\"javascript:void(0);\" ui-sref=\".edit({id:product.id})\" translate-cloak=\"\">{{\'shop.btn.edit\' | translate}}</a></div><a ng-if=\"myUser.group == \'superadmin\'\" class=\"m-t-sm btn btn-block btn-danger btn-outline\" href=\"javascript:void(0);\" ng-click=\"Shop.removeProduct(product.id)\" translate-cloak=\"\">{{\'shop.btn.delete\' | translate}}</a></div></div>");
$templateCache.put("app/logged/shop/product_publication.html","<div class=\"ibox\"><div class=\"ibox-content\"><div class=\"m-b-sm\" ng-show=\"product.image.real_path\"><a href=\"javascript:void(0);\" ui-sref=\".({id:product.id})\"><img alt=\"Imagen del producto/servicio\" ng-src=\"{{product.image.real_path}}\" class=\"img-responsive max-h-200 center-block\"></a></div><h3><a href=\"javascript:void(0);\" ng-if=\"product.type != \'redirect\'\" ui-sref=\".({id:product.id})\"><strong class=\"text-success\"></strong>{{product.title}}</a> <a ng-href=\"{{product.url}}\" ng-if=\"product.type == \'redirect\'\" target=\"_blank\"><strong class=\"text-success\"></strong>{{product.title}}</a></h3><h4 class=\"m-t-md\"><span class=\"bg-primary p-xxs\">{{product.price | number}}€</span> <a href=\"javascript:void(0);\" ui-sref=\".({id:product.id})\" class=\"btn btn-outline btn-success btn-sm\" ng-if=\"product.type != \'redirect\'\" ng-disabled=\"product.status != \'active\'\"><em class=\"fa fa-shopping-cart\"></em></a> <a ng-href=\"{{product.url}}\" target=\"_blank\" class=\"btn btn-outline btn-success btn-sm\" ng-if=\"product.type == \'redirect\'\" ng-disabled=\"product.status != \'active\'\"><em class=\"fa fa-shopping-cart\"></em></a></h4><div ng-bind-html=\"product.description | filter:limitCaracters:70\"></div><hr><div class=\"clearfix\"><div class=\"pull-left\" ng-if=\"product.url && product.url !== \'null\'\"><a ng-href=\"{{product.url}}\" target=\"_blank\" translate-cloak=\"\">{{\'shop.gotoweb\' | translate}}</a></div><div class=\"pull-right\" am-time-ago=\"{{product.updated_at.date | amUtc | amLocal}}\"></div></div><div class=\"m-t-md\"><a ng-if=\"myUser.group == \'superadmin\'\" class=\"btn btn-block btn-success btn-outline\" href=\"javascript:void(0);\" ui-sref=\".edit({id:product.id})\" translate-cloak=\"\">{{\'shop.btn.edit\' | translate}}</a></div><a ng-if=\"myUser.group == \'superadmin\'\" class=\"m-t-sm btn btn-block btn-danger btn-outline\" href=\"javascript:void(0);\" ng-click=\"Shop.removeProduct(product.id)\" translate-cloak=\"\">{{\'shop.btn.delete\' | translate}}</a></div></div>");
$templateCache.put("app/logged/shop/shop.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"m-b-md\" ng-if=\"myUser.group == \'superadmin\' || myUser.group == \'admin\'\"><a href=\"javascript:void(0);\" ui-sref=\".edit\" class=\"btn btn-success\" translate-cloak=\"\">{{\'shop.btn.add\' | translate}}</a></div><div ui-view=\"\"></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"ibox\" ng-if=\"Shop.product\"><div class=\"ibox-title\"><h1 class=\"text-success\">{{Shop.product.title}}</h1></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Shop.loadingProduct}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"m-b-lg\" ng-if=\"Shop.product.image\"><img alt=\"Imagen del producto/servicio\" ng-src=\"{{Shop.product.image.real_path}}\" class=\"img-responsive max-h-250\"></div><h2 class=\"m-t-lg\"><span class=\"bg-primary p-xxs\">{{Shop.product.price| number}}€</span></h2><div class=\"m-t-lg\" ng-bind-html=\"Shop.product.description\"></div><hr><div class=\"m-b-lg\" ng-if=\"Shop.product.url && Shop.product.url !== \'null\'\"><span translate-cloak=\"\">{{\'shop.url_info\' | translate}}</span><a href=\"javascript:void(0);\" ng-href=\"{{Shop.product.url}}\" target=\"_blank\">{{Shop.product.url}}</a></div><form ng-if=\"Shop.product.type !== \'redirect\'\" class=\"form-inline advertiser-form-pay\" ng-submit=\"Shop.payment(Shop.product.id)\" novalidate=\"\"><div ng-show=\"!myUser.company.customer_id\" class=\"form-group\" style=\"width: 100%;\"><p><strong>Datos tarjeta:</strong></p><div id=\"card-element-{{Shop.product.id}}\" style=\"background: #eee; padding: 1rem 0.5rem; margin-bottom: 2rem;\"></div></div><div class=\"block\"><div class=\"alert\" ng-if=\"Shop.paymentResult.code\" ng-class=\"{\'alert-danger\': Shop.paymentResult.code === -1, \'alert-success\': Shop.paymentResult.code === 1}\">{{Shop.paymentResult.message}}</div><button type=\"submit\" class=\"btn btn-success btn-lg\" ng-disabled=\"Shop.loading || (Shop.product.status !== \'active\')\"><em class=\"fa fa-shopping-cart\"></em> <span translate-cloak=\"\">{{\'shop.btn.buy\' | translate}}</span></button></div></form><a ng-href=\"{{Shop.product.url}}\" ng-if=\"Shop.product.type == \'redirect\'\" target=\"_blank\" class=\"btn btn-success btn-lg\" ng-disabled=\"(Shop.product.status !== \'active\')\"><em class=\"fa fa-shopping-cart\"></em> <span translate-cloak=\"\">{{\'shop.btn.buy\' | translate}}</span></a><div class=\"m-t-md\"><a ng-if=\"myUser.group == \'superadmin\' || myUser.group == \'admin\'\" class=\"btn btn-block btn-success btn-outline\" href=\"javascript:void(0);\" ui-sref=\".edit({id:Shop.product.id})\" translate-cloak=\"\">{{\'shop.btn.edit\' | translate}}</a> <a ng-if=\"myUser.group == \'superadmin\' || myUser.group == \'admin\'\" class=\"btn btn-block btn-danger btn-outline\" href=\"javascript:void(0);\" ng-click=\"Shop.removeProduct(product.id)\" translate-cloak=\"\">{{\'shop.btn.delete\' | translate}}</a></div></div></div></div></div></div><div class=\"m-b-md\"><div class=\"sk-spinner sk-spinner-double-bounce\" ng-if=\"Shop.loading\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"row\"><div class=\"col-12 col-sm-6 col-md-4\" ng-repeat=\"product in Shop.publication track by $index\"><div ng-include=\"\'app/logged/shop/product_publication.html\'\"></div></div></div><div masonry=\"{ gutter: 25 }\" load-images=\"true\" preserve-order=\"\" column-width=\"330\" masonry-options=\'{\"isFitWidth\": true}\' reload-on-show=\"\" reload-on-resize=\"\"><div class=\"masonry-brick\" ng-repeat=\"product in Shop.products.data track by $index\"><div ng-if=\"product.files.real_path\" ng-include=\"\'app/logged/shop/product.html\'\"></div></div></div></div><div class=\"m-t-md m-b-md text-center\" ng-if=\"Shop.available\"><button ng-disabled=\"Shop.loading\" ng-click=\"Shop.getList();\" class=\"btn btn-primary\"><em ng-show=\"Shop.loading\" class=\"fa fa-spinner fa-spin\"></em> <span translate-cloak=\"\">{{\'shop.btn.more\' | translate}}</span></button></div>");
$templateCache.put("app/logged/startups/startups.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox\"><div class=\"ibox-content clearfix\"><div class=\"pull-right\"><form name=\"StartupFormSearch\" class=\"form-inline\" ng-submit=\"Startups.getList()\"><div class=\"form-group m-r-sm\"><input type=\"text\" class=\"form-control\" name=\"q\" id=\"q\" placeholder=\"{{\'startups.search\' | translate}}...\" ng-model=\"Startups.params.q\"></div><div class=\"form-group m-r-sm\"><input type=\"text\" class=\"form-control\" name=\"sector\" id=\"sector\" placeholder=\"{{\'startups.search_sector\' | translate}}...\" ng-model=\"Startups.params.sector\"></div><div class=\"form-group m-t-xs m-r-sm\"><input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"Startups.params.favourite\" name=\"default\"> <span translate-cloak=\"\">{{ \'startups.favourite\' | translate}}</span></div><button type=\"submit\" class=\"btn btn-success\" translate-cloak=\"\">{{\'startups.search\' | translate}}</button></form></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\" translate-cloak=\"\">{{\'startups.title\' | translate}}</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Startups.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div ng-if=\"!Startups.startups.length && !Startups.loading\" translate-cloak=\"\">{{\'startups.no_results\' | translate}}</div><div class=\"table-responsive\" ng-if=\"Startups.startups.length\"><table class=\"table table-striped table-hover\" width=\"100%\"><thead><th width=\"50\" translate-cloak=\"\">{{\'startups.logo\' | translate}}</th><th translate-cloak=\"\">{{\'startups.name\' | translate}}</th><th translate-cloak=\"\">{{\'startups.sector\' | translate}}</th><th translate-cloak=\"\">{{\'startups.date\' | translate}}</th><th translate-cloak=\"\">{{\'startups.web\' | translate}}</th><th translate-cloak=\"\">{{\'startups.presentation\' | translate}}</th><th>{{\'startups.favourite\' | translate}}</th><th ng-if=\"myUser.group == \'superadmin\'\">{{\'startups.remove\' | translate}}</th><th></th></thead><tbody><tr ng-repeat=\"startup in Startups.startups track by $index\"><td><img alt=\"Logo StartUp\" ng-src=\"{{startup.logo}}\" class=\"img-responsive\"></td><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"12\" data=\"startup\">{{startup.title}}</a></td><td>{{startup.sector}}</td><td><span am-time-ago=\"startup.created_at\"></span></td><td><a ng-href=\"{{startup.web}}\" target=\"_blank\"><em class=\"fa fa-link\"></em></a></td><td><a ng-href=\"{{startup.link_presentation}}\" target=\"_blank\"><em class=\"fa fa-rocket\"></em></a></td><td><a href=\"javascript:void(0);\" ng-click=\"Startups.favourite($index, startup.id, startup.isFavourite)\"><em class=\"fa fa-refresh text-success\" ng-if=\"Startups.loading_favourite\"></em> <em class=\"fa fa-check\" ng-class=\"{\'text-muted\': !startup.isFavourite, \'text-success\': startup.isFavourite}\" title=\"{{\'startups.tooltip.add_remove\' | translate}}\"></em></a></td><td ng-if=\"myUser.group == \'superadmin\'\"><a href=\"javascript:void(0);\" ng-click=\"Startups.remove($index, startup.id)\"><em class=\"fa fa-refresh text-success\" ng-if=\"Startups.loading_remove\"></em> <em class=\"fa fa-close\"></em></a></td><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"12\" data=\"startup\"><em class=\"fa fa-share\" title=\"{{\'startups.tooltip.view\' | translate}}\"></em></a></td></tr></tbody></table></div><div class=\"clearfix m-r-md\"><div class=\"pull-right\"><uib-pagination total-items=\"Startups.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"Startups.getList()\" ng-model=\"Startups.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"20\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/logged/stats/stats.html","<div class=\"wrapper wrapper-content animated fadeInRight statsPage\"><div class=\"ibox\"><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Stats.loadingActions || Stats.loadingRoutes}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><form name=\"statsFrom\" ng-submit=\"Stats.getStats(false, true)\"><div class=\"form-group m-r-sm\"><chosen-companies selected-company=\"Stats.selectedCompanyId\" on-company-change=\"Stats.handleCompanySelection(companyId, company)\"></chosen-companies></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" id=\"from\" ng-class=\"{\'has-error\': (statsFrom.from.$dirty || statsFrom.$submitted) && statsFrom.from.$invalid}\"><label class=\"font-normal\" translate-cloak=\"\">Desde:</label><div class=\"input-group date\"><input type=\"datetime\" class=\"form-control\" name=\"from\" date-time=\"\" ng-model=\"Stats.params.from\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"YYYY-MM-DD\" required=\"\"> <span class=\"input-group-addon\"><em class=\"fa fa-calendar\"></em></span></div></div><p ng-show=\"(statsFrom.from.$dirty || statsFrom.$submitted) && statsFrom.from.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">Revisa este campo</p></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" id=\"to\" ng-class=\"{\'has-error\': (statsFrom.to.$dirty || statsFrom.$submitted) && statsFrom.to.$invalid}\"><label class=\"font-normal\" translate-cloak=\"\">Hasta:</label><div class=\"input-group date\"><input type=\"datetime\" class=\"form-control\" name=\"to\" date-time=\"\" ng-model=\"Stats.params.to\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"YYYY-MM-DD\" required=\"\"> <span class=\"input-group-addon\"><em class=\"fa fa-calendar\"></em></span></div></div><p ng-show=\"(statsFrom.to.$dirty || statsFrom.$submitted) && statsFrom.to.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">Revisa este campo</p></div></div><div class=\"text-right\"><button type=\"submit\" class=\"btn btn-success\">Filtrar</button></div></form><hr><div class=\"text-right\"><div><button type=\"button\" ng-click=\"Stats.exportExcel()\" class=\"btn btn-outline btn-success\">Generar excel</button></div><div class=\"m-t-lg\" ng-if=\"Stats.linkExport\"><a ng-href=\"{{Stats.linkExport}}\" class=\"btn btn-block btn-info\" target=\"_blank\">Descarga el excel pinchando aquí</a></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><span class=\"label label-primary pull-right\">Total</span><h5>Páginas vistas</h5></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Stats.loadingRoutes}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><h1 class=\"no-margins text-right text-success\"><strong>{{Stats.total.routes | number}}</strong></h1></div></div><div class=\"ibox\" id=\"routesList\"><div class=\"ibox-title\"><h5 class=\"text-success\">Páginas</h5></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Stats.loadingRoutes}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><canvas ng-show=\"Stats.labels.routes.length && Stats.data.routes.length\" id=\"line\" class=\"chart chart-line\" chart-data=\"Stats.data.routes\" chart-labels=\"Stats.labels.routes\" chart-click=\"Stats.onClick\"></canvas><hr><div class=\"table-responsive\"><table width=\"100%\" class=\"table table-striped table-hover\"><thead><tr><th style=\"width:20%;\">Día</th><th style=\"\">Empresas</th><th>Página vista</th><th class=\"text-right\">Total</th></tr></thead><tbody><tr ng-repeat=\"route in Stats.routes track by $index\"><td>{{route.day | date: \'dd-MM-yyyy\'}}</td><td class=\"no-ellipsis\"><a href=\"javascript:void(0);\" ng-repeat=\"company in route.companies track by $index\" link-sidebar=\"\" type=\"1\" id=\"{{company.id}}\"><span ng-if=\"$index > 0\">|</span>{{company.name}}</a></td><td>{{route.route}}</td><td class=\"text-right\">{{route.total | number}}</td></tr></tbody></table></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><span class=\"label label-primary pull-right\">Total</span><h5>Empresas con nota de prensa</h5></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Stats.loadingNotices}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><h1 class=\"no-margins text-success text-right\"><strong>{{Stats.notices.length}}</strong></h1></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\">Listado</h5><div class=\"ibox-tools\"><div class=\"input-group text-right\"><input type=\"text\" ng-model=\"nameNotice\" placeholder=\"Buscar...\" class=\"form-control input-sm pull-right w150 p-xxs\" aria-invalid=\"false\" style=\"\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-xs btn-primary\"><em class=\"text-primary fa fa-search\"></em></button></span></div></div></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Stats.loadingNotices}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"table-responsive\"><table width=\"100%\" class=\"table table-striped table-hover\"><thead><tr><th style=\"width:20%;\">Último día</th><th>Empresa</th></tr></thead><tbody><tr ng-repeat=\"notice in Stats.notices | filter: nameNotice track by $index\"><td>{{notice.date_published | date: \'dd-MM-yyyy\'}}</td><td><a href=\"javascript:void(0);\" ng-click=\"Stats.getStats(1, false, notice.id)\">{{notice.name}}</a></td></tr></tbody></table></div></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"ibox\"><div class=\"ibox-title\"><span class=\"label label-primary pull-right\">Total</span><h5>Acciones finalizadas</h5></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Stats.loadingActions}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><h1 class=\"no-margins text-success text-right\"><strong>{{Stats.total.actions}}</strong></h1></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\">Acciones</h5></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Stats.loadingActions}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><canvas ng-show=\"Stats.labels.actions.length && Stats.data.actions.length\" id=\"line\" class=\"chart chart-line\" chart-data=\"Stats.data.actions\" chart-labels=\"Stats.labels.actions\" chart-click=\"Stats.onClick\"></canvas><hr><div class=\"table-responsive\"><table width=\"100%\" class=\"table table-striped table-hover\"><thead><tr><th style=\"width:20%;\">Día</th><th>Acción</th><th class=\"text-right\">Usuarios</th><th class=\"text-right\">Total</th></tr></thead><tbody><tr ng-repeat=\"action in Stats.actions track by $index\"><td>{{action.date | date: \'dd-MM-yyyy\'}}</td><td>{{action.action}}</td><td class=\"text-right\">{{action.users}}</td><td class=\"text-right\">{{action.total | number}}</td></tr></tbody></table></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><span class=\"label label-primary pull-right\">Total</span><h5>Empresas que accedieron</h5></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Stats.loadingAccess}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><h1 class=\"no-margins text-success text-right\"><strong>{{Stats.access.length}}</strong></h1></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\">Listado</h5><div class=\"ibox-tools\"><div class=\"input-group text-right\"><input type=\"text\" ng-model=\"name\" placeholder=\"Buscar...\" class=\"form-control input-sm pull-right w150 p-xxs\" aria-invalid=\"false\" style=\"\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-xs btn-primary\"><em class=\"text-primary fa fa-search\"></em></button></span></div></div></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Stats.loadingAccess}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"table-responsive\"><table width=\"100%\" class=\"table table-striped table-hover\"><thead><tr><th style=\"width:20%;\">Último día</th><th>Empresa</th></tr></thead><tbody><tr ng-repeat=\"access in Stats.access | filter: name track by $index\"><td>{{access.last_access | date: \'dd-MM-yyyy\'}}</td><td><a href=\"javascript:void(0);\" ng-click=\"Stats.getStats(1, false, access.id)\">{{access.name}}</a></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/logged/users/users.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\" translate-cloak=\"\">{{\'users.title\' | translate}}</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Users.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"m-t-sm bg-muted p-sm clearfix\"><form class=\"form-inline pull-right\"><div class=\"form-group m-r-sm\"><chosen-companies selected-company=\"Users.selectedCompanyId\" on-company-change=\"Users.handleCompanySelection(companyId, company)\"></chosen-companies></div><div class=\"form-group m-r-sm\"><select class=\"form-control\" chosen=\"\" name=\"status\" id=\"status\" data-placeholder-text-single=\"\'{{\'general.chosen.status\' | translate}}\'\" allow-single-deselect=\"true\" ng-model=\"Users.params.status\" ng-options=\"status.value as status.name for status in Users.selectStatus\"><option value=\"\"></option></select></div><button type=\"button\" class=\"btn btn-primary\" ng-click=\"Users.filter()\" translate-cloak=\"\">{{\'users.btn.filter\' | translate}}</button></form></div><hr class=\"hr-line-dashed\"><div class=\"table-responsive\" ng-if=\"Users.users.length\"><table class=\"table table-striped table-hover\" width=\"100%\"><thead><tr><th width=\"55\"></th><th translate-cloak=\"\">{{\'users.name\' | translate}}</th><th translate-cloak=\"\">{{\'users.email\' | translate}}</th><th translate-cloak=\"\">{{\'users.phone\' | translate}}</th><th translate-cloak=\"\">{{\'users.company\' | translate}}</th><th translate-cloak=\"\">{{\'users.position\' | translate}}</th><th translate-cloak=\"\">{{\'users.province\' | translate}}</th><th class=\"text-center\">{{\'users.state\' | translate}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in Users.users track by $index\" ng-class=\"{\'tr-danger\': user.status == 2, \'tr-inactive\': !user.status}\"><td><img alt=\"Imagen del contacto\" ng-if=\"(user.contact.name + \' \' + user.contact.surname == user.name) && user.contact.image.url\" ng-src=\"{{user.contact.image.url}}\" class=\"img-circle block-center img-responsive\"></td><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"2\" id=\"{{user.contact.id}}\">{{user.name}}</a> <sup ng-if=\"user.contact.default && (user.contact.name + \' \' + user.contact.surname == user.name)\" class=\"text-success fa fa-check-circle\"></sup></td><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"4\" id=\"{{user.company.id}}\">{{user.email}}</a></td><td><span ng-if=\"user.conact.phone_number\"></span><span ng-if=\"!user.conact.phone_number\">{{user.company.principal_address.phone_number}}</span></td><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"1\" data=\"user.company\">{{user.company.name}}</a></td><td>{{user.contact.job_title}}</td><td>{{user.company.principal_address.province.name}}</td><td class=\"text-center\"><span tooltip-placement=\"top\" ng-class=\"{\'badge badge-primary\': user.status == 1, \'badge badge-danger\': user.status == 2, \'badge\': !user.status}\"></span></td><td width=\"50\"><a ng-if=\"user.status == 1\" href=\"javascript:void(0);\" ng-click=\"Users.changeStatus(true, user.id, $index)\" title=\"{{\'users.tooltip.remove\' | translate}}\"><em class=\"fa fa-close\"></em></a> <a ng-if=\"user.status != 1\" href=\"javascript:void(0);\" ng-click=\"Users.changeStatus(false, user.id, $index)\" title=\"{{\'users.tooltip.activate\' | translate}}\"><em class=\"fa fa-check\"></em></a> <a href=\"javascript:void(0);\" ui-sref=\"^.profile.step_five({id: user.company.id})\" title=\"{{\'users.tooltip.edit\' | translate}}\"><em class=\"fa fa-pencil\"></em></a></td></tr></tbody></table></div><div class=\"clearfix m-r-md\"><div class=\"pull-right\"><uib-pagination total-items=\"Users.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"Users.filter()\" ng-model=\"Users.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"20\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/logged/world.pact/worldpact.feedback.html","<div class=\"col-12 col-md-3 col-md-offset-1\"><img src=\"https://empresaseuskadi2030.webintra.net/pix/k_app/badge_congrats_big.png\" class=\"img-responsive\"></div><div class=\"col-12 col-md-6 col-md-offset-1 text-center\" ng-if=\"WorldPact.showFeedback\"><h2 class=\"text-success\">{{\'worldpact.feedback.good.title\' | translate}}</h2><h4>{{\'worldpact.feedback.good.description\' | translate}}</h4><form name=\"FeedbackForm\" ng-submit=\"WorldPact.sendFeedback(content.id, FeedbackForm);\" novalidate=\"\"><div class=\"form-group\"><star-rating rating-value=\"WorldPact.feedback.stars\" no-update=\"false\" data-max=\"5\" class=\"rating\"></star-rating></div><div class=\"form-group\" ng-class=\"{\'has-error\': (FeedbackForm.feedback.$dirty || FeedbackForm.$submitted) && FeedbackForm.feedback.$invalid}\"><textarea name=\"feedback\" ng-model=\"WorldPact.feedback.feedback\" rows=\"5\" class=\"form-control\" placeholder=\"Danos feedback\" required=\"\"></textarea><p ng-show=\"(FeedbackForm.feedback.$dirty || FeedbackForm.$submitted) && FeedbackForm.feedback.$invalid\" class=\"help-block text-danger\">{{\'worldpact.feedback.reviewfield\' | translate}}</p></div><button class=\"btn btn-success\" type=\"submit\">Yeah!</button></form></div><div class=\"col-12 col-md-6 col-md-offset-1 text-center\" ng-if=\"!WorldPact.showFeedback\"><h3 class=\"text-center m-t-md\">{{ \'worldpact.feedback.notfinalized\' | translate}}</h3></div>");
$templateCache.put("app/logged/world.pact/worldpact.html","<div class=\"wrapper wrapper-content animated fadeInRight world-pack\"><div class=\"ibox\" ng-if=\"$state.current.name === \'app.logged.worldpact\'\"><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': WorldPact.loadingPrevModule}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"row module-select\"><div class=\"col-xs-{{12/WorldPact.modulesPrev.length}}\" ng-class=\"{\'text-right\': $index + 1 === WorldPact.modulesPrev.length, \'text-center\': $index > 0 && $index + 1 < WorldPact.modulesPrev.length}\" ng-repeat=\"modulesPrev in WorldPact.modulesPrev\" ng-if=\"WorldPact.modulesPrev\"><button type=\"button\" ng-class=\"{\'btn-outline\': WorldPact.moduleSelected == ($index + 1)}\" ng-click=\"WorldPact.changeModulePrev($index);\" class=\"btn btn-circle btn-success btn-sm\" tooltip-placement=\"bottom\" uib-tooltip=\"{{::modulesPrev.title}}\">{{$index + 1}}</button></div></div><div class=\"progress m-b-xs m-t-sm\" value=\"{{WorldPact.course.progress}}\" style=\"height: 5px\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{WorldPact.course.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\': WorldPact.course.progress + \'%\'}\" style=\"height:5px;\" aria-labelledby=\"progressbar\"></div></div><div class=\"m-b-sm text-muted\"><small>{{\'worldpact.progress.course\' | translate}} {{WorldPact.course.progress}}%</small></div><div class=\"row\" ng-if=\"WorldPact.module\"><div class=\"col-12 col-md-10\"><strong>{{WorldPact.module.title}}</strong> | <span class=\"text-muted\">{{\'worldpact.progress.module\' | translate}}: {{WorldPact.module.progress}}%</span><br>{{WorldPact.module.description}}</div><div class=\"col-12 col-md-2 text-right\" ng-if=\"WorldPact.module.available\"><button type=\"button\" class=\"btn btn-success btn-sm\" ng-if=\"WorldPact.moduleSelected === ($index + 1)\" ng-click=\"WorldPact.startCourse()\"><span ng-if=\"WorldPact.module.progress == 100\">{{\'worldpact.module.finalized\' | translate}}</span> <span ng-if=\"WorldPact.module.progress == 0\">{{\'worldpact.module.init\' | translate}}</span> <span ng-if=\"WorldPact.module.progress < 100 && WorldPact.module.progress > 0\">{{\'worldpact.module.continue\' | translate}}</span></button> <a class=\"btn btn-success btn-sm\" ng-if=\"WorldPact.moduleSelected > ($index + 1)\" ui-sref=\"^.worldpact.module({id: WorldPact.moduleSelected})\"><span ng-if=\"WorldPact.module.progress == 100\">{{\'worldpact.module.finalized\' | translate}}</span> <span ng-if=\"WorldPact.module.progress == 0\">{{\'worldpact.module.init\' | translate}}</span> <span ng-if=\"WorldPact.module.progress < 100 && WorldPact.module.progress > 0\">{{\'worldpact.module.continue\' | translate}}</span></a></div></div><div class=\"text-right\" ng-if=\"!WorldPact.module\"><button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"WorldPact.startCourse();\">{{\'worldpact.module.init.first\' | translate}}</button></div></div></div><div class=\"ibox\" ng-if=\"$state.current.name !== \'app.logged.worldpact\'\"><div class=\"text-right m-b-sm\"><a ui-sref=\"^.worldpact\">{{\'worldpact.comeback\' | translate}} <em class=\"fa fa-close\"></em></a></div><div class=\"ibox-content\"><div class=\"progress m-t-sm\" value=\"{{WorldPact.module.progress}}\" style=\"height: 5px\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{WorldPact.module.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\': WorldPact.module.progress + \'%\'}\" style=\"height:5px;\" aria-labelledby=\"progressbar\"></div></div><div ng-if=\"WorldPact.module\"><strong>{{WorldPact.module.title}}</strong> | <span class=\"text-muted\">{{ \'worldpact.progress\' | translate }}: {{WorldPact.module.progress}}%</span><br>{{WorldPact.module.description}}</div></div></div><div ui-view=\"\"><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\">{{::WorldPact.course.title}}</h3></div><div class=\"ibox-content\" ng-bind-html=\"::WorldPact.course.description\"></div></div></div></div>");
$templateCache.put("app/logged/world.pact/worldpact.module.html","<div class=\"ibox animated animated fadeIn\"><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': WorldPact.loadingModule}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"row\"><div class=\"menu-world-pact\" ng-class=\"{\'col-xs-3\': WorldPact.minimizedActive, \'col-xs-1\': !WorldPact.minimizedActive}\"><div class=\"clearfix m-b-md\"><button type=\"button\" class=\"navbar-minimalize btn btn-sm btn-outline btn-success\" href=\"#\" ng-click=\"WorldPact.minimalize()\"><em class=\"fa fa-bars\"></em></button></div><div ng-repeat=\"content in WorldPact.module.contents track by $index\" ng-show=\"WorldPact.minimizedActive\" class=\"ellipsis\"><a href=\"#\" ng-class=\"{\'btn-border-left\': WorldPact.contentSelected == $index}\" class=\"btn btn-sm btn-link\" ng-click=\"WorldPact.goTo($index)\">{{content.description}}</a></div></div><div class=\"content-world-pact\" ng-class=\"{\'col-xs-9\': WorldPact.minimizedActive, \'col-xs-11\': !WorldPact.minimizedActive}\"><div class=\"owl-carousel\"><div class=\"text-center\" ng-repeat=\"content in WorldPact.module.contents track by $index\" ng-show=\"! WorldPact.minimizeLoading\"><img ng-if=\"content.type === \'image\'\" ng-src=\"{{content.file | trustUrl}}\" class=\"img-responsive\"><iframe ng-if=\"content.type === \'video\'\" ng-src=\"{{content.file | trustUrl }}\" class=\"worldPackIframeVideo\" width=\"640\" height=\"480\" ng-style=\"{\'height\': WorldPact.itemHeight + \'px\'}\" style=\"width: 97%;\" frameborder=\"0\" allowfullscreen=\"\"></iframe><embed ng-if=\"content.type === \'pdf\'\" ng-src=\"{{content.file | trustUrl }}\" width=\"97%\" height=\"500\" ng-style=\"{\'height\': WorldPact.itemHeight + \'px\'}\" frameborder=\"0\" allowfullscreen=\"\"><div ng-if=\"content.type === \'html\'\" ng-bind-html=\"content.file\"></div><div ng-if=\"content.type === \'test\'\" ng-include=\"\'app/logged/world.pact/worldpact.test.html\'\"></div><div ng-if=\"content.type === \'feedback\'\" class=\"row p-h-xl\" ng-include=\"\'app/logged/world.pact/worldpact.feedback.html\'\"></div></div></div></div></div></div></div>");
$templateCache.put("app/logged/world.pact/worldpact.stats.html","<div class=\"ibox m-t-lg\"><div class=\"ibox-title\"><h3 class=\"text-success\">Estadísticas del curso ODS</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': WorldPactStats.loadingStats}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"m-t-sm bg-muted p-sm\"><form class=\"\" name=\"statsFrom\" ng-submit=\"WorldPactStats.filter()\"><div class=\"form-group w-100 m-r-sm\"><chosen-companies selected-company=\"WorldPactStats.selectedCompanyId\" on-company-change=\"WorldPactStats.handleCompanySelection(companyId, company)\"></chosen-companies></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" id=\"from\" ng-class=\"{\'has-error\': (statsFrom.from.$dirty || statsFrom.$submitted) && statsFrom.from.$invalid}\"><label class=\"font-normal\" translate-cloak=\"\">Desde:</label><div class=\"input-group date\"><input type=\"datetime\" class=\"form-control\" name=\"from\" date-time=\"\" ng-model=\"WorldPactStats.params.from\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"DD-MM-YYYY\" required=\"\"> <span class=\"input-group-addon\"><em class=\"fa fa-calendar\"></em></span></div></div><p ng-show=\"(statsFrom.from.$dirty || statsFrom.$submitted) && statsFrom.from.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">Revisa este campo</p></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" id=\"to\" ng-class=\"{\'has-error\': (statsFrom.to.$dirty || statsFrom.$submitted) && statsFrom.to.$invalid}\"><label class=\"font-normal\" translate-cloak=\"\">Hasta:</label><div class=\"input-group date\"><input type=\"datetime\" class=\"form-control\" name=\"to\" date-time=\"\" ng-model=\"WorldPactStats.params.to\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"DD-MM-YYYY\" required=\"\"> <span class=\"input-group-addon\"><em class=\"fa fa-calendar\"></em></span></div></div><p ng-show=\"(statsFrom.to.$dirty || statsFrom.$submitted) && statsFrom.to.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">Revisa este campo</p></div></div><div class=\"text-right\"><span class=\"m-r\"><input type=\"checkbox\" ng-model=\"WorldPactStats.params.finalized\" name=\"has_premium\" ng-true-value=\"1\" ng-false-value=\"\"> Curso finalizado</span> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"WorldPactStats.filter()\" translate-cloak=\"\">{{\'users.btn.filter\' | translate}}</button> <button type=\"button\" class=\"btn btn-sm btn-primary btn-outline\" ng-click=\"WorldPactStats.ressetParams()\" translate-cloak=\"\">Eliminar filtros</button></div></form></div><div class=\"table-responsive m-t-md\" ng-if=\"WorldPactStats.total\"><table width=\"100%\" class=\"table table-striped table-hover\"><thead><tr><th style=\"\">Empresas</th><th>Módulo</th><th>Contenido</th><th>Fecha Inicio</th><th>Último acceso</th><th>Curso finalizado</th></tr></thead><tbody><tr ng-repeat=\"stat in WorldPactStats.stats track by $index\"><td><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"1\" data=\"stat.user.company\">{{stat.user.company.name}}</a></td><td>{{stat.progress.module.title}}</td><td>{{stat.progress.content.description}}</td><td>{{stat.started_at | date: \'dd/MM/yy HH:mm\'}}</td><td>{{stat.last_access_at | date: \'dd/MM/yy HH:mm\'}}</td><td class=\"text-center\"><em ng-if=\"stat.status\" class=\"text-success fa fa-check\"></em> <small ng-if=\"!stat.status\">NO</small></td></tr></tbody></table></div><div class=\"text-center m-t-md\" ng-if=\"!WorldPactStats.total && !WorldPactStats.loadingStats\">No hay resultados para esta búsqueda</div><div class=\"clearfix m-r-md\"><div class=\"pull-right\"><uib-pagination total-items=\"WorldPactStats.total\" previous-text=\"<\" next-text=\">\" first-text=\"<<\" last-text=\">>\" ng-change=\"WorldPactStats.filter(true)\" ng-model=\"WorldPactStats.params.page\" force-ellipses=\"true\" max-size=\"7\" items-per-page=\"20\" class=\"pagination-sm\" boundary-links=\"true\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/logged/world.pact/worldpact.test.html","<div class=\"text-left row\"><div class=\"col-12 col-md-10 col-md-offset-1\"><h3>{{content.description}}</h3><form ng-submit=\"WorldPact.sendTest(content.id)\"><div class=\"form-group m-t\" ng-repeat=\"test in content.file track by $index\"><label>{{test.question}}</label><br><input type=\"hidden\" name=\"question[{{$index}}]\" ng-value=\"test.question\" ng-model=\"WorldPact.testForm[$index].question\"> <span ng-repeat=\"answer in test.answers track by $index\"><input type=\"radio\" name=\"answer[{{$parent.$index}}]\" ng-change=\"WorldPact.updateTestAnswer($parent.$index, answer.answer)\" ng-model=\"WorldPact.testForm[$parent.$index].answer\" ng-value=\"answer.answer\"> {{answer.answer}}<br></span> <span ng-if=\"WorldPact.updateTestAnswerVal[$index]\"><span ng-if=\"WorldPact.updateTestAnswerVal[$index].result\" class=\"text-success\">{{\'worldpact.test.correct\' | translate}}</span> <span ng-if=\"! WorldPact.updateTestAnswerVal[$index].result\" class=\"text-danger\">{{\'worldpact.test.incorrect\' | translate}}</span></span></div></form></div></div>");
$templateCache.put("app/templates/sidebar/advertiser.html","<div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\">{{Sidebar.advertiser.data.social_name}}</h3><p><strong>{{Sidebar.advertiser.data.cif}}</strong></p></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Sidebar.advertiser.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div ng-bind-html=\"Sidebar.advertiser.data.description\"></div><hr><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><span translate-cloak=\"\">{{\'advertisers.sidebar.view.province\'| translate}}</span> <span class=\"text-success\">{{Sidebar.advertiser.data.province.name}}</span></div><div class=\"col-xs-12 col-md-6\"><span translate-cloak=\"\">{{\'advertisers.sidebar.view.scope\'| translate}}</span> <span class=\"text-success\">{{Sidebar.advertiser.data.scope}}</span></div></div><hr><div>Web: <a ng-href=\"{{Sidebar.advertiser.data.web}}\" target=\"_blank\">{{Sidebar.advertiser.data.web}}</a></div><div ng-if=\"Sidebar.advertiser.data.online\"><span translate-cloak=\"\">{{\'advertisers.sidebar.view.online\'| translate}}</span> <a ng-href=\"{{Sidebar.advertiser.data.online}}\" target=\"_blank\">{{Sidebar.advertiser.data.online}}</a></div><div ng-if=\"Sidebar.advertiser.data.catalog\"><span translate-cloak=\"\">{{\'advertisers.sidebar.view.catalog\'| translate}}</span> <a ng-href=\"{{Sidebar.advertiser.data.catalog}}\" target=\"_blank\">{{Sidebar.advertiser.data.catalog}}</a></div><hr><div class=\"row\"><div class=\"col-xs-12 col-md-2\"><h1 class=\"text-center\"><em class=\"fa fa-user text-success\"></em></h1></div><div class=\"col-xs-12 col-md-9\"><div><span translate-cloak=\"\">{{\'advertisers.sidebar.view.personal_contact\'| translate}}</span> <span class=\"text-success\">{{Sidebar.advertiser.data.person_contact}}</span></div><div><span translate-cloak=\"\">{{\'advertisers.sidebar.view.phone\'| translate}}</span> <span class=\"text-success\">{{Sidebar.advertiser.data.phone}}</span></div><div><span translate-cloak=\"\">{{\'advertisers.sidebar.view.email\'| translate}}</span> <span class=\"text-success\">{{Sidebar.advertiser.data.email}}</span></div></div></div></div></div>");
$templateCache.put("app/templates/sidebar/company.html","<div ng-if=\"Sidebar.company.name\" id=\"sidebar-company\" class=\"company-print\"><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\">{{Sidebar.company.name}}</h5><div ibox-tools=\"\" class=\"ng-scope\"><div class=\"ibox-tools hidden-print\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"4\" id=\"{{Sidebar.company.id}}\" class=\"btn btn-success btn-outline btn-xs\"><em class=\"fa fa-envelope\"></em> <span translate-cloak=\"\">{{\"directory.sidebar.company.btn.contact\" | translate}}</span></a> <button ng-if=\"[\'superadmin\', \'admin\'].indexOf(myUser.group) > -1\" ng-click=\"Sidebar.printSidebar(\'sidebar-company\')\" type=\"button\" class=\"btn btn-xs btn-outline m-l-xs btn-info\">Imprimir</button></div></div></div><div class=\"ibox-content form-horizontal\"><div class=\"m-md\" ng-if=\"Sidebar.company.logo.url\"><img alt=\"Logo de la empresa\" ng-src=\"{{Sidebar.company.logo.url}}\" class=\"img-responsive center-block\"></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\" translate-cloak=\"\">{{\"directory.sidebar.company.activity\" | translate}}:</label><div class=\"col-lg-8\"><p class=\"form-control-static\">{{Sidebar.company.activity}}</p></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\" translate-cloak=\"\">{{\"directory.sidebar.company.cnae\" | translate}}:</label><div class=\"col-lg-8\"><p class=\"form-control-static\">{{Sidebar.company.cnae.id}} / {{Sidebar.company.cnae.name}}</p></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-if=\"Sidebar.company.financials && Sidebar.company.financials.length && Sidebar.company.financials[0].employees\"><label class=\"col-lg-6 control-label\" translate-cloak=\"\">{{\"directory.sidebar.company.employees\" | translate}}:</label><div class=\"col-lg-6\"><p class=\"form-control-static\">{{Sidebar.company.financials[0].employees}}</p></div></div><div class=\"form-group\"><label class=\"col-lg-6 control-label\" translate-cloak=\"\">{{\"directory.sidebar.company.import_export\" | translate}}:</label><div class=\"col-lg-6\"><p class=\"form-control-static\">{{Sidebar.company.import_export}}</p></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\" translate-cloak=\"\">{{\"directory.sidebar.company.description\" | translate}}:</label><div class=\"col-lg-10\"><div class=\"form-control-static\" ng-bind-html=\"Sidebar.company.description\"></div></div></div></div></div><div class=\"row\"><div class=\"col-12 col-md-6\"><div class=\"form-group\"><label class=\"col-12 col-md-4 control-label\" translate-cloak=\"\">{{\"directory.sidebar.company.web\" | translate}}:</label><div class=\"col-12 col-md-8\"><p class=\"form-control-static ellipsis\"><a ng-href=\"{{Sidebar.company.web}}\" target=\"_blank\">{{Sidebar.company.web}}</a></p></div></div></div><div class=\"col-12 col-md-6\"><div class=\"form-group\"><label class=\"col-12 col-md-4 control-label\" translate-cloak=\"\">{{\"directory.sidebar.company.edition\" | translate}}:</label><div class=\"col-12 col-md-8\"><p class=\"form-control-static\"><span class=\"badge badge-primary\" ng-repeat=\"year in Sidebar.company.years track by $index\">{{year.year}}</span></p></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\" ng-if=\"Sidebar.company.linkedin\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\"><em class=\"fa fa-linkedin\"></em>:</label><div class=\"col-lg-8\"><p class=\"form-control-static ellipsis\"><a ng-href=\"{{Sidebar.company.linkedin}}\" target=\"_blank\">{{Sidebar.company.linkedin}}</a></p></div></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"Sidebar.company.twitter\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\"><em class=\"fa fa-twitter\"></em>:</label><div class=\"col-lg-8\"><p class=\"form-control-static ellipsis\"><a ng-href=\"{{Sidebar.company.linkedin}}\" target=\"_blank\">{{Sidebar.company.twitter}}</a></p></div></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"Sidebar.company.facebook\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\"><em class=\"fa fa-facebook\"></em>:</label><div class=\"col-lg-8\"><p class=\"form-control-static ellipsis\"><a ng-href=\"{{Sidebar.company.facebook}}\" target=\"_blank\">{{Sidebar.company.facebook}}</a></p></div></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"Sidebar.company.google\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\"><em class=\"fa fa-google\"></em>:</label><div class=\"col-lg-8\"><p class=\"form-control-static ellipsis\"><a ng-href=\"{{Sidebar.company.google}}\" target=\"_blank\">{{Sidebar.company.google}}</a></p></div></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"Sidebar.company.youtube\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\"><em class=\"fa fa-youtube\"></em>:</label><div class=\"col-lg-8\"><p class=\"form-control-static ellipsis\"><a ng-href=\"{{Sidebar.company.youtube}}\" target=\"_blank\">{{Sidebar.company.youtube}}</a></p></div></div></div><div class=\"col-md-6 col-xs-12\" ng-if=\"Sidebar.company.linkedin_contacts\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\" translate-cloak=\"\">{{\"directory.sidebar.company.import_export\" | translate}}:</label><div class=\"col-lg-8\"><p class=\"form-control-static\">{{Sidebar.company.linkedin_contacts}}</p></div></div></div></div><div class=\"row m-t-lg\"><div class=\"col-xs-12\" ng-repeat=\"financial in Sidebar.company.financials track by $index\" ng-if=\"financial.year > 2014\"><h4 class=\"text-success\"><span translate-cloak=\"\">{{\"directory.sidebar.company.data_economics\" | translate}}</span> {{financial.year}}</h4><div class=\"table-responsive\"><table class=\"table table-striped table-hover\"><tr><td translate-cloak=\"\">{{\"directory.sidebar.company.cagr\" | translate}}</td><td class=\"text-right\"><strong class=\"text-success\"><span ng-if=\"financial.cagr\">{{financial.cagr | number: 2}}%</span></strong> <span ng-if=\"!financial.cagr\">-</span></td></tr><tr><td translate-cloak=\"\">{{\"directory.sidebar.company.development\" | translate}}</td><td class=\"text-right\"><strong class=\"text-success\"><span ng-if=\"financial.development\">{{financial.development | number: 2}} €</span></strong> <span ng-if=\"!financial.development\">-</span></td></tr><tr><td translate-cloak=\"\">{{\"directory.sidebar.company.ebitda\" | translate}}</td><td class=\"text-right\"><strong class=\"text-success\"><span ng-if=\"financial.ebitda\">{{financial.ebitda * 1000 | number: 2}} €</span></strong> <span ng-if=\"!financial.ebitda\">-</span></td></tr><tr><td translate-cloak=\"\">{{\"directory.sidebar.company.foreign_investiments\" | translate}}</td><td class=\"text-right\"><strong class=\"text-success\"><span ng-if=\"financial.foreign_investiments\">{{financial.foreign_investiments}}</span></strong> <span ng-if=\"!financial.foreign_investiments\">-</span></td></tr><tr><td translate-cloak=\"\">{{\"directory.sidebar.company.investigation\" | translate}}</td><td class=\"text-right\"><strong class=\"text-success\"><span ng-if=\"financial.investigation\">{{financial.investigation | number: 2}} €</span></strong> <span ng-if=\"!financial.investigation\">-</span></td></tr><tr><td translate-cloak=\"\">{{\"directory.sidebar.company.patents\" | translate}}</td><td class=\"text-right\"><strong class=\"text-success\"><span ng-if=\"financial.patents\">{{financial.patents}}</span></strong> <span ng-if=\"!financial.patents\">-</span></td></tr><tr><td translate-cloak=\"\">{{\"directory.sidebar.company.roa\" | translate}}</td><td class=\"text-right\"><strong class=\"text-success\"><span ng-if=\"financial.roa\">{{financial.roa | number: 2}}%</span></strong> <span ng-if=\"!financial.roa\">-</span></td></tr><tr><td translate-cloak=\"\">{{\"directory.sidebar.company.sales\" | translate}}</td><td class=\"text-right\"><strong class=\"text-success\"><span ng-if=\"financial.sales\">{{financial.sales | number: 2}} €</span></strong> <span ng-if=\"!financial.sales\">-</span></td></tr><tr><td translate-cloak=\"\">{{\"directory.sidebar.company.employees\" | translate}}</td><td class=\"text-right\"><strong class=\"text-success\"><span ng-if=\"financial.employees\">{{financial.employees | number}}</span></strong> <span ng-if=\"!financial.employees\">-</span></td></tr></table></div></div></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\"directory.sidebar.company.addresses\" | translate}}</h5></div><div class=\"ibox-content\"><div ng-repeat=\"address in Sidebar.company.addresses track by $index\"><div class=\"m-b\" ng-if=\"[\'superadmin\', \'admin\'].indexOf(myUser.group) > -1\"><ng-container>Email: {{Sidebar.company.email}} | Phone: {{address.phone_number}}<br></ng-container>{{address.street}}, {{address.postal_code}}, {{address.town}}</div></div><div class=\"hidden-print\" ng-if=\"Sidebar.gMapReady\"><ui-gmap-google-map center=\"Sidebar.mapCenter\" zoom=\"5\"><ui-gmap-marker ng-repeat=\"address in Sidebar.company.addresses track by $index\" idkey=\"address.id\" coords=\"{\'latitude\': address.lat, \'longitude\': address.lng}\" options=\"Sidebar.markerOptions\"><ui-gmap-window><p><strong>{{address.street}}</strong><br>{{address.postal_code}}, {{address.town}}, {{address.province_id | ProvinceFilter: \'id\'}}<br><em class=\"fa fa-envelope\"></em> {{Sidebar.company.email}} | <em class=\"fa fa-phone\"></em> {{address.phone_number}}</p></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\"directory.sidebar.company.contacts\" | translate}}</h5></div><div class=\"ibox-content\"><div class=\"contact-box center-version\" ng-repeat=\"contact in Sidebar.company.contacts track by $index\"><div class=\"text-center p-lg\"><p class=\"m-b-md\" ng-if=\"contact.image.url\"><img alt=\"Imagen del contacto\" class=\"img-circle img-lg center-block\" ng-src=\"{{contact.image.url}}\"></p><h4 class=\"m-b-xs\"><strong ng-class=\"{\'text-success\': contact.default}\">{{contact.name}} {{contact.surname}}</strong> <sup ng-if=\"contact.default\" class=\"fs-sm text-success fa fa-check-circle\"></sup></h4><div class=\"font-bold\">{{contact.job_title}} <span ng-if=\"contact.departament && contact.job_title\">/</span> {{contact.departament}}</div><address class=\"m-t-md\"><p ng-if=\"contact.phone_number\"><a ng-href=\"tel:{{contact.phone_number}}\"><em class=\"fa fa-phone text-success\"></em></a> (+34) {{contact.phone_number}}</p><p ng-if=\"contact.email\"><a ng-href=\"mailto:{{contact.email}}\"><em class=\"fa fa-envelope text-success\"></em></a> {{contact.email}}</p><span ng-if=\"contact.linkedin\"><a ng-href=\"{{contact.linkedin}}\" target=\"_blank\"><em class=\"fa fa-linkedin text-success\"></em> Visitar</a> <span ng-if=\"contact.linkedin_contacts\">+ {{contact.linkedin_contacts}}</span></span></address></div></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\"directory.sidebar.company.countries_market\" | translate}}</h5></div><div class=\"ibox-content\"><div ng-if=\"Sidebar.vectorMapReady\"><vector-map class=\"vector-map-no-clickleabe\" no-clickleabe=\"1\" countries=\"Sidebar.company.countriesMarketIds\" emit=\"mapCountrySelecedSales\"></vector-map></div></div></div><div class=\"ibox\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\"directory.sidebar.company.countries_office\" | translate}}</h5></div><div class=\"ibox-content\"><div ng-if=\"Sidebar.vectorMapReady\"><vector-map class=\"vector-map-no-clickleabe\" no-clickleabe=\"1\" countries=\"Sidebar.company.countriesOfficeIds\" fill-selected=\"#1abc9c\" emit=\"mapCountrySelecedOffice\"></vector-map></div></div></div><div class=\"ibox\" ng-if=\"Sidebar.company.interview\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\"directory.sidebar.company.interview\" | translate}}</h5></div><div class=\"ibox-content\"><div ng-if=\"Sidebar.company.interview.image.url\"><img alt=\"Imagen de la entrevista\" ng-src=\"{{Sidebar.company.interview.image.url}}\" class=\"max-h-150\"></div><h4>{{Sidebar.company.interview.name}}</h4><div>{{Sidebar.company.interview.job_title}} <span ng-if=\"Sidebar.company.interview.departament\">| {{Sidebar.company.interview.departament}}</span></div><hr><div ng-bind-html=\"Sidebar.company.interview.interview\"></div></div></div></div>");
$templateCache.put("app/templates/sidebar/compose_advertiser.html","<div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Sidebar.advertiser.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><form name=\"AdvertiserForm\" ng-submit=\"Sidebar.advertiser.sendAdvertiser(AdvertiserForm)\"><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.social_name.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.social_name.$invalid}\"><label class=\"control-label text-success\" translate-cloak=\"\">{{\'advertisers.sidebar.name\'| translate}}</label><div class=\"\"><input type=\"text\" name=\"social_name\" ng-model=\"Sidebar.advertiser.data.social_name\" class=\"form-control\" required=\"\"></div><p ng-show=\"(AdvertiserForm.social_name.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.social_name.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.cif.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.cif.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'advertisers.sidebar.cif\'| translate}}</label><div class=\"\"><input type=\"text\" name=\"cif\" ng-model=\"Sidebar.advertiser.data.cif\" class=\"form-control\" required=\"\"></div><p ng-show=\"(AdvertiserForm.cif.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.cif.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.activity.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.activity.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'advertisers.sidebar.activity\'| translate}}</label><div class=\"\"><input type=\"text\" name=\"activity\" ng-model=\"Sidebar.advertiser.data.activity\" class=\"form-control\" required=\"\"></div><p ng-show=\"(AdvertiserForm.activity.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.activity.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.province_id.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.province_id.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'advertisers.sidebar.province\'| translate}}</label><div><select class=\"form-control\" chosen=\"\" name=\"province_id\" id=\"province_id\" placeholder-text-single=\"\'{{\'general.chosen.province\' | translate}}\'\" ng-model=\"Sidebar.advertiser.data.province_id\" ng-options=\"province.id as province.name for province in Sidebar.advertiser.provinces\" required=\"\"></select></div><p ng-show=\"(AdvertiserForm.province_id.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.province_id.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.scope.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.scope.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'advertisers.sidebar.scope\'| translate}}</label><div><select class=\"form-control\" name=\"scope\" id=\"scope\" placeholder-text-single=\"\'{{\'general.chosen.province\' | translate}}\'\" ng-model=\"Sidebar.advertiser.data.scope\" required=\"\"><option value=\"local\">Local</option><option value=\"national\">Nacional</option><option value=\"international\">Internacional</option></select></div><p ng-show=\"(AdvertiserForm.scope.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.scope.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.description.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.description.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'advertisers.sidebar.description\'| translate}}</label><div class=\"form-group-summernote\"><summernote on-paste=\"Sidebar.advertiser.pasteSummernote()\" ng-if=\"Sidebar.advertiser.config\" name=\"description\" id=\"description\" config=\"Sidebar.advertiser.config\" ng-model=\"Sidebar.advertiser.data.description\" required=\"\"></summernote></div><p ng-show=\"(AdvertiserForm.description.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.description.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.web.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.web.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'advertisers.sidebar.web\'| translate}}</label><div class=\"\"><input type=\"url\" placeholder=\"link\" name=\"web\" ng-model=\"Sidebar.advertiser.data.web\" class=\"form-control\" required=\"\"></div><p ng-show=\"(AdvertiserForm.web.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.web.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.url_valid\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.online.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.online.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'advertisers.sidebar.ecommerce\'| translate}}</label><div class=\"\"><input type=\"url\" placeholder=\"link\" name=\"online\" ng-model=\"Sidebar.advertiser.data.online\" class=\"form-control\"></div><p ng-show=\"(AdvertiserForm.online.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.online.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.url_valid\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.catalog.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.catalog.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'advertisers.sidebar.catalog\'| translate}}</label><div class=\"\"><input type=\"url\" placeholder=\"link\" name=\"catalog\" ng-model=\"Sidebar.advertiser.data.catalog\" class=\"form-control\"></div><p ng-show=\"(AdvertiserForm.catalog.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.catalog.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.url_valid\' | translate}}</p></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.person_contact.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.person_contact.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'advertisers.sidebar.personal_contact\'| translate}}</label><div class=\"\"><input type=\"text\" name=\"person_contact\" ng-model=\"Sidebar.advertiser.data.person_contact\" class=\"form-control\" required=\"\"></div><p ng-show=\"(AdvertiserForm.person_contact.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.person_contact.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.email.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.email.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'advertisers.sidebar.email\'| translate}}</label><div class=\"\"><input type=\"email\" name=\"email\" ng-model=\"Sidebar.advertiser.data.email\" class=\"form-control\" required=\"\"></div><p ng-show=\"(AdvertiserForm.email.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.email.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (AdvertiserForm.phone.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.phone.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'advertisers.sidebar.phone\'| translate}}</label><div class=\"\"><input type=\"tel\" name=\"phone\" ng-model=\"Sidebar.advertiser.data.phone\" class=\"form-control\" required=\"\"></div><p ng-show=\"(AdvertiserForm.phone.$dirty || AdvertiserForm.$submitted) && AdvertiserForm.phone.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'advertisers.review\' | translate}}</p></div><p class=\"text-right text-success\" translate-cloak=\"\">{{\'advertisers.sidebar.required\'| translate}}</p><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"Sidebar.advertiser.loading\" translate-cloak=\"\">{{\'advertisers.sidebar.btn.publish\'| translate}}</button></div></form></div>");
$templateCache.put("app/templates/sidebar/compose_email.html","<form name=\"MailboxFrom\" ng-submit=\"Sidebar.composeMail.submit(MailboxFrom)\" novalidate=\"\"><div class=\"form-group\"><div class=\"cleafix ellipsis\"><div class=\"pull-left\"><h3><label class=\"control-label text-success\" translate-cloak=\"\">{{\'mailbox.to\' | translate}}</label></h3></div><div class=\"pull-right\"><button ng-if=\"Sidebar.composeMail.mail.to === \'All companies\'\" type=\"button\" class=\"btn btn-success btn-outline btn-xs\" ng-click=\"Sidebar.composeMail.selectAll(true)\" translate-cloak=\"\">{{\'mailbox.removeall\' | translate}}</button> <button ng-if=\"Sidebar.composeMail.mail.to !== \'All companies\'\" type=\"button\" class=\"btn btn-success btn-outline btn-xs\" ng-click=\"Sidebar.composeMail.selectAll()\" translate-cloak=\"\">{{\'mailbox.toall\' | translate}}</button></div></div><div ng-if=\"(myUser.group == \'superadmin\' || myUser.group == \'admin\') && Sidebar.composeMail.mail.to !== \'all\'\"><div class=\"form-group m-r-sm\" ng-if=\"Sidebar.composeMail.provincesSelect.length\"><select ng-change=\"Sidebar.composeMail.filtersChange()\" class=\"form-control chosen-select\" multiple=\"\" chosen=\"\" name=\"province\" id=\"province\" data-placeholder-text-multiple=\"\'{{\'general.chosen.province\' | translate}}\'\" ng-model=\"Sidebar.composeMail.filters.province\" allow-single-deselect=\"true\" ng-options=\"province.id as province.name for province in Sidebar.composeMail.provincesSelect\"><option value=\"\"></option></select></div><div class=\"form-group m-r-sm\" ng-if=\"Sidebar.composeMail.cnaesSelect.length\"><select ng-change=\"Sidebar.composeMail.filtersChange()\" class=\"form-control chosen-select\" multiple=\"\" chosen=\"\" name=\"cnae\" id=\"cnae\" data-placeholder-text-multiple=\"\'{{\'general.chosen.cnaes\' | translate}}\'\" ng-model=\"Sidebar.composeMail.filters.cnae\" allow-single-deselect=\"true\" ng-options=\"cnae.id as cnae.id + \' \' + cnae.name for cnae in Sidebar.composeMail.cnaesSelect\"><option value=\"\"></option></select></div><div class=\"form-group m-r-sm max-w-100p\"><select ng-change=\"Sidebar.composeMail.filtersChange()\" class=\"form-control chosen-select\" multiple=\"\" chosen=\"\" name=\"sector\" id=\"sector\" data-placeholder-text-multiple=\"\'Sector\'\" ng-model=\"Sidebar.composeMail.filters.sector\"><option value=\"\"></option><option value=\"ECONOMIA DIGITAL\">ECONOMIA DIGITAL</option><option value=\"INDUSTRIA MANUFACTURERA\">INDUSTRIA MANUFACTURERA</option><option value=\"DISTRIBUCION COMERCIAL\">DISTRIBUCION COMERCIAL</option><option value=\"CONSTRUCCION\">CONSTRUCCION</option><option value=\"PRIMARIO\">PRIMARIO</option><option value=\"TRANSPORTE\">TRANSPORTE</option><option value=\"SERVICIOS EMPRESARIALES\">SERVICIOS EMPRESARIALES</option><option value=\"OTROS\">OTROS</option></select></div></div><div ng-if=\"Sidebar.composeMail.mail.to === \'All companies\' || Sidebar.composeMail.mail.to === \'Active filters\'\"><input type=\"text\" class=\"form-control disabled\" value=\"{{Sidebar.composeMail.mail.to}}\" disabled=\"\"></div><div ng-if=\"Sidebar.composeMail.mail.to !== \'All companies\' && Sidebar.composeMail.mail.to !== \'Active filters\'\" class=\"form-group\" ng-class=\"{\'has-error\': (MailboxFrom.company.$dirty || MailboxFrom.$submitted) && MailboxFrom.company.$invalid}\"><chosen-companies selected-company=\"Sidebar.composeMail.selectedCompanyId\" on-company-change=\"Sidebar.composeMail.handleCompanySelection(companyId, company)\"></chosen-companies><p ng-show=\"(MailboxFrom.company.$dirty || MailboxFrom.$submitted) && MailboxFrom.company.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'mailbox.review\' | translate}}</p></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (MailboxFrom.subject.$dirty || MailboxFrom.$submitted) && MailboxFrom.subject.$invalid}\"><label class=\"control-label text-success\" translate-cloak=\"\">{{\'mailbox.subject\' | translate}}</label><div class=\"\"><input type=\"text\" name=\"subject\" ng-model=\"Sidebar.composeMail.mail.subject\" class=\"form-control\" maxlength=\"189\" ng-maxlength=\"189\" required=\"\"></div><div class=\"form-text m-b-none text-muted\">Max. 189 caract.</div><p ng-show=\"(MailboxFrom.subject.$dirty || MailboxFrom.$submitted) && MailboxFrom.subject.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'mailbox.review\' | translate}}</p></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (MailboxFrom.content.$dirty || MailboxFrom.$submitted) && MailboxFrom.content.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'mailbox.body\' | translate}}</label><div class=\"form-group-summernote\"><summernote on-paste=\"Sidebar.composeMail.pasteSummernote()\" ng-if=\"Sidebar.composeMail.config\" name=\"content\" id=\"content\" config=\"Sidebar.composeMail.config\" ng-model=\"Sidebar.composeMail.mail.body\" required=\"\"></summernote></div><p ng-show=\"(MailboxFrom.content.$dirty || MailboxFrom.$submitted) && MailboxFrom.content.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'mailbox.review\' | translate}}</p></div><hr><label class=\"control-label\" translate-cloak=\"\">{{\'mailbox.attachments\' | translate}}</label><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"\" name=\"files\" ngf-keep=\"\'distinct\'\" ngf-drop=\"\" ng-model=\"Sidebar.composeMail.mail.files\" ngf-pattern=\"\'.jpeg,.jpg,.png,.bmp,.gif,.pdf,.doc,.docx,.xls,.xlsx,.txt\'\" ngf-multiple=\"true\" ngf-max-files=\"10\" ngf-max-size=\"10MB\" ngf-drop-available=\"true\"><h4 class=\"text-center font-bold text-success\" translate=\"mailbox.drag_drop\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\" ng-click=\"Sidebar.composeMail.removeFile($index)\" ng-repeat=\"file in Sidebar.composeMail.mail.files track by $index\">{{file.name}}</a></div></div><p class=\"m-t-md\" translate-cloak=\"\">{{\'mailbox.help\' | translate}}</p><p ng-show=\"(MailboxFrom.files.$dirty || MailboxFrom.$submitted) && MailboxFrom.files.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'mailbox.review\' | translate}}</p><p class=\"text-right text-success\" translate-cloak=\"\">* {{\'mailbox.sidebar.required\' | translate}}</p><div class=\"form-group\"><button type=\"submit\" ng-disabled=\"Sidebar.composeMail.loading\" class=\"btn btn-sm btn-primary pull-right m-t-n-xs\" translate-cloak=\"\">{{\'mailbox.btn.send\' | translate}}</button></div></form>");
$templateCache.put("app/templates/sidebar/compose_employ.html","<div class=\"ibox\" ng-if=\"Sidebar.employCompose.requests\"><div class=\"ibox-title\"><h5 class=\"text-success\" translate-cloak=\"\">{{\'employment.sidebar.requestsTitle\' | translate}}</h5></div><div class=\"ibox-content\"><table width=\"100%\" class=\"table table-striped table-hover\"><thead><th translate-cloak=\"\">{{\'employment.sidebar.date\' | translate}}</th><th translate-cloak=\"\">{{\'employment.sidebar.requests\' | translate}}</th></thead><tbody><tr ng-repeat=\"(key, data) in Sidebar.employCompose.requests\"><td>{{key}}</td><td>{{data}}</td></tr></tbody></table><span translate-cloak=\"\" translate=\"employment.sidebar.requestsSentence\" translate-values=\'{ email: \"{{myUser.company.email}}\"}\'></span></div></div><div class=\"ibox-content bg-muted\" ng-class=\"{\'sk-loading\': Sidebar.loadingEmploy}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><form name=\"EmployFrom\" ng-submit=\"Sidebar.employCompose.submit(EmployFrom)\" method=\"post\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': (EmployFrom.title.$dirty || EmployFrom.$submitted) && EmployFrom.title.$invalid}\"><h3><label class=\"control-label text-success\" translate-cloak=\"\">{{\'employment.sidebar.position\' | translate}}</label></h3><div class=\"\"><input type=\"text\" name=\"title\" ng-model=\"Sidebar.employCompose.employ.title\" class=\"form-control\" required=\"\"></div><p ng-show=\"(EmployFrom.title.$dirty || EmployFrom.$submitted) && EmployFrom.title.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (EmployFrom.type.$dirty || EmployFrom.$submitted) && EmployFrom.type.$invalid}\"><label class=\"font-normal\" translate-cloak=\"\">{{\'employment.sidebar.type\' | translate}}</label><select class=\"form-control\" chosen=\"\" name=\"type\" id=\"type\" placeholder-text-single=\"\'{{\'employment.sidebar.typePlaceholder\' | translate}}\'\" ng-model=\"Sidebar.employCompose.employ.type\" ng-options=\"type for type in Sidebar.employCompose.jobType | translate\" required=\"\"></select><p ng-show=\"(EmployFrom.type.$dirty || EmployFrom.$submitted) && EmployFrom.type.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" id=\"date_from\" ng-class=\"{\'has-error\': (EmployFrom.date_from.$dirty || EmployFrom.$submitted) && EmployFrom.date_from.$invalid}\"><label class=\"font-normal\" translate-cloak=\"\">{{\'employment.sidebar.date_from\' | translate}}</label><div class=\"input-group date\"><input type=\"datetime\" class=\"form-control\" name=\"date_from\" date-time=\"\" ng-model=\"Sidebar.employCompose.employ.date_from\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"YYYY-MM-DD\" required=\"\"> <span class=\"input-group-addon\"><em class=\"fa fa-calendar\"></em></span></div></div><p ng-show=\"(EmployFrom.date_from.$dirty || EmployFrom.$submitted) && EmployFrom.date_from.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" id=\"date_to\" ng-class=\"{\'has-error\': (EmployFrom.date_to.$dirty || EmployFrom.$submitted) && EmployFrom.date_to.$invalid}\"><label class=\"font-normal\" translate-cloak=\"\">{{\'employment.sidebar.date_to\' | translate}}</label><div class=\"input-group date\"><input type=\"datetime\" class=\"form-control\" name=\"date_to\" date-time=\"\" ng-model=\"Sidebar.employCompose.employ.date_to\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"YYYY-MM-DD\" required=\"\"> <span class=\"input-group-addon\"><em class=\"fa fa-calendar\"></em></span></div></div><p ng-show=\"(EmployFrom.date_to.$dirty || EmployFrom.$submitted) && EmployFrom.date_to.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': (EmployFrom.salary_from.$dirty || EmployFrom.$submitted) && EmployFrom.salary_from.$invalid}\"><label class=\"font-normal\" translate-cloak=\"\">{{\'employment.sidebar.salary_from\' | translate}}</label><div class=\"input-group\"><input type=\"number\" name=\"salary_from\" ng-model=\"Sidebar.employCompose.employ.salary_from\" class=\"form-control\"> <span class=\"input-group-addon\"><em class=\"fa fa-euro\"></em></span></div><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.miles_point\' | translate}}</p><p ng-show=\"(EmployFrom.salary_from.$dirty || EmployFrom.$submitted) && EmployFrom.salary_from.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': (EmployFrom.salary_to.$dirty || EmployFrom.$submitted) && EmployFrom.salary_to.$invalid}\"><label class=\"font-normal\" translate-cloak=\"\">{{\'employment.sidebar.salary_to\' | translate}}</label><div class=\"input-group\"><input type=\"number\" name=\"salary_to\" ng-model=\"Sidebar.employCompose.employ.salary_to\" class=\"form-control\"> <span class=\"input-group-addon\"><em class=\"fa fa-euro\"></em></span></div></div><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.miles_point\' | translate}}</p><p ng-show=\"(EmployFrom.salary_to.$dirty || EmployFrom.$submitted) && EmployFrom.salary_to.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (EmployFrom.description.$dirty || EmployFrom.$submitted) && EmployFrom.description.$invalid}\"><label class=\"control-label font-normal\" translate-cloak=\"\">{{\'employment.sidebar.characteristics\' | translate}}</label> <textarea name=\"description\" ng-model=\"Sidebar.employCompose.employ.description\" class=\"form-control\" rows=\"5\" required=\"\"></textarea><p ng-show=\"(EmployFrom.description.$dirty || EmployFrom.$submitted) && EmployFrom.description.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\"><label class=\"control-label font-normal\" translate-cloak=\"\">{{\'employment.sidebar.requirements\' | translate}}</label> <textarea name=\"minimun_requirements\" ng-model=\"Sidebar.employCompose.employ.minimun_requirements\" class=\"form-control\" rows=\"3\"></textarea></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\"><label class=\"control-label font-normal\" translate-cloak=\"\">{{\'employment.sidebar.desired_requirements\' | translate}}</label> <textarea name=\"desired_requirements\" ng-model=\"Sidebar.employCompose.employ.desired_requirements\" class=\"form-control\" rows=\"3\"></textarea></div></div></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (EmployFrom.email.$dirty || EmployFrom.$submitted) && EmployFrom.email.$invalid}\"><label class=\"control-label font-normal\" translate-cloak=\"\">{{\'employment.sidebar.email\' | translate}}</label><div><input type=\"text\" name=\"email\" ng-model=\"Sidebar.employCompose.employ.email\" class=\"form-control\" required=\"\"><p ng-show=\"(EmployFrom.email.$dirty || EmployFrom.$submitted) && EmployFrom.email.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div><p ng-show=\"(EmployFrom.province_id.$dirty || EmployFrom.$submitted) && EmployFrom.province_id.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (EmployFrom.province_id.$dirty || EmployFrom.$submitted) && EmployFrom.province_id.$invalid}\"><label class=\"control-label font-normal\" translate-cloak=\"\">{{\'employment.sidebar.province\' | translate}}</label><div><select class=\"form-control\" chosen=\"\" name=\"province_id\" id=\"province_id\" placeholder-text-single=\"\'{{\'employment.sidebar.provincePlaceholder\' | translate}}\'\" ng-model=\"Sidebar.employCompose.employ.province_id\" ng-options=\"province.id as province.name for province in Sidebar.employCompose.provinces\" required=\"\"></select></div><p ng-show=\"(EmployFrom.province_id.$dirty || EmployFrom.$submitted) && EmployFrom.province_id.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (EmployFrom.city.$dirty || EmployFrom.$submitted) && EmployFrom.city.$invalid}\"><label class=\"control-label font-normal\" translate-cloak=\"\">{{\'employment.sidebar.town\' | translate}}</label> <input type=\"text\" name=\"city\" ng-model=\"Sidebar.employCompose.employ.city\" class=\"form-control\" required=\"\"><p ng-show=\"(EmployFrom.city.$dirty || EmployFrom.$submitted) && EmployFrom.city.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (EmployFrom.sector.$dirty || EmployFrom.$submitted) && EmployFrom.sector.$invalid}\"><label class=\"control-label font-normal\" translate-cloak=\"\">{{\'employment.sidebar.sector\' | translate}}</label> <input type=\"text\" name=\"sector\" ng-model=\"Sidebar.employCompose.employ.sector\" class=\"form-control\" required=\"\"><p ng-show=\"(EmployFrom.sector.$dirty || EmployFrom.$submitted) && EmployFrom.sector.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'employment.sidebar.review\' | translate}}</p></div><p class=\"help-block text-right\" translate-cloak=\"\">{{\'employment.sidebar.required\' | translate}}</p><div class=\"m-t-lg text-right\"><button type=\"button\" ng-click=\"Sidebar.close(10, true)\" class=\"btn btn-default\" translate-cloak=\"\">{{\'employment.sidebar.cancel\' | translate}}</button> <button type=\"submit\" ng-disabled=\"Sidebar.employCompose.loadingSend\" class=\"btn btn-success\" translate-cloak=\"\">{{\'employment.sidebar.publish\' | translate}}</button></div></form></div>");
$templateCache.put("app/templates/sidebar/compose_event.html","<div class=\"ibox\"><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Sidebar.event.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><form name=\"eventsForm\" ng-submit=\"Sidebar.event.eventsSubmit(eventsForm)\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': (eventsForm.title.$dirty || eventsForm.$submitted) && eventsForm.title.$invalid}\"><h3><label class=\"control-label text-success\" translate-cloak=\"\">{{\'events.sidebar.title\' | translate}} *</label></h3><div class=\"\"><input type=\"text\" name=\"title\" ng-model=\"Sidebar.event.data.title\" class=\"form-control\" required=\"\"></div><p ng-show=\"(eventsForm.title.$dirty || eventsForm.$submitted) && eventsForm.title.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'events.sidebar.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (eventsForm.category.$dirty || eventsForm.$submitted) && eventsForm.category.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'events.sidebar.type\' | translate}}: *</label><div><select class=\"form-control\" name=\"category\" id=\"category\" placeholder-text-single=\"\'Escoge el tipo\'\" ng-model=\"Sidebar.event.data.category\" ng-options=\"opt.id as opt.name for opt in Sidebar.event.categories\" required=\"\"></select></div><p ng-show=\"(eventsForm.category.$dirty || eventsForm.$submitted) && eventsForm.category.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'events.sidebar.review\' | translate}}</p></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" id=\"date_from\" ng-class=\"{\'has-error\': (eventsForm.date_from.$dirty || eventsForm.$submitted) && eventsForm.date_from.$invalid}\"><label translate-cloak=\"\">{{\'events.sidebar.date_from\' | translate}}*</label><div class=\"input-group date\"><input type=\"datetime\" class=\"form-control\" name=\"date_from\" date-time=\"\" view=\"date\" min-view=\"hours\" ng-model=\"Sidebar.event.data.date_from\" auto-close=\"true\" format=\"YYYY-MM-DD HH:mm:ss\" required=\"\"> <span class=\"input-group-addon\"><em class=\"fa fa-calendar\"></em></span></div></div><p ng-show=\"(eventsForm.date_from.$dirty || eventsForm.$submitted) && eventsForm.date_from.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'events.sidebar.review\' | translate}}</p></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" id=\"date_to\" ng-class=\"{\'has-error\': (eventsForm.date_to.$dirty || eventsForm.$submitted) && eventsForm.date_to.$invalid}\"><label translate-cloak=\"\">{{\'events.sidebar.date_to\' | translate}}*</label><div class=\"input-group date\"><input type=\"datetime\" class=\"form-control\" name=\"date_to\" date-time=\"\" view=\"date\" min-view=\"hours\" ng-model=\"Sidebar.event.data.date_to\" auto-close=\"true\" format=\"YYYY-MM-DD HH:mm:ss\" required=\"\"> <span class=\"input-group-addon\"><em class=\"fa fa-calendar\"></em></span></div></div><p ng-show=\"(eventsForm.date_to.$dirty || eventsForm.$submitted) && eventsForm.date_to.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'events.sidebar.review\' | translate}}</p></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (eventsForm.place.$dirty || eventsForm.$submitted) && eventsForm.place.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'events.sidebar.address\' | translate}} *</label><div class=\"\"><input type=\"text\" name=\"place\" ng-model=\"Sidebar.event.data.place\" class=\"form-control\" required=\"\"></div><p ng-show=\"(eventsForm.place.$dirty || eventsForm.$submitted) && eventsForm.place.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'events.sidebar.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (eventsForm.planner.$dirty || eventsForm.$submitted) && eventsForm.planner.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'events.sidebar.planner\' | translate}} *</label><div class=\"\"><input type=\"text\" name=\"planner\" ng-model=\"Sidebar.event.data.planner\" class=\"form-control\" required=\"\"></div><p ng-show=\"(eventsForm.planner.$dirty || eventsForm.$submitted) && eventsForm.planner.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'events.sidebar.review\' | translate}}</p><p class=\"text-help\" translate-cloak=\"\">{{\'events.sidebar.change\' | translate}}</p></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (eventsForm.content.$dirty || eventsForm.$submitted) && eventsForm.content.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'events.sidebar.description\' | translate}}</label><div class=\"form-group-summernote\"><summernote on-paste=\"Sidebar.event.pasteSummernote(\'description\')\" ng-if=\"Sidebar.event.config\" name=\"content\" id=\"content\" config=\"Sidebar.event.config\" ng-model=\"Sidebar.event.data.description\" ng-minlength=\"5\"></summernote></div><p ng-show=\"(eventsForm.content.$dirty || eventsForm.$submitted) && eventsForm.content.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'events.sidebar.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (eventsForm.comment.$dirty || eventsForm.$submitted) && eventsForm.comment.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'events.sidebar.comments\' | translate}}</label><div class=\"form-group-summernote\"><summernote on-paste=\"Sidebar.event.pasteSummernote(\'comment\')\" ng-if=\"Sidebar.event.config\" name=\"comment\" id=\"comment\" config=\"Sidebar.event.config\" ng-model=\"Sidebar.event.data.comment\" ng-minlength=\"5\"></summernote></div><p ng-show=\"(eventsForm.comment.$dirty || eventsForm.$submitted) && eventsForm.comment.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'events.sidebar.review\' | translate}}</p></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (eventsForm.web.$dirty || eventsForm.$submitted) && eventsForm.web.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'events.sidebar.web\' | translate}}</label><div class=\"\"><input type=\"url\" name=\"web\" ng-model=\"Sidebar.event.data.web\" class=\"form-control\"></div><p ng-show=\"(eventsForm.web.$dirty || eventsForm.$submitted) && eventsForm.web.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'events.sidebar.review\' | translate}}</p><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.url_valid\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (eventsForm.link_register.$dirty || eventsForm.$submitted) && eventsForm.link_register.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'events.sidebar.check_in\' | translate}}</label><div class=\"\"><input type=\"url\" name=\"link_register\" ng-model=\"Sidebar.event.data.link_register\" class=\"form-control\"></div><p ng-show=\"(eventsForm.link_register.$dirty || eventsForm.$submitted) && eventsForm.link_register.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'events.sidebar.review\' | translate}}</p><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.url_valid\' | translate}}</p></div><hr><div ng-if=\"Sidebar.event.data.image.url\"><label class=\"control-label\" translate-cloak=\"\">{{\'events.sidebar.image\' | translate}}</label> <img alt=\"Imagen del evento\" ng-src=\"{{Sidebar.event.data.image.url}}\" class=\"img-responsive\"><hr></div><p><strong ng-if=\"!Sidebar.event.data.image.url\" translate-cloak=\"\">{{\'events.sidebar.upload_image\' | translate}}</strong><strong ng-if=\"Sidebar.event.data.image.url\" translate-cloak=\"\">{{\'events.sidebar.change_image\' | translate}}</strong></p><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"\" name=\"image\" ngf-keep=\"false\" ngf-drop=\"\" ng-model=\"Sidebar.event.data.image_ng\" ngf-pattern=\"\'.jpeg,.jpg,.png,.gif,.pdf,\'\" ngf-multiple=\"false\" ngf-max-size=\"10MB\" ngf-drop-available=\"true\"><h4 class=\"text-center font-bold text-success\" translate=\"events.sidebar.drag_drop\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\" ng-click=\"Sidebar.event.removeImg()\"><img alt=\"Imagen a enviar\" ngf-size=\"{height: 80}\" ngf-thumbnail=\"Sidebar.event.data.image_ng\"></a></div></div><p class=\"m-t-md\" translate-cloak=\"\">{{\'events.sidebar.max\' | translate}}</p><p ng-show=\"(eventsForm.image.$dirty || eventsForm.$submitted) && eventsForm.image.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'events.sidebar.review\' | translate}}</p><p class=\"m-t-sm text-right text-success\" translate-cloak=\"\">{{\'events.sidebar.required\' | translate}}</p><div class=\"m-t-md\"><button type=\"submit\" class=\"btn btn-success\" translate-cloak=\"\">{{ \'events.btn.send\' | translate}}</button></div></form></div></div>");
$templateCache.put("app/templates/sidebar/compose_offer.html","<form name=\"OfferFrom\" ng-submit=\"Sidebar.composeOffer.submit(OfferFrom)\" method=\"post\" enctype=\"multipart/form-data\" novalidate=\"\"><div class=\"form-group\"><div class=\"cleafix\"><div class=\"pull-left\"><h3><label class=\"control-label text-success\" translate-cloak=\"\">{{\'offers.offer\' | translate}}</label></h3></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (OfferFrom.to.$dirty || OfferFrom.$submitted) && OfferFrom.to.$invalid}\"><chosen-companies selected-company=\"Sidebar.composeOffer.selectedCompanyId\" on-company-change=\"Sidebar.composeOffer.handleCompanySelection(companyId, company)\"></chosen-companies><p ng-show=\"(OfferFrom.to.$dirty || OfferFrom.$submitted) && OfferFrom.to.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'offers.review\' | translate}}</p></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (OfferFrom.title.$dirty || OfferFrom.$submitted) && OfferFrom.title.$invalid}\"><label class=\"control-label text-success\" translate-cloak=\"\">{{\'offers.title_field\' | translate}} *</label><div class=\"\"><input type=\"text\" name=\"title\" ng-model=\"Sidebar.composeOffer.mail.title\" class=\"form-control\" required=\"\"></div><p ng-show=\"(OfferFrom.title.$dirty || OfferFrom.$submitted) && OfferFrom.title.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'offers.review\' | translate}}</p></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (OfferFrom.description.$dirty || OfferFrom.$submitted) && OfferFrom.description.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'offers.description\' | translate}} *</label><div class=\"form-group-summernote\"><summernote on-paste=\"Sidebar.composeOffer.pasteSummernote()\" ng-if=\"Sidebar.composeOffer.config\" name=\"content\" id=\"description\" config=\"Sidebar.composeOffer.config\" ng-model=\"Sidebar.composeOffer.mail.description\" required=\"\"></summernote></div><p ng-show=\"(OfferFrom.description.$dirty || OfferFrom.$submitted) && OfferFrom.description.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'offers.review\' | translate}}</p></div><hr><div class=\"form-group\" id=\"date_to\" ng-class=\"{\'has-error\': (OfferFrom.date_to.$dirty || OfferFrom.$submitted) && OfferFrom.date_to.$invalid}\"><label class=\"font-normal\" translate-cloak=\"\">{{\'offers.date_to\' | translate}}</label><div class=\"input-group date\"><input type=\"datetime\" class=\"form-control\" name=\"date_to\" date-time=\"\" ng-model=\"Sidebar.composeOffer.mail.date_to\" view=\"date\" auto-close=\"true\" min-view=\"date\" format=\"YYYY-MM-DD\"> <span class=\"input-group-addon\"><em class=\"fa fa-calendar\"></em></span></div><p ng-show=\"(OfferFrom.date_to.$dirty || OfferFrom.$submitted) && OfferFrom.date_to.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'offers.review\' | translate}}</p></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': (OfferFrom.discount.$dirty || OfferFrom.$submitted) && OfferFrom.discount.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'offers.discount\' | translate}} *</label><div class=\"input-group\"><input type=\"number\" name=\"discount\" ng-model=\"Sidebar.composeOffer.mail.discount\" class=\"form-control\" required=\"\"> <span class=\"input-group-addon\">%</span></div><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.miles_point\' | translate}}</p><p ng-show=\"(OfferFrom.discount.$dirty || OfferFrom.$submitted) && OfferFrom.discount.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'offers.review\' | translate}}</p></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': (OfferFrom.price.$dirty || OfferFrom.$submitted) && OfferFrom.price.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'offers.price\' | translate}}</label><div class=\"input-group\"><input type=\"number\" name=\"price\" ng-model=\"Sidebar.composeOffer.mail.price\" class=\"form-control\"> <span class=\"input-group-addon\">€</span></div><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.miles_point\' | translate}}</p><p ng-show=\"(OfferFrom.price.$dirty || OfferFrom.$submitted) && OfferFrom.price.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'offers.review\' | translate}}</p></div></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (OfferFrom.url.$dirty || OfferFrom.$submitted) && OfferFrom.url.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'offers.link\' | translate}}</label><div class=\"\"><input type=\"url\" name=\"url\" ng-model=\"Sidebar.composeOffer.mail.url\" class=\"form-control\"></div><p ng-show=\"(OfferFrom.url.$dirty || OfferFrom.$submitted) && OfferFrom.url.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'offers.review\' | translate}}</p><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.url_valid\' | translate}}</p></div><hr><label class=\"control-label\" translate-cloak=\"\">{{\'offers.image\' | translate}}</label><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" name=\"image\" ngf-select=\"\" ngf-keep=\"false\" ngf-drop=\"\" ng-model=\"Sidebar.composeOffer.mail.image\" ngf-pattern=\"\'.jpeg,.jpg,.png,.bmp,.gif\'\" ngf-multiple=\"false\" ngf-max-files=\"1\" ngf-max-size=\"10MB\" ngf-drop-available=\"true\"><h4 class=\"text-center font-bold\" translate=\"{{\'offers.drag_drop\'}}\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\" ng-click=\"Sidebar.composeOffer.removeFile($index, \'image\')\"><img alt=\"Imagen a enviar\" ngf-size=\"{height: 80}\" ngf-thumbnail=\"Sidebar.composeOffer.mail.image\"></a></div></div><p class=\"m-t-md\" translate-cloak=\"\">{{\'offers.help_image\' | translate}}</p><p ng-show=\"(OfferFrom.image.$dirty || OfferFrom.$submitted) && OfferFrom.image.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'offers.review\' | translate}}</p><hr><label class=\"control-label\" translate-cloak=\"\">{{\'offers.attach\' | translate}}</label><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"\" name=\"file\" ngf-keep=\"false\" ngf-drop=\"\" ng-model=\"Sidebar.composeOffer.mail.file\" ngf-pattern=\"\'.jpeg,.jpg,.png,.bmp,.gif,.pdf,.doc,.docx,.xls,.xlsx,.txt\'\" ngf-multiple=\"false\" ngf-max-files=\"1\" ngf-max-size=\"10MB\" ngf-drop-available=\"true\"><h4 class=\"text-center font-bold text-success\" translate=\"{{\'offers.drag_drop\'}}\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\" ng-click=\"Sidebar.composeOffer.removeFile($index, \'file\')\">{{Sidebar.composeOffer.mail.file.name}}</a></div></div><p ng-show=\"(OfferFrom.file.$dirty || OfferFrom.$submitted) && OfferFrom.file.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'offers.review\' | translate}}</p><p class=\"m-t-md\" translate-cloak=\"\">{{\'offers.help_files\' | translate}}</p><p class=\"text-right text-success\" translate-cloak=\"\">* {{\'offers.sidebar.required\'| translate}}</p><div class=\"form-group p-lg\"><button type=\"submit\" ng-disabled=\"Sidebar.composeOffer.loading\" class=\"btn btn-sm btn-primary pull-right m-t-n-xs\" translate-cloak=\"\">{{\'offers.btn.send\' | translate}}</button></div></form>");
$templateCache.put("app/templates/sidebar/compose_prelease.html","<form name=\"PressReleaseFrom\" ng-submit=\"Sidebar.pReleease.submit(PressReleaseFrom, Sidebar.pReleease.update)\" method=\"post\" enctype=\"multipart/form-data\" novalidate=\"\"><div class=\"form-group\" ng-if=\"myUser.group === \'admin\' || myUser.group === \'superadmin\'\"><h5><label class=\"control-label text-success\">Cambiar empresa</label></h5><chosen-companies selected-company=\"Sidebar.pReleease.selectedCompanyId\" on-company-change=\"Sidebar.pReleease.handleCompanySelection(companyId, company)\"></chosen-companies><hr></div><div class=\"form-group\" ng-class=\"{\'has-error\': (PressReleaseFrom.title.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.title.$invalid}\"><h3><label class=\"control-label text-success\" translate-cloak=\"\">{{\'press_releases.form.title\' | translate}}*</label></h3><div class=\"\"><input type=\"text\" ng-minlength=\"8\" name=\"title\" ng-model=\"Sidebar.pReleease.article.title\" class=\"form-control\" required=\"\"></div><p translate-cloak=\"\">{{\'general.carateres9_short\' | translate}}</p><p ng-show=\"(PressReleaseFrom.title.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.title.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'press_releases.form.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (PressReleaseFrom.subtitle.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.subtitle.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'press_releases.form.subtitle\' | translate}}*</label><div class=\"\"><textarea type=\"text\" name=\"subtitle\" ng-model=\"Sidebar.pReleease.article.subtitle\" class=\"form-control\" required=\"\" rows=\"5\"></textarea></div><p ng-show=\"(PressReleaseFrom.subtitle.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.subtitle.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'press_releases.form.review\' | translate}}</p></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (PressReleaseFrom.content.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.content.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'press_releases.form.content\' | translate}}*</label><div class=\"form-group-summernote\"><summernote on-paste=\"Sidebar.pReleease.pasteSummernote()\" ng-minlength=\"8\" ng-if=\"Sidebar.pReleease.config\" name=\"content\" id=\"content\" config=\"Sidebar.pReleease.config\" ng-model=\"Sidebar.pReleease.article.content\" required=\"\"></summernote></div><p translate-cloak=\"\">{{\'general.carateres9_short\' | translate}}</p><p ng-show=\"(PressReleaseFrom.content.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.content.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'press_releases.form.review\' | translate}}</p></div><hr><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': (PressReleaseFrom.person.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.person.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'press_releases.form.person\' | translate}}*</label><div class=\"\"><input type=\"text\" name=\"person\" ng-model=\"Sidebar.pReleease.article.contact_person\" class=\"form-control\" required=\"\"></div><p ng-show=\"(PressReleaseFrom.person.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.person.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'press_releases.form.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (PressReleaseFrom.email.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.email.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'press_releases.form.email\' | translate}}*</label><div class=\"\"><input type=\"email\" name=\"email\" ng-model=\"Sidebar.pReleease.article.contact_email\" class=\"form-control\" required=\"\"></div><p ng-show=\"(PressReleaseFrom.email.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.email.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'press_releases.form.review\' | translate}}</p></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': (PressReleaseFrom.phone.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.phone.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'press_releases.form.phone\' | translate}}*</label><div class=\"\"><input type=\"tel\" name=\"phone\" ng-model=\"Sidebar.pReleease.article.contact_phone\" class=\"form-control\" required=\"\"></div><p ng-show=\"(PressReleaseFrom.phone.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.phone.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'press_releases.form.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (PressReleaseFrom.web.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.web.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'press_releases.form.contact_web\' | translate}}*</label><div class=\"\"><input type=\"text\" name=\"web\" ng-model=\"Sidebar.pReleease.article.contact_web\" class=\"form-control\" required=\"\"></div><p ng-show=\"(PressReleaseFrom.web.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.web.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'press_releases.form.review\' | translate}}</p></div></div></div><hr><label class=\"control-label\" translate-cloak=\"\">{{\'press_releases.form.main_image\' | translate}}</label><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"\" name=\"image\" ngf-drop=\"\" ng-model=\"Sidebar.pReleease.article.image\" ngf-drop-available=\"true\" ngf-pattern=\"\'.jpeg,.jpg,.png,.bmp,.gif\'\" ngf-max-size=\"2MB\"><h4 class=\"text-center font-bold text-success\" translate-cloak=\"\" translate=\"press_releases.form.drag_drop\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\"><img alt=\"Imagen principal\" style=\"height:80px; max-width: 100%\" ng-if=\"!Sidebar.pReleease.article.image.real_path\" ngf-size=\"{height: 80}\" ngf-thumbnail=\"Sidebar.pReleease.article.image\" ng-click=\"Sidebar.pReleease.removeFile(\'image\')\"> <img alt=\"Imagen principal\" style=\"height:80px; max-width: 100%\" ngf-size=\"{height: 80}\" ngf-thumbnail=\"Sidebar.pReleease.article.image.real_path\" ng-click=\"Sidebar.pReleease.removeFile(\'image\', null, Sidebar.pReleease.article.image.id)\"></a></div></div><p ng-show=\"(PressReleaseFrom.image.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.image.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'press_releases.form.review\' | translate}}</p><p class=\"m-t-md\" translate-cloak=\"\">{{\'mailbox.help.main_image\' | translate}}</p><hr><label class=\"control-label\" translate-cloak=\"\">{{\'press_releases.form.more_image\' | translate}}</label><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"\" name=\"images\" ngf-keep=\"\'distinct\'\" ngf-drop=\"\" ng-model=\"Sidebar.pReleease.article.images\" ngf-pattern=\"\'.jpeg,.jpg,.png,.bmp,.gif\'\" ngf-multiple=\"true\" ngf-max-files=\"10\" ngf-max-size=\"2MB\" ngf-drop-available=\"true\"><h4 class=\"text-center font-bold text-success\" translate-cloak=\"\" translate=\"press_releases.form.drag_drop\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\" ng-click=\"Sidebar.pReleease.removeFile(\'images\', $index, image.id)\" ng-repeat=\"image in Sidebar.pReleease.article.images track by $index\"><img alt=\"Imagenes secundarias\" style=\"height:80px; max-width: 100%\" ng-if=\"!image.real_path\" ngf-size=\"{height: 80}\" ngf-thumbnail=\"image\"> <img alt=\"Imagenes secundarias\" ngf-size=\"{height: 80}\" style=\"height:80px; max-width: 100%\" ngf-thumbnail=\"image.real_path\"></a></div></div><p ng-show=\"(PressReleaseFrom.images.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.images.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'press_releases.form.review\' | translate}}</p><p class=\"m-t-md\" translate-cloak=\"\">{{\'mailbox.help.images\' | translate}}</p><hr><label class=\"control-label\" translate-cloak=\"\">{{\'press_releases.form.more_documents\' | translate}}</label><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"\" name=\"documents\" ngf-keep=\"\'distinct\'\" ngf-pattern=\"\'.pdf,.doc,.docx,.xls,.xlsx\'\" ngf-drop=\"\" ng-model=\"Sidebar.pReleease.article.documents\" ngf-multiple=\"true\" ngf-max-files=\"10\" ngf-max-size=\"2MB\" ngf-drop-available=\"true\"><h4 class=\"text-center font-bold text-success\" translate-cloak=\"\" translate=\"press_releases.form.drag_drop\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a ng-if=\"document.name\" href=\"javascript:void(0);\" class=\"m-xs pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\" ng-click=\"Sidebar.pReleease.removeFile(\'documents\', $index, document.id)\" ng-repeat=\"document in Sidebar.pReleease.article.documents track by $index\">{{document.name}}</a> <a ng-if=\"document.original_name\" href=\"javascript:void(0);\" class=\"m-xs pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\" ng-click=\"Sidebar.pReleease.removeFile(\'documents\', $index, document.id)\" ng-repeat=\"document in Sidebar.pReleease.article.documents track by $index\">{{document.original_name}}</a></div></div><p ng-show=\"(PressReleaseFrom.file.$dirty || PressReleaseFrom.$submitted) && PressReleaseFrom.file.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'press_releases.form.review\' | translate}}</p><p class=\"m-t-md\" translate-cloak=\"\">{{\'mailbox.help.docs\' | translate}}</p><hr><p class=\"text-right text-success\" translate-cloak=\"\">* {{\'press_releases.form.required\'| translate}}</p><div class=\"form-group p-lg\"><em class=\"fa fa-spinner text-success\" ng-if=\"Sidebar.pReleease.loading\"></em> <button type=\"submit\" ng-disabled=\"Sidebar.pReleease.loading\" class=\"btn btn-sm btn-primary pull-right m-t-n-xs\" translate-cloak=\"\">{{\'press_releases.form.send\' | translate}}</button> <button class=\"btn btn-default pull-right btn-sm m-t-n-xs m-r-md\" ng-click=\"Sidebar.close(6, true);\">CANCELAR</button></div></form>");
$templateCache.put("app/templates/sidebar/compose_project.html","<div class=\"ibox\"><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Sidebar.project.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><form name=\"projectForm\" ng-submit=\"Sidebar.project.projectSubmit(projectForm)\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': (projectForm.title.$dirty || projectForm.$submitted) && projectForm.title.$invalid}\"><h3><label class=\"control-label text-success\" translate-cloak=\"\">{{\'sidebar.project.form.title\' | translate}}</label></h3><div class=\"\"><input type=\"text\" name=\"title\" ng-model=\"Sidebar.project.data.title\" class=\"form-control\" required=\"\"></div><p ng-show=\"(projectForm.title.$dirty || projectForm.$submitted) && projectForm.title.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'projects.sidebar.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (projectForm.scope.$dirty || projectForm.$submitted) && projectForm.scope.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'sidebar.project.form.scope\' | translate}}</label><div><select class=\"form-control\" name=\"scope\" id=\"scope\" placeholder-text-single=\"\'Escoge el ámbito\'\" ng-model=\"Sidebar.project.data.scope\" required=\"\"><option value=\"Nacional\">Nacional</option><option value=\"Internacional\">Internacional</option></select></div><p ng-show=\"(projectForm.scope.$dirty || projectForm.$submitted) && projectForm.scope.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'projects.sidebar.review\' | translate}}</p></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" id=\"date_from\" ng-class=\"{\'has-error\': (projectForm.date_from.$dirty || projectForm.$submitted) && projectForm.date_from.$invalid}\"><label translate-cloak=\"\">{{\'sidebar.project.form.from\' | translate}}</label><div class=\"input-group date\"><input type=\"datetime\" class=\"form-control\" name=\"date_from\" date-time=\"\" view=\"date\" ng-model=\"Sidebar.project.data.date_from\" auto-close=\"true\" min-view=\"date\" format=\"YYYY-MM-DD\"> <span class=\"input-group-addon\"><em class=\"fa fa-calendar\"></em></span></div></div><p ng-show=\"(projectForm.date_from.$dirty || projectForm.$submitted) && projectForm.date_from.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'projects.sidebar.review\' | translate}}</p></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group\" id=\"date_to\" ng-class=\"{\'has-error\': (projectForm.date_to.$dirty || projectForm.$submitted) && projectForm.date_to.$invalid}\"><label translate-cloak=\"\">{{\'sidebar.project.form.to\' | translate}}</label><div class=\"input-group date\"><input type=\"datetime\" class=\"form-control\" name=\"date_to\" date-time=\"\" view=\"date\" ng-model=\"Sidebar.project.data.date_to\" auto-close=\"true\" min-view=\"date\" format=\"YYYY-MM-DD\"> <span class=\"input-group-addon\"><em class=\"fa fa-calendar\"></em></span></div></div><p ng-show=\"(projectForm.date_to.$dirty || projectForm.$submitted) && projectForm.date_to.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'projects.sidebar.review\' | translate}}</p></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': (projectForm.url.$dirty || projectForm.$submitted) && projectForm.url.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'sidebar.project.form.documentation\' | translate}}</label><div class=\"\"><input type=\"url\" name=\"url\" ng-model=\"Sidebar.project.data.url\" class=\"form-control\" required=\"\"></div><p ng-show=\"(projectForm.url.$dirty || projectForm.$submitted) && projectForm.url.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'projects.sidebar.review\' | translate}}</p><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.url_valid\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (projectForm.aproach.$dirty || projectForm.$submitted) && projectForm.aproach.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'sidebar.project.form.aproach\' | translate}}</label><div class=\"input-group text-right\"><input type=\"number\" name=\"aproach\" ng-model=\"Sidebar.project.data.aproach\" class=\"form-control\" required=\"\"><span class=\"input-group-addon\">€</span></div><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.miles_point\' | translate}}</p><p ng-show=\"(projectForm.aproach.$dirty || projectForm.$submitted) && projectForm.aproach.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'projects.sidebar.review\' | translate}}</p></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (projectForm.description.$dirty || projectForm.$submitted) && projectForm.description.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'sidebar.project.form.description\' | translate}}</label><div class=\"form-group-summernote\"><summernote on-paste=\"Sidebar.project.pasteSummernote(\'description\')\" ng-if=\"Sidebar.project.config\" name=\"description\" id=\"description\" config=\"Sidebar.project.config\" ng-model=\"Sidebar.project.data.description\" required=\"\" ng-minlength=\"5\"></summernote></div><p ng-show=\"(projectForm.description.$dirty || projectForm.$submitted) && projectForm.description.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'projects.sidebar.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (projectForm.comments.$dirty || projectForm.$submitted) && projectForm.comments.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'sidebar.project.form.comments\' | translate}}</label><div class=\"form-group-summernote\"><summernote on-paste=\"Sidebar.project.pasteSummernote(\'comments\')\" ng-if=\"Sidebar.project.config\" name=\"comments\" id=\"comments\" config=\"Sidebar.project.config\" ng-model=\"Sidebar.project.data.comments\" ng-minlength=\"5\"></summernote></div><p ng-show=\"(projectForm.comments.$dirty || projectForm.$submitted) && projectForm.comments.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'projects.sidebar.review\' | translate}}</p></div><hr><div class=\"form-group\" ng-class=\"{\'has-error\': (projectForm.person_contact.$dirty || projectForm.$submitted) && projectForm.person_contact.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'sidebar.project.form.person_contact\' | translate}}</label><div class=\"\"><input type=\"text\" name=\"person_contact\" ng-model=\"Sidebar.project.data.person_contact\" class=\"form-control\" required=\"\"></div><p ng-show=\"(projectForm.person_contact.$dirty || projectForm.$submitted) && projectForm.person_contact.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'projects.sidebar.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (projectForm.phone.$dirty || projectForm.$submitted) && projectForm.phone.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'sidebar.project.form.phone\' | translate}}</label><div class=\"\"><input type=\"tel\" name=\"phone\" ng-model=\"Sidebar.project.data.phone\" class=\"form-control\" required=\"\"></div><p ng-show=\"(projectForm.phone.$dirty || projectForm.$submitted) && projectForm.phone.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'projects.sidebar.review\' | translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (projectForm.email.$dirty || projectForm.$submitted) && projectForm.email.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'sidebar.project.form.email\' | translate}}</label><div class=\"\"><input type=\"email\" name=\"email\" ng-model=\"Sidebar.project.data.email\" class=\"form-control\" required=\"\"></div><p ng-show=\"(projectForm.email.$dirty || projectForm.$submitted) && projectForm.email.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'projects.sidebar.review\' | translate}}</p></div><button type=\"submit\" class=\"btn btn-success\" translate-cloak=\"\">{{\'sidebar.project.form.publish\' | translate}}</button><p class=\"m-t-sm text-right text-success\" translate-cloak=\"\">{{\'sidebar.project.form.required\' | translate}}</p></form></div></div>");
$templateCache.put("app/templates/sidebar/compose_tv.html","<div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Sidebar.tv.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><form name=\"tvForm\" ng-submit=\"Sidebar.tv.submit(tvForm)\"><div class=\"form-group\" ng-class=\"{\'has-error\': (tvForm.title.$dirty || tvForm.$submitted) && tvForm.title.$invalid}\"><label class=\"control-label text-success\" translate-cloak=\"\">{{\'cepyme500tv.form.title\' |translate}}</label><div><input type=\"text\" name=\"title\" ng-model=\"Sidebar.tv.video.title\" class=\"form-control\" required=\"\"></div><p ng-show=\"(tvForm.title.$dirty || tvForm.$submitted) && tvForm.title.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'cepyme500tv.form.review\' |translate}}</p></div><div class=\"form-group\" ng-class=\"{\'has-error\': (tvForm.url.$dirty || tvForm.$submitted) && tvForm.url.$invalid}\"><label class=\"control-label\" translate-cloak=\"\">{{\'cepyme500tv.form.youtube\' |translate}}</label><div class=\"input-group m-b\"><span class=\"input-group-addon\"><em class=\"fa fa-youtube\"></em></span> <input type=\"url\" name=\"url\" ng-model=\"Sidebar.tv.video.url\" class=\"form-control\" required=\"\"></div><p ng-show=\"(tvForm.url.$dirty || tvForm.$submitted) && tvForm.url.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'cepyme500tv.form.review\' |translate}}</p><p class=\"m-t-sm text-muted\" translate-cloak=\"\">{{ \'general.form.url_valid\' | translate}}</p></div><div><button type=\"submit\" class=\"btn btn-success\">{{\'cepyme500tv.form.publish\' |translate}}</button></div></form></div>");
$templateCache.put("app/templates/sidebar/contact.html","<div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Sidebar.loadingContact}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"center-version\"><div class=\"text-center p-lg\"><p class=\"m-b-md\" ng-if=\"Sidebar.contact.image.url\"><img alt=\"Imagen del contacto\" class=\"img-responsive center-block\" ng-src=\"{{Sidebar.contact.image.url}}\"></p><div class=\"\"><strong class=\"text-success\">{{Sidebar.contact.name}} {{Sidebar.contact.surname}} <sup ng-if=\"Sidebar.contact.default\" class=\"fa fa-check-circle\"></sup></strong></div><div class=\"font-bold m-b-sm\">{{Sidebar.contact.job_title}} <span ng-if=\"Sidebar.contact.departament && Sidebar.contact.job_title\">/</span> {{Sidebar.contact.departament}}</div><p class=\"text-success\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"1\" id=\"{{Sidebar.contact.company_id}}\">{{Sidebar.contact.company_name}}</a></p><address class=\"m-t-md\" ng-if=\"Sidebar.contact.phone_number || Sidebar.contact.email || Sidebar.contact.linkedin || Sidebar.contact.linkedin_contacts\"><hr class=\"hr-line-dashed\"><a ng-if=\"Sidebar.contact.phone_number\" ng-href=\"tel:{{Sidebar.contact.phone_number}}\"><em class=\"fa fa-phone text-primary\"></em></a> (+34) {{Sidebar.contact.phone_number}}<br><a ng-if=\"Sidebar.contact.email\" ng-href=\"mailto:{{Sidebar.contact.email}}\"><em class=\"fa fa-envelope text-primary\"></em></a> {{Sidebar.contact.email}}<br><span ng-if=\"Sidebar.contact.linkedin\"><a ng-href=\"{{Sidebar.contact.linkedin}}\" target=\"_blank\"><em class=\"fa fa-linkedin text-primary\"></em> Visitar</a> <span ng-if=\"Sidebar.contact.linkedin_contacts\">+ {{Sidebar.contact.linkedin_contacts}}</span></span></address><div class=\"m-t-lg\" ng-if=\"Sidebar.contact.default\"><a href=\"javascript:void(0);\" link-sidebar=\"\" type=\"4\" id=\"{{Sidebar.contact.company_id}}\" class=\"btn btn-success\">Contactar</a></div></div></div></div>");
$templateCache.put("app/templates/sidebar/email.html","<div class=\"ibox\" ng-if=\"!Sidebar.mail.message[0].subject && !Sidebar.mail.loading\"><div class=\"ibox-title text-danger\">Este mensaje ya no está disponible</div></div><div class=\"mail-box-header ibox-content\" ng-class=\"{\'sk-loading\': Sidebar.mail.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div ng-if=\"Sidebar.mail.message[0].subject\"><div class=\"clearfix\"><div class=\"pull-right tooltip-demo\"><a class=\"btn btn-white btn-sm\" data-toggle=\"tooltip\" ng-click=\"Sidebar.mail.replyCollapse(true, 1)\" data-placement=\"top\" title=\"Reply\"><em class=\"fa fa-reply\"></em> <span translate-cloak=\"\">{{\'mailbox.reply\' | translate}}</span></a><a class=\"btn btn-sm btn-white\" ng-click=\"Sidebar.mail.replyCollapse(true, 3)\"><em class=\"fa fa-arrow-right\"></em> <span translate-cloak=\"\">{{\'mailbox.forward\' | translate}}</span></a></div></div><div ng-repeat=\"message in Sidebar.mail.message track by $index\"><div class=\"mail-tools tooltip-demo m-t-md\"><h2 class=\"text-success\" ng-if=\"$index<1\">{{message.subject}}</h2><h5 class=\"clearfix\"><span class=\"pull-right font-normal\" am-time-ago=\"{{message.created_at.date | amUtc | amLocal}}\"></span><div class=\"pull-left\"><span>{{message.sender.name}}</span> <em class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></em></div></h5></div><div class=\"mail-box\"><div class=\"mail-body\" ng-bind-html=\"message.body | decodeHtml:true\"></div><div class=\"mail-attachment\" ng-if=\"message.attachments.length\"><p><span><em class=\"fa fa-paperclip\"></em> {{message.attachments.length}} <span translate-cloak=\"\">{{\'mailbox.attachments\' | translate}}</span></span></p><div class=\"attachment\"><div class=\"file-box\" ng-repeat=\"attach in message.attachments track by $index\"><div class=\"file\"><a ng-href=\"{{attach.real_path}}\" target=\"_blank\"><span class=\"corner\"></span><div class=\"icon\" ng-if=\"!Sidebar.mail.checkTypeImg(attach.real_path)\"><em class=\"fa fa-file\"></em></div><div class=\"image\" ng-if=\"Sidebar.mail.checkTypeImg(attach.real_path)\"><img alt=\"Imagend el correo\" class=\"img-responsive center-block\" ng-src=\"{{attach.real_path}}\"></div><div class=\"file-name ellipsis\">{{attach.original_name}}</div></a></div></div><div class=\"clearfix\"></div></div></div></div><hr ng-if=\"Sidebar.mail.message.length > $index+1\" class=\"hr-line-solid\"></div><div class=\"mail-body text-right\"><a class=\"btn btn-sm btn-white\" ng-click=\"Sidebar.mail.replyCollapse(false, 1)\"><em class=\"fa fa-reply\"></em> <span translate-cloak=\"\">{{\'mailbox.reply\' | translate}}</span></a><a class=\"btn btn-sm btn-white\" ng-click=\"Sidebar.mail.replyCollapse(false, 3)\"><em class=\"fa fa-arrow-right\"></em> <span translate-cloak=\"\">{{\'mailbox.forward\' | translate}}</span></a></div><div ng-if=\"!Sidebar.mail.isCollapsedReply\" class=\"p-md\"><form id=\"reply\" name=\"emailReplyFrom\" ng-submit=\"Sidebar.mail.replySubmit(emailReplyFrom)\"><div class=\"form-group\"><div class=\"form-group-summernote border-left-right\"><summernote on-paste=\"Sidebar.mail.pasteSummernote()\" ng-if=\"Sidebar.mail.config\" name=\"body\" id=\"body\" config=\"Sidebar.mail.config\" ng-model=\"Sidebar.mail.reply.body\" required=\"\"></summernote></div><p ng-show=\"(emailReplyFrom.body.$dirty || emailReplyFrom.$submitted) && emailReplyFrom.body.$invalid\" class=\"help-block text-danger\" translate-cloak=\"\">{{\'mailbox.review\' | translate}</p></div><label class=\"control-label\" translate-cloak=\"\">{{\'mailbox.attachments\' | translate}}:</label><div class=\"row\"><div class=\"col-xs-3\"><div class=\"drop-upload\" ngf-select=\"\" ngf-keep=\"\'distinct\'\" ngf-drop=\"\" ng-model=\"Sidebar.mail.reply.files\" ngf-pattern=\"\'.jpeg,.jpg,.png,.bmp,.gif,.pdf,.doc,.docx,.xls,.xlsx,.txt\'\" ngf-multiple=\"true\" ngf-max-files=\"10\" ngf-max-size=\"10MB\" ngf-drop-available=\"true\"><h4 class=\"text-center font-bold text-success\" translate=\"{{\'mailbox.drag_drop\'}}\"></h4></div></div><div class=\"col-xs-9 bg-white drop-upload-preview-content\"><a href=\"javascript:void(0);\" class=\"m-md pull-left\" tooltip-placement=\"top\" uib-tooltip=\"Click para eliminar\" ng-click=\"Sidebar.mail.removeFile($index)\" ng-repeat=\"file in Sidebar.mail.reply.files track by $index\">{{file.name}}</a></div></div><p class=\"m-t-md\" translate-cloak=\"\">{{\'mailbox.help\' | translate}}</p><div class=\"m-t-md text-right\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"emailReplyFrom.$invalid\" translate-cloak=\"\">{{\'mailbox.btn.send\' | translate}}</button></div></form></div><div class=\"clearfix\"></div></div></div>");
$templateCache.put("app/templates/sidebar/employ.html","<div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\">{{Sidebar.employ.title}}</h3><p><strong class=\"text-success\">{{Sidebar.employ.type}}</strong> | <strong>{{Sidebar.employ.company.name}}</strong> | <span class=\"text-uppercase\">{{Sidebar.employ.city}}</span></p></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><p>{{\'employment.sidebar.view.date_from\' | translate}} {{Sidebar.employ.date_from}}</p><p>{{\'employment.sidebar.view.salary_from\' | translate}} {{Sidebar.employ.salary_from | number}}€</p><p ng-if=\"Sidebar.employ.minimun_requirements\">{{\'employment.sidebar.view.minimun_requirements\' | translate}}<br>{{Sidebar.employ.minimun_requirements}}</p></div><div class=\"col-md-6 col-xs-12\"><p>{{\'employment.sidebar.view.date_to\' | translate}} {{Sidebar.employ.date_to}}</p><p>{{\'employment.sidebar.view.salary_to\' | translate}} {{Sidebar.employ.salary_to | number}}€</p><p ng-if=\"Sidebar.employ.desired_requirements\">{{\'employment.sidebar.view.desired_requirements\' | translate}}<br>{{Sidebar.employ.desired_requirements}}</p></div></div><hr><div class=\"\" ng-bind-html=\"Sidebar.employ.description\"></div></div></div>");
$templateCache.put("app/templates/sidebar/event.html","<div ng-if=\"Sidebar.event.map.center.latitude\"><ui-gmap-google-map center=\"Sidebar.event.map.center\" zoom=\"Sidebar.event.map.zoom\"><ui-gmap-marker idkey=\"Sidebar.event.data.id\" coords=\"{\'latitude\': Sidebar.event.data.lat, \'longitude\': Sidebar.event.data.lng}\" options=\"Sidebar.event.markerOptions\"><ui-gmap-window><p><strong>{{Sidebar.event.data.place}}</strong></p></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map></div><div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\">{{Sidebar.event.data.title}}</h3></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Sidebar.event.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"row\"><div class=\"col-xs12 col-md-9\"><div ng-if=\"Sidebar.event.data.image.url\" class=\"m-b-md\"><img alt=\"Imagen del evento\" ng-src=\"{{Sidebar.event.data.image.url}}\" class=\"img-responsive\"></div><div ng-if=\"Sidebar.event.data.image.web\"><strong>Visitar web:</strong><br><a ng-href=\"{{Sidebar.event.data.web}}\" target=\"_blank\">{{Sidebar.event.data.web}}</a></div><div ng-if=\"Sidebar.event.data.link_register\"><strong translate-cloak=\"\">{{\'Sidebar.event.registration\' | translate}}</strong><br><a ng-href=\"{{Sidebar.event.data.link_register}}\" target=\"_blank\">{{Sidebar.event.data.link_register}}</a></div><div class=\"m-t-md\"><p><em class=\"fa fa-map-marker\"></em> {{Sidebar.event.data.place}}</p><p><em class=\"fa fa-certificate\"></em> <span translate-cloak=\"\">{{ \'Sidebar.event.planner\' | translate}}</span> <strong class=\"text-sucess\">{{Sidebar.event.data.planner}}</strong></p></div><hr ng-if=\"Sidebar.event.data.description\"><div ng-if=\"Sidebar.event.data.description\" class=\"\" ng-bind-html=\"Sidebar.event.data.description\"></div><hr ng-if=\"Sidebar.event.data.comment\"><div ng-if=\"Sidebar.event.data.comment\" class=\"\" ng-bind-html=\"Sidebar.event.data.comment\"></div></div><div class=\"col-xs12 col-md-3\"><div class=\"m-b-sm\"><span translate-cloak=\"\">{{\'Sidebar.event.from\' | translate}}</span><div class=\"event-date\" ng-bind-html=\"Sidebar.event.data.date_from | date: \'dd-MM-yyyy\\\'<br>\\\'hh:mm\'\"></div></div><div ng-if=\"Sidebar.event.data.date_to\"><span translate-cloak=\"\">{{\'Sidebar.event.to\' | translate}}</span><div class=\"event-date\" ng-bind-html=\"Sidebar.event.data.date_to | date: \'dd-MM-yyyy\\\'<br>\\\'hh:mm\'\"></div></div></div></div><hr class=\"hr-line-dashed\"><p><span translate-cloak=\"\">{{\'Sidebar.event.publisher\' | translate}}</span> <strong class=\"text-success\">{{Sidebar.event.data.company.name}}</strong></p></div></div>");
$templateCache.put("app/templates/sidebar/press_release.html","<div class=\"ibox prelease\"><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Sidebar.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"text-center\"><span class=\"text-muted\"><em class=\"fa fa-clock-o\"></em> <span am-time-ago=\"Sidebar.pReleease.updated_at.date | amUtc | amLocal\"></span></span><h2 class=\"m-b-lg text-success\">{{Sidebar.pReleease.title}}</h2></div><div ng-if=\"Sidebar.pReleease.image\" class=\"img-content\"><img alt=\"Imagen de la noticia\" ng-src=\"{{Sidebar.pReleease.image.real_path}}\" class=\"img-responsive center-block\"></div><div class=\"m-t-md m-b-md font-bold\">{{Sidebar.pReleease.subtitle}}</div><div ng-bind-html=\"Sidebar.pReleease.content\"></div><hr><div ng-if=\"Sidebar.pReleease.images.length\"><div class=\"row\"><div class=\"col-md-3 col-xs-6\" ng-repeat=\"image in Sidebar.pReleease.images track by $index\"><img alt=\"Imagen de la noticia\" ng-src=\"{{image.real_path}}\" class=\"img-responsive center-block\"></div></div><hr></div><div ng-if=\"Sidebar.pReleease.files.length\"><p translate-cloak=\"\"><em class=\"fa fa-paperclip\"></em> {{\'press_releases.view.attachs\' | translate}}</p><div class=\"row\"><div class=\"col-md-1 col-xs-3\" ng-repeat=\"file in Sidebar.pReleease.files track by $index\"><a ng-href=\"{{file.real_path}}\" target=\"_blank\"><em class=\"fa fa-file fa-3\"></em></a></div></div><hr></div><h5 class=\"text-success\" translate-cloak=\"\">{{\'press_releases.view.contact\' | translate}}:</h5><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><em class=\"fa fa-user\"></em> <strong>{{Sidebar.pReleease.contact_person}}</strong><br><em class=\"fa fa-envelope\"></em> {{Sidebar.pReleease.contact_email}}</div><div class=\"col-xs-12 col-md-6\"><em class=\"fa fa-phone\"></em> {{Sidebar.pReleease.contact_phone}}<br><em class=\"fa fa-link\"></em> <a ng-href=\"{{Sidebar.pReleease.contact_web}}\" target=\"_blank\">{{Sidebar.pReleease.contact_web}}</a></div></div><hr><div class=\"row\" ng-if=\"Sidebar.pReleease.comments.length > 0\"><div class=\"col-lg-12\"><h5 class=\"text-success\" translate-cloak=\"\">Comments:</h5><div class=\"social-feed-box\" ng-repeat=\"comment in Sidebar.pReleease.comments track by $index\"><div class=\"social-avatar\"><a ng-if=\"comment.user.image.real_path\" link-sidebar=\"\" type=\"2\" data=\"comment.user\" class=\"pull-left\"><img alt=\"Logo de la empresa\" ng-src=\"{{comment.image.real_path}}\"></a><div class=\"media-body\"><a link-sidebar=\"\" type=\"2\" data=\"comment.user\" href=\"javascript:void(0);\">{{comment.user.name}}</a> <a link-sidebar=\"\" type=\"1\" data=\"comment.company\" href=\"javascript:void(0);\" class=\"text-primary\"><small>{{comment.company.name}}</small></a> <small class=\"text-muted\" am-time-ago=\"{{comment.created_at.date | amUtc | amLocal}}\"></small></div></div><div class=\"social-body\" ng-bind-html=\"comment.comment\"></div></div></div></div><hr class=\"hr-line-dashed\" ng-if=\"Sidebar.pReleease.comments.length > 0\"><div><form name=\"composePReleaseCommnet\" ng-submit=\"Sidebar.pReleeaseSendComment(composePReleaseCommnet)\"><div class=\"form-group\"><textarea class=\"form-control\" row=\"4\" ng-model=\"Sidebar.pReleaseComment\" required=\"\"></textarea></div><div class=\"text-right\"><button type=\"submit\" ng-disabled=\"Sidebar.loadingComment || composePReleaseCommnet.$invalid\" class=\"btn btn-success btn-sm\" translate-cloak=\"\">{{\'press_releases.view.send\' | translate}}</button></div></form></div></div></div>");
$templateCache.put("app/templates/sidebar/project.html","<div class=\"ibox\"><div class=\"ibox-title\"><h3 class=\"text-success\">{{Sidebar.project.data.title}}</h3><strong>{{Sidebar.project.data.company.name}}</strong></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Sidebar.project.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"row\"><div class=\"col-xs12 col-md-9\"><div><span translate-cloak=\"\">{{\'sidebar.project.scope\' | translate}}</span> <strong class=\"text-success\">{{Sidebar.project.data.scope}}</strong></div><div class=\"m-t-sm\" ng-if=\"Sidebar.project.data.aproach\" translate-cloak=\"\">{{\'sidebar.project.aproach\' | translate}}: <strong class=\"text-success\">{{Sidebar.project.data.aproach}}€</strong></div><div class=\"m-t-sm\"><span translate-cloak=\"\">{{\'sidebar.project.documentation\' | translate}}</span><br><a ng-href=\"{{Sidebar.project.data.url}}\" target=\"_blank\">{{Sidebar.project.data.url}}</a></div><hr><div class=\"\" ng-bind-html=\"Sidebar.project.data.description\"></div><hr><div ng-if=\"Sidebar.project.data.comments\"><div class=\"\" ng-bind-html=\"Sidebar.project.data.comments\"></div><hr></div><p><span translate-cloak=\"\">{{\'sidebar.project.personal_contact\' | translate}}</span> <span class=\"text-success\">{{Sidebar.project.data.person_contact}}</span></p><p><span translate-cloak=\"\">{{\'sidebar.project.email\' | translate}}</span> <span class=\"text-success\">{{Sidebar.project.data.email}}</span></p><p><span translate-cloak=\"\">{{\'sidebar.project.phone\' | translate}}</span> <span class=\"text-success\">{{Sidebar.project.data.phone}}</span></p></div><div class=\"col-xs12 col-md-3\"><div class=\"m-b-sm\" ng-if=\"Sidebar.project.data.date_from\"><span translate-cloak=\"\">{{\'sidebar.project.from\' | translate}}</span><div class=\"event-date\" ng-bind-html=\"Sidebar.project.data.date_from | date: \'dd-MM-yyyy\'\"></div></div><div ng-if=\"Sidebar.project.data.date_to\"><span translate-cloak=\"\">{{\'sidebar.project.to\' | translate}}</span><div class=\"event-date\" ng-bind-html=\"Sidebar.project.data.date_to | date: \'dd-MM-yyyy\'\"></div></div></div></div><div ng-if=\"Sidebar.project.data.participants.length && (myUser.company.id == Sidebar.project.data.company.id || myUser.group == \'superadmin\' || myUser.group == \'admin\')\"><hr class=\"hr-line-solid\"><h5 translate-cloak=\"\">{{\'sidebar.project.participants\' | translate}}Participantes:</h5><div ng-repeat=\"participant in Sidebar.project.data.participants track by $index\"><span class=\"text-success\">{{participant.company[0].name}}</span> <a href=\"javascript:void(0);\" ng-click=\"Sidebar.project.removeUser(Sidebar.project.data.id, participant.company[0].id, $index)\" title=\"Desligarse\"><em class=\"fa fa-close text-warning\"></em></a></div></div></div></div>");
$templateCache.put("app/templates/sidebar/startup.html","<div class=\"ibox\"><div class=\"ibox-title\"><div><img alt=\"Logo StartUp\" ng-src=\"{{Sidebar.startup.data.logo}}\" class=\"img-responsive\"></div><h3 class=\"text-success\">{{Sidebar.startup.data.title}}</h3><p>{{Sidebar.startup.data.sector}}</p></div><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': Sidebar.startup.loading}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"\" ng-bind-html=\"Sidebar.startup.data.description\"></div><hr><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><p ng-if=\"Sidebar.startup.data.isFavourite\" translate-cloak=\"\">{{ \'startups.favourite\' | translate}}: <em class=\"fa fa-check text-success\"></em></p><p><span translate-cloak=\"\">{{ \'startups.date\' | translate}}:</span> <span am-time-ago=\"Sidebar.startup.data.created_at\"></span></p></div><div class=\"col-md-6 col-xs-12\"><p><span translate-cloak=\"\">{{ \'startups.web\' | translate}}</span>: <a ng-href=\"{{Sidebar.startup.data.web}}\" target=\"_blank\">{{Sidebar.startup.data.web}}</a></p><p><span translate-cloak=\"\">{{ \'startups.presentation\' | translate}}</span>: <a ng-href=\"{{Sidebar.startup.data.link_presentation}}\" target=\"_blank\"><em class=\"fa fa-rocket\"></em></a></p></div></div></div></div>");
$templateCache.put("app/templates/sidebar/view_email.html","email");}]);